
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefe00"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefe00"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d05Lk", function(module, exports) {
/**
 * xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */ 
var $lblM3 = parcelRequire("lblM3");

var $iH2xc = parcelRequire("iH2xc");

var $a2Uky = parcelRequire("a2Uky");
/**
 * filter xss function
 *
 * @param {String} html
 * @param {Object} options { whiteList, onTag, onTagAttr, onIgnoreTag, onIgnoreTagAttr, safeAttrValue, escapeHtml }
 * @return {String}
 */ function filterXSS(html, options) {
    var xss = new $a2Uky(options);
    return xss.process(html);
}
exports = module.exports = filterXSS;
exports.filterXSS = filterXSS;
exports.FilterXSS = $a2Uky;
(function() {
    for(var i in $lblM3)exports[i] = $lblM3[i];
    for(var j in $iH2xc)exports[j] = $iH2xc[j];
})();
// using `xss` on the browser, output `filterXSS` to the globals
if (typeof window !== "undefined") window.filterXSS = module.exports;
// using `xss` on the WebWorker, output `filterXSS` to the globals
function isWorkerEnv() {
    return typeof self !== "undefined" && typeof DedicatedWorkerGlobalScope !== "undefined" && self instanceof DedicatedWorkerGlobalScope;
}
if (isWorkerEnv()) self.filterXSS = module.exports;

});
parcelRegister("lblM3", function(module, exports) {

$parcel$export(module.exports, "whiteList", function () { return $f6bb83f40ed388bb$export$81959c441b85a1ce; }, function (v) { return $f6bb83f40ed388bb$export$81959c441b85a1ce = v; });
$parcel$export(module.exports, "getDefaultWhiteList", function () { return $f6bb83f40ed388bb$export$df33d771471df647; }, function (v) { return $f6bb83f40ed388bb$export$df33d771471df647 = v; });
$parcel$export(module.exports, "onTag", function () { return $f6bb83f40ed388bb$export$8ee080b6f5c498c5; }, function (v) { return $f6bb83f40ed388bb$export$8ee080b6f5c498c5 = v; });
$parcel$export(module.exports, "onIgnoreTag", function () { return $f6bb83f40ed388bb$export$6a8dcd2af568ef73; }, function (v) { return $f6bb83f40ed388bb$export$6a8dcd2af568ef73 = v; });
$parcel$export(module.exports, "onTagAttr", function () { return $f6bb83f40ed388bb$export$68f34a033c535f39; }, function (v) { return $f6bb83f40ed388bb$export$68f34a033c535f39 = v; });
$parcel$export(module.exports, "onIgnoreTagAttr", function () { return $f6bb83f40ed388bb$export$c08c9f0d730a9b5f; }, function (v) { return $f6bb83f40ed388bb$export$c08c9f0d730a9b5f = v; });
$parcel$export(module.exports, "safeAttrValue", function () { return $f6bb83f40ed388bb$export$3b380fb6422d8d92; }, function (v) { return $f6bb83f40ed388bb$export$3b380fb6422d8d92 = v; });
$parcel$export(module.exports, "escapeHtml", function () { return $f6bb83f40ed388bb$export$4cf11838cdc2a8a8; }, function (v) { return $f6bb83f40ed388bb$export$4cf11838cdc2a8a8 = v; });
$parcel$export(module.exports, "escapeQuote", function () { return $f6bb83f40ed388bb$export$b34053251219d4d; }, function (v) { return $f6bb83f40ed388bb$export$b34053251219d4d = v; });
$parcel$export(module.exports, "unescapeQuote", function () { return $f6bb83f40ed388bb$export$b8b43266c0fd884b; }, function (v) { return $f6bb83f40ed388bb$export$b8b43266c0fd884b = v; });
$parcel$export(module.exports, "escapeHtmlEntities", function () { return $f6bb83f40ed388bb$export$2bf939f54de7f222; }, function (v) { return $f6bb83f40ed388bb$export$2bf939f54de7f222 = v; });
$parcel$export(module.exports, "escapeDangerHtml5Entities", function () { return $f6bb83f40ed388bb$export$23813bdaf7b05b02; }, function (v) { return $f6bb83f40ed388bb$export$23813bdaf7b05b02 = v; });
$parcel$export(module.exports, "clearNonPrintableCharacter", function () { return $f6bb83f40ed388bb$export$a940bb329b7402b7; }, function (v) { return $f6bb83f40ed388bb$export$a940bb329b7402b7 = v; });
$parcel$export(module.exports, "friendlyAttrValue", function () { return $f6bb83f40ed388bb$export$474346ac3b97b91e; }, function (v) { return $f6bb83f40ed388bb$export$474346ac3b97b91e = v; });
$parcel$export(module.exports, "escapeAttrValue", function () { return $f6bb83f40ed388bb$export$3182ddfe050dbeb2; }, function (v) { return $f6bb83f40ed388bb$export$3182ddfe050dbeb2 = v; });
$parcel$export(module.exports, "onIgnoreTagStripAll", function () { return $f6bb83f40ed388bb$export$8662d7a29d0836de; }, function (v) { return $f6bb83f40ed388bb$export$8662d7a29d0836de = v; });
$parcel$export(module.exports, "StripTagBody", function () { return $f6bb83f40ed388bb$export$c5207ac5d2688c71; }, function (v) { return $f6bb83f40ed388bb$export$c5207ac5d2688c71 = v; });
$parcel$export(module.exports, "stripCommentTag", function () { return $f6bb83f40ed388bb$export$89570102812ee0df; }, function (v) { return $f6bb83f40ed388bb$export$89570102812ee0df = v; });
$parcel$export(module.exports, "stripBlankChar", function () { return $f6bb83f40ed388bb$export$d540559455185e53; }, function (v) { return $f6bb83f40ed388bb$export$d540559455185e53 = v; });
$parcel$export(module.exports, "attributeWrapSign", function () { return $f6bb83f40ed388bb$export$8581cab6b127478e; }, function (v) { return $f6bb83f40ed388bb$export$8581cab6b127478e = v; });
$parcel$export(module.exports, "cssFilter", function () { return $f6bb83f40ed388bb$export$39da57ce707585be; }, function (v) { return $f6bb83f40ed388bb$export$39da57ce707585be = v; });
$parcel$export(module.exports, "getDefaultCSSWhiteList", function () { return $f6bb83f40ed388bb$export$c47b8d41609c6a49; }, function (v) { return $f6bb83f40ed388bb$export$c47b8d41609c6a49 = v; });
/**
 * default settings
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */ var $f6bb83f40ed388bb$export$81959c441b85a1ce;
var $f6bb83f40ed388bb$export$df33d771471df647;
var $f6bb83f40ed388bb$export$8ee080b6f5c498c5;
var $f6bb83f40ed388bb$export$6a8dcd2af568ef73;
var $f6bb83f40ed388bb$export$68f34a033c535f39;
var $f6bb83f40ed388bb$export$c08c9f0d730a9b5f;
var $f6bb83f40ed388bb$export$3b380fb6422d8d92;
var $f6bb83f40ed388bb$export$4cf11838cdc2a8a8;
var $f6bb83f40ed388bb$export$b34053251219d4d;
var $f6bb83f40ed388bb$export$b8b43266c0fd884b;
var $f6bb83f40ed388bb$export$2bf939f54de7f222;
var $f6bb83f40ed388bb$export$23813bdaf7b05b02;
var $f6bb83f40ed388bb$export$a940bb329b7402b7;
var $f6bb83f40ed388bb$export$474346ac3b97b91e;
var $f6bb83f40ed388bb$export$3182ddfe050dbeb2;
var $f6bb83f40ed388bb$export$8662d7a29d0836de;
var $f6bb83f40ed388bb$export$c5207ac5d2688c71;
var $f6bb83f40ed388bb$export$89570102812ee0df;
var $f6bb83f40ed388bb$export$d540559455185e53;
var $f6bb83f40ed388bb$export$8581cab6b127478e;
var $f6bb83f40ed388bb$export$39da57ce707585be;
var $f6bb83f40ed388bb$export$c47b8d41609c6a49;

var $6mFtf = parcelRequire("6mFtf");
var $f6bb83f40ed388bb$require$FilterCSS = $6mFtf.FilterCSS;

var $6mFtf = parcelRequire("6mFtf");
var $f6bb83f40ed388bb$require$getDefaultCSSWhiteList = $6mFtf.getDefaultWhiteList;

var $9UvL9 = parcelRequire("9UvL9");
function $f6bb83f40ed388bb$var$getDefaultWhiteList() {
    return {
        a: [
            "target",
            "href",
            "title"
        ],
        abbr: [
            "title"
        ],
        address: [],
        area: [
            "shape",
            "coords",
            "href",
            "alt"
        ],
        article: [],
        aside: [],
        audio: [
            "autoplay",
            "controls",
            "crossorigin",
            "loop",
            "muted",
            "preload",
            "src"
        ],
        b: [],
        bdi: [
            "dir"
        ],
        bdo: [
            "dir"
        ],
        big: [],
        blockquote: [
            "cite"
        ],
        br: [],
        caption: [],
        center: [],
        cite: [],
        code: [],
        col: [
            "align",
            "valign",
            "span",
            "width"
        ],
        colgroup: [
            "align",
            "valign",
            "span",
            "width"
        ],
        dd: [],
        del: [
            "datetime"
        ],
        details: [
            "open"
        ],
        div: [],
        dl: [],
        dt: [],
        em: [],
        figcaption: [],
        figure: [],
        font: [
            "color",
            "size",
            "face"
        ],
        footer: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        header: [],
        hr: [],
        i: [],
        img: [
            "src",
            "alt",
            "title",
            "width",
            "height",
            "loading"
        ],
        ins: [
            "datetime"
        ],
        kbd: [],
        li: [],
        mark: [],
        nav: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        section: [],
        small: [],
        span: [],
        sub: [],
        summary: [],
        sup: [],
        strong: [],
        strike: [],
        table: [
            "width",
            "border",
            "align",
            "valign"
        ],
        tbody: [
            "align",
            "valign"
        ],
        td: [
            "width",
            "rowspan",
            "colspan",
            "align",
            "valign"
        ],
        tfoot: [
            "align",
            "valign"
        ],
        th: [
            "width",
            "rowspan",
            "colspan",
            "align",
            "valign"
        ],
        thead: [
            "align",
            "valign"
        ],
        tr: [
            "rowspan",
            "align",
            "valign"
        ],
        tt: [],
        u: [],
        ul: [],
        video: [
            "autoplay",
            "controls",
            "crossorigin",
            "loop",
            "muted",
            "playsinline",
            "poster",
            "preload",
            "src",
            "height",
            "width"
        ]
    };
}
var $f6bb83f40ed388bb$var$defaultCSSFilter = new $f6bb83f40ed388bb$require$FilterCSS();
/**
 * default onTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */ function $f6bb83f40ed388bb$var$onTag(tag, html, options) {
// do nothing
}
/**
 * default onIgnoreTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */ function $f6bb83f40ed388bb$var$onIgnoreTag(tag, html, options) {
// do nothing
}
/**
 * default onTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */ function $f6bb83f40ed388bb$var$onTagAttr(tag, name, value) {
// do nothing
}
/**
 * default onIgnoreTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */ function $f6bb83f40ed388bb$var$onIgnoreTagAttr(tag, name, value) {
// do nothing
}
/**
 * default escapeHtml function
 *
 * @param {String} html
 */ function $f6bb83f40ed388bb$var$escapeHtml(html) {
    return html.replace($f6bb83f40ed388bb$var$REGEXP_LT, "&lt;").replace($f6bb83f40ed388bb$var$REGEXP_GT, "&gt;");
}
/**
 * default safeAttrValue function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @param {Object} cssFilter
 * @return {String}
 */ function $f6bb83f40ed388bb$var$safeAttrValue(tag, name, value, cssFilter) {
    // unescape attribute value firstly
    value = $f6bb83f40ed388bb$var$friendlyAttrValue(value);
    if (name === "href" || name === "src") {
        // filter `href` and `src` attribute
        // only allow the value that starts with `http://` | `https://` | `mailto:` | `/` | `#`
        value = $9UvL9.trim(value);
        if (value === "#") return "#";
        if (!(value.substr(0, 7) === "http://" || value.substr(0, 8) === "https://" || value.substr(0, 7) === "mailto:" || value.substr(0, 4) === "tel:" || value.substr(0, 11) === "data:image/" || value.substr(0, 6) === "ftp://" || value.substr(0, 2) === "./" || value.substr(0, 3) === "../" || value[0] === "#" || value[0] === "/")) return "";
    } else if (name === "background") {
        // filter `background` attribute (maybe no use)
        // `javascript:`
        $f6bb83f40ed388bb$var$REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
        if ($f6bb83f40ed388bb$var$REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) return "";
    } else if (name === "style") {
        // `expression()`
        $f6bb83f40ed388bb$var$REGEXP_DEFAULT_ON_TAG_ATTR_7.lastIndex = 0;
        if ($f6bb83f40ed388bb$var$REGEXP_DEFAULT_ON_TAG_ATTR_7.test(value)) return "";
        // `url()`
        $f6bb83f40ed388bb$var$REGEXP_DEFAULT_ON_TAG_ATTR_8.lastIndex = 0;
        if ($f6bb83f40ed388bb$var$REGEXP_DEFAULT_ON_TAG_ATTR_8.test(value)) {
            $f6bb83f40ed388bb$var$REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
            if ($f6bb83f40ed388bb$var$REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) return "";
        }
        if (cssFilter !== false) {
            cssFilter = cssFilter || $f6bb83f40ed388bb$var$defaultCSSFilter;
            value = cssFilter.process(value);
        }
    }
    // escape `<>"` before returns
    value = $f6bb83f40ed388bb$var$escapeAttrValue(value);
    return value;
}
// RegExp list
var $f6bb83f40ed388bb$var$REGEXP_LT = /</g;
var $f6bb83f40ed388bb$var$REGEXP_GT = />/g;
var $f6bb83f40ed388bb$var$REGEXP_QUOTE = /"/g;
var $f6bb83f40ed388bb$var$REGEXP_QUOTE_2 = /&quot;/g;
var $f6bb83f40ed388bb$var$REGEXP_ATTR_VALUE_1 = /&#([a-zA-Z0-9]*);?/gim;
var $f6bb83f40ed388bb$var$REGEXP_ATTR_VALUE_COLON = /&colon;?/gim;
var $f6bb83f40ed388bb$var$REGEXP_ATTR_VALUE_NEWLINE = /&newline;?/gim;
// var REGEXP_DEFAULT_ON_TAG_ATTR_3 = /\/\*|\*\//gm;
var $f6bb83f40ed388bb$var$REGEXP_DEFAULT_ON_TAG_ATTR_4 = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi;
// var REGEXP_DEFAULT_ON_TAG_ATTR_5 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:/gi;
// var REGEXP_DEFAULT_ON_TAG_ATTR_6 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:\s*image\//gi;
var $f6bb83f40ed388bb$var$REGEXP_DEFAULT_ON_TAG_ATTR_7 = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi;
var $f6bb83f40ed388bb$var$REGEXP_DEFAULT_ON_TAG_ATTR_8 = /u\s*r\s*l\s*\(.*/gi;
/**
 * escape double quote
 *
 * @param {String} str
 * @return {String} str
 */ function $f6bb83f40ed388bb$var$escapeQuote(str) {
    return str.replace($f6bb83f40ed388bb$var$REGEXP_QUOTE, "&quot;");
}
/**
 * unescape double quote
 *
 * @param {String} str
 * @return {String} str
 */ function $f6bb83f40ed388bb$var$unescapeQuote(str) {
    return str.replace($f6bb83f40ed388bb$var$REGEXP_QUOTE_2, '"');
}
/**
 * escape html entities
 *
 * @param {String} str
 * @return {String}
 */ function $f6bb83f40ed388bb$var$escapeHtmlEntities(str) {
    return str.replace($f6bb83f40ed388bb$var$REGEXP_ATTR_VALUE_1, function replaceUnicode(str, code) {
        return code[0] === "x" || code[0] === "X" ? String.fromCharCode(parseInt(code.substr(1), 16)) : String.fromCharCode(parseInt(code, 10));
    });
}
/**
 * escape html5 new danger entities
 *
 * @param {String} str
 * @return {String}
 */ function $f6bb83f40ed388bb$var$escapeDangerHtml5Entities(str) {
    return str.replace($f6bb83f40ed388bb$var$REGEXP_ATTR_VALUE_COLON, ":").replace($f6bb83f40ed388bb$var$REGEXP_ATTR_VALUE_NEWLINE, " ");
}
/**
 * clear nonprintable characters
 *
 * @param {String} str
 * @return {String}
 */ function $f6bb83f40ed388bb$var$clearNonPrintableCharacter(str) {
    var str2 = "";
    for(var i = 0, len = str.length; i < len; i++)str2 += str.charCodeAt(i) < 32 ? " " : str.charAt(i);
    return $9UvL9.trim(str2);
}
/**
 * get friendly attribute value
 *
 * @param {String} str
 * @return {String}
 */ function $f6bb83f40ed388bb$var$friendlyAttrValue(str) {
    str = $f6bb83f40ed388bb$var$unescapeQuote(str);
    str = $f6bb83f40ed388bb$var$escapeHtmlEntities(str);
    str = $f6bb83f40ed388bb$var$escapeDangerHtml5Entities(str);
    str = $f6bb83f40ed388bb$var$clearNonPrintableCharacter(str);
    return str;
}
/**
 * unescape attribute value
 *
 * @param {String} str
 * @return {String}
 */ function $f6bb83f40ed388bb$var$escapeAttrValue(str) {
    str = $f6bb83f40ed388bb$var$escapeQuote(str);
    str = $f6bb83f40ed388bb$var$escapeHtml(str);
    return str;
}
/**
 * `onIgnoreTag` function for removing all the tags that are not in whitelist
 */ function $f6bb83f40ed388bb$var$onIgnoreTagStripAll() {
    return "";
}
/**
 * remove tag body
 * specify a `tags` list, if the tag is not in the `tags` list then process by the specify function (optional)
 *
 * @param {array} tags
 * @param {function} next
 */ function $f6bb83f40ed388bb$var$StripTagBody(tags, next) {
    if (typeof next !== "function") next = function() {};
    var isRemoveAllTag = !Array.isArray(tags);
    function isRemoveTag(tag) {
        if (isRemoveAllTag) return true;
        return $9UvL9.indexOf(tags, tag) !== -1;
    }
    var removeList = [];
    var posStart = false;
    return {
        onIgnoreTag: function(tag, html, options) {
            if (isRemoveTag(tag)) {
                if (options.isClosing) {
                    var ret = "[/removed]";
                    var end = options.position + ret.length;
                    removeList.push([
                        posStart !== false ? posStart : options.position,
                        end
                    ]);
                    posStart = false;
                    return ret;
                } else {
                    if (!posStart) posStart = options.position;
                    return "[removed]";
                }
            } else return next(tag, html, options);
        },
        remove: function(html) {
            var rethtml = "";
            var lastPos = 0;
            $9UvL9.forEach(removeList, function(pos) {
                rethtml += html.slice(lastPos, pos[0]);
                lastPos = pos[1];
            });
            rethtml += html.slice(lastPos);
            return rethtml;
        }
    };
}
/**
 * remove html comments
 *
 * @param {String} html
 * @return {String}
 */ function $f6bb83f40ed388bb$var$stripCommentTag(html) {
    var retHtml = "";
    var lastPos = 0;
    while(lastPos < html.length){
        var i = html.indexOf("<!--", lastPos);
        if (i === -1) {
            retHtml += html.slice(lastPos);
            break;
        }
        retHtml += html.slice(lastPos, i);
        var j = html.indexOf("-->", i);
        if (j === -1) break;
        lastPos = j + 3;
    }
    return retHtml;
}
/**
 * remove invisible characters
 *
 * @param {String} html
 * @return {String}
 */ function $f6bb83f40ed388bb$var$stripBlankChar(html) {
    var chars = html.split("");
    chars = chars.filter(function(char) {
        var c = char.charCodeAt(0);
        if (c === 127) return false;
        if (c <= 31) {
            if (c === 10 || c === 13) return true;
            return false;
        }
        return true;
    });
    return chars.join("");
}
$f6bb83f40ed388bb$export$81959c441b85a1ce = $f6bb83f40ed388bb$var$getDefaultWhiteList();
$f6bb83f40ed388bb$export$df33d771471df647 = $f6bb83f40ed388bb$var$getDefaultWhiteList;
$f6bb83f40ed388bb$export$8ee080b6f5c498c5 = $f6bb83f40ed388bb$var$onTag;
$f6bb83f40ed388bb$export$6a8dcd2af568ef73 = $f6bb83f40ed388bb$var$onIgnoreTag;
$f6bb83f40ed388bb$export$68f34a033c535f39 = $f6bb83f40ed388bb$var$onTagAttr;
$f6bb83f40ed388bb$export$c08c9f0d730a9b5f = $f6bb83f40ed388bb$var$onIgnoreTagAttr;
$f6bb83f40ed388bb$export$3b380fb6422d8d92 = $f6bb83f40ed388bb$var$safeAttrValue;
$f6bb83f40ed388bb$export$4cf11838cdc2a8a8 = $f6bb83f40ed388bb$var$escapeHtml;
$f6bb83f40ed388bb$export$b34053251219d4d = $f6bb83f40ed388bb$var$escapeQuote;
$f6bb83f40ed388bb$export$b8b43266c0fd884b = $f6bb83f40ed388bb$var$unescapeQuote;
$f6bb83f40ed388bb$export$2bf939f54de7f222 = $f6bb83f40ed388bb$var$escapeHtmlEntities;
$f6bb83f40ed388bb$export$23813bdaf7b05b02 = $f6bb83f40ed388bb$var$escapeDangerHtml5Entities;
$f6bb83f40ed388bb$export$a940bb329b7402b7 = $f6bb83f40ed388bb$var$clearNonPrintableCharacter;
$f6bb83f40ed388bb$export$474346ac3b97b91e = $f6bb83f40ed388bb$var$friendlyAttrValue;
$f6bb83f40ed388bb$export$3182ddfe050dbeb2 = $f6bb83f40ed388bb$var$escapeAttrValue;
$f6bb83f40ed388bb$export$8662d7a29d0836de = $f6bb83f40ed388bb$var$onIgnoreTagStripAll;
$f6bb83f40ed388bb$export$c5207ac5d2688c71 = $f6bb83f40ed388bb$var$StripTagBody;
$f6bb83f40ed388bb$export$89570102812ee0df = $f6bb83f40ed388bb$var$stripCommentTag;
$f6bb83f40ed388bb$export$d540559455185e53 = $f6bb83f40ed388bb$var$stripBlankChar;
$f6bb83f40ed388bb$export$8581cab6b127478e = '"';
$f6bb83f40ed388bb$export$39da57ce707585be = $f6bb83f40ed388bb$var$defaultCSSFilter;
$f6bb83f40ed388bb$export$c47b8d41609c6a49 = $f6bb83f40ed388bb$require$getDefaultCSSWhiteList;

});
parcelRegister("6mFtf", function(module, exports) {
/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */ 
var $9qe8D = parcelRequire("9qe8D");

var $gy24b = parcelRequire("gy24b");
/**
 * XSS过滤
 *
 * @param {String} css 要过滤的CSS代码
 * @param {Object} options 选项：whiteList, onAttr, onIgnoreAttr
 * @return {String}
 */ function filterCSS(html, options) {
    var xss = new $gy24b(options);
    return xss.process(html);
}
// 输出
exports = module.exports = filterCSS;
exports.FilterCSS = $gy24b;
for(var i in $9qe8D)exports[i] = $9qe8D[i];
// 在浏览器端使用
if (typeof window !== 'undefined') window.filterCSS = module.exports;

});
parcelRegister("9qe8D", function(module, exports) {

$parcel$export(module.exports, "whiteList", function () { return $6dc182533680a423$export$81959c441b85a1ce; }, function (v) { return $6dc182533680a423$export$81959c441b85a1ce = v; });
$parcel$export(module.exports, "getDefaultWhiteList", function () { return $6dc182533680a423$export$df33d771471df647; }, function (v) { return $6dc182533680a423$export$df33d771471df647 = v; });
$parcel$export(module.exports, "onAttr", function () { return $6dc182533680a423$export$4f8a1255fd179c1f; }, function (v) { return $6dc182533680a423$export$4f8a1255fd179c1f = v; });
$parcel$export(module.exports, "onIgnoreAttr", function () { return $6dc182533680a423$export$6d1d10ce80791ec5; }, function (v) { return $6dc182533680a423$export$6d1d10ce80791ec5 = v; });
$parcel$export(module.exports, "safeAttrValue", function () { return $6dc182533680a423$export$3b380fb6422d8d92; }, function (v) { return $6dc182533680a423$export$3b380fb6422d8d92 = v; });
/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */ var $6dc182533680a423$export$81959c441b85a1ce;
var $6dc182533680a423$export$df33d771471df647;
var $6dc182533680a423$export$4f8a1255fd179c1f;
var $6dc182533680a423$export$6d1d10ce80791ec5;
var $6dc182533680a423$export$3b380fb6422d8d92;
function $6dc182533680a423$var$getDefaultWhiteList() {
    // 白名单值说明：
    // true: 允许该属性
    // Function: function (val) { } 返回true表示允许该属性，其他值均表示不允许
    // RegExp: regexp.test(val) 返回true表示允许该属性，其他值均表示不允许
    // 除上面列出的值外均表示不允许
    var whiteList = {};
    whiteList['align-content'] = false; // default: auto
    whiteList['align-items'] = false; // default: auto
    whiteList['align-self'] = false; // default: auto
    whiteList['alignment-adjust'] = false; // default: auto
    whiteList['alignment-baseline'] = false; // default: baseline
    whiteList['all'] = false; // default: depending on individual properties
    whiteList['anchor-point'] = false; // default: none
    whiteList['animation'] = false; // default: depending on individual properties
    whiteList['animation-delay'] = false; // default: 0
    whiteList['animation-direction'] = false; // default: normal
    whiteList['animation-duration'] = false; // default: 0
    whiteList['animation-fill-mode'] = false; // default: none
    whiteList['animation-iteration-count'] = false; // default: 1
    whiteList['animation-name'] = false; // default: none
    whiteList['animation-play-state'] = false; // default: running
    whiteList['animation-timing-function'] = false; // default: ease
    whiteList['azimuth'] = false; // default: center
    whiteList['backface-visibility'] = false; // default: visible
    whiteList['background'] = true; // default: depending on individual properties
    whiteList['background-attachment'] = true; // default: scroll
    whiteList['background-clip'] = true; // default: border-box
    whiteList['background-color'] = true; // default: transparent
    whiteList['background-image'] = true; // default: none
    whiteList['background-origin'] = true; // default: padding-box
    whiteList['background-position'] = true; // default: 0% 0%
    whiteList['background-repeat'] = true; // default: repeat
    whiteList['background-size'] = true; // default: auto
    whiteList['baseline-shift'] = false; // default: baseline
    whiteList['binding'] = false; // default: none
    whiteList['bleed'] = false; // default: 6pt
    whiteList['bookmark-label'] = false; // default: content()
    whiteList['bookmark-level'] = false; // default: none
    whiteList['bookmark-state'] = false; // default: open
    whiteList['border'] = true; // default: depending on individual properties
    whiteList['border-bottom'] = true; // default: depending on individual properties
    whiteList['border-bottom-color'] = true; // default: current color
    whiteList['border-bottom-left-radius'] = true; // default: 0
    whiteList['border-bottom-right-radius'] = true; // default: 0
    whiteList['border-bottom-style'] = true; // default: none
    whiteList['border-bottom-width'] = true; // default: medium
    whiteList['border-collapse'] = true; // default: separate
    whiteList['border-color'] = true; // default: depending on individual properties
    whiteList['border-image'] = true; // default: none
    whiteList['border-image-outset'] = true; // default: 0
    whiteList['border-image-repeat'] = true; // default: stretch
    whiteList['border-image-slice'] = true; // default: 100%
    whiteList['border-image-source'] = true; // default: none
    whiteList['border-image-width'] = true; // default: 1
    whiteList['border-left'] = true; // default: depending on individual properties
    whiteList['border-left-color'] = true; // default: current color
    whiteList['border-left-style'] = true; // default: none
    whiteList['border-left-width'] = true; // default: medium
    whiteList['border-radius'] = true; // default: 0
    whiteList['border-right'] = true; // default: depending on individual properties
    whiteList['border-right-color'] = true; // default: current color
    whiteList['border-right-style'] = true; // default: none
    whiteList['border-right-width'] = true; // default: medium
    whiteList['border-spacing'] = true; // default: 0
    whiteList['border-style'] = true; // default: depending on individual properties
    whiteList['border-top'] = true; // default: depending on individual properties
    whiteList['border-top-color'] = true; // default: current color
    whiteList['border-top-left-radius'] = true; // default: 0
    whiteList['border-top-right-radius'] = true; // default: 0
    whiteList['border-top-style'] = true; // default: none
    whiteList['border-top-width'] = true; // default: medium
    whiteList['border-width'] = true; // default: depending on individual properties
    whiteList['bottom'] = false; // default: auto
    whiteList['box-decoration-break'] = true; // default: slice
    whiteList['box-shadow'] = true; // default: none
    whiteList['box-sizing'] = true; // default: content-box
    whiteList['box-snap'] = true; // default: none
    whiteList['box-suppress'] = true; // default: show
    whiteList['break-after'] = true; // default: auto
    whiteList['break-before'] = true; // default: auto
    whiteList['break-inside'] = true; // default: auto
    whiteList['caption-side'] = false; // default: top
    whiteList['chains'] = false; // default: none
    whiteList['clear'] = true; // default: none
    whiteList['clip'] = false; // default: auto
    whiteList['clip-path'] = false; // default: none
    whiteList['clip-rule'] = false; // default: nonzero
    whiteList['color'] = true; // default: implementation dependent
    whiteList['color-interpolation-filters'] = true; // default: auto
    whiteList['column-count'] = false; // default: auto
    whiteList['column-fill'] = false; // default: balance
    whiteList['column-gap'] = false; // default: normal
    whiteList['column-rule'] = false; // default: depending on individual properties
    whiteList['column-rule-color'] = false; // default: current color
    whiteList['column-rule-style'] = false; // default: medium
    whiteList['column-rule-width'] = false; // default: medium
    whiteList['column-span'] = false; // default: none
    whiteList['column-width'] = false; // default: auto
    whiteList['columns'] = false; // default: depending on individual properties
    whiteList['contain'] = false; // default: none
    whiteList['content'] = false; // default: normal
    whiteList['counter-increment'] = false; // default: none
    whiteList['counter-reset'] = false; // default: none
    whiteList['counter-set'] = false; // default: none
    whiteList['crop'] = false; // default: auto
    whiteList['cue'] = false; // default: depending on individual properties
    whiteList['cue-after'] = false; // default: none
    whiteList['cue-before'] = false; // default: none
    whiteList['cursor'] = false; // default: auto
    whiteList['direction'] = false; // default: ltr
    whiteList['display'] = true; // default: depending on individual properties
    whiteList['display-inside'] = true; // default: auto
    whiteList['display-list'] = true; // default: none
    whiteList['display-outside'] = true; // default: inline-level
    whiteList['dominant-baseline'] = false; // default: auto
    whiteList['elevation'] = false; // default: level
    whiteList['empty-cells'] = false; // default: show
    whiteList['filter'] = false; // default: none
    whiteList['flex'] = false; // default: depending on individual properties
    whiteList['flex-basis'] = false; // default: auto
    whiteList['flex-direction'] = false; // default: row
    whiteList['flex-flow'] = false; // default: depending on individual properties
    whiteList['flex-grow'] = false; // default: 0
    whiteList['flex-shrink'] = false; // default: 1
    whiteList['flex-wrap'] = false; // default: nowrap
    whiteList['float'] = false; // default: none
    whiteList['float-offset'] = false; // default: 0 0
    whiteList['flood-color'] = false; // default: black
    whiteList['flood-opacity'] = false; // default: 1
    whiteList['flow-from'] = false; // default: none
    whiteList['flow-into'] = false; // default: none
    whiteList['font'] = true; // default: depending on individual properties
    whiteList['font-family'] = true; // default: implementation dependent
    whiteList['font-feature-settings'] = true; // default: normal
    whiteList['font-kerning'] = true; // default: auto
    whiteList['font-language-override'] = true; // default: normal
    whiteList['font-size'] = true; // default: medium
    whiteList['font-size-adjust'] = true; // default: none
    whiteList['font-stretch'] = true; // default: normal
    whiteList['font-style'] = true; // default: normal
    whiteList['font-synthesis'] = true; // default: weight style
    whiteList['font-variant'] = true; // default: normal
    whiteList['font-variant-alternates'] = true; // default: normal
    whiteList['font-variant-caps'] = true; // default: normal
    whiteList['font-variant-east-asian'] = true; // default: normal
    whiteList['font-variant-ligatures'] = true; // default: normal
    whiteList['font-variant-numeric'] = true; // default: normal
    whiteList['font-variant-position'] = true; // default: normal
    whiteList['font-weight'] = true; // default: normal
    whiteList['grid'] = false; // default: depending on individual properties
    whiteList['grid-area'] = false; // default: depending on individual properties
    whiteList['grid-auto-columns'] = false; // default: auto
    whiteList['grid-auto-flow'] = false; // default: none
    whiteList['grid-auto-rows'] = false; // default: auto
    whiteList['grid-column'] = false; // default: depending on individual properties
    whiteList['grid-column-end'] = false; // default: auto
    whiteList['grid-column-start'] = false; // default: auto
    whiteList['grid-row'] = false; // default: depending on individual properties
    whiteList['grid-row-end'] = false; // default: auto
    whiteList['grid-row-start'] = false; // default: auto
    whiteList['grid-template'] = false; // default: depending on individual properties
    whiteList['grid-template-areas'] = false; // default: none
    whiteList['grid-template-columns'] = false; // default: none
    whiteList['grid-template-rows'] = false; // default: none
    whiteList['hanging-punctuation'] = false; // default: none
    whiteList['height'] = true; // default: auto
    whiteList['hyphens'] = false; // default: manual
    whiteList['icon'] = false; // default: auto
    whiteList['image-orientation'] = false; // default: auto
    whiteList['image-resolution'] = false; // default: normal
    whiteList['ime-mode'] = false; // default: auto
    whiteList['initial-letters'] = false; // default: normal
    whiteList['inline-box-align'] = false; // default: last
    whiteList['justify-content'] = false; // default: auto
    whiteList['justify-items'] = false; // default: auto
    whiteList['justify-self'] = false; // default: auto
    whiteList['left'] = false; // default: auto
    whiteList['letter-spacing'] = true; // default: normal
    whiteList['lighting-color'] = true; // default: white
    whiteList['line-box-contain'] = false; // default: block inline replaced
    whiteList['line-break'] = false; // default: auto
    whiteList['line-grid'] = false; // default: match-parent
    whiteList['line-height'] = false; // default: normal
    whiteList['line-snap'] = false; // default: none
    whiteList['line-stacking'] = false; // default: depending on individual properties
    whiteList['line-stacking-ruby'] = false; // default: exclude-ruby
    whiteList['line-stacking-shift'] = false; // default: consider-shifts
    whiteList['line-stacking-strategy'] = false; // default: inline-line-height
    whiteList['list-style'] = true; // default: depending on individual properties
    whiteList['list-style-image'] = true; // default: none
    whiteList['list-style-position'] = true; // default: outside
    whiteList['list-style-type'] = true; // default: disc
    whiteList['margin'] = true; // default: depending on individual properties
    whiteList['margin-bottom'] = true; // default: 0
    whiteList['margin-left'] = true; // default: 0
    whiteList['margin-right'] = true; // default: 0
    whiteList['margin-top'] = true; // default: 0
    whiteList['marker-offset'] = false; // default: auto
    whiteList['marker-side'] = false; // default: list-item
    whiteList['marks'] = false; // default: none
    whiteList['mask'] = false; // default: border-box
    whiteList['mask-box'] = false; // default: see individual properties
    whiteList['mask-box-outset'] = false; // default: 0
    whiteList['mask-box-repeat'] = false; // default: stretch
    whiteList['mask-box-slice'] = false; // default: 0 fill
    whiteList['mask-box-source'] = false; // default: none
    whiteList['mask-box-width'] = false; // default: auto
    whiteList['mask-clip'] = false; // default: border-box
    whiteList['mask-image'] = false; // default: none
    whiteList['mask-origin'] = false; // default: border-box
    whiteList['mask-position'] = false; // default: center
    whiteList['mask-repeat'] = false; // default: no-repeat
    whiteList['mask-size'] = false; // default: border-box
    whiteList['mask-source-type'] = false; // default: auto
    whiteList['mask-type'] = false; // default: luminance
    whiteList['max-height'] = true; // default: none
    whiteList['max-lines'] = false; // default: none
    whiteList['max-width'] = true; // default: none
    whiteList['min-height'] = true; // default: 0
    whiteList['min-width'] = true; // default: 0
    whiteList['move-to'] = false; // default: normal
    whiteList['nav-down'] = false; // default: auto
    whiteList['nav-index'] = false; // default: auto
    whiteList['nav-left'] = false; // default: auto
    whiteList['nav-right'] = false; // default: auto
    whiteList['nav-up'] = false; // default: auto
    whiteList['object-fit'] = false; // default: fill
    whiteList['object-position'] = false; // default: 50% 50%
    whiteList['opacity'] = false; // default: 1
    whiteList['order'] = false; // default: 0
    whiteList['orphans'] = false; // default: 2
    whiteList['outline'] = false; // default: depending on individual properties
    whiteList['outline-color'] = false; // default: invert
    whiteList['outline-offset'] = false; // default: 0
    whiteList['outline-style'] = false; // default: none
    whiteList['outline-width'] = false; // default: medium
    whiteList['overflow'] = false; // default: depending on individual properties
    whiteList['overflow-wrap'] = false; // default: normal
    whiteList['overflow-x'] = false; // default: visible
    whiteList['overflow-y'] = false; // default: visible
    whiteList['padding'] = true; // default: depending on individual properties
    whiteList['padding-bottom'] = true; // default: 0
    whiteList['padding-left'] = true; // default: 0
    whiteList['padding-right'] = true; // default: 0
    whiteList['padding-top'] = true; // default: 0
    whiteList['page'] = false; // default: auto
    whiteList['page-break-after'] = false; // default: auto
    whiteList['page-break-before'] = false; // default: auto
    whiteList['page-break-inside'] = false; // default: auto
    whiteList['page-policy'] = false; // default: start
    whiteList['pause'] = false; // default: implementation dependent
    whiteList['pause-after'] = false; // default: implementation dependent
    whiteList['pause-before'] = false; // default: implementation dependent
    whiteList['perspective'] = false; // default: none
    whiteList['perspective-origin'] = false; // default: 50% 50%
    whiteList['pitch'] = false; // default: medium
    whiteList['pitch-range'] = false; // default: 50
    whiteList['play-during'] = false; // default: auto
    whiteList['position'] = false; // default: static
    whiteList['presentation-level'] = false; // default: 0
    whiteList['quotes'] = false; // default: text
    whiteList['region-fragment'] = false; // default: auto
    whiteList['resize'] = false; // default: none
    whiteList['rest'] = false; // default: depending on individual properties
    whiteList['rest-after'] = false; // default: none
    whiteList['rest-before'] = false; // default: none
    whiteList['richness'] = false; // default: 50
    whiteList['right'] = false; // default: auto
    whiteList['rotation'] = false; // default: 0
    whiteList['rotation-point'] = false; // default: 50% 50%
    whiteList['ruby-align'] = false; // default: auto
    whiteList['ruby-merge'] = false; // default: separate
    whiteList['ruby-position'] = false; // default: before
    whiteList['shape-image-threshold'] = false; // default: 0.0
    whiteList['shape-outside'] = false; // default: none
    whiteList['shape-margin'] = false; // default: 0
    whiteList['size'] = false; // default: auto
    whiteList['speak'] = false; // default: auto
    whiteList['speak-as'] = false; // default: normal
    whiteList['speak-header'] = false; // default: once
    whiteList['speak-numeral'] = false; // default: continuous
    whiteList['speak-punctuation'] = false; // default: none
    whiteList['speech-rate'] = false; // default: medium
    whiteList['stress'] = false; // default: 50
    whiteList['string-set'] = false; // default: none
    whiteList['tab-size'] = false; // default: 8
    whiteList['table-layout'] = false; // default: auto
    whiteList['text-align'] = true; // default: start
    whiteList['text-align-last'] = true; // default: auto
    whiteList['text-combine-upright'] = true; // default: none
    whiteList['text-decoration'] = true; // default: none
    whiteList['text-decoration-color'] = true; // default: currentColor
    whiteList['text-decoration-line'] = true; // default: none
    whiteList['text-decoration-skip'] = true; // default: objects
    whiteList['text-decoration-style'] = true; // default: solid
    whiteList['text-emphasis'] = true; // default: depending on individual properties
    whiteList['text-emphasis-color'] = true; // default: currentColor
    whiteList['text-emphasis-position'] = true; // default: over right
    whiteList['text-emphasis-style'] = true; // default: none
    whiteList['text-height'] = true; // default: auto
    whiteList['text-indent'] = true; // default: 0
    whiteList['text-justify'] = true; // default: auto
    whiteList['text-orientation'] = true; // default: mixed
    whiteList['text-overflow'] = true; // default: clip
    whiteList['text-shadow'] = true; // default: none
    whiteList['text-space-collapse'] = true; // default: collapse
    whiteList['text-transform'] = true; // default: none
    whiteList['text-underline-position'] = true; // default: auto
    whiteList['text-wrap'] = true; // default: normal
    whiteList['top'] = false; // default: auto
    whiteList['transform'] = false; // default: none
    whiteList['transform-origin'] = false; // default: 50% 50% 0
    whiteList['transform-style'] = false; // default: flat
    whiteList['transition'] = false; // default: depending on individual properties
    whiteList['transition-delay'] = false; // default: 0s
    whiteList['transition-duration'] = false; // default: 0s
    whiteList['transition-property'] = false; // default: all
    whiteList['transition-timing-function'] = false; // default: ease
    whiteList['unicode-bidi'] = false; // default: normal
    whiteList['vertical-align'] = false; // default: baseline
    whiteList['visibility'] = false; // default: visible
    whiteList['voice-balance'] = false; // default: center
    whiteList['voice-duration'] = false; // default: auto
    whiteList['voice-family'] = false; // default: implementation dependent
    whiteList['voice-pitch'] = false; // default: medium
    whiteList['voice-range'] = false; // default: medium
    whiteList['voice-rate'] = false; // default: normal
    whiteList['voice-stress'] = false; // default: normal
    whiteList['voice-volume'] = false; // default: medium
    whiteList['volume'] = false; // default: medium
    whiteList['white-space'] = false; // default: normal
    whiteList['widows'] = false; // default: 2
    whiteList['width'] = true; // default: auto
    whiteList['will-change'] = false; // default: auto
    whiteList['word-break'] = true; // default: normal
    whiteList['word-spacing'] = true; // default: normal
    whiteList['word-wrap'] = true; // default: normal
    whiteList['wrap-flow'] = false; // default: auto
    whiteList['wrap-through'] = false; // default: wrap
    whiteList['writing-mode'] = false; // default: horizontal-tb
    whiteList['z-index'] = false; // default: auto
    return whiteList;
}
/**
 * 匹配到白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */ function $6dc182533680a423$var$onAttr(name, value, options) {
// do nothing
}
/**
 * 匹配到不在白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */ function $6dc182533680a423$var$onIgnoreAttr(name, value, options) {
// do nothing
}
var $6dc182533680a423$var$REGEXP_URL_JAVASCRIPT = /javascript\s*\:/img;
/**
 * 过滤属性值
 *
 * @param {String} name
 * @param {String} value
 * @return {String}
 */ function $6dc182533680a423$var$safeAttrValue(name, value) {
    if ($6dc182533680a423$var$REGEXP_URL_JAVASCRIPT.test(value)) return '';
    return value;
}
$6dc182533680a423$export$81959c441b85a1ce = $6dc182533680a423$var$getDefaultWhiteList();
$6dc182533680a423$export$df33d771471df647 = $6dc182533680a423$var$getDefaultWhiteList;
$6dc182533680a423$export$4f8a1255fd179c1f = $6dc182533680a423$var$onAttr;
$6dc182533680a423$export$6d1d10ce80791ec5 = $6dc182533680a423$var$onIgnoreAttr;
$6dc182533680a423$export$3b380fb6422d8d92 = $6dc182533680a423$var$safeAttrValue;

});

parcelRegister("gy24b", function(module, exports) {
/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */ 
var $9qe8D = parcelRequire("9qe8D");

var $9gFLa = parcelRequire("9gFLa");
parcelRequire("jWyqt");
/**
 * 返回值是否为空
 *
 * @param {Object} obj
 * @return {Boolean}
 */ function $c0c16cb357766122$var$isNull(obj) {
    return obj === undefined || obj === null;
}
/**
 * 浅拷贝对象
 *
 * @param {Object} obj
 * @return {Object}
 */ function $c0c16cb357766122$var$shallowCopyObject(obj) {
    var ret = {};
    for(var i in obj)ret[i] = obj[i];
    return ret;
}
/**
 * 创建CSS过滤器
 *
 * @param {Object} options
 *   - {Object} whiteList
 *   - {Function} onAttr
 *   - {Function} onIgnoreAttr
 *   - {Function} safeAttrValue
 */ function $c0c16cb357766122$var$FilterCSS(options) {
    options = $c0c16cb357766122$var$shallowCopyObject(options || {});
    options.whiteList = options.whiteList || $9qe8D.whiteList;
    options.onAttr = options.onAttr || $9qe8D.onAttr;
    options.onIgnoreAttr = options.onIgnoreAttr || $9qe8D.onIgnoreAttr;
    options.safeAttrValue = options.safeAttrValue || $9qe8D.safeAttrValue;
    this.options = options;
}
$c0c16cb357766122$var$FilterCSS.prototype.process = function(css) {
    // 兼容各种奇葩输入
    css = css || '';
    css = css.toString();
    if (!css) return '';
    var me = this;
    var options = me.options;
    var whiteList = options.whiteList;
    var onAttr = options.onAttr;
    var onIgnoreAttr = options.onIgnoreAttr;
    var safeAttrValue = options.safeAttrValue;
    var retCSS = $9gFLa(css, function(sourcePosition, position, name, value, source) {
        var check = whiteList[name];
        var isWhite = false;
        if (check === true) isWhite = check;
        else if (typeof check === 'function') isWhite = check(value);
        else if (check instanceof RegExp) isWhite = check.test(value);
        if (isWhite !== true) isWhite = false;
        // 如果过滤后 value 为空则直接忽略
        value = safeAttrValue(name, value);
        if (!value) return;
        var opts = {
            position: position,
            sourcePosition: sourcePosition,
            source: source,
            isWhite: isWhite
        };
        if (isWhite) {
            var ret = onAttr(name, value, opts);
            if ($c0c16cb357766122$var$isNull(ret)) return name + ':' + value;
            else return ret;
        } else {
            var ret = onIgnoreAttr(name, value, opts);
            if (!$c0c16cb357766122$var$isNull(ret)) return ret;
        }
    });
    return retCSS;
};
module.exports = $c0c16cb357766122$var$FilterCSS;

});
parcelRegister("9gFLa", function(module, exports) {
/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */ 
var $jWyqt = parcelRequire("jWyqt");
/**
 * 解析style
 *
 * @param {String} css
 * @param {Function} onAttr 处理属性的函数
 *   参数格式： function (sourcePosition, position, name, value, source)
 * @return {String}
 */ function $6bf60047dc8fac8f$var$parseStyle(css, onAttr) {
    css = $jWyqt.trimRight(css);
    if (css[css.length - 1] !== ';') css += ';';
    var cssLength = css.length;
    var isParenthesisOpen = false;
    var lastPos = 0;
    var i = 0;
    var retCSS = '';
    function addNewAttr() {
        // 如果没有正常的闭合圆括号，则直接忽略当前属性
        if (!isParenthesisOpen) {
            var source = $jWyqt.trim(css.slice(lastPos, i));
            var j = source.indexOf(':');
            if (j !== -1) {
                var name = $jWyqt.trim(source.slice(0, j));
                var value = $jWyqt.trim(source.slice(j + 1));
                // 必须有属性名称
                if (name) {
                    var ret = onAttr(lastPos, retCSS.length, name, value, source);
                    if (ret) retCSS += ret + '; ';
                }
            }
        }
        lastPos = i + 1;
    }
    for(; i < cssLength; i++){
        var c = css[i];
        if (c === '/' && css[i + 1] === '*') {
            // 备注开始
            var j = css.indexOf('*/', i + 2);
            // 如果没有正常的备注结束，则后面的部分全部跳过
            if (j === -1) break;
            // 直接将当前位置调到备注结尾，并且初始化状态
            i = j + 1;
            lastPos = i + 1;
            isParenthesisOpen = false;
        } else if (c === '(') isParenthesisOpen = true;
        else if (c === ')') isParenthesisOpen = false;
        else if (c === ';') {
            if (isParenthesisOpen) ;
            else addNewAttr();
        } else if (c === '\n') addNewAttr();
    }
    return $jWyqt.trim(retCSS);
}
module.exports = $6bf60047dc8fac8f$var$parseStyle;

});
parcelRegister("jWyqt", function(module, exports) {
module.exports = {
    indexOf: function(arr, item) {
        var i, j;
        if (Array.prototype.indexOf) return arr.indexOf(item);
        for(i = 0, j = arr.length; i < j; i++){
            if (arr[i] === item) return i;
        }
        return -1;
    },
    forEach: function(arr, fn, scope) {
        var i, j;
        if (Array.prototype.forEach) return arr.forEach(fn, scope);
        for(i = 0, j = arr.length; i < j; i++)fn.call(scope, arr[i], i, arr);
    },
    trim: function(str) {
        if (String.prototype.trim) return str.trim();
        return str.replace(/(^\s*)|(\s*$)/g, '');
    },
    trimRight: function(str) {
        if (String.prototype.trimRight) return str.trimRight();
        return str.replace(/(\s*$)/g, '');
    }
};

});




parcelRegister("9UvL9", function(module, exports) {
module.exports = {
    indexOf: function(arr, item) {
        var i, j;
        if (Array.prototype.indexOf) return arr.indexOf(item);
        for(i = 0, j = arr.length; i < j; i++){
            if (arr[i] === item) return i;
        }
        return -1;
    },
    forEach: function(arr, fn, scope) {
        var i, j;
        if (Array.prototype.forEach) return arr.forEach(fn, scope);
        for(i = 0, j = arr.length; i < j; i++)fn.call(scope, arr[i], i, arr);
    },
    trim: function(str) {
        if (String.prototype.trim) return str.trim();
        return str.replace(/(^\s*)|(\s*$)/g, "");
    },
    spaceIndex: function(str) {
        var reg = /\s|\n|\t/;
        var match = reg.exec(str);
        return match ? match.index : -1;
    }
};

});


parcelRegister("iH2xc", function(module, exports) {

$parcel$export(module.exports, "parseTag", function () { return $d9be356abf2bc7db$export$99bca2eadc127ad2; }, function (v) { return $d9be356abf2bc7db$export$99bca2eadc127ad2 = v; });
$parcel$export(module.exports, "parseAttr", function () { return $d9be356abf2bc7db$export$d543073c23be49b9; }, function (v) { return $d9be356abf2bc7db$export$d543073c23be49b9 = v; });
/**
 * Simple HTML Parser
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */ var $d9be356abf2bc7db$export$99bca2eadc127ad2;
var $d9be356abf2bc7db$export$d543073c23be49b9;

var $9UvL9 = parcelRequire("9UvL9");
/**
 * get tag name
 *
 * @param {String} html e.g. '<a hef="#">'
 * @return {String}
 */ function $d9be356abf2bc7db$var$getTagName(html) {
    var i = $9UvL9.spaceIndex(html);
    var tagName;
    if (i === -1) tagName = html.slice(1, -1);
    else tagName = html.slice(1, i + 1);
    tagName = $9UvL9.trim(tagName).toLowerCase();
    if (tagName.slice(0, 1) === "/") tagName = tagName.slice(1);
    if (tagName.slice(-1) === "/") tagName = tagName.slice(0, -1);
    return tagName;
}
/**
 * is close tag?
 *
 * @param {String} html 如：'<a hef="#">'
 * @return {Boolean}
 */ function $d9be356abf2bc7db$var$isClosing(html) {
    return html.slice(0, 2) === "</";
}
/**
 * parse input html and returns processed html
 *
 * @param {String} html
 * @param {Function} onTag e.g. function (sourcePosition, position, tag, html, isClosing)
 * @param {Function} escapeHtml
 * @return {String}
 */ function $d9be356abf2bc7db$var$parseTag(html, onTag, escapeHtml) {
    "use strict";
    var rethtml = "";
    var lastPos = 0;
    var tagStart = false;
    var quoteStart = false;
    var currentPos = 0;
    var len = html.length;
    var currentTagName = "";
    var currentHtml = "";
    chariterator: for(currentPos = 0; currentPos < len; currentPos++){
        var c = html.charAt(currentPos);
        if (tagStart === false) {
            if (c === "<") {
                tagStart = currentPos;
                continue;
            }
        } else {
            if (quoteStart === false) {
                if (c === "<") {
                    rethtml += escapeHtml(html.slice(lastPos, currentPos));
                    tagStart = currentPos;
                    lastPos = currentPos;
                    continue;
                }
                if (c === ">" || currentPos === len - 1) {
                    rethtml += escapeHtml(html.slice(lastPos, tagStart));
                    currentHtml = html.slice(tagStart, currentPos + 1);
                    currentTagName = $d9be356abf2bc7db$var$getTagName(currentHtml);
                    rethtml += onTag(tagStart, rethtml.length, currentTagName, currentHtml, $d9be356abf2bc7db$var$isClosing(currentHtml));
                    lastPos = currentPos + 1;
                    tagStart = false;
                    continue;
                }
                if (c === '"' || c === "'") {
                    var i = 1;
                    var ic = html.charAt(currentPos - i);
                    while(ic.trim() === "" || ic === "="){
                        if (ic === "=") {
                            quoteStart = c;
                            continue chariterator;
                        }
                        ic = html.charAt(currentPos - ++i);
                    }
                }
            } else if (c === quoteStart) {
                quoteStart = false;
                continue;
            }
        }
    }
    if (lastPos < len) rethtml += escapeHtml(html.substr(lastPos));
    return rethtml;
}
var $d9be356abf2bc7db$var$REGEXP_ILLEGAL_ATTR_NAME = /[^a-zA-Z0-9\\_:.-]/gim;
/**
 * parse input attributes and returns processed attributes
 *
 * @param {String} html e.g. `href="#" target="_blank"`
 * @param {Function} onAttr e.g. `function (name, value)`
 * @return {String}
 */ function $d9be356abf2bc7db$var$parseAttr(html, onAttr) {
    "use strict";
    var lastPos = 0;
    var lastMarkPos = 0;
    var retAttrs = [];
    var tmpName = false;
    var len = html.length;
    function addAttr(name, value) {
        name = $9UvL9.trim(name);
        name = name.replace($d9be356abf2bc7db$var$REGEXP_ILLEGAL_ATTR_NAME, "").toLowerCase();
        if (name.length < 1) return;
        var ret = onAttr(name, value || "");
        if (ret) retAttrs.push(ret);
    }
    // 逐个分析字符
    for(var i = 0; i < len; i++){
        var c = html.charAt(i);
        var v, j;
        if (tmpName === false && c === "=") {
            tmpName = html.slice(lastPos, i);
            lastPos = i + 1;
            lastMarkPos = html.charAt(lastPos) === '"' || html.charAt(lastPos) === "'" ? lastPos : $d9be356abf2bc7db$var$findNextQuotationMark(html, i + 1);
            continue;
        }
        if (tmpName !== false) {
            if (i === lastMarkPos) {
                j = html.indexOf(c, i + 1);
                if (j === -1) break;
                else {
                    v = $9UvL9.trim(html.slice(lastMarkPos + 1, j));
                    addAttr(tmpName, v);
                    tmpName = false;
                    i = j;
                    lastPos = i + 1;
                    continue;
                }
            }
        }
        if (/\s|\n|\t/.test(c)) {
            html = html.replace(/\s|\n|\t/g, " ");
            if (tmpName === false) {
                j = $d9be356abf2bc7db$var$findNextEqual(html, i);
                if (j === -1) {
                    v = $9UvL9.trim(html.slice(lastPos, i));
                    addAttr(v);
                    tmpName = false;
                    lastPos = i + 1;
                    continue;
                } else {
                    i = j - 1;
                    continue;
                }
            } else {
                j = $d9be356abf2bc7db$var$findBeforeEqual(html, i - 1);
                if (j === -1) {
                    v = $9UvL9.trim(html.slice(lastPos, i));
                    v = $d9be356abf2bc7db$var$stripQuoteWrap(v);
                    addAttr(tmpName, v);
                    tmpName = false;
                    lastPos = i + 1;
                    continue;
                } else continue;
            }
        }
    }
    if (lastPos < html.length) {
        if (tmpName === false) addAttr(html.slice(lastPos));
        else addAttr(tmpName, $d9be356abf2bc7db$var$stripQuoteWrap($9UvL9.trim(html.slice(lastPos))));
    }
    return $9UvL9.trim(retAttrs.join(" "));
}
function $d9be356abf2bc7db$var$findNextEqual(str, i) {
    for(; i < str.length; i++){
        var c = str[i];
        if (c === " ") continue;
        if (c === "=") return i;
        return -1;
    }
}
function $d9be356abf2bc7db$var$findNextQuotationMark(str, i) {
    for(; i < str.length; i++){
        var c = str[i];
        if (c === " ") continue;
        if (c === "'" || c === '"') return i;
        return -1;
    }
}
function $d9be356abf2bc7db$var$findBeforeEqual(str, i) {
    for(; i > 0; i--){
        var c = str[i];
        if (c === " ") continue;
        if (c === "=") return i;
        return -1;
    }
}
function $d9be356abf2bc7db$var$isQuoteWrapString(text) {
    if (text[0] === '"' && text[text.length - 1] === '"' || text[0] === "'" && text[text.length - 1] === "'") return true;
    else return false;
}
function $d9be356abf2bc7db$var$stripQuoteWrap(text) {
    if ($d9be356abf2bc7db$var$isQuoteWrapString(text)) return text.substr(1, text.length - 2);
    else return text;
}
$d9be356abf2bc7db$export$99bca2eadc127ad2 = $d9be356abf2bc7db$var$parseTag;
$d9be356abf2bc7db$export$d543073c23be49b9 = $d9be356abf2bc7db$var$parseAttr;

});

parcelRegister("a2Uky", function(module, exports) {
/**
 * filter xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */ 
var $6mFtf = parcelRequire("6mFtf");
var $7505c95651e01118$require$FilterCSS = $6mFtf.FilterCSS;

var $lblM3 = parcelRequire("lblM3");

var $iH2xc = parcelRequire("iH2xc");
var $7505c95651e01118$var$parseTag = $iH2xc.parseTag;
var $7505c95651e01118$var$parseAttr = $iH2xc.parseAttr;

var $9UvL9 = parcelRequire("9UvL9");
/**
 * returns `true` if the input value is `undefined` or `null`
 *
 * @param {Object} obj
 * @return {Boolean}
 */ function $7505c95651e01118$var$isNull(obj) {
    return obj === undefined || obj === null;
}
/**
 * get attributes for a tag
 *
 * @param {String} html
 * @return {Object}
 *   - {String} html
 *   - {Boolean} closing
 */ function $7505c95651e01118$var$getAttrs(html) {
    var i = $9UvL9.spaceIndex(html);
    if (i === -1) return {
        html: "",
        closing: html[html.length - 2] === "/"
    };
    html = $9UvL9.trim(html.slice(i + 1, -1));
    var isClosing = html[html.length - 1] === "/";
    if (isClosing) html = $9UvL9.trim(html.slice(0, -1));
    return {
        html: html,
        closing: isClosing
    };
}
/**
 * shallow copy
 *
 * @param {Object} obj
 * @return {Object}
 */ function $7505c95651e01118$var$shallowCopyObject(obj) {
    var ret = {};
    for(var i in obj)ret[i] = obj[i];
    return ret;
}
function $7505c95651e01118$var$keysToLowerCase(obj) {
    var ret = {};
    for(var i in obj)if (Array.isArray(obj[i])) ret[i.toLowerCase()] = obj[i].map(function(item) {
        return item.toLowerCase();
    });
    else ret[i.toLowerCase()] = obj[i];
    return ret;
}
/**
 * FilterXSS class
 *
 * @param {Object} options
 *        whiteList (or allowList), onTag, onTagAttr, onIgnoreTag,
 *        onIgnoreTagAttr, safeAttrValue, escapeHtml
 *        stripIgnoreTagBody, allowCommentTag, stripBlankChar
 *        css{whiteList, onAttr, onIgnoreAttr} `css=false` means don't use `cssfilter`
 */ function $7505c95651e01118$var$FilterXSS(options) {
    options = $7505c95651e01118$var$shallowCopyObject(options || {});
    if (options.stripIgnoreTag) {
        if (options.onIgnoreTag) console.error('Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time');
        options.onIgnoreTag = $lblM3.onIgnoreTagStripAll;
    }
    if (options.whiteList || options.allowList) options.whiteList = $7505c95651e01118$var$keysToLowerCase(options.whiteList || options.allowList);
    else options.whiteList = $lblM3.whiteList;
    this.attributeWrapSign = options.singleQuotedAttributeValue === true ? "'" : $lblM3.attributeWrapSign;
    options.onTag = options.onTag || $lblM3.onTag;
    options.onTagAttr = options.onTagAttr || $lblM3.onTagAttr;
    options.onIgnoreTag = options.onIgnoreTag || $lblM3.onIgnoreTag;
    options.onIgnoreTagAttr = options.onIgnoreTagAttr || $lblM3.onIgnoreTagAttr;
    options.safeAttrValue = options.safeAttrValue || $lblM3.safeAttrValue;
    options.escapeHtml = options.escapeHtml || $lblM3.escapeHtml;
    this.options = options;
    if (options.css === false) this.cssFilter = false;
    else {
        options.css = options.css || {};
        this.cssFilter = new $7505c95651e01118$require$FilterCSS(options.css);
    }
}
/**
 * start process and returns result
 *
 * @param {String} html
 * @return {String}
 */ $7505c95651e01118$var$FilterXSS.prototype.process = function(html) {
    // compatible with the input
    html = html || "";
    html = html.toString();
    if (!html) return "";
    var me = this;
    var options = me.options;
    var whiteList = options.whiteList;
    var onTag = options.onTag;
    var onIgnoreTag = options.onIgnoreTag;
    var onTagAttr = options.onTagAttr;
    var onIgnoreTagAttr = options.onIgnoreTagAttr;
    var safeAttrValue = options.safeAttrValue;
    var escapeHtml = options.escapeHtml;
    var attributeWrapSign = me.attributeWrapSign;
    var cssFilter = me.cssFilter;
    // remove invisible characters
    if (options.stripBlankChar) html = $lblM3.stripBlankChar(html);
    // remove html comments
    if (!options.allowCommentTag) html = $lblM3.stripCommentTag(html);
    // if enable stripIgnoreTagBody
    var stripIgnoreTagBody = false;
    if (options.stripIgnoreTagBody) {
        stripIgnoreTagBody = $lblM3.StripTagBody(options.stripIgnoreTagBody, onIgnoreTag);
        onIgnoreTag = stripIgnoreTagBody.onIgnoreTag;
    }
    var retHtml = $7505c95651e01118$var$parseTag(html, function(sourcePosition, position, tag, html, isClosing) {
        var info = {
            sourcePosition: sourcePosition,
            position: position,
            isClosing: isClosing,
            isWhite: Object.prototype.hasOwnProperty.call(whiteList, tag)
        };
        // call `onTag()`
        var ret = onTag(tag, html, info);
        if (!$7505c95651e01118$var$isNull(ret)) return ret;
        if (info.isWhite) {
            if (info.isClosing) return "</" + tag + ">";
            var attrs = $7505c95651e01118$var$getAttrs(html);
            var whiteAttrList = whiteList[tag];
            var attrsHtml = $7505c95651e01118$var$parseAttr(attrs.html, function(name, value) {
                // call `onTagAttr()`
                var isWhiteAttr = $9UvL9.indexOf(whiteAttrList, name) !== -1;
                var ret = onTagAttr(tag, name, value, isWhiteAttr);
                if (!$7505c95651e01118$var$isNull(ret)) return ret;
                if (isWhiteAttr) {
                    // call `safeAttrValue()`
                    value = safeAttrValue(tag, name, value, cssFilter);
                    if (value) return name + '=' + attributeWrapSign + value + attributeWrapSign;
                    else return name;
                } else {
                    // call `onIgnoreTagAttr()`
                    ret = onIgnoreTagAttr(tag, name, value, isWhiteAttr);
                    if (!$7505c95651e01118$var$isNull(ret)) return ret;
                    return;
                }
            });
            // build new tag html
            html = "<" + tag;
            if (attrsHtml) html += " " + attrsHtml;
            if (attrs.closing) html += " /";
            html += ">";
            return html;
        } else {
            // call `onIgnoreTag()`
            ret = onIgnoreTag(tag, html, info);
            if (!$7505c95651e01118$var$isNull(ret)) return ret;
            return escapeHtml(html);
        }
    }, escapeHtml);
    // if enable stripIgnoreTagBody
    if (stripIgnoreTagBody) retHtml = stripIgnoreTagBody.remove(retHtml);
    return retHtml;
};
module.exports = $7505c95651e01118$var$FilterXSS;

});


const $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3 = {
    loadingToggle: (btn)=>{
        if (btn) {
            if (!btn.classList.contains("rec-is-loading")) {
                btn.setAttribute("data-default-text", btn.innerHTML);
                btn.innerHTML = `<div class="rec-flex rec-justify-center rec-items-center">
                        <?xml version="1.0" ?><svg class="rec-animate-spin" fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M10 3.5C6.41015 3.5 3.5 6.41015 3.5 10C3.5 10.4142 3.16421 10.75 2.75 10.75C2.33579 10.75 2 10.4142 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C9.58579 18 9.25 17.6642 9.25 17.25C9.25 16.8358 9.58579 16.5 10 16.5C13.5899 16.5 16.5 13.5899 16.5 10C16.5 6.41015 13.5899 3.5 10 3.5Z" fill="#212121"/></svg>
                      </div>`;
            }
            btn.classList.toggle("rec-is-loading");
            btn.classList.add("disabled");
            if (btn instanceof HTMLButtonElement) btn.disabled = true;
        }
    },
    reset: ()=>{
        document.querySelectorAll(".rec-is-loading").forEach((thisLoadingElem)=>{
            if (thisLoadingElem.classList.contains("rec-is-loading")) {
                const defaultText = thisLoadingElem.getAttribute("data-default-text");
                thisLoadingElem.innerHTML = defaultText !== null ? defaultText : "";
            }
            thisLoadingElem.classList.remove("rec-is-loading");
            thisLoadingElem.classList.remove("disabled");
            // Cast thisLoadingElem to HTMLButtonElement or HTMLInputElement
            if (thisLoadingElem instanceof HTMLButtonElement || thisLoadingElem instanceof HTMLInputElement) thisLoadingElem.disabled = false;
        });
    }
};
const $0aaed1fbbefba3fa$export$677c23edf9caf375 = ()=>{
    let check = false;
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent);
    return check;
};
const $0aaed1fbbefba3fa$export$a6cdc56e425d0d0a = (obj)=>{
    return Object.prototype.toString.call(obj) === "[object Object]";
};
const $0aaed1fbbefba3fa$export$6779263a4a120d42 = (toastId)=>{
    const toastELem = document.getElementById(toastId);
    if (toastELem) {
        toastELem.classList.remove("rec-hidden");
        const url = new URL(window.location.href);
        const currentQueryString = new URLSearchParams(window.location.search);
        currentQueryString.delete("t");
        window.history.pushState({}, "", `${url.pathname}?${currentQueryString.toString()}`);
        window.setTimeout(function() {
            toastELem.classList.add("rec-hidden");
        }, 4000);
    } else console.error(`Element with ID ${toastId} not found.`);
};
const $0aaed1fbbefba3fa$export$554f10b70e241fff = (sellerListingForm, qtyOverride)=>{
    // TODO: reverse-eng this form to generate a better type. This was originally written in JS.
    let formData = $0aaed1fbbefba3fa$export$2bccf78e246a5305(sellerListingForm);
    const minQty = qtyOverride >= 0 ? qtyOverride : recAppProxyConfig.settings.slf.seller_images_min;
    // Check/append images
    let listingImageKeys = [];
    sellerListingForm.querySelectorAll(".rec-slf-entry .dz-preview").forEach((thisPreviewElem)=>{
        const imageKey = thisPreviewElem.getAttribute("data-image-key");
        listingImageKeys.push(imageKey);
    });
    if (listingImageKeys.length < minQty && [
        "draft",
        "patch_draft"
    ].indexOf(formData.action_type) < 0) {
        $0aaed1fbbefba3fa$export$6779263a4a120d42("toast-slf-images");
        $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3.reset();
        const imageValidationError = sellerListingForm.querySelector(".rec-slf-listing-error-images");
        if (imageValidationError) imageValidationError.style.display = "block";
        return false;
    }
    return true;
};
const $0aaed1fbbefba3fa$export$f01be45804d2885c = function(form) {
    // Setup our serialized data
    let serialized = {};
    // Loop through each field in the form
    form.querySelectorAll("input, select, checkbox, textarea, button").forEach((element)=>{
        const field = element;
        // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
        if (!field.name || field.disabled || field.type === "file" || field.type === "reset" || field.type === "submit" || field.type === "button") ;
        else {
            // If a multi-select, get all selections
            if (field instanceof HTMLSelectElement) for(var n = 0; n < field.options.length; n++){
                if (!field.options[n].selected) continue;
                serialized[field.name] = field.options[n].value;
            }
            else if (field instanceof HTMLInputElement && field.type !== "checkbox" && field.type !== "radio" || field instanceof HTMLInputElement && field.checked) serialized[field.name] = field.value;
        }
    });
    return serialized;
};
const $0aaed1fbbefba3fa$export$2bccf78e246a5305 = function(form) {
    let obj = {};
    const formData = new FormData(form);
    // @ts-expect-error: You might see an error here on .entries() depending on your TS config. The method does in fact exist: https://developer.mozilla.org/en-US/docs/Web/API/FormData/entries
    for (let pair of formData.entries())if (pair[0] in obj) obj[pair[0]] += "," + pair[1];
    else obj[pair[0]] = pair[1];
    return obj;
};
const $0aaed1fbbefba3fa$export$3441ccf90c75f0cd = (elem)=>{
    let evt = new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window
    });
    let canceled = !elem.dispatchEvent(evt);
};
const $0aaed1fbbefba3fa$export$7272b5ee9aadcdd9 = function(str, appendRandom) {
    let newStr = str.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "");
    return appendRandom ? newStr + "-" + $0aaed1fbbefba3fa$var$randomIntFromInterval(1000, 10000000) : newStr;
};
function $0aaed1fbbefba3fa$var$randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}


var $2ee8315a27b33153$exports = {};
/*!
 * Compressor.js v1.2.1
 * https://fengyuanchen.github.io/compressorjs
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-02-28T14:09:41.732Z
 */ (function(global, factory) {
    $2ee8315a27b33153$exports = factory();
})($2ee8315a27b33153$exports, function() {
    'use strict';
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly && (symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            })), keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    var canvasToBlob = {
        exports: {}
    };
    /*
   * JavaScript Canvas to Blob
   * https://github.com/blueimp/JavaScript-Canvas-to-Blob
   *
   * Copyright 2012, Sebastian Tschan
   * https://blueimp.net
   *
   * Licensed under the MIT license:
   * https://opensource.org/licenses/MIT
   *
   * Based on stackoverflow user Stoive's code snippet:
   * http://stackoverflow.com/q/4998908
   */ (function(module1) {
        if (typeof window === 'undefined') return;
        (function(window1) {
            var CanvasPrototype = window1.HTMLCanvasElement && window1.HTMLCanvasElement.prototype;
            var hasBlobConstructor = window1.Blob && function() {
                try {
                    return Boolean(new Blob());
                } catch (e) {
                    return false;
                }
            }();
            var hasArrayBufferViewSupport = hasBlobConstructor && window1.Uint8Array && function() {
                try {
                    return new Blob([
                        new Uint8Array(100)
                    ]).size === 100;
                } catch (e) {
                    return false;
                }
            }();
            var BlobBuilder = window1.BlobBuilder || window1.WebKitBlobBuilder || window1.MozBlobBuilder || window1.MSBlobBuilder;
            var dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/;
            var dataURLtoBlob = (hasBlobConstructor || BlobBuilder) && window1.atob && window1.ArrayBuffer && window1.Uint8Array && function(dataURI) {
                var matches, mediaType, isBase64, dataString, byteString, arrayBuffer, intArray, i, bb;
                // Parse the dataURI components as per RFC 2397
                matches = dataURI.match(dataURIPattern);
                if (!matches) throw new Error('invalid data URI');
                // Default to text/plain;charset=US-ASCII
                mediaType = matches[2] ? matches[1] : 'text/plain' + (matches[3] || ';charset=US-ASCII');
                isBase64 = !!matches[4];
                dataString = dataURI.slice(matches[0].length);
                if (isBase64) // Convert base64 to raw binary data held in a string:
                byteString = atob(dataString);
                else // Convert base64/URLEncoded data component to raw binary:
                byteString = decodeURIComponent(dataString);
                // Write the bytes of the string to an ArrayBuffer:
                arrayBuffer = new ArrayBuffer(byteString.length);
                intArray = new Uint8Array(arrayBuffer);
                for(i = 0; i < byteString.length; i += 1)intArray[i] = byteString.charCodeAt(i);
                // Write the ArrayBuffer (or ArrayBufferView) to a blob:
                if (hasBlobConstructor) return new Blob([
                    hasArrayBufferViewSupport ? intArray : arrayBuffer
                ], {
                    type: mediaType
                });
                bb = new BlobBuilder();
                bb.append(arrayBuffer);
                return bb.getBlob(mediaType);
            };
            if (window1.HTMLCanvasElement && !CanvasPrototype.toBlob) {
                if (CanvasPrototype.mozGetAsFile) CanvasPrototype.toBlob = function(callback, type, quality) {
                    var self = this;
                    setTimeout(function() {
                        if (quality && CanvasPrototype.toDataURL && dataURLtoBlob) callback(dataURLtoBlob(self.toDataURL(type, quality)));
                        else callback(self.mozGetAsFile('blob', type));
                    });
                };
                else if (CanvasPrototype.toDataURL && dataURLtoBlob) {
                    if (CanvasPrototype.msToBlob) CanvasPrototype.toBlob = function(callback, type, quality) {
                        var self = this;
                        setTimeout(function() {
                            if ((type && type !== 'image/png' || quality) && CanvasPrototype.toDataURL && dataURLtoBlob) callback(dataURLtoBlob(self.toDataURL(type, quality)));
                            else callback(self.msToBlob(type));
                        });
                    };
                    else CanvasPrototype.toBlob = function(callback, type, quality) {
                        var self = this;
                        setTimeout(function() {
                            callback(dataURLtoBlob(self.toDataURL(type, quality)));
                        });
                    };
                }
            }
            if (module1.exports) module1.exports = dataURLtoBlob;
            else window1.dataURLtoBlob = dataURLtoBlob;
        })(window);
    })(canvasToBlob);
    var toBlob = canvasToBlob.exports;
    var isBlob = function isBlob(value) {
        if (typeof Blob === 'undefined') return false;
        return value instanceof Blob || Object.prototype.toString.call(value) === '[object Blob]';
    };
    var DEFAULTS = {
        /**
     * Indicates if output the original image instead of the compressed one
     * when the size of the compressed image is greater than the original one's
     * @type {boolean}
     */ strict: true,
        /**
     * Indicates if read the image's Exif Orientation information,
     * and then rotate or flip the image automatically.
     * @type {boolean}
     */ checkOrientation: true,
        /**
     * Indicates if retain the image's Exif information after compressed.
     * @type {boolean}
    */ retainExif: false,
        /**
     * The max width of the output image.
     * @type {number}
     */ maxWidth: Infinity,
        /**
     * The max height of the output image.
     * @type {number}
     */ maxHeight: Infinity,
        /**
     * The min width of the output image.
     * @type {number}
     */ minWidth: 0,
        /**
     * The min height of the output image.
     * @type {number}
     */ minHeight: 0,
        /**
     * The width of the output image.
     * If not specified, the natural width of the source image will be used.
     * @type {number}
     */ width: undefined,
        /**
     * The height of the output image.
     * If not specified, the natural height of the source image will be used.
     * @type {number}
     */ height: undefined,
        /**
     * Sets how the size of the image should be resized to the container
     * specified by the `width` and `height` options.
     * @type {string}
     */ resize: 'none',
        /**
     * The quality of the output image.
     * It must be a number between `0` and `1`,
     * and only available for `image/jpeg` and `image/webp` images.
     * Check out {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob canvas.toBlob}.
     * @type {number}
     */ quality: 0.8,
        /**
     * The mime type of the output image.
     * By default, the original mime type of the source image file will be used.
     * @type {string}
     */ mimeType: 'auto',
        /**
     * Files whose file type is included in this list,
     * and whose file size exceeds the `convertSize` value will be converted to JPEGs.
     * @type {string｜Array}
     */ convertTypes: [
            'image/png'
        ],
        /**
     * PNG files over this size (5 MB by default) will be converted to JPEGs.
     * To disable this, just set the value to `Infinity`.
     * @type {number}
     */ convertSize: 5000000,
        /**
     * The hook function to execute before draw the image into the canvas for compression.
     * @type {Function}
     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
     * @param {HTMLCanvasElement} canvas - The canvas for compression.
     * @example
     * function (context, canvas) {
     *   context.fillStyle = '#fff';
     * }
     */ beforeDraw: null,
        /**
     * The hook function to execute after drew the image into the canvas for compression.
     * @type {Function}
     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
     * @param {HTMLCanvasElement} canvas - The canvas for compression.
     * @example
     * function (context, canvas) {
     *   context.filter = 'grayscale(100%)';
     * }
     */ drew: null,
        /**
     * The hook function to execute when success to compress the image.
     * @type {Function}
     * @param {File} file - The compressed image File object.
     * @example
     * function (file) {
     *   console.log(file);
     * }
     */ success: null,
        /**
     * The hook function to execute when fail to compress the image.
     * @type {Function}
     * @param {Error} err - An Error object.
     * @example
     * function (err) {
     *   console.log(err.message);
     * }
     */ error: null
    };
    var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    var WINDOW = IS_BROWSER ? window : {};
    /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */ var isPositiveNumber = function isPositiveNumber(value) {
        return value > 0 && value < Infinity;
    };
    var slice = Array.prototype.slice;
    /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */ function toArray(value) {
        return Array.from ? Array.from(value) : slice.call(value);
    }
    var REGEXP_IMAGE_TYPE = /^image\/.+$/;
    /**
   * Check if the given value is a mime type of image.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given is a mime type of image, else `false`.
   */ function isImageType(value) {
        return REGEXP_IMAGE_TYPE.test(value);
    }
    /**
   * Convert image type to extension.
   * @param {string} value - The image type to convert.
   * @returns {boolean} Returns the image extension.
   */ function imageTypeToExtension(value) {
        var extension = isImageType(value) ? value.substr(6) : '';
        if (extension === 'jpeg') extension = 'jpg';
        return ".".concat(extension);
    }
    var fromCharCode = String.fromCharCode;
    /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */ function getStringFromCharCode(dataView, start, length) {
        var str = '';
        var i;
        length += start;
        for(i = start; i < length; i += 1)str += fromCharCode(dataView.getUint8(i));
        return str;
    }
    var btoa = WINDOW.btoa;
    /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */ function arrayBufferToDataURL(arrayBuffer, mimeType) {
        var chunks = [];
        var chunkSize = 8192;
        var uint8 = new Uint8Array(arrayBuffer);
        while(uint8.length > 0){
            // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
            // eslint-disable-next-line prefer-spread
            chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
            uint8 = uint8.subarray(chunkSize);
        }
        return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
    }
    /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */ function resetAndGetOrientation(arrayBuffer) {
        var dataView = new DataView(arrayBuffer);
        var orientation;
        // Ignores range error when the image does not have correct Exif information
        try {
            var littleEndian;
            var app1Start;
            var ifdStart;
            // Only handle JPEG image (start by 0xFFD8)
            if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
                var length = dataView.byteLength;
                var offset = 2;
                while(offset + 1 < length){
                    if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
                        app1Start = offset;
                        break;
                    }
                    offset += 1;
                }
            }
            if (app1Start) {
                var exifIDCode = app1Start + 4;
                var tiffOffset = app1Start + 10;
                if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
                    var endianness = dataView.getUint16(tiffOffset);
                    littleEndian = endianness === 0x4949;
                    if (littleEndian || endianness === 0x4D4D /* bigEndian */ ) {
                        if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                            var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
                            if (firstIFDOffset >= 0x00000008) ifdStart = tiffOffset + firstIFDOffset;
                        }
                    }
                }
            }
            if (ifdStart) {
                var _length = dataView.getUint16(ifdStart, littleEndian);
                var _offset;
                var i;
                for(i = 0; i < _length; i += 1){
                    _offset = ifdStart + i * 12 + 2;
                    if (dataView.getUint16(_offset, littleEndian) === 0x0112 /* Orientation */ ) {
                        // 8 is the offset of the current tag's value
                        _offset += 8;
                        // Get the original orientation value
                        orientation = dataView.getUint16(_offset, littleEndian);
                        // Override the orientation with its default value
                        dataView.setUint16(_offset, 1, littleEndian);
                        break;
                    }
                }
            }
        } catch (e) {
            orientation = 1;
        }
        return orientation;
    }
    /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */ function parseOrientation(orientation) {
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;
        switch(orientation){
            // Flip horizontal
            case 2:
                scaleX = -1;
                break;
            // Rotate left 180°
            case 3:
                rotate = -180;
                break;
            // Flip vertical
            case 4:
                scaleY = -1;
                break;
            // Flip vertical and rotate right 90°
            case 5:
                rotate = 90;
                scaleY = -1;
                break;
            // Rotate right 90°
            case 6:
                rotate = 90;
                break;
            // Flip horizontal and rotate right 90°
            case 7:
                rotate = 90;
                scaleX = -1;
                break;
            // Rotate left 90°
            case 8:
                rotate = -90;
                break;
        }
        return {
            rotate: rotate,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
    /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */ function normalizeDecimalNumber(value) {
        var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
        return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
    }
    /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */ function getAdjustedSizes(_ref) {
        var aspectRatio = _ref.aspectRatio, height = _ref.height, width = _ref.width;
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
        var isValidWidth = isPositiveNumber(width);
        var isValidHeight = isPositiveNumber(height);
        if (isValidWidth && isValidHeight) {
            var adjustedWidth = height * aspectRatio;
            if ((type === 'contain' || type === 'none') && adjustedWidth > width || type === 'cover' && adjustedWidth < width) height = width / aspectRatio;
            else width = height * aspectRatio;
        } else if (isValidWidth) height = width / aspectRatio;
        else if (isValidHeight) width = height * aspectRatio;
        return {
            width: width,
            height: height
        };
    }
    /**
   * Get Exif information from the given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {Array} The read Exif information.
   */ function getExif(arrayBuffer) {
        var array = toArray(new Uint8Array(arrayBuffer));
        var length = array.length;
        var segments = [];
        var start = 0;
        while(start + 3 < length){
            var value = array[start];
            var next = array[start + 1];
            // SOS (Start of Scan)
            if (value === 0xFF && next === 0xDA) break;
            // SOI (Start of Image)
            if (value === 0xFF && next === 0xD8) start += 2;
            else {
                var offset = array[start + 2] * 256 + array[start + 3];
                var end = start + offset + 2;
                var segment = array.slice(start, end);
                segments.push(segment);
                start = end;
            }
        }
        return segments.reduce(function(exifArray, current) {
            if (current[0] === 0xFF && current[1] === 0xE1) return exifArray.concat(current);
            return exifArray;
        }, []);
    }
    /**
   * Insert Exif information into the given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {Array} exifArray - The Exif information to insert.
   * @returns {ArrayBuffer} The transformed array buffer.
   */ function insertExif(arrayBuffer, exifArray) {
        var array = toArray(new Uint8Array(arrayBuffer));
        if (array[2] !== 0xFF || array[3] !== 0xE0) return arrayBuffer;
        var app0Length = array[4] * 256 + array[5];
        var newArrayBuffer = [
            0xFF,
            0xD8
        ].concat(exifArray, array.slice(4 + app0Length));
        return new Uint8Array(newArrayBuffer);
    }
    var ArrayBuffer$1 = WINDOW.ArrayBuffer, FileReader = WINDOW.FileReader;
    var URL = WINDOW.URL || WINDOW.webkitURL;
    var REGEXP_EXTENSION = /\.\w+$/;
    var AnotherCompressor = WINDOW.Compressor;
    /**
   * Creates a new image compressor.
   * @class
   */ var Compressor = /*#__PURE__*/ function() {
        /**
     * The constructor of Compressor.
     * @param {File|Blob} file - The target image file for compressing.
     * @param {Object} [options] - The options for compressing.
     */ function Compressor(file, options) {
            _classCallCheck(this, Compressor);
            this.file = file;
            this.exif = [];
            this.image = new Image();
            this.options = _objectSpread2(_objectSpread2({}, DEFAULTS), options);
            this.aborted = false;
            this.result = null;
            this.init();
        }
        _createClass(Compressor, [
            {
                key: "init",
                value: function init() {
                    var _this = this;
                    var file = this.file, options = this.options;
                    if (!isBlob(file)) {
                        this.fail(new Error('The first argument must be a File or Blob object.'));
                        return;
                    }
                    var mimeType = file.type;
                    if (!isImageType(mimeType)) {
                        this.fail(new Error('The first argument must be an image File or Blob object.'));
                        return;
                    }
                    if (!URL || !FileReader) {
                        this.fail(new Error('The current browser does not support image compression.'));
                        return;
                    }
                    if (!ArrayBuffer$1) {
                        options.checkOrientation = false;
                        options.retainExif = false;
                    }
                    var isJPEGImage = mimeType === 'image/jpeg';
                    var checkOrientation = isJPEGImage && options.checkOrientation;
                    var retainExif = isJPEGImage && options.retainExif;
                    if (URL && !checkOrientation && !retainExif) this.load({
                        url: URL.createObjectURL(file)
                    });
                    else {
                        var reader = new FileReader();
                        this.reader = reader;
                        reader.onload = function(_ref) {
                            var target = _ref.target;
                            var result = target.result;
                            var data = {};
                            var orientation = 1;
                            if (checkOrientation) {
                                // Reset the orientation value to its default value 1
                                // as some iOS browsers will render image with its orientation
                                orientation = resetAndGetOrientation(result);
                                if (orientation > 1) _extends(data, parseOrientation(orientation));
                            }
                            if (retainExif) _this.exif = getExif(result);
                            if (checkOrientation || retainExif) {
                                if (!URL || orientation > 1) data.url = arrayBufferToDataURL(result, mimeType);
                                else data.url = URL.createObjectURL(file);
                            } else data.url = result;
                            _this.load(data);
                        };
                        reader.onabort = function() {
                            _this.fail(new Error('Aborted to read the image with FileReader.'));
                        };
                        reader.onerror = function() {
                            _this.fail(new Error('Failed to read the image with FileReader.'));
                        };
                        reader.onloadend = function() {
                            _this.reader = null;
                        };
                        if (checkOrientation || retainExif) reader.readAsArrayBuffer(file);
                        else reader.readAsDataURL(file);
                    }
                }
            },
            {
                key: "load",
                value: function load(data) {
                    var _this2 = this;
                    var file = this.file, image = this.image;
                    image.onload = function() {
                        _this2.draw(_objectSpread2(_objectSpread2({}, data), {}, {
                            naturalWidth: image.naturalWidth,
                            naturalHeight: image.naturalHeight
                        }));
                    };
                    image.onabort = function() {
                        _this2.fail(new Error('Aborted to load the image.'));
                    };
                    image.onerror = function() {
                        _this2.fail(new Error('Failed to load the image.'));
                    };
                    // Match all browsers that use WebKit as the layout engine in iOS devices,
                    // such as Safari for iOS, Chrome for iOS, and in-app browsers.
                    if (WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent)) // Fix the `The operation is insecure` error (#57)
                    image.crossOrigin = 'anonymous';
                    image.alt = file.name;
                    image.src = data.url;
                }
            },
            {
                key: "draw",
                value: function draw(_ref2) {
                    var _this3 = this;
                    var naturalWidth = _ref2.naturalWidth, naturalHeight = _ref2.naturalHeight, _ref2$rotate = _ref2.rotate, rotate = _ref2$rotate === void 0 ? 0 : _ref2$rotate, _ref2$scaleX = _ref2.scaleX, scaleX = _ref2$scaleX === void 0 ? 1 : _ref2$scaleX, _ref2$scaleY = _ref2.scaleY, scaleY = _ref2$scaleY === void 0 ? 1 : _ref2$scaleY;
                    var file = this.file, image = this.image, options = this.options;
                    var canvas = document.createElement('canvas');
                    var context = canvas.getContext('2d');
                    var is90DegreesRotated = Math.abs(rotate) % 180 === 90;
                    var resizable = (options.resize === 'contain' || options.resize === 'cover') && isPositiveNumber(options.width) && isPositiveNumber(options.height);
                    var maxWidth = Math.max(options.maxWidth, 0) || Infinity;
                    var maxHeight = Math.max(options.maxHeight, 0) || Infinity;
                    var minWidth = Math.max(options.minWidth, 0) || 0;
                    var minHeight = Math.max(options.minHeight, 0) || 0;
                    var aspectRatio = naturalWidth / naturalHeight;
                    var width = options.width, height = options.height;
                    if (is90DegreesRotated) {
                        var _ref3 = [
                            maxHeight,
                            maxWidth
                        ];
                        maxWidth = _ref3[0];
                        maxHeight = _ref3[1];
                        var _ref4 = [
                            minHeight,
                            minWidth
                        ];
                        minWidth = _ref4[0];
                        minHeight = _ref4[1];
                        var _ref5 = [
                            height,
                            width
                        ];
                        width = _ref5[0];
                        height = _ref5[1];
                    }
                    if (resizable) aspectRatio = width / height;
                    var _getAdjustedSizes = getAdjustedSizes({
                        aspectRatio: aspectRatio,
                        width: maxWidth,
                        height: maxHeight
                    }, 'contain');
                    maxWidth = _getAdjustedSizes.width;
                    maxHeight = _getAdjustedSizes.height;
                    var _getAdjustedSizes2 = getAdjustedSizes({
                        aspectRatio: aspectRatio,
                        width: minWidth,
                        height: minHeight
                    }, 'cover');
                    minWidth = _getAdjustedSizes2.width;
                    minHeight = _getAdjustedSizes2.height;
                    if (resizable) {
                        var _getAdjustedSizes3 = getAdjustedSizes({
                            aspectRatio: aspectRatio,
                            width: width,
                            height: height
                        }, options.resize);
                        width = _getAdjustedSizes3.width;
                        height = _getAdjustedSizes3.height;
                    } else {
                        var _getAdjustedSizes4 = getAdjustedSizes({
                            aspectRatio: aspectRatio,
                            width: width,
                            height: height
                        });
                        var _getAdjustedSizes4$wi = _getAdjustedSizes4.width;
                        width = _getAdjustedSizes4$wi === void 0 ? naturalWidth : _getAdjustedSizes4$wi;
                        var _getAdjustedSizes4$he = _getAdjustedSizes4.height;
                        height = _getAdjustedSizes4$he === void 0 ? naturalHeight : _getAdjustedSizes4$he;
                    }
                    width = Math.floor(normalizeDecimalNumber(Math.min(Math.max(width, minWidth), maxWidth)));
                    height = Math.floor(normalizeDecimalNumber(Math.min(Math.max(height, minHeight), maxHeight)));
                    var destX = -width / 2;
                    var destY = -height / 2;
                    var destWidth = width;
                    var destHeight = height;
                    var params = [];
                    if (resizable) {
                        var srcX = 0;
                        var srcY = 0;
                        var srcWidth = naturalWidth;
                        var srcHeight = naturalHeight;
                        var _getAdjustedSizes5 = getAdjustedSizes({
                            aspectRatio: aspectRatio,
                            width: naturalWidth,
                            height: naturalHeight
                        }, {
                            contain: 'cover',
                            cover: 'contain'
                        }[options.resize]);
                        srcWidth = _getAdjustedSizes5.width;
                        srcHeight = _getAdjustedSizes5.height;
                        srcX = (naturalWidth - srcWidth) / 2;
                        srcY = (naturalHeight - srcHeight) / 2;
                        params.push(srcX, srcY, srcWidth, srcHeight);
                    }
                    params.push(destX, destY, destWidth, destHeight);
                    if (is90DegreesRotated) {
                        var _ref6 = [
                            height,
                            width
                        ];
                        width = _ref6[0];
                        height = _ref6[1];
                    }
                    canvas.width = width;
                    canvas.height = height;
                    if (!isImageType(options.mimeType)) options.mimeType = file.type;
                    var fillStyle = 'transparent';
                    // Converts PNG files over the `convertSize` to JPEGs.
                    if (file.size > options.convertSize && options.convertTypes.indexOf(options.mimeType) >= 0) options.mimeType = 'image/jpeg';
                    var isJPEGImage = options.mimeType === 'image/jpeg';
                    if (isJPEGImage) fillStyle = '#fff';
                    // Override the default fill color (#000, black)
                    context.fillStyle = fillStyle;
                    context.fillRect(0, 0, width, height);
                    if (options.beforeDraw) options.beforeDraw.call(this, context, canvas);
                    if (this.aborted) return;
                    context.save();
                    context.translate(width / 2, height / 2);
                    context.rotate(rotate * Math.PI / 180);
                    context.scale(scaleX, scaleY);
                    context.drawImage.apply(context, [
                        image
                    ].concat(params));
                    context.restore();
                    if (options.drew) options.drew.call(this, context, canvas);
                    if (this.aborted) return;
                    var callback = function callback(blob) {
                        if (!_this3.aborted) {
                            var done = function done(result) {
                                return _this3.done({
                                    naturalWidth: naturalWidth,
                                    naturalHeight: naturalHeight,
                                    result: result
                                });
                            };
                            if (blob && isJPEGImage && options.retainExif && _this3.exif && _this3.exif.length > 0) {
                                var next = function next(arrayBuffer) {
                                    return done(toBlob(arrayBufferToDataURL(insertExif(arrayBuffer, _this3.exif), options.mimeType)));
                                };
                                if (blob.arrayBuffer) blob.arrayBuffer().then(next).catch(function() {
                                    _this3.fail(new Error('Failed to read the compressed image with Blob.arrayBuffer().'));
                                });
                                else {
                                    var reader = new FileReader();
                                    _this3.reader = reader;
                                    reader.onload = function(_ref7) {
                                        var target = _ref7.target;
                                        next(target.result);
                                    };
                                    reader.onabort = function() {
                                        _this3.fail(new Error('Aborted to read the compressed image with FileReader.'));
                                    };
                                    reader.onerror = function() {
                                        _this3.fail(new Error('Failed to read the compressed image with FileReader.'));
                                    };
                                    reader.onloadend = function() {
                                        _this3.reader = null;
                                    };
                                    reader.readAsArrayBuffer(blob);
                                }
                            } else done(blob);
                        }
                    };
                    if (canvas.toBlob) canvas.toBlob(callback, options.mimeType, options.quality);
                    else callback(toBlob(canvas.toDataURL(options.mimeType, options.quality)));
                }
            },
            {
                key: "done",
                value: function done(_ref8) {
                    var naturalWidth = _ref8.naturalWidth, naturalHeight = _ref8.naturalHeight, result = _ref8.result;
                    var file = this.file, image = this.image, options = this.options;
                    if (URL && image.src.indexOf('blob:') === 0) URL.revokeObjectURL(image.src);
                    if (result) {
                        // Returns original file if the result is greater than it and without size related options
                        if (options.strict && !options.retainExif && result.size > file.size && options.mimeType === file.type && !(options.width > naturalWidth || options.height > naturalHeight || options.minWidth > naturalWidth || options.minHeight > naturalHeight || options.maxWidth < naturalWidth || options.maxHeight < naturalHeight)) result = file;
                        else {
                            var date = new Date();
                            result.lastModified = date.getTime();
                            result.lastModifiedDate = date;
                            result.name = file.name;
                            // Convert the extension to match its type
                            if (result.name && result.type !== file.type) result.name = result.name.replace(REGEXP_EXTENSION, imageTypeToExtension(result.type));
                        }
                    } else // Returns original file if the result is null in some cases.
                    result = file;
                    this.result = result;
                    if (options.success) options.success.call(this, result);
                }
            },
            {
                key: "fail",
                value: function fail(err) {
                    var options = this.options;
                    if (options.error) options.error.call(this, err);
                    else throw err;
                }
            },
            {
                key: "abort",
                value: function abort() {
                    if (!this.aborted) {
                        this.aborted = true;
                        if (this.reader) this.reader.abort();
                        else if (!this.image.complete) {
                            this.image.onload = null;
                            this.image.onabort();
                        } else this.fail(new Error('The compression process has been aborted.'));
                    }
                }
            }
        ], [
            {
                key: "noConflict",
                value: function noConflict() {
                    window.Compressor = AnotherCompressor;
                    return Compressor;
                }
            },
            {
                key: "setDefaults",
                value: function setDefaults(options) {
                    _extends(DEFAULTS, options);
                }
            }
        ]);
        return Compressor;
    }();
    return Compressor;
});


var $496ab7d22471764e$export$2e2bcd8739ae039 = $496ab7d22471764e$var$extend;
/*
  var obj = {a: 3, b: 5};
  extend(obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 4, b: 5, c: 8}

  var obj = {a: 3, b: 5};
  extend({}, obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 3, b: 5}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3, 4]}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(true, obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3]}

  extend({a: 4, b: 5}); // {a: 4, b: 5}
  extend({a: 4, b: 5}, 3); {a: 4, b: 5}
  extend({a: 4, b: 5}, true); {a: 4, b: 5}
  extend('hello', {a: 4, b: 5}); // throws
  extend(3, {a: 4, b: 5}); // throws
*/ function $496ab7d22471764e$var$extend() {
    var args = [].slice.call(arguments);
    var deep = false;
    if (typeof args[0] == 'boolean') deep = args.shift();
    var result = args[0];
    if ($496ab7d22471764e$var$isUnextendable(result)) throw new Error('extendee must be an object');
    var extenders = args.slice(1);
    var len = extenders.length;
    for(var i = 0; i < len; i++){
        var extender = extenders[i];
        for(var key in extender)if (Object.prototype.hasOwnProperty.call(extender, key)) {
            var value = extender[key];
            if (deep && $496ab7d22471764e$var$isCloneable(value)) {
                var base = Array.isArray(value) ? [] : {};
                result[key] = $496ab7d22471764e$var$extend(true, Object.prototype.hasOwnProperty.call(result, key) && !$496ab7d22471764e$var$isUnextendable(result[key]) ? result[key] : base, value);
            } else result[key] = value;
        }
    }
    return result;
}
function $496ab7d22471764e$var$isCloneable(obj) {
    return Array.isArray(obj) || ({}).toString.call(obj) == '[object Object]';
}
function $496ab7d22471764e$var$isUnextendable(val) {
    return !val || typeof val != 'object' && typeof val != 'function';
}


function $ef07192511817417$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
class $ef07192511817417$var$$4040acfd8584338d$export$2e2bcd8739ae039 {
    // Add an event listener for given event
    on(event, fn) {
        this._callbacks = this._callbacks || {};
        // Create namespace for this event
        if (!this._callbacks[event]) this._callbacks[event] = [];
        this._callbacks[event].push(fn);
        return this;
    }
    emit(event, ...args) {
        this._callbacks = this._callbacks || {};
        let callbacks = this._callbacks[event];
        if (callbacks) for (let callback of callbacks)callback.apply(this, args);
        // trigger a corresponding DOM event
        if (this.element) this.element.dispatchEvent(this.makeEvent("dropzone:" + event, {
            args: args
        }));
        return this;
    }
    makeEvent(eventName, detail) {
        let params = {
            bubbles: true,
            cancelable: true,
            detail: detail
        };
        if (typeof window.CustomEvent === "function") return new CustomEvent(eventName, params);
        else {
            // IE 11 support
            // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
            var evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(eventName, params.bubbles, params.cancelable, params.detail);
            return evt;
        }
    }
    // Remove event listener for given event. If fn is not provided, all event
    // listeners for that event will be removed. If neither is provided, all
    // event listeners will be removed.
    off(event, fn) {
        if (!this._callbacks || arguments.length === 0) {
            this._callbacks = {};
            return this;
        }
        // specific event
        let callbacks = this._callbacks[event];
        if (!callbacks) return this;
        // remove all handlers
        if (arguments.length === 1) {
            delete this._callbacks[event];
            return this;
        }
        // remove specific handler
        for(let i = 0; i < callbacks.length; i++){
            let callback = callbacks[i];
            if (callback === fn) {
                callbacks.splice(i, 1);
                break;
            }
        }
        return this;
    }
}
var $ef07192511817417$var$$fd6031f88dce2e32$exports = {};
$ef07192511817417$var$$fd6031f88dce2e32$exports = "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail=\"\"></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size=\"\"></span></div>\n    <div class=\"dz-filename\"><span data-dz-name=\"\"></span></div>\n  </div>\n  <div class=\"dz-progress\">\n    <span class=\"dz-upload\" data-dz-uploadprogress=\"\"></span>\n  </div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage=\"\"></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54\" height=\"54\" viewBox=\"0 0 54 54\" fill=\"white\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M10.2071 29.7929L14.2929 25.7071C14.6834 25.3166 15.3166 25.3166 15.7071 25.7071L21.2929 31.2929C21.6834 31.6834 22.3166 31.6834 22.7071 31.2929L38.2929 15.7071C38.6834 15.3166 39.3166 15.3166 39.7071 15.7071L43.7929 19.7929C44.1834 20.1834 44.1834 20.8166 43.7929 21.2071L22.7071 42.2929C22.3166 42.6834 21.6834 42.6834 21.2929 42.2929L10.2071 31.2071C9.81658 30.8166 9.81658 30.1834 10.2071 29.7929Z\"></path>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54\" height=\"54\" viewBox=\"0 0 54 54\" fill=\"white\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M26.2929 20.2929L19.2071 13.2071C18.8166 12.8166 18.1834 12.8166 17.7929 13.2071L13.2071 17.7929C12.8166 18.1834 12.8166 18.8166 13.2071 19.2071L20.2929 26.2929C20.6834 26.6834 20.6834 27.3166 20.2929 27.7071L13.2071 34.7929C12.8166 35.1834 12.8166 35.8166 13.2071 36.2071L17.7929 40.7929C18.1834 41.1834 18.8166 41.1834 19.2071 40.7929L26.2929 33.7071C26.6834 33.3166 27.3166 33.3166 27.7071 33.7071L34.7929 40.7929C35.1834 41.1834 35.8166 41.1834 36.2071 40.7929L40.7929 36.2071C41.1834 35.8166 41.1834 35.1834 40.7929 34.7929L33.7071 27.7071C33.3166 27.3166 33.3166 26.6834 33.7071 26.2929L40.7929 19.2071C41.1834 18.8166 41.1834 18.1834 40.7929 17.7929L36.2071 13.2071C35.8166 12.8166 35.1834 12.8166 34.7929 13.2071L27.7071 20.2929C27.3166 20.6834 26.6834 20.6834 26.2929 20.2929Z\"></path>\n    </svg>\n  </div>\n</div>\n";
let $ef07192511817417$var$$4ca367182776f80b$var$defaultOptions = {
    /**
   * Has to be specified on elements other than form (or when the form doesn't
   * have an `action` attribute).
   *
   * You can also provide a function that will be called with `files` and
   * `dataBlocks`  and must return the url as string.
   */ url: null,
    /**
   * Can be changed to `"put"` if necessary. You can also provide a function
   * that will be called with `files` and must return the method (since `v3.12.0`).
   */ method: "post",
    /**
   * Will be set on the XHRequest.
   */ withCredentials: false,
    /**
   * The timeout for the XHR requests in milliseconds (since `v4.4.0`).
   * If set to null or 0, no timeout is going to be set.
   */ timeout: null,
    /**
   * How many file uploads to process in parallel (See the
   * Enqueuing file uploads documentation section for more info)
   */ parallelUploads: 2,
    /**
   * Whether to send multiple files in one request. If
   * this it set to true, then the fallback file input element will
   * have the `multiple` attribute as well. This option will
   * also trigger additional events (like `processingmultiple`). See the events
   * documentation section for more information.
   */ uploadMultiple: false,
    /**
   * Whether you want files to be uploaded in chunks to your server. This can't be
   * used in combination with `uploadMultiple`.
   *
   * See [chunksUploaded](#config-chunksUploaded) for the callback to finalise an upload.
   */ chunking: false,
    /**
   * If `chunking` is enabled, this defines whether **every** file should be chunked,
   * even if the file size is below chunkSize. This means, that the additional chunk
   * form data will be submitted and the `chunksUploaded` callback will be invoked.
   */ forceChunking: false,
    /**
   * If `chunking` is `true`, then this defines the chunk size in bytes.
   */ chunkSize: 2097152,
    /**
   * If `true`, the individual chunks of a file are being uploaded simultaneously.
   */ parallelChunkUploads: false,
    /**
   * Whether a chunk should be retried if it fails.
   */ retryChunks: false,
    /**
   * If `retryChunks` is true, how many times should it be retried.
   */ retryChunksLimit: 3,
    /**
   * The maximum filesize (in MiB) that is allowed to be uploaded.
   */ maxFilesize: 256,
    /**
   * The name of the file param that gets transferred.
   * **NOTE**: If you have the option  `uploadMultiple` set to `true`, then
   * Dropzone will append `[]` to the name.
   */ paramName: "file",
    /**
   * Whether thumbnails for images should be generated
   */ createImageThumbnails: true,
    /**
   * In MB. When the filename exceeds this limit, the thumbnail will not be generated.
   */ maxThumbnailFilesize: 10,
    /**
   * If `null`, the ratio of the image will be used to calculate it.
   */ thumbnailWidth: 120,
    /**
   * The same as `thumbnailWidth`. If both are null, images will not be resized.
   */ thumbnailHeight: 120,
    /**
   * How the images should be scaled down in case both, `thumbnailWidth` and `thumbnailHeight` are provided.
   * Can be either `contain` or `crop`.
   */ thumbnailMethod: "crop",
    /**
   * If set, images will be resized to these dimensions before being **uploaded**.
   * If only one, `resizeWidth` **or** `resizeHeight` is provided, the original aspect
   * ratio of the file will be preserved.
   *
   * The `options.transformFile` function uses these options, so if the `transformFile` function
   * is overridden, these options don't do anything.
   */ resizeWidth: null,
    /**
   * See `resizeWidth`.
   */ resizeHeight: null,
    /**
   * The mime type of the resized image (before it gets uploaded to the server).
   * If `null` the original mime type will be used. To force jpeg, for example, use `image/jpeg`.
   * See `resizeWidth` for more information.
   */ resizeMimeType: null,
    /**
   * The quality of the resized images. See `resizeWidth`.
   */ resizeQuality: 0.8,
    /**
   * How the images should be scaled down in case both, `resizeWidth` and `resizeHeight` are provided.
   * Can be either `contain` or `crop`.
   */ resizeMethod: "contain",
    /**
   * The base that is used to calculate the **displayed** filesize. You can
   * change this to 1024 if you would rather display kibibytes, mebibytes,
   * etc... 1024 is technically incorrect, because `1024 bytes` are `1 kibibyte`
   * not `1 kilobyte`. You can change this to `1024` if you don't care about
   * validity.
   */ filesizeBase: 1000,
    /**
   * If not `null` defines how many files this Dropzone handles. If it exceeds,
   * the event `maxfilesexceeded` will be called. The dropzone element gets the
   * class `dz-max-files-reached` accordingly so you can provide visual
   * feedback.
   */ maxFiles: null,
    /**
   * An optional object to send additional headers to the server. Eg:
   * `{ "My-Awesome-Header": "header value" }`
   */ headers: null,
    /**
   * Should the default headers be set or not?
   * Accept: application/json <- for requesting json response
   * Cache-Control: no-cache <- Request shouldnt be cached
   * X-Requested-With: XMLHttpRequest <- We sent the request via XMLHttpRequest
   */ defaultHeaders: true,
    /**
   * If `true`, the dropzone element itself will be clickable, if `false`
   * nothing will be clickable.
   *
   * You can also pass an HTML element, a CSS selector (for multiple elements)
   * or an array of those. In that case, all of those elements will trigger an
   * upload when clicked.
   */ clickable: true,
    /**
   * Whether hidden files in directories should be ignored.
   */ ignoreHiddenFiles: true,
    /**
   * The default implementation of `accept` checks the file's mime type or
   * extension against this list. This is a comma separated list of mime
   * types or file extensions.
   *
   * Eg.: `image/*,application/pdf,.psd`
   *
   * If the Dropzone is `clickable` this option will also be used as
   * [`accept`](https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept)
   * parameter on the hidden file input as well.
   */ acceptedFiles: null,
    /**
   * **Deprecated!**
   * Use acceptedFiles instead.
   */ acceptedMimeTypes: null,
    /**
   * If false, files will be added to the queue but the queue will not be
   * processed automatically.
   * This can be useful if you need some additional user input before sending
   * files (or if you want want all files sent at once).
   * If you're ready to send the file simply call `myDropzone.processQueue()`.
   *
   * See the [enqueuing file uploads](#enqueuing-file-uploads) documentation
   * section for more information.
   */ autoProcessQueue: true,
    /**
   * If false, files added to the dropzone will not be queued by default.
   * You'll have to call `enqueueFile(file)` manually.
   */ autoQueue: true,
    /**
   * If `true`, this will add a link to every file preview to remove or cancel (if
   * already uploading) the file. The `dictCancelUpload`, `dictCancelUploadConfirmation`
   * and `dictRemoveFile` options are used for the wording.
   */ addRemoveLinks: false,
    /**
   * Defines where to display the file previews – if `null` the
   * Dropzone element itself is used. Can be a plain `HTMLElement` or a CSS
   * selector. The element should have the `dropzone-previews` class so
   * the previews are displayed properly.
   */ previewsContainer: null,
    /**
   * Set this to `true` if you don't want previews to be shown.
   */ disablePreviews: false,
    /**
   * This is the element the hidden input field (which is used when clicking on the
   * dropzone to trigger file selection) will be appended to. This might
   * be important in case you use frameworks to switch the content of your page.
   *
   * Can be a selector string, or an element directly.
   */ hiddenInputContainer: "body",
    /**
   * If null, no capture type will be specified
   * If camera, mobile devices will skip the file selection and choose camera
   * If microphone, mobile devices will skip the file selection and choose the microphone
   * If camcorder, mobile devices will skip the file selection and choose the camera in video mode
   * On apple devices multiple must be set to false.  AcceptedFiles may need to
   * be set to an appropriate mime type (e.g. "image/*", "audio/*", or "video/*").
   */ capture: null,
    /**
   * **Deprecated**. Use `renameFile` instead.
   */ renameFilename: null,
    /**
   * A function that is invoked before the file is uploaded to the server and renames the file.
   * This function gets the `File` as argument and can use the `file.name`. The actual name of the
   * file that gets used during the upload can be accessed through `file.upload.filename`.
   */ renameFile: null,
    /**
   * If `true` the fallback will be forced. This is very useful to test your server
   * implementations first and make sure that everything works as
   * expected without dropzone if you experience problems, and to test
   * how your fallbacks will look.
   */ forceFallback: false,
    /**
   * The text used before any files are dropped.
   */ dictDefaultMessage: "Drop files here to upload",
    /**
   * The text that replaces the default message text it the browser is not supported.
   */ dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
    /**
   * The text that will be added before the fallback form.
   * If you provide a  fallback element yourself, or if this option is `null` this will
   * be ignored.
   */ dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
    /**
   * If the filesize is too big.
   * `{{filesize}}` and `{{maxFilesize}}` will be replaced with the respective configuration values.
   */ dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
    /**
   * If the file doesn't match the file type.
   */ dictInvalidFileType: "You can't upload files of this type.",
    /**
   * If the server response was invalid.
   * `{{statusCode}}` will be replaced with the servers status code.
   */ dictResponseError: "Server responded with {{statusCode}} code.",
    /**
   * If `addRemoveLinks` is true, the text to be used for the cancel upload link.
   */ dictCancelUpload: "Cancel upload",
    /**
   * The text that is displayed if an upload was manually canceled
   */ dictUploadCanceled: "Upload canceled.",
    /**
   * If `addRemoveLinks` is true, the text to be used for confirmation when cancelling upload.
   */ dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
    /**
   * If `addRemoveLinks` is true, the text to be used to remove a file.
   */ dictRemoveFile: "Remove file",
    /**
   * If this is not null, then the user will be prompted before removing a file.
   */ dictRemoveFileConfirmation: null,
    /**
   * Displayed if `maxFiles` is st and exceeded.
   * The string `{{maxFiles}}` will be replaced by the configuration value.
   */ dictMaxFilesExceeded: "You can not upload any more files.",
    /**
   * Allows you to translate the different units. Starting with `tb` for terabytes and going down to
   * `b` for bytes.
   */ dictFileSizeUnits: {
        tb: "TB",
        gb: "GB",
        mb: "MB",
        kb: "KB",
        b: "b"
    },
    /**
   * Called when dropzone initialized
   * You can add event listeners here
   */ init () {},
    /**
   * Can be an **object** of additional parameters to transfer to the server, **or** a `Function`
   * that gets invoked with the `files`, `xhr` and, if it's a chunked upload, `chunk` arguments. In case
   * of a function, this needs to return a map.
   *
   * The default implementation does nothing for normal uploads, but adds relevant information for
   * chunked uploads.
   *
   * This is the same as adding hidden input fields in the form element.
   */ params (files, xhr, chunk) {
        if (chunk) return {
            dzuuid: chunk.file.upload.uuid,
            dzchunkindex: chunk.index,
            dztotalfilesize: chunk.file.size,
            dzchunksize: this.options.chunkSize,
            dztotalchunkcount: chunk.file.upload.totalChunkCount,
            dzchunkbyteoffset: chunk.index * this.options.chunkSize
        };
    },
    /**
   * A function that gets a [file](https://developer.mozilla.org/en-US/docs/DOM/File)
   * and a `done` function as parameters.
   *
   * If the done function is invoked without arguments, the file is "accepted" and will
   * be processed. If you pass an error message, the file is rejected, and the error
   * message will be displayed.
   * This function will not be called if the file is too big or doesn't match the mime types.
   */ accept (file, done) {
        return done();
    },
    /**
   * The callback that will be invoked when all chunks have been uploaded for a file.
   * It gets the file for which the chunks have been uploaded as the first parameter,
   * and the `done` function as second. `done()` needs to be invoked when everything
   * needed to finish the upload process is done.
   */ chunksUploaded: function(file, done) {
        done();
    },
    /**
   * Sends the file as binary blob in body instead of form data.
   * If this is set, the `params` option will be ignored.
   * It's an error to set this to `true` along with `uploadMultiple` since
   * multiple files cannot be in a single binary body.
   */ binaryBody: false,
    /**
   * Gets called when the browser is not supported.
   * The default implementation shows the fallback input field and adds
   * a text.
   */ fallback () {
        // This code should pass in IE7... :(
        let messageElement;
        this.element.className = `${this.element.className} dz-browser-not-supported`;
        for (let child of this.element.getElementsByTagName("div"))if (/(^| )dz-message($| )/.test(child.className)) {
            messageElement = child;
            child.className = "dz-message"; // Removes the 'dz-default' class
            break;
        }
        if (!messageElement) {
            messageElement = $ef07192511817417$export$2e2bcd8739ae039.createElement('<div class="dz-message"><span></span></div>');
            this.element.appendChild(messageElement);
        }
        let span = messageElement.getElementsByTagName("span")[0];
        if (span) {
            if (span.textContent != null) span.textContent = this.options.dictFallbackMessage;
            else if (span.innerText != null) span.innerText = this.options.dictFallbackMessage;
        }
        return this.element.appendChild(this.getFallbackForm());
    },
    /**
   * Gets called to calculate the thumbnail dimensions.
   *
   * It gets `file`, `width` and `height` (both may be `null`) as parameters and must return an object containing:
   *
   *  - `srcWidth` & `srcHeight` (required)
   *  - `trgWidth` & `trgHeight` (required)
   *  - `srcX` & `srcY` (optional, default `0`)
   *  - `trgX` & `trgY` (optional, default `0`)
   *
   * Those values are going to be used by `ctx.drawImage()`.
   */ resize (file, width, height, resizeMethod) {
        let info = {
            srcX: 0,
            srcY: 0,
            srcWidth: file.width,
            srcHeight: file.height
        };
        let srcRatio = file.width / file.height;
        // Automatically calculate dimensions if not specified
        if (width == null && height == null) {
            width = info.srcWidth;
            height = info.srcHeight;
        } else if (width == null) width = height * srcRatio;
        else if (height == null) height = width / srcRatio;
        // Make sure images aren't upscaled
        width = Math.min(width, info.srcWidth);
        height = Math.min(height, info.srcHeight);
        let trgRatio = width / height;
        if (info.srcWidth > width || info.srcHeight > height) {
            // Image is bigger and needs rescaling
            if (resizeMethod === "crop") {
                if (srcRatio > trgRatio) {
                    info.srcHeight = file.height;
                    info.srcWidth = info.srcHeight * trgRatio;
                } else {
                    info.srcWidth = file.width;
                    info.srcHeight = info.srcWidth / trgRatio;
                }
            } else if (resizeMethod === "contain") {
                // Method 'contain'
                if (srcRatio > trgRatio) height = width / srcRatio;
                else width = height * srcRatio;
            } else throw new Error(`Unknown resizeMethod '${resizeMethod}'`);
        }
        info.srcX = (file.width - info.srcWidth) / 2;
        info.srcY = (file.height - info.srcHeight) / 2;
        info.trgWidth = width;
        info.trgHeight = height;
        return info;
    },
    /**
   * Can be used to transform the file (for example, resize an image if necessary).
   *
   * The default implementation uses `resizeWidth` and `resizeHeight` (if provided) and resizes
   * images according to those dimensions.
   *
   * Gets the `file` as the first parameter, and a `done()` function as the second, that needs
   * to be invoked with the file when the transformation is done.
   */ transformFile (file, done) {
        if ((this.options.resizeWidth || this.options.resizeHeight) && file.type.match(/image.*/)) return this.resizeImage(file, this.options.resizeWidth, this.options.resizeHeight, this.options.resizeMethod, done);
        else return done(file);
    },
    /**
   * A string that contains the template used for each dropped
   * file. Change it to fulfill your needs but make sure to properly
   * provide all elements.
   *
   * If you want to use an actual HTML element instead of providing a String
   * as a config option, you could create a div with the id `tpl`,
   * put the template inside it and provide the element like this:
   *
   *     document
   *       .querySelector('#tpl')
   *       .innerHTML
   *
   */ previewTemplate: /*@__PURE__*/ $ef07192511817417$var$$parcel$interopDefault($ef07192511817417$var$$fd6031f88dce2e32$exports),
    /*
   Those functions register themselves to the events on init and handle all
   the user interface specific stuff. Overwriting them won't break the upload
   but can break the way it's displayed.
   You can overwrite them if you don't like the default behavior. If you just
   want to add an additional event handler, register it on the dropzone object
   and don't overwrite those options.
   */ // Those are self explanatory and simply concern the DragnDrop.
    drop (e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    dragstart (e) {},
    dragend (e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    dragenter (e) {
        return this.element.classList.add("dz-drag-hover");
    },
    dragover (e) {
        return this.element.classList.add("dz-drag-hover");
    },
    dragleave (e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    paste (e) {},
    // Called whenever there are no files left in the dropzone anymore, and the
    // dropzone should be displayed as if in the initial state.
    reset () {
        return this.element.classList.remove("dz-started");
    },
    // Called when a file is added to the queue
    // Receives `file`
    addedfile (file) {
        if (this.element === this.previewsContainer) this.element.classList.add("dz-started");
        if (this.previewsContainer && !this.options.disablePreviews) {
            file.previewElement = $ef07192511817417$export$2e2bcd8739ae039.createElement(this.options.previewTemplate.trim());
            file.previewTemplate = file.previewElement; // Backwards compatibility
            this.previewsContainer.appendChild(file.previewElement);
            for (var node of file.previewElement.querySelectorAll("[data-dz-name]"))node.textContent = file.name;
            for (node of file.previewElement.querySelectorAll("[data-dz-size]"))node.innerHTML = this.filesize(file.size);
            if (this.options.addRemoveLinks) {
                file._removeLink = $ef07192511817417$export$2e2bcd8739ae039.createElement(`<a class="dz-remove" href="javascript:undefined;" data-dz-remove>${this.options.dictRemoveFile}</a>`);
                file.previewElement.appendChild(file._removeLink);
            }
            let removeFileEvent = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                if (file.status === $ef07192511817417$export$2e2bcd8739ae039.UPLOADING) return $ef07192511817417$export$2e2bcd8739ae039.confirm(this.options.dictCancelUploadConfirmation, ()=>this.removeFile(file));
                else {
                    if (this.options.dictRemoveFileConfirmation) return $ef07192511817417$export$2e2bcd8739ae039.confirm(this.options.dictRemoveFileConfirmation, ()=>this.removeFile(file));
                    else return this.removeFile(file);
                }
            };
            for (let removeLink of file.previewElement.querySelectorAll("[data-dz-remove]"))removeLink.addEventListener("click", removeFileEvent);
        }
    },
    // Called whenever a file is removed.
    removedfile (file) {
        if (file.previewElement != null && file.previewElement.parentNode != null) file.previewElement.parentNode.removeChild(file.previewElement);
        return this._updateMaxFilesReachedClass();
    },
    // Called when a thumbnail has been generated
    // Receives `file` and `dataUrl`
    thumbnail (file, dataUrl) {
        if (file.previewElement) {
            file.previewElement.classList.remove("dz-file-preview");
            for (let thumbnailElement of file.previewElement.querySelectorAll("[data-dz-thumbnail]")){
                thumbnailElement.alt = file.name;
                thumbnailElement.src = dataUrl;
            }
            return setTimeout(()=>file.previewElement.classList.add("dz-image-preview"), 1);
        }
    },
    // Called whenever an error occurs
    // Receives `file` and `message`
    error (file, message) {
        if (file.previewElement) {
            file.previewElement.classList.add("dz-error");
            if (typeof message !== "string" && message.error) message = message.error;
            for (let node of file.previewElement.querySelectorAll("[data-dz-errormessage]"))node.textContent = message;
        }
    },
    errormultiple () {},
    // Called when a file gets processed. Since there is a cue, not all added
    // files are processed immediately.
    // Receives `file`
    processing (file) {
        if (file.previewElement) {
            file.previewElement.classList.add("dz-processing");
            if (file._removeLink) return file._removeLink.innerHTML = this.options.dictCancelUpload;
        }
    },
    processingmultiple () {},
    // Called whenever the upload progress gets updated.
    // Receives `file`, `progress` (percentage 0-100) and `bytesSent`.
    // To get the total number of bytes of the file, use `file.size`
    uploadprogress (file, progress, bytesSent) {
        if (file.previewElement) for (let node of file.previewElement.querySelectorAll("[data-dz-uploadprogress]"))node.nodeName === "PROGRESS" ? node.value = progress : node.style.width = `${progress}%`;
    },
    // Called whenever the total upload progress gets updated.
    // Called with totalUploadProgress (0-100), totalBytes and totalBytesSent
    totaluploadprogress () {},
    // Called just before the file is sent. Gets the `xhr` object as second
    // parameter, so you can modify it (for example to add a CSRF token) and a
    // `formData` object to add additional information.
    sending () {},
    sendingmultiple () {},
    // When the complete upload is finished and successful
    // Receives `file`
    success (file) {
        if (file.previewElement) return file.previewElement.classList.add("dz-success");
    },
    successmultiple () {},
    // When the upload is canceled.
    canceled (file) {
        return this.emit("error", file, this.options.dictUploadCanceled);
    },
    canceledmultiple () {},
    // When the upload is finished, either with success or an error.
    // Receives `file`
    complete (file) {
        if (file._removeLink) file._removeLink.innerHTML = this.options.dictRemoveFile;
        if (file.previewElement) return file.previewElement.classList.add("dz-complete");
    },
    completemultiple () {},
    maxfilesexceeded () {},
    maxfilesreached () {},
    queuecomplete () {},
    addedfiles () {}
};
var $ef07192511817417$var$$4ca367182776f80b$export$2e2bcd8739ae039 = $ef07192511817417$var$$4ca367182776f80b$var$defaultOptions;
class $ef07192511817417$export$2e2bcd8739ae039 extends $ef07192511817417$var$$4040acfd8584338d$export$2e2bcd8739ae039 {
    static initClass() {
        // Exposing the emitter class, mainly for tests
        this.prototype.Emitter = $ef07192511817417$var$$4040acfd8584338d$export$2e2bcd8739ae039;
        /*
     This is a list of all available events you can register on a dropzone object.

     You can register an event handler like this:

     dropzone.on("dragEnter", function() { });

     */ this.prototype.events = [
            "drop",
            "dragstart",
            "dragend",
            "dragenter",
            "dragover",
            "dragleave",
            "addedfile",
            "addedfiles",
            "removedfile",
            "thumbnail",
            "error",
            "errormultiple",
            "processing",
            "processingmultiple",
            "uploadprogress",
            "totaluploadprogress",
            "sending",
            "sendingmultiple",
            "success",
            "successmultiple",
            "canceled",
            "canceledmultiple",
            "complete",
            "completemultiple",
            "reset",
            "maxfilesexceeded",
            "maxfilesreached",
            "queuecomplete"
        ];
        this.prototype._thumbnailQueue = [];
        this.prototype._processingThumbnail = false;
    }
    // Returns all files that have been accepted
    getAcceptedFiles() {
        return this.files.filter((file)=>file.accepted).map((file)=>file);
    }
    // Returns all files that have been rejected
    // Not sure when that's going to be useful, but added for completeness.
    getRejectedFiles() {
        return this.files.filter((file)=>!file.accepted).map((file)=>file);
    }
    getFilesWithStatus(status) {
        return this.files.filter((file)=>file.status === status).map((file)=>file);
    }
    // Returns all files that are in the queue
    getQueuedFiles() {
        return this.getFilesWithStatus($ef07192511817417$export$2e2bcd8739ae039.QUEUED);
    }
    getUploadingFiles() {
        return this.getFilesWithStatus($ef07192511817417$export$2e2bcd8739ae039.UPLOADING);
    }
    getAddedFiles() {
        return this.getFilesWithStatus($ef07192511817417$export$2e2bcd8739ae039.ADDED);
    }
    // Files that are either queued or uploading
    getActiveFiles() {
        return this.files.filter((file)=>file.status === $ef07192511817417$export$2e2bcd8739ae039.UPLOADING || file.status === $ef07192511817417$export$2e2bcd8739ae039.QUEUED).map((file)=>file);
    }
    // The function that gets called when Dropzone is initialized. You
    // can (and should) setup event listeners inside this function.
    init() {
        // In case it isn't set already
        if (this.element.tagName === "form") this.element.setAttribute("enctype", "multipart/form-data");
        if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) this.element.appendChild($ef07192511817417$export$2e2bcd8739ae039.createElement(`<div class="dz-default dz-message"><button class="dz-button" type="button">${this.options.dictDefaultMessage}</button></div>`));
        if (this.clickableElements.length) {
            let setupHiddenFileInput = ()=>{
                if (this.hiddenFileInput) this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
                this.hiddenFileInput = document.createElement("input");
                this.hiddenFileInput.setAttribute("type", "file");
                if (this.options.maxFiles === null || this.options.maxFiles > 1) this.hiddenFileInput.setAttribute("multiple", "multiple");
                this.hiddenFileInput.className = "dz-hidden-input";
                if (this.options.acceptedFiles !== null) this.hiddenFileInput.setAttribute("accept", this.options.acceptedFiles);
                if (this.options.capture !== null) this.hiddenFileInput.setAttribute("capture", this.options.capture);
                // Making sure that no one can "tab" into this field.
                this.hiddenFileInput.setAttribute("tabindex", "-1");
                // Not setting `display="none"` because some browsers don't accept clicks
                // on elements that aren't displayed.
                this.hiddenFileInput.style.visibility = "hidden";
                this.hiddenFileInput.style.position = "absolute";
                this.hiddenFileInput.style.top = "0";
                this.hiddenFileInput.style.left = "0";
                this.hiddenFileInput.style.height = "0";
                this.hiddenFileInput.style.width = "0";
                $ef07192511817417$export$2e2bcd8739ae039.getElement(this.options.hiddenInputContainer, "hiddenInputContainer").appendChild(this.hiddenFileInput);
                this.hiddenFileInput.addEventListener("change", ()=>{
                    let { files: files } = this.hiddenFileInput;
                    if (files.length) for (let file of files)this.addFile(file);
                    this.emit("addedfiles", files);
                    setupHiddenFileInput();
                });
            };
            setupHiddenFileInput();
        }
        this.URL = window.URL !== null ? window.URL : window.webkitURL;
        // Setup all event listeners on the Dropzone object itself.
        // They're not in @setupEventListeners() because they shouldn't be removed
        // again when the dropzone gets disabled.
        for (let eventName of this.events)this.on(eventName, this.options[eventName]);
        this.on("uploadprogress", ()=>this.updateTotalUploadProgress());
        this.on("removedfile", ()=>this.updateTotalUploadProgress());
        this.on("canceled", (file)=>this.emit("complete", file));
        // Emit a `queuecomplete` event if all files finished uploading.
        this.on("complete", (file)=>{
            if (this.getAddedFiles().length === 0 && this.getUploadingFiles().length === 0 && this.getQueuedFiles().length === 0) return setTimeout(()=>this.emit("queuecomplete"), 0);
        });
        const containsFiles = function(e) {
            if (e.dataTransfer.types) // IE, we need to iterate like this instead of
            // using e.dataTransfer.types.some()
            for(var i = 0; i < e.dataTransfer.types.length; i++){
                if (e.dataTransfer.types[i] === "Files") return true;
            }
            return false;
        };
        let noPropagation = function(e) {
            // If there are no files, we don't want to stop
            // propagation so we don't interfere with other
            // drag and drop behaviour.
            if (!containsFiles(e)) return;
            e.stopPropagation();
            if (e.preventDefault) return e.preventDefault();
            else return e.returnValue = false;
        };
        // Create the listeners
        this.listeners = [
            {
                element: this.element,
                events: {
                    dragstart: (e)=>{
                        return this.emit("dragstart", e);
                    },
                    dragenter: (e)=>{
                        noPropagation(e);
                        return this.emit("dragenter", e);
                    },
                    dragover: (e)=>{
                        // Makes it possible to drag files from chrome's download bar
                        // http://stackoverflow.com/questions/19526430/drag-and-drop-file-uploads-from-chrome-downloads-bar
                        // Try is required to prevent bug in Internet Explorer 11 (SCRIPT65535 exception)
                        let efct;
                        try {
                            efct = e.dataTransfer.effectAllowed;
                        } catch (error) {}
                        e.dataTransfer.dropEffect = "move" === efct || "linkMove" === efct ? "move" : "copy";
                        noPropagation(e);
                        return this.emit("dragover", e);
                    },
                    dragleave: (e)=>{
                        return this.emit("dragleave", e);
                    },
                    drop: (e)=>{
                        noPropagation(e);
                        return this.drop(e);
                    },
                    dragend: (e)=>{
                        return this.emit("dragend", e);
                    }
                }
            }
        ];
        this.clickableElements.forEach((clickableElement)=>{
            return this.listeners.push({
                element: clickableElement,
                events: {
                    click: (evt)=>{
                        // Only the actual dropzone or the message element should trigger file selection
                        if (clickableElement !== this.element || evt.target === this.element || $ef07192511817417$export$2e2bcd8739ae039.elementInside(evt.target, this.element.querySelector(".dz-message"))) this.hiddenFileInput.click(); // Forward the click
                        return true;
                    }
                }
            });
        });
        this.enable();
        return this.options.init.call(this);
    }
    // Not fully tested yet
    destroy() {
        this.disable();
        this.removeAllFiles(true);
        if (this.hiddenFileInput != null ? this.hiddenFileInput.parentNode : undefined) {
            this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
            this.hiddenFileInput = null;
        }
        delete this.element.dropzone;
        return $ef07192511817417$export$2e2bcd8739ae039.instances.splice($ef07192511817417$export$2e2bcd8739ae039.instances.indexOf(this), 1);
    }
    updateTotalUploadProgress() {
        let totalUploadProgress;
        let totalBytesSent = 0;
        let totalBytes = 0;
        let activeFiles = this.getActiveFiles();
        if (activeFiles.length) {
            for (let file of this.getActiveFiles()){
                totalBytesSent += file.upload.bytesSent;
                totalBytes += file.upload.total;
            }
            totalUploadProgress = 100 * totalBytesSent / totalBytes;
        } else totalUploadProgress = 100;
        return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    }
    // @options.paramName can be a function taking one parameter rather than a string.
    // A parameter name for a file is obtained simply by calling this with an index number.
    _getParamName(n) {
        if (typeof this.options.paramName === "function") return this.options.paramName(n);
        else return `${this.options.paramName}${this.options.uploadMultiple ? `[${n}]` : ""}`;
    }
    // If @options.renameFile is a function,
    // the function will be used to rename the file.name before appending it to the formData
    _renameFile(file) {
        if (typeof this.options.renameFile !== "function") return file.name;
        return this.options.renameFile(file);
    }
    // Returns a form that can be used as fallback if the browser does not support DragnDrop
    //
    // If the dropzone is already a form, only the input field and button are returned. Otherwise a complete form element is provided.
    // This code has to pass in IE7 :(
    getFallbackForm() {
        let existingFallback, form;
        if (existingFallback = this.getExistingFallback()) return existingFallback;
        let fieldsString = '<div class="dz-fallback">';
        if (this.options.dictFallbackText) fieldsString += `<p>${this.options.dictFallbackText}</p>`;
        fieldsString += `<input type="file" name="${this._getParamName(0)}" ${this.options.uploadMultiple ? 'multiple="multiple"' : undefined} /><input type="submit" value="Upload!"></div>`;
        let fields = $ef07192511817417$export$2e2bcd8739ae039.createElement(fieldsString);
        if (this.element.tagName !== "FORM") {
            form = $ef07192511817417$export$2e2bcd8739ae039.createElement(`<form action="${this.options.url}" enctype="multipart/form-data" method="${this.options.method}"></form>`);
            form.appendChild(fields);
        } else {
            // Make sure that the enctype and method attributes are set properly
            this.element.setAttribute("enctype", "multipart/form-data");
            this.element.setAttribute("method", this.options.method);
        }
        return form != null ? form : fields;
    }
    // Returns the fallback elements if they exist already
    //
    // This code has to pass in IE7 :(
    getExistingFallback() {
        let getFallback = function(elements) {
            for (let el of elements){
                if (/(^| )fallback($| )/.test(el.className)) return el;
            }
        };
        for (let tagName of [
            "div",
            "form"
        ]){
            var fallback;
            if (fallback = getFallback(this.element.getElementsByTagName(tagName))) return fallback;
        }
    }
    // Activates all listeners stored in @listeners
    setupEventListeners() {
        return this.listeners.map((elementListeners)=>(()=>{
                let result = [];
                for(let event in elementListeners.events){
                    let listener = elementListeners.events[event];
                    result.push(elementListeners.element.addEventListener(event, listener, false));
                }
                return result;
            })());
    }
    // Deactivates all listeners stored in @listeners
    removeEventListeners() {
        return this.listeners.map((elementListeners)=>(()=>{
                let result = [];
                for(let event in elementListeners.events){
                    let listener = elementListeners.events[event];
                    result.push(elementListeners.element.removeEventListener(event, listener, false));
                }
                return result;
            })());
    }
    // Removes all event listeners and cancels all files in the queue or being processed.
    disable() {
        this.clickableElements.forEach((element)=>element.classList.remove("dz-clickable"));
        this.removeEventListeners();
        this.disabled = true;
        return this.files.map((file)=>this.cancelUpload(file));
    }
    enable() {
        delete this.disabled;
        this.clickableElements.forEach((element)=>element.classList.add("dz-clickable"));
        return this.setupEventListeners();
    }
    // Returns a nicely formatted filesize
    filesize(size) {
        let selectedSize = 0;
        let selectedUnit = "b";
        if (size > 0) {
            let units = [
                "tb",
                "gb",
                "mb",
                "kb",
                "b"
            ];
            for(let i = 0; i < units.length; i++){
                let unit = units[i];
                let cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
                if (size >= cutoff) {
                    selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
                    selectedUnit = unit;
                    break;
                }
            }
            selectedSize = Math.round(10 * selectedSize) / 10; // Cutting of digits
        }
        return `<strong>${selectedSize}</strong> ${this.options.dictFileSizeUnits[selectedUnit]}`;
    }
    // Adds or removes the `dz-max-files-reached` class from the form.
    _updateMaxFilesReachedClass() {
        if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
            if (this.getAcceptedFiles().length === this.options.maxFiles) this.emit("maxfilesreached", this.files);
            return this.element.classList.add("dz-max-files-reached");
        } else return this.element.classList.remove("dz-max-files-reached");
    }
    drop(e) {
        if (!e.dataTransfer) return;
        this.emit("drop", e);
        // Convert the FileList to an Array
        // This is necessary for IE11
        let files = [];
        for(let i = 0; i < e.dataTransfer.files.length; i++)files[i] = e.dataTransfer.files[i];
        // Even if it's a folder, files.length will contain the folders.
        if (files.length) {
            let { items: items } = e.dataTransfer;
            if (items && items.length && items[0].webkitGetAsEntry != null) this._addFilesFromItems(items);
            else this.handleFiles(files);
        }
        this.emit("addedfiles", files);
    }
    paste(e) {
        if ($ef07192511817417$var$$3ed269f2f0fb224b$var$__guard__(e != null ? e.clipboardData : undefined, (x)=>x.items) == null) return;
        this.emit("paste", e);
        let { items: items } = e.clipboardData;
        if (items.length) return this._addFilesFromItems(items);
    }
    handleFiles(files) {
        for (let file of files)this.addFile(file);
    }
    // When a folder is dropped (or files are pasted), items must be handled
    // instead of files.
    _addFilesFromItems(items) {
        return (()=>{
            let result = [];
            for (let item of items){
                var entry;
                if (item.webkitGetAsEntry != null && (entry = item.webkitGetAsEntry())) {
                    if (entry.isFile) result.push(this.addFile(item.getAsFile()));
                    else if (entry.isDirectory) result.push(this._addFilesFromDirectory(entry, entry.name));
                    else result.push(undefined);
                } else if (item.getAsFile != null) {
                    if (item.kind == null || item.kind === "file") result.push(this.addFile(item.getAsFile()));
                    else result.push(undefined);
                } else result.push(undefined);
            }
            return result;
        })();
    }
    // Goes through the directory, and adds each file it finds recursively
    _addFilesFromDirectory(directory, path) {
        let dirReader = directory.createReader();
        let errorHandler = (error)=>$ef07192511817417$var$$3ed269f2f0fb224b$var$__guardMethod__(console, "log", (o)=>o.log(error));
        var readEntries = ()=>{
            return dirReader.readEntries((entries)=>{
                if (entries.length > 0) {
                    for (let entry of entries){
                        if (entry.isFile) entry.file((file)=>{
                            if (this.options.ignoreHiddenFiles && file.name.substring(0, 1) === ".") return;
                            file.fullPath = `${path}/${file.name}`;
                            return this.addFile(file);
                        });
                        else if (entry.isDirectory) this._addFilesFromDirectory(entry, `${path}/${entry.name}`);
                    }
                    // Recursively call readEntries() again, since browser only handle
                    // the first 100 entries.
                    // See: https://developer.mozilla.org/en-US/docs/Web/API/DirectoryReader#readEntries
                    readEntries();
                }
                return null;
            }, errorHandler);
        };
        return readEntries();
    }
    // If `done()` is called without argument the file is accepted
    // If you call it with an error message, the file is rejected
    // (This allows for asynchronous validation)
    //
    // This function checks the filesize, and if the file.type passes the
    // `acceptedFiles` check.
    accept(file, done) {
        if (this.options.maxFilesize && file.size > this.options.maxFilesize * 1048576) done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
        else if (!$ef07192511817417$export$2e2bcd8739ae039.isValidFile(file, this.options.acceptedFiles)) done(this.options.dictInvalidFileType);
        else if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
            done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
            this.emit("maxfilesexceeded", file);
        } else this.options.accept.call(this, file, done);
    }
    addFile(file) {
        file.upload = {
            uuid: $ef07192511817417$export$2e2bcd8739ae039.uuidv4(),
            progress: 0,
            // Setting the total upload size to file.size for the beginning
            // It's actual different than the size to be transmitted.
            total: file.size,
            bytesSent: 0,
            filename: this._renameFile(file)
        };
        this.files.push(file);
        file.status = $ef07192511817417$export$2e2bcd8739ae039.ADDED;
        this.emit("addedfile", file);
        this._enqueueThumbnail(file);
        this.accept(file, (error)=>{
            if (error) {
                file.accepted = false;
                this._errorProcessing([
                    file
                ], error); // Will set the file.status
            } else {
                file.accepted = true;
                if (this.options.autoQueue) this.enqueueFile(file);
            // Will set .accepted = true
            }
            this._updateMaxFilesReachedClass();
        });
    }
    // Wrapper for enqueueFile
    enqueueFiles(files) {
        for (let file of files)this.enqueueFile(file);
        return null;
    }
    enqueueFile(file) {
        if (file.status === $ef07192511817417$export$2e2bcd8739ae039.ADDED && file.accepted === true) {
            file.status = $ef07192511817417$export$2e2bcd8739ae039.QUEUED;
            if (this.options.autoProcessQueue) return setTimeout(()=>this.processQueue(), 0); // Deferring the call
        } else throw new Error("This file can't be queued because it has already been processed or was rejected.");
    }
    _enqueueThumbnail(file) {
        if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1048576) {
            this._thumbnailQueue.push(file);
            return setTimeout(()=>this._processThumbnailQueue(), 0); // Deferring the call
        }
    }
    _processThumbnailQueue() {
        if (this._processingThumbnail || this._thumbnailQueue.length === 0) return;
        this._processingThumbnail = true;
        let file = this._thumbnailQueue.shift();
        return this.createThumbnail(file, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, true, (dataUrl)=>{
            this.emit("thumbnail", file, dataUrl);
            this._processingThumbnail = false;
            return this._processThumbnailQueue();
        });
    }
    // Can be called by the user to remove a file
    removeFile(file) {
        if (file.status === $ef07192511817417$export$2e2bcd8739ae039.UPLOADING) this.cancelUpload(file);
        this.files = $ef07192511817417$var$$3ed269f2f0fb224b$var$without(this.files, file);
        this.emit("removedfile", file);
        if (this.files.length === 0) return this.emit("reset");
    }
    // Removes all files that aren't currently processed from the list
    removeAllFiles(cancelIfNecessary) {
        // Create a copy of files since removeFile() changes the @files array.
        if (cancelIfNecessary == null) cancelIfNecessary = false;
        for (let file of this.files.slice())if (file.status !== $ef07192511817417$export$2e2bcd8739ae039.UPLOADING || cancelIfNecessary) this.removeFile(file);
        return null;
    }
    // Resizes an image before it gets sent to the server. This function is the default behavior of
    // `options.transformFile` if `resizeWidth` or `resizeHeight` are set. The callback is invoked with
    // the resized blob.
    resizeImage(file, width, height, resizeMethod, callback) {
        return this.createThumbnail(file, width, height, resizeMethod, true, (dataUrl, canvas)=>{
            if (canvas == null) return callback(file);
            else {
                let { resizeMimeType: resizeMimeType } = this.options;
                if (resizeMimeType == null) resizeMimeType = file.type;
                let resizedDataURL = canvas.toDataURL(resizeMimeType, this.options.resizeQuality);
                if (resizeMimeType === "image/jpeg" || resizeMimeType === "image/jpg") resizedDataURL = $ef07192511817417$var$$3ed269f2f0fb224b$var$ExifRestore.restore(file.dataURL, resizedDataURL);
                return callback($ef07192511817417$export$2e2bcd8739ae039.dataURItoBlob(resizedDataURL));
            }
        });
    }
    createThumbnail(file, width, height, resizeMethod, fixOrientation, callback) {
        let fileReader = new FileReader();
        fileReader.onload = ()=>{
            file.dataURL = fileReader.result;
            // Don't bother creating a thumbnail for SVG images since they're vector
            if (file.type === "image/svg+xml") {
                if (callback != null) callback(fileReader.result);
                return;
            }
            this.createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback);
        };
        fileReader.readAsDataURL(file);
    }
    // `mockFile` needs to have these attributes:
    //
    //     { name: 'name', size: 12345, imageUrl: '' }
    //
    // `callback` will be invoked when the image has been downloaded and displayed.
    // `crossOrigin` will be added to the `img` tag when accessing the file.
    displayExistingFile(mockFile, imageUrl, callback, crossOrigin, resizeThumbnail = true) {
        this.emit("addedfile", mockFile);
        this.emit("complete", mockFile);
        if (!resizeThumbnail) {
            this.emit("thumbnail", mockFile, imageUrl);
            if (callback) callback();
        } else {
            let onDone = (thumbnail)=>{
                this.emit("thumbnail", mockFile, thumbnail);
                if (callback) callback();
            };
            mockFile.dataURL = imageUrl;
            this.createThumbnailFromUrl(mockFile, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, this.options.fixOrientation, onDone, crossOrigin);
        }
    }
    createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback, crossOrigin) {
        // Not using `new Image` here because of a bug in latest Chrome versions.
        // See https://github.com/enyo/dropzone/pull/226
        let img = document.createElement("img");
        if (crossOrigin) img.crossOrigin = crossOrigin;
        // fixOrientation is not needed anymore with browsers handling imageOrientation
        fixOrientation = getComputedStyle(document.body)["imageOrientation"] == "from-image" ? false : fixOrientation;
        img.onload = ()=>{
            let loadExif = (callback)=>callback(1);
            if (typeof EXIF !== "undefined" && EXIF !== null && fixOrientation) loadExif = (callback)=>EXIF.getData(img, function() {
                    return callback(EXIF.getTag(this, "Orientation"));
                });
            return loadExif((orientation)=>{
                file.width = img.width;
                file.height = img.height;
                let resizeInfo = this.options.resize.call(this, file, width, height, resizeMethod);
                let canvas = document.createElement("canvas");
                let ctx = canvas.getContext("2d");
                canvas.width = resizeInfo.trgWidth;
                canvas.height = resizeInfo.trgHeight;
                if (orientation > 4) {
                    canvas.width = resizeInfo.trgHeight;
                    canvas.height = resizeInfo.trgWidth;
                }
                switch(orientation){
                    case 2:
                        // horizontal flip
                        ctx.translate(canvas.width, 0);
                        ctx.scale(-1, 1);
                        break;
                    case 3:
                        // 180° rotate left
                        ctx.translate(canvas.width, canvas.height);
                        ctx.rotate(Math.PI);
                        break;
                    case 4:
                        // vertical flip
                        ctx.translate(0, canvas.height);
                        ctx.scale(1, -1);
                        break;
                    case 5:
                        // vertical flip + 90 rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.scale(1, -1);
                        break;
                    case 6:
                        // 90° rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.translate(0, -canvas.width);
                        break;
                    case 7:
                        // horizontal flip + 90 rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.translate(canvas.height, -canvas.width);
                        ctx.scale(-1, 1);
                        break;
                    case 8:
                        // 90° rotate left
                        ctx.rotate(-0.5 * Math.PI);
                        ctx.translate(-canvas.height, 0);
                        break;
                }
                // This is a bugfix for iOS' scaling bug.
                $ef07192511817417$var$$3ed269f2f0fb224b$var$drawImageIOSFix(ctx, img, resizeInfo.srcX != null ? resizeInfo.srcX : 0, resizeInfo.srcY != null ? resizeInfo.srcY : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, resizeInfo.trgX != null ? resizeInfo.trgX : 0, resizeInfo.trgY != null ? resizeInfo.trgY : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
                let thumbnail = canvas.toDataURL("image/png");
                if (callback != null) return callback(thumbnail, canvas);
            });
        };
        if (callback != null) img.onerror = callback;
        return img.src = file.dataURL;
    }
    // Goes through the queue and processes files if there aren't too many already.
    processQueue() {
        let { parallelUploads: parallelUploads } = this.options;
        let processingLength = this.getUploadingFiles().length;
        let i = processingLength;
        // There are already at least as many files uploading than should be
        if (processingLength >= parallelUploads) return;
        let queuedFiles = this.getQueuedFiles();
        if (!(queuedFiles.length > 0)) return;
        if (this.options.uploadMultiple) return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
        else while(i < parallelUploads){
            if (!queuedFiles.length) return;
            // Nothing left to process
            this.processFile(queuedFiles.shift());
            i++;
        }
    }
    // Wrapper for `processFiles`
    processFile(file) {
        return this.processFiles([
            file
        ]);
    }
    // Loads the file, then calls finishedLoading()
    processFiles(files) {
        for (let file of files){
            file.processing = true; // Backwards compatibility
            file.status = $ef07192511817417$export$2e2bcd8739ae039.UPLOADING;
            this.emit("processing", file);
        }
        if (this.options.uploadMultiple) this.emit("processingmultiple", files);
        return this.uploadFiles(files);
    }
    _getFilesWithXhr(xhr) {
        let files;
        return files = this.files.filter((file)=>file.xhr === xhr).map((file)=>file);
    }
    // Cancels the file upload and sets the status to CANCELED
    // **if** the file is actually being uploaded.
    // If it's still in the queue, the file is being removed from it and the status
    // set to CANCELED.
    cancelUpload(file) {
        if (file.status === $ef07192511817417$export$2e2bcd8739ae039.UPLOADING) {
            let groupedFiles = this._getFilesWithXhr(file.xhr);
            for (let groupedFile of groupedFiles)groupedFile.status = $ef07192511817417$export$2e2bcd8739ae039.CANCELED;
            if (typeof file.xhr !== "undefined") file.xhr.abort();
            for (let groupedFile1 of groupedFiles)this.emit("canceled", groupedFile1);
            if (this.options.uploadMultiple) this.emit("canceledmultiple", groupedFiles);
        } else if (file.status === $ef07192511817417$export$2e2bcd8739ae039.ADDED || file.status === $ef07192511817417$export$2e2bcd8739ae039.QUEUED) {
            file.status = $ef07192511817417$export$2e2bcd8739ae039.CANCELED;
            this.emit("canceled", file);
            if (this.options.uploadMultiple) this.emit("canceledmultiple", [
                file
            ]);
        }
        if (this.options.autoProcessQueue) return this.processQueue();
    }
    resolveOption(option, ...args) {
        if (typeof option === "function") return option.apply(this, args);
        return option;
    }
    uploadFile(file) {
        return this.uploadFiles([
            file
        ]);
    }
    uploadFiles(files) {
        this._transformFiles(files, (transformedFiles)=>{
            if (this.options.chunking) {
                // Chunking is not allowed to be used with `uploadMultiple` so we know
                // that there is only __one__file.
                let transformedFile = transformedFiles[0];
                files[0].upload.chunked = this.options.chunking && (this.options.forceChunking || transformedFile.size > this.options.chunkSize);
                files[0].upload.totalChunkCount = Math.ceil(transformedFile.size / this.options.chunkSize);
            }
            if (files[0].upload.chunked) {
                // This file should be sent in chunks!
                // If the chunking option is set, we **know** that there can only be **one** file, since
                // uploadMultiple is not allowed with this option.
                let file = files[0];
                let transformedFile = transformedFiles[0];
                let startedChunkCount = 0;
                file.upload.chunks = [];
                let handleNextChunk = ()=>{
                    let chunkIndex = 0;
                    // Find the next item in file.upload.chunks that is not defined yet.
                    while(file.upload.chunks[chunkIndex] !== undefined)chunkIndex++;
                    // This means, that all chunks have already been started.
                    if (chunkIndex >= file.upload.totalChunkCount) return;
                    startedChunkCount++;
                    let start = chunkIndex * this.options.chunkSize;
                    let end = Math.min(start + this.options.chunkSize, transformedFile.size);
                    let dataBlock = {
                        name: this._getParamName(0),
                        data: transformedFile.webkitSlice ? transformedFile.webkitSlice(start, end) : transformedFile.slice(start, end),
                        filename: file.upload.filename,
                        chunkIndex: chunkIndex
                    };
                    file.upload.chunks[chunkIndex] = {
                        file: file,
                        index: chunkIndex,
                        dataBlock: dataBlock,
                        status: $ef07192511817417$export$2e2bcd8739ae039.UPLOADING,
                        progress: 0,
                        retries: 0
                    };
                    this._uploadData(files, [
                        dataBlock
                    ]);
                };
                file.upload.finishedChunkUpload = (chunk, response)=>{
                    let allFinished = true;
                    chunk.status = $ef07192511817417$export$2e2bcd8739ae039.SUCCESS;
                    // Clear the data from the chunk
                    chunk.dataBlock = null;
                    chunk.response = chunk.xhr.responseText;
                    chunk.responseHeaders = chunk.xhr.getAllResponseHeaders();
                    // Leaving this reference to xhr will cause memory leaks.
                    chunk.xhr = null;
                    for(let i = 0; i < file.upload.totalChunkCount; i++){
                        if (file.upload.chunks[i] === undefined) return handleNextChunk();
                        if (file.upload.chunks[i].status !== $ef07192511817417$export$2e2bcd8739ae039.SUCCESS) allFinished = false;
                    }
                    if (allFinished) this.options.chunksUploaded(file, ()=>{
                        this._finished(files, response, null);
                    });
                };
                if (this.options.parallelChunkUploads) for(let i = 0; i < file.upload.totalChunkCount; i++)handleNextChunk();
                else handleNextChunk();
            } else {
                let dataBlocks = [];
                for(let i = 0; i < files.length; i++)dataBlocks[i] = {
                    name: this._getParamName(i),
                    data: transformedFiles[i],
                    filename: files[i].upload.filename
                };
                this._uploadData(files, dataBlocks);
            }
        });
    }
    /// Returns the right chunk for given file and xhr
    _getChunk(file, xhr) {
        for(let i = 0; i < file.upload.totalChunkCount; i++){
            if (file.upload.chunks[i] !== undefined && file.upload.chunks[i].xhr === xhr) return file.upload.chunks[i];
        }
    }
    // This function actually uploads the file(s) to the server.
    //
    //  If dataBlocks contains the actual data to upload (meaning, that this could
    // either be transformed files, or individual chunks for chunked upload) then
    // they will be used for the actual data to upload.
    _uploadData(files, dataBlocks) {
        let xhr = new XMLHttpRequest();
        // Put the xhr object in the file objects to be able to reference it later.
        for (let file of files)file.xhr = xhr;
        if (files[0].upload.chunked) // later, and found with _getChunk.
        files[0].upload.chunks[dataBlocks[0].chunkIndex].xhr = xhr;
        let method = this.resolveOption(this.options.method, files, dataBlocks);
        let url = this.resolveOption(this.options.url, files, dataBlocks);
        xhr.open(method, url, true);
        // Setting the timeout after open because of IE11 issue: https://gitlab.com/meno/dropzone/issues/8
        let timeout = this.resolveOption(this.options.timeout, files);
        if (timeout) xhr.timeout = this.resolveOption(this.options.timeout, files);
        // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
        xhr.withCredentials = !!this.options.withCredentials;
        xhr.onload = (e)=>{
            this._finishedUploading(files, xhr, e);
        };
        xhr.ontimeout = ()=>{
            this._handleUploadError(files, xhr, `Request timedout after ${this.options.timeout / 1000} seconds`);
        };
        xhr.onerror = ()=>{
            this._handleUploadError(files, xhr);
        };
        // Some browsers do not have the .upload property
        let progressObj = xhr.upload != null ? xhr.upload : xhr;
        progressObj.onprogress = (e)=>this._updateFilesUploadProgress(files, xhr, e);
        let headers = this.options.defaultHeaders ? {
            Accept: "application/json",
            "Cache-Control": "no-cache",
            "X-Requested-With": "XMLHttpRequest"
        } : {};
        if (this.options.binaryBody) headers["Content-Type"] = files[0].type;
        if (this.options.headers) (0, $496ab7d22471764e$export$2e2bcd8739ae039)(headers, this.options.headers);
        for(let headerName in headers){
            let headerValue = headers[headerName];
            if (headerValue) xhr.setRequestHeader(headerName, headerValue);
        }
        if (this.options.binaryBody) {
            // Since the file is going to be sent as binary body, it doesn't make
            // any sense to generate `FormData` for it.
            for (let file of files)this.emit("sending", file, xhr);
            if (this.options.uploadMultiple) this.emit("sendingmultiple", files, xhr);
            this.submitRequest(xhr, null, files);
        } else {
            let formData = new FormData();
            // Adding all @options parameters
            if (this.options.params) {
                let additionalParams = this.options.params;
                if (typeof additionalParams === "function") additionalParams = additionalParams.call(this, files, xhr, files[0].upload.chunked ? this._getChunk(files[0], xhr) : null);
                for(let key in additionalParams){
                    let value = additionalParams[key];
                    if (Array.isArray(value)) // so lets iterate over it to attach each value
                    // individually.
                    for(let i = 0; i < value.length; i++)formData.append(key, value[i]);
                    else formData.append(key, value);
                }
            }
            // Let the user add additional data if necessary
            for (let file of files)this.emit("sending", file, xhr, formData);
            if (this.options.uploadMultiple) this.emit("sendingmultiple", files, xhr, formData);
            this._addFormElementData(formData);
            // Finally add the files
            // Has to be last because some servers (eg: S3) expect the file to be the last parameter
            for(let i = 0; i < dataBlocks.length; i++){
                let dataBlock = dataBlocks[i];
                formData.append(dataBlock.name, dataBlock.data, dataBlock.filename);
            }
            this.submitRequest(xhr, formData, files);
        }
    }
    // Transforms all files with this.options.transformFile and invokes done with the transformed files when done.
    _transformFiles(files, done) {
        let transformedFiles = [];
        // Clumsy way of handling asynchronous calls, until I get to add a proper Future library.
        let doneCounter = 0;
        for(let i = 0; i < files.length; i++)this.options.transformFile.call(this, files[i], (transformedFile)=>{
            transformedFiles[i] = transformedFile;
            if (++doneCounter === files.length) done(transformedFiles);
        });
    }
    // Takes care of adding other input elements of the form to the AJAX request
    _addFormElementData(formData) {
        // Take care of other input elements
        if (this.element.tagName === "FORM") for (let input of this.element.querySelectorAll("input, textarea, select, button")){
            let inputName = input.getAttribute("name");
            let inputType = input.getAttribute("type");
            if (inputType) inputType = inputType.toLowerCase();
            // If the input doesn't have a name, we can't use it.
            if (typeof inputName === "undefined" || inputName === null) continue;
            if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
                // Possibly multiple values
                for (let option of input.options)if (option.selected) formData.append(inputName, option.value);
            } else if (!inputType || inputType !== "checkbox" && inputType !== "radio" || input.checked) formData.append(inputName, input.value);
        }
    }
    // Invoked when there is new progress information about given files.
    // If e is not provided, it is assumed that the upload is finished.
    _updateFilesUploadProgress(files, xhr, e) {
        if (!files[0].upload.chunked) for (let file of files){
            if (file.upload.total && file.upload.bytesSent && file.upload.bytesSent == file.upload.total) continue;
            if (e) {
                file.upload.progress = 100 * e.loaded / e.total;
                file.upload.total = e.total;
                file.upload.bytesSent = e.loaded;
            } else {
                // No event, so we're at 100%
                file.upload.progress = 100;
                file.upload.bytesSent = file.upload.total;
            }
            this.emit("uploadprogress", file, file.upload.progress, file.upload.bytesSent);
        }
        else {
            // Handle chunked file uploads
            // Chunked upload is not compatible with uploading multiple files in one
            // request, so we know there's only one file.
            let file = files[0];
            // Since this is a chunked upload, we need to update the appropriate chunk
            // progress.
            let chunk = this._getChunk(file, xhr);
            if (e) {
                chunk.progress = 100 * e.loaded / e.total;
                chunk.total = e.total;
                chunk.bytesSent = e.loaded;
            } else {
                // No event, so we're at 100%
                chunk.progress = 100;
                chunk.bytesSent = chunk.total;
            }
            // Now tally the *file* upload progress from its individual chunks
            file.upload.progress = 0;
            file.upload.total = 0;
            file.upload.bytesSent = 0;
            for(let i = 0; i < file.upload.totalChunkCount; i++)if (file.upload.chunks[i] && typeof file.upload.chunks[i].progress !== "undefined") {
                file.upload.progress += file.upload.chunks[i].progress;
                file.upload.total += file.upload.chunks[i].total;
                file.upload.bytesSent += file.upload.chunks[i].bytesSent;
            }
            // Since the process is a percentage, we need to divide by the amount of
            // chunks we've used.
            file.upload.progress = file.upload.progress / file.upload.totalChunkCount;
            this.emit("uploadprogress", file, file.upload.progress, file.upload.bytesSent);
        }
    }
    _finishedUploading(files, xhr, e) {
        let response;
        if (files[0].status === $ef07192511817417$export$2e2bcd8739ae039.CANCELED) return;
        if (xhr.readyState !== 4) return;
        if (xhr.responseType !== "arraybuffer" && xhr.responseType !== "blob") {
            response = xhr.responseText;
            if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) try {
                response = JSON.parse(response);
            } catch (error) {
                e = error;
                response = "Invalid JSON response from server.";
            }
        }
        this._updateFilesUploadProgress(files, xhr);
        if (!(200 <= xhr.status && xhr.status < 300)) this._handleUploadError(files, xhr, response);
        else if (files[0].upload.chunked) files[0].upload.finishedChunkUpload(this._getChunk(files[0], xhr), response);
        else this._finished(files, response, e);
    }
    _handleUploadError(files, xhr, response) {
        if (files[0].status === $ef07192511817417$export$2e2bcd8739ae039.CANCELED) return;
        if (files[0].upload.chunked && this.options.retryChunks) {
            let chunk = this._getChunk(files[0], xhr);
            if (chunk.retries++ < this.options.retryChunksLimit) {
                this._uploadData(files, [
                    chunk.dataBlock
                ]);
                return;
            } else console.warn("Retried this chunk too often. Giving up.");
        }
        this._errorProcessing(files, response || this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr);
    }
    submitRequest(xhr, formData, files) {
        if (xhr.readyState != 1) {
            console.warn("Cannot send this request because the XMLHttpRequest.readyState is not OPENED.");
            return;
        }
        if (this.options.binaryBody) {
            if (files[0].upload.chunked) {
                const chunk = this._getChunk(files[0], xhr);
                xhr.send(chunk.dataBlock.data);
            } else xhr.send(files[0]);
        } else xhr.send(formData);
    }
    // Called internally when processing is finished.
    // Individual callbacks have to be called in the appropriate sections.
    _finished(files, responseText, e) {
        for (let file of files){
            file.status = $ef07192511817417$export$2e2bcd8739ae039.SUCCESS;
            this.emit("success", file, responseText, e);
            this.emit("complete", file);
        }
        if (this.options.uploadMultiple) {
            this.emit("successmultiple", files, responseText, e);
            this.emit("completemultiple", files);
        }
        if (this.options.autoProcessQueue) return this.processQueue();
    }
    // Called internally when processing is finished.
    // Individual callbacks have to be called in the appropriate sections.
    _errorProcessing(files, message, xhr) {
        for (let file of files){
            file.status = $ef07192511817417$export$2e2bcd8739ae039.ERROR;
            this.emit("error", file, message, xhr);
            this.emit("complete", file);
        }
        if (this.options.uploadMultiple) {
            this.emit("errormultiple", files, message, xhr);
            this.emit("completemultiple", files);
        }
        if (this.options.autoProcessQueue) return this.processQueue();
    }
    static uuidv4() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            let r = Math.random() * 16 | 0, v = c === "x" ? r : r & 3 | 8;
            return v.toString(16);
        });
    }
    constructor(el, options){
        super();
        let fallback, left;
        this.element = el;
        this.clickableElements = [];
        this.listeners = [];
        this.files = []; // All files
        if (typeof this.element === "string") this.element = document.querySelector(this.element);
        // Not checking if instance of HTMLElement or Element since IE9 is extremely weird.
        if (!this.element || this.element.nodeType == null) throw new Error("Invalid dropzone element.");
        if (this.element.dropzone) throw new Error("Dropzone already attached.");
        // Now add this dropzone to the instances.
        $ef07192511817417$export$2e2bcd8739ae039.instances.push(this);
        // Put the dropzone inside the element itself.
        this.element.dropzone = this;
        let elementOptions = (left = $ef07192511817417$export$2e2bcd8739ae039.optionsForElement(this.element)) != null ? left : {};
        this.options = (0, $496ab7d22471764e$export$2e2bcd8739ae039)(true, {}, $ef07192511817417$var$$4ca367182776f80b$export$2e2bcd8739ae039, elementOptions, options != null ? options : {});
        this.options.previewTemplate = this.options.previewTemplate.replace(/\n*/g, "");
        // If the browser failed, just call the fallback and leave
        if (this.options.forceFallback || !$ef07192511817417$export$2e2bcd8739ae039.isBrowserSupported()) return this.options.fallback.call(this);
        // @options.url = @element.getAttribute "action" unless @options.url?
        if (this.options.url == null) this.options.url = this.element.getAttribute("action");
        if (!this.options.url) throw new Error("No URL provided.");
        if (this.options.acceptedFiles && this.options.acceptedMimeTypes) throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
        if (this.options.uploadMultiple && this.options.chunking) throw new Error("You cannot set both: uploadMultiple and chunking.");
        if (this.options.binaryBody && this.options.uploadMultiple) throw new Error("You cannot set both: binaryBody and uploadMultiple.");
        // Backwards compatibility
        if (this.options.acceptedMimeTypes) {
            this.options.acceptedFiles = this.options.acceptedMimeTypes;
            delete this.options.acceptedMimeTypes;
        }
        // Backwards compatibility
        if (this.options.renameFilename != null) this.options.renameFile = (file)=>this.options.renameFilename.call(this, file.name, file);
        if (typeof this.options.method === "string") this.options.method = this.options.method.toUpperCase();
        if ((fallback = this.getExistingFallback()) && fallback.parentNode) fallback.parentNode.removeChild(fallback);
        // Display previews in the previewsContainer element or the Dropzone element unless explicitly set to false
        if (this.options.previewsContainer !== false) {
            if (this.options.previewsContainer) this.previewsContainer = $ef07192511817417$export$2e2bcd8739ae039.getElement(this.options.previewsContainer, "previewsContainer");
            else this.previewsContainer = this.element;
        }
        if (this.options.clickable) {
            if (this.options.clickable === true) this.clickableElements = [
                this.element
            ];
            else this.clickableElements = $ef07192511817417$export$2e2bcd8739ae039.getElements(this.options.clickable, "clickable");
        }
        this.init();
    }
}
$ef07192511817417$export$2e2bcd8739ae039.initClass();
// This is a map of options for your different dropzones. Add configurations
// to this object for your different dropzone elemens.
//
// Example:
//
//     Dropzone.options.myDropzoneElementId = { maxFilesize: 1 };
//
// And in html:
//
//     <form action="/upload" id="my-dropzone-element-id" class="dropzone"></form>
$ef07192511817417$export$2e2bcd8739ae039.options = {};
// Returns the options for an element or undefined if none available.
$ef07192511817417$export$2e2bcd8739ae039.optionsForElement = function(element) {
    // Get the `Dropzone.options.elementId` for this element if it exists
    if (element.getAttribute("id")) return $ef07192511817417$export$2e2bcd8739ae039.options[$ef07192511817417$var$$3ed269f2f0fb224b$var$camelize(element.getAttribute("id"))];
    else return undefined;
};
// Holds a list of all dropzone instances
$ef07192511817417$export$2e2bcd8739ae039.instances = [];
// Returns the dropzone for given element if any
$ef07192511817417$export$2e2bcd8739ae039.forElement = function(element) {
    if (typeof element === "string") element = document.querySelector(element);
    if ((element != null ? element.dropzone : undefined) == null) throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
    return element.dropzone;
};
// Looks for all .dropzone elements and creates a dropzone for them
$ef07192511817417$export$2e2bcd8739ae039.discover = function() {
    let dropzones;
    if (document.querySelectorAll) dropzones = document.querySelectorAll(".dropzone");
    else {
        dropzones = [];
        // IE :(
        let checkElements = (elements)=>(()=>{
                let result = [];
                for (let el of elements)if (/(^| )dropzone($| )/.test(el.className)) result.push(dropzones.push(el));
                else result.push(undefined);
                return result;
            })();
        checkElements(document.getElementsByTagName("div"));
        checkElements(document.getElementsByTagName("form"));
    }
    return (()=>{
        let result = [];
        for (let dropzone of dropzones)if ($ef07192511817417$export$2e2bcd8739ae039.optionsForElement(dropzone) !== false) result.push(new $ef07192511817417$export$2e2bcd8739ae039(dropzone));
        else result.push(undefined);
        return result;
    })();
};
// Some browsers support drag and drog functionality, but not correctly.
//
// So I created a blocklist of userAgents. Yes, yes. Browser sniffing, I know.
// But what to do when browsers *theoretically* support an API, but crash
// when using it.
//
// This is a list of regular expressions tested against navigator.userAgent
//
// ** It should only be used on browser that *do* support the API, but
// incorrectly **
$ef07192511817417$export$2e2bcd8739ae039.blockedBrowsers = [
    // The mac os and windows phone version of opera 12 seems to have a problem with the File drag'n'drop API.
    /opera.*(Macintosh|Windows Phone).*version\/12/i
];
// Checks if the browser is supported
$ef07192511817417$export$2e2bcd8739ae039.isBrowserSupported = function() {
    let capableBrowser = true;
    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
        if (!("classList" in document.createElement("a"))) capableBrowser = false;
        else {
            if ($ef07192511817417$export$2e2bcd8739ae039.blacklistedBrowsers !== undefined) // configuration.
            $ef07192511817417$export$2e2bcd8739ae039.blockedBrowsers = $ef07192511817417$export$2e2bcd8739ae039.blacklistedBrowsers;
            // The browser supports the API, but may be blocked.
            for (let regex of $ef07192511817417$export$2e2bcd8739ae039.blockedBrowsers)if (regex.test(navigator.userAgent)) {
                capableBrowser = false;
                continue;
            }
        }
    } else capableBrowser = false;
    return capableBrowser;
};
$ef07192511817417$export$2e2bcd8739ae039.dataURItoBlob = function(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    let byteString = atob(dataURI.split(",")[1]);
    // separate out the mime component
    let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    // write the bytes of the string to an ArrayBuffer
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for(let i = 0, end = byteString.length, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--)ia[i] = byteString.charCodeAt(i);
    // write the ArrayBuffer to a blob
    return new Blob([
        ab
    ], {
        type: mimeString
    });
};
// Returns an array without the rejected item
const $ef07192511817417$var$$3ed269f2f0fb224b$var$without = (list, rejectedItem)=>list.filter((item)=>item !== rejectedItem).map((item)=>item);
// abc-def_ghi -> abcDefGhi
const $ef07192511817417$var$$3ed269f2f0fb224b$var$camelize = (str)=>str.replace(/[\-_](\w)/g, (match)=>match.charAt(1).toUpperCase());
// Creates an element from string
$ef07192511817417$export$2e2bcd8739ae039.createElement = function(string) {
    let div = document.createElement("div");
    div.innerHTML = string;
    return div.childNodes[0];
};
// Tests if given element is inside (or simply is) the container
$ef07192511817417$export$2e2bcd8739ae039.elementInside = function(element, container) {
    if (element === container) return true;
    // Coffeescript doesn't support do/while loops
    while(element = element.parentNode){
        if (element === container) return true;
    }
    return false;
};
$ef07192511817417$export$2e2bcd8739ae039.getElement = function(el, name) {
    let element;
    if (typeof el === "string") element = document.querySelector(el);
    else if (el.nodeType != null) element = el;
    if (element == null) throw new Error(`Invalid \`${name}\` option provided. Please provide a CSS selector or a plain HTML element.`);
    return element;
};
$ef07192511817417$export$2e2bcd8739ae039.getElements = function(els, name) {
    let el, elements;
    if (els instanceof Array) {
        elements = [];
        try {
            for (el of els)elements.push(this.getElement(el, name));
        } catch (e) {
            elements = null;
        }
    } else if (typeof els === "string") {
        elements = [];
        for (el of document.querySelectorAll(els))elements.push(el);
    } else if (els.nodeType != null) elements = [
        els
    ];
    if (elements == null || !elements.length) throw new Error(`Invalid \`${name}\` option provided. Please provide a CSS selector, a plain HTML element or a list of those.`);
    return elements;
};
// Asks the user the question and calls accepted or rejected accordingly
//
// The default implementation just uses `window.confirm` and then calls the
// appropriate callback.
$ef07192511817417$export$2e2bcd8739ae039.confirm = function(question, accepted, rejected) {
    if (window.confirm(question)) return accepted();
    else if (rejected != null) return rejected();
};
// Validates the mime type like this:
//
// https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept
$ef07192511817417$export$2e2bcd8739ae039.isValidFile = function(file, acceptedFiles) {
    if (!acceptedFiles) return true;
    // If there are no accepted mime types, it's OK
    acceptedFiles = acceptedFiles.split(",");
    let mimeType = file.type;
    let baseMimeType = mimeType.replace(/\/.*$/, "");
    for (let validType of acceptedFiles){
        validType = validType.trim();
        if (validType.charAt(0) === ".") {
            if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) return true;
        } else if (/\/\*$/.test(validType)) {
            // This is something like a image/* mime type
            if (baseMimeType === validType.replace(/\/.*$/, "")) return true;
        } else {
            if (mimeType === validType) return true;
        }
    }
    return false;
};
// Augment jQuery
if (typeof jQuery !== "undefined" && jQuery !== null) jQuery.fn.dropzone = function(options) {
    return this.each(function() {
        return new $ef07192511817417$export$2e2bcd8739ae039(this, options);
    });
};
// Dropzone file status codes
$ef07192511817417$export$2e2bcd8739ae039.ADDED = "added";
$ef07192511817417$export$2e2bcd8739ae039.QUEUED = "queued";
// For backwards compatibility. Now, if a file is accepted, it's either queued
// or uploading.
$ef07192511817417$export$2e2bcd8739ae039.ACCEPTED = $ef07192511817417$export$2e2bcd8739ae039.QUEUED;
$ef07192511817417$export$2e2bcd8739ae039.UPLOADING = "uploading";
$ef07192511817417$export$2e2bcd8739ae039.PROCESSING = $ef07192511817417$export$2e2bcd8739ae039.UPLOADING; // alias
$ef07192511817417$export$2e2bcd8739ae039.CANCELED = "canceled";
$ef07192511817417$export$2e2bcd8739ae039.ERROR = "error";
$ef07192511817417$export$2e2bcd8739ae039.SUCCESS = "success";
/*

 Bugfix for iOS 6 and 7
 Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
 based on the work of https://github.com/stomita/ios-imagefile-megapixel

 */ // Detecting vertical squash in loaded image.
// Fixes a bug which squash image vertically while drawing into canvas for some images.
// This is a bug in iOS6 devices. This function from https://github.com/stomita/ios-imagefile-megapixel
let $ef07192511817417$var$$3ed269f2f0fb224b$var$detectVerticalSquash = function(img) {
    let iw = img.naturalWidth;
    let ih = img.naturalHeight;
    let canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = ih;
    let ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    let { data: data } = ctx.getImageData(1, 0, 1, ih);
    // search image edge pixel position in case it is squashed vertically.
    let sy = 0;
    let ey = ih;
    let py = ih;
    while(py > sy){
        let alpha = data[(py - 1) * 4 + 3];
        if (alpha === 0) ey = py;
        else sy = py;
        py = ey + sy >> 1;
    }
    let ratio = py / ih;
    if (ratio === 0) return 1;
    else return ratio;
};
// A replacement for context.drawImage
// (args are for source and destination).
var $ef07192511817417$var$$3ed269f2f0fb224b$var$drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
    let vertSquashRatio = $ef07192511817417$var$$3ed269f2f0fb224b$var$detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
};
// Based on MinifyJpeg
// Source: http://www.perry.cz/files/ExifRestorer.js
// http://elicon.blog57.fc2.com/blog-entry-206.html
class $ef07192511817417$var$$3ed269f2f0fb224b$var$ExifRestore {
    static initClass() {
        this.KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    }
    static encode64(input) {
        let output = "";
        let chr1 = undefined;
        let chr2 = undefined;
        let chr3 = "";
        let enc1 = undefined;
        let enc2 = undefined;
        let enc3 = undefined;
        let enc4 = "";
        let i = 0;
        while(true){
            chr1 = input[i++];
            chr2 = input[i++];
            chr3 = input[i++];
            enc1 = chr1 >> 2;
            enc2 = (chr1 & 3) << 4 | chr2 >> 4;
            enc3 = (chr2 & 15) << 2 | chr3 >> 6;
            enc4 = chr3 & 63;
            if (isNaN(chr2)) enc3 = enc4 = 64;
            else if (isNaN(chr3)) enc4 = 64;
            output = output + this.KEY_STR.charAt(enc1) + this.KEY_STR.charAt(enc2) + this.KEY_STR.charAt(enc3) + this.KEY_STR.charAt(enc4);
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
            if (!(i < input.length)) break;
        }
        return output;
    }
    static restore(origFileBase64, resizedFileBase64) {
        if (!origFileBase64.match("data:image/jpeg;base64,")) return resizedFileBase64;
        let rawImage = this.decode64(origFileBase64.replace("data:image/jpeg;base64,", ""));
        let segments = this.slice2Segments(rawImage);
        let image = this.exifManipulation(resizedFileBase64, segments);
        return `data:image/jpeg;base64,${this.encode64(image)}`;
    }
    static exifManipulation(resizedFileBase64, segments) {
        let exifArray = this.getExifArray(segments);
        let newImageArray = this.insertExif(resizedFileBase64, exifArray);
        let aBuffer = new Uint8Array(newImageArray);
        return aBuffer;
    }
    static getExifArray(segments) {
        let seg = undefined;
        let x = 0;
        while(x < segments.length){
            seg = segments[x];
            if (seg[0] === 255 & seg[1] === 225) return seg;
            x++;
        }
        return [];
    }
    static insertExif(resizedFileBase64, exifArray) {
        let imageData = resizedFileBase64.replace("data:image/jpeg;base64,", "");
        let buf = this.decode64(imageData);
        let separatePoint = buf.indexOf(255, 3);
        let mae = buf.slice(0, separatePoint);
        let ato = buf.slice(separatePoint);
        let array = mae;
        array = array.concat(exifArray);
        array = array.concat(ato);
        return array;
    }
    static slice2Segments(rawImageArray) {
        let head = 0;
        let segments = [];
        while(true){
            var length;
            if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) break;
            if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) head += 2;
            else {
                length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3];
                let endPoint = head + length + 2;
                let seg = rawImageArray.slice(head, endPoint);
                segments.push(seg);
                head = endPoint;
            }
            if (head > rawImageArray.length) break;
        }
        return segments;
    }
    static decode64(input) {
        let output = "";
        let chr1 = undefined;
        let chr2 = undefined;
        let chr3 = "";
        let enc1 = undefined;
        let enc2 = undefined;
        let enc3 = undefined;
        let enc4 = "";
        let i = 0;
        let buf = [];
        // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
        let base64test = /[^A-Za-z0-9\+\/\=]/g;
        if (base64test.exec(input)) console.warn("There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding.");
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while(true){
            enc1 = this.KEY_STR.indexOf(input.charAt(i++));
            enc2 = this.KEY_STR.indexOf(input.charAt(i++));
            enc3 = this.KEY_STR.indexOf(input.charAt(i++));
            enc4 = this.KEY_STR.indexOf(input.charAt(i++));
            chr1 = enc1 << 2 | enc2 >> 4;
            chr2 = (enc2 & 15) << 4 | enc3 >> 2;
            chr3 = (enc3 & 3) << 6 | enc4;
            buf.push(chr1);
            if (enc3 !== 64) buf.push(chr2);
            if (enc4 !== 64) buf.push(chr3);
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
            if (!(i < input.length)) break;
        }
        return buf;
    }
}
$ef07192511817417$var$$3ed269f2f0fb224b$var$ExifRestore.initClass();
/*
 * contentloaded.js
 *
 * Author: Diego Perini (diego.perini at gmail.com)
 * Summary: cross-browser wrapper for DOMContentLoaded
 * Updated: 20101020
 * License: MIT
 * Version: 1.2
 *
 * URL:
 * http://javascript.nwbox.com/ContentLoaded/
 * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
 */ // @win window reference
// @fn function reference
let $ef07192511817417$var$$3ed269f2f0fb224b$var$contentLoaded = function(win, fn) {
    let done = false;
    let top = true;
    let doc = win.document;
    let root = doc.documentElement;
    let add = doc.addEventListener ? "addEventListener" : "attachEvent";
    let rem = doc.addEventListener ? "removeEventListener" : "detachEvent";
    let pre = doc.addEventListener ? "" : "on";
    var init = function(e) {
        if (e.type === "readystatechange" && doc.readyState !== "complete") return;
        (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
        if (!done && (done = true)) return fn.call(win, e.type || e);
    };
    var poll = function() {
        try {
            root.doScroll("left");
        } catch (e) {
            setTimeout(poll, 50);
            return;
        }
        return init("poll");
    };
    if (doc.readyState !== "complete") {
        if (doc.createEventObject && root.doScroll) {
            try {
                top = !win.frameElement;
            } catch (error) {}
            if (top) poll();
        }
        doc[add](pre + "DOMContentLoaded", init, false);
        doc[add](pre + "readystatechange", init, false);
        return win[add](pre + "load", init, false);
    }
};
function $ef07192511817417$var$$3ed269f2f0fb224b$var$__guard__(value, transform) {
    return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}
function $ef07192511817417$var$$3ed269f2f0fb224b$var$__guardMethod__(obj, methodName, transform) {
    if (typeof obj !== "undefined" && obj !== null && typeof obj[methodName] === "function") return transform(obj, methodName);
    else return undefined;
}


const $b00299261358dd80$export$d3cd5a45b9e13a7 = (containerSelector, isSellingListingForm, dropzoneObjects, recDropzoneFiles, recDropzoneFilesCompressed, recDropzonePreloaded)=>{
    const container = document.querySelector(containerSelector);
    let recDropzoneFileCount = 0;
    /* Image Compression Logic */ const bytesToMegaBytes = (bytes)=>bytes / 1024 ** 2;
    const blobRead = (blob)=>new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function() {
                if (typeof reader.result === 'string') resolve(reader.result);
                else resolve(undefined);
            };
            reader.onerror = function(error) {
                reject(error);
            };
        });
    const convertObjectToBytes = async (obj)=>{
        const blob = await fetch(obj).then((r)=>r.blob());
        return await blobRead(blob);
    };
    const imageCompress = async (fileKey, fileOrig, fileData, q, w, h)=>{
        // log all the arguments on separate lines
        let outputQuality = (100 - q) / 100;
        let outputWidth = w * outputQuality;
        let outputHeight = h * outputQuality;
        new (0, (/*@__PURE__*/$parcel$interopDefault($2ee8315a27b33153$exports)))(fileData, {
            quality: outputQuality,
            width: outputWidth,
            height: outputHeight,
            async success (result) {
                let fileNew = fileOrig;
                var url = URL.createObjectURL(result);
                fileNew.dataURL = await convertObjectToBytes(url);
                recDropzoneFilesCompressed[fileKey] = fileNew;
                if (fileOrig.previewElement) fileOrig.previewElement.style.setProperty("background-image", fileKey.indexOf("listing-image") < 0 ? `url(${recDropzoneFilesCompressed[fileKey].dataURL})` : `url(${recDropzonePreloaded[fileOrig.name]})`);
            },
            async error (err) {
                console.error("imageCompress: ", err);
                //TODO handle compression error
                if (fileOrig.previewElement) fileOrig.previewElement.style.setProperty("background-image", fileKey.indexOf("listing-image") < 0 ? `url(${recDropzoneFilesCompressed[fileKey].dataURL})` : `url(${recDropzonePreloaded[fileOrig.name]})`);
            }
        });
    };
    const convertHEIC = async (file)=>{
        if (!file.dataURL) throw new Error("File dataURL is undefined");
        try {
            const currentFile = await fetch(file.dataURL);
            const currentBlob = await currentFile.blob();
            return await heic2any({
                blob: currentBlob,
                toType: "image/jpeg",
                quality: 0.8
            });
        } catch (error) {
            (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-heic-error");
        }
    };
    const dropzones = document.querySelectorAll(".rec-image-dropzone");
    // The variable below is the max number of images to load into the dropzone at one time. Listings can have up to five but this value determines how many can be loaded at once. There are issues with loading multiple HEIC images so this is set to 1. Users will have to select images one at a time. Issues revolve around the compression/conversion of multiple images and the async operations of Dropzone.
    const maxImagesLoad = 1;
    if (dropzones && dropzones.length > 0) for(var dzi = 0; dzi < dropzones.length; dzi++){
        var myDropzone = new (0, $ef07192511817417$export$2e2bcd8739ae039)(dropzones[dzi], {
            url: "/upload",
            parallelUploads: 1,
            autoProcessQueue: false,
            maxFilesize: 10,
            paramName: dropzones[dzi].attributes.getNamedItem("data-name")?.value,
            maxThumbnailFilesize: 10,
            thumbnailMethod: "contain",
            maxFiles: maxImagesLoad,
            dictRemoveFile: "&times;",
            addRemoveLinks: true,
            acceptedFiles: ".jpeg,.jpg,.png,.heic",
            hiddenInputContainer: container || undefined,
            init: function() {
                this.on("addedfile", function(file) {
                    recDropzoneFileCount++;
                });
                this.on("thumbnail", async (file)=>{
                    const fileKey = file.name.indexOf("listing_image") < 0 ? file.upload?.uuid || `${file.name}-${Date.now()}` : (0, $0aaed1fbbefba3fa$export$7272b5ee9aadcdd9)(file.name);
                    file.previewElement.setAttribute("data-image-key", fileKey);
                    let fileToCompress = file;
                    //heic image?
                    try {
                        if (fileKey.indexOf("listing-image") < 0 && !(fileKey in recDropzoneFilesCompressed) && file?.type == "image/heic") {
                            const heicBlob = await convertHEIC(file);
                            if (heicBlob !== undefined) {
                                // @ts-expect-error: this seems to work dispite the type mistmatch. Original implementation was JS.
                                fileToCompress = new File([
                                    heicBlob
                                ], file.name, {
                                    type: "image/jpeg"
                                });
                                console.log("fileToCompress: ", fileToCompress);
                                blobRead(fileToCompress).then((dataURL)=>{
                                    if (dataURL !== undefined) {
                                        file.dataURL = dataURL;
                                        const imgElement = file.previewElement.querySelector(".dz-image-preview img");
                                        if (imgElement !== null) imgElement.src = dataURL;
                                    } else console.error("HEIC dataURL is undefined");
                                });
                            } else this.removeFile(file);
                        }
                    } catch (err) {
                        console.error("HEIC error: ", err);
                        (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-heic-error");
                    }
                    //init the file in the main array
                    recDropzoneFiles[fileKey] = file;
                    //compress image?
                    if (fileKey.indexOf("listing-image") < 0 && bytesToMegaBytes(file.size) >= 0.5) {
                        recDropzoneFilesCompressed[fileKey] = file;
                        await imageCompress(fileKey, file, fileToCompress, 45, 900, 1200);
                    } else if (file.previewElement) file.previewElement.style.setProperty("background-image", fileKey.indexOf("listing-image") < 0 ? `url(${recDropzoneFiles[fileKey].dataURL})` : `url(${recDropzonePreloaded[file.name]})`);
                    // Apply alt tag to image
                    if (isSellingListingForm) {
                        const dzParent = file.previewElement.closest(".rec-image-dropzone");
                        const previewImg = file.previewElement.querySelector("img");
                        const removeLink = dzParent?.querySelector("a.dz-remove");
                        const productTitle = document.getElementById("rec-product-title");
                        if (previewImg) {
                            if (productTitle) previewImg.setAttribute("alt", `${productTitle.value} - ${dzParent?.getAttribute("data-rec-text") || ""}`);
                            else previewImg.setAttribute("alt", dzParent?.getAttribute("data-rec-text") || "");
                        }
                        // Apply aria label to remove image
                        if (removeLink) removeLink.setAttribute("aria-label", `Remove ${dzParent?.getAttribute("data-rec-text")?.toLowerCase() || ""} image`);
                    }
                    // this removes duplication of files when using image QR upload
                    if (recDropzoneFileCount) for(let i = 1; i <= recDropzoneFileCount; i++){
                        const dzKey = `listing-image${i}`;
                        if (recDropzoneFiles[dzKey]) {
                            if (recDropzoneFiles[dzKey]["name"] === file.name) this.files.push(recDropzoneFiles[dzKey]);
                        }
                    }
                    if (this.files.length > 1) {
                        let filesToMove = this.files.length - 1;
                        for(let fi = 0; fi <= filesToMove; fi++){
                            const moveFile = this.files[fi];
                            if (moveFile) {
                                await this.removeFile(this.files[fi]);
                                for (let thisDZ of dropzoneObjects)if (thisDZ.files.length == 0 && thisDZ.element != this.element) {
                                    await thisDZ.displayExistingFile(moveFile, moveFile.dataURL || "", undefined, undefined, false);
                                    await thisDZ.files.push(moveFile);
                                    break;
                                }
                            }
                        }
                    }
                });
                this.on("removedfile", function(file) {
                    const fileKey = file.name.indexOf("listing_image") < 0 ? file.upload?.uuid || `${file.name}-${Date.now()}` : (0, $0aaed1fbbefba3fa$export$7272b5ee9aadcdd9)(file.name);
                    delete recDropzoneFiles[fileKey];
                    delete recDropzonePreloaded[fileKey];
                    recDropzoneFileCount--;
                    file.previewElement.remove();
                });
                this.on("maxfilesexceeded", (file)=>{
                    this.removeFile(file);
                    (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-max-images");
                });
                dropzoneObjects.push(this);
                //apply any currently saved images
                if (typeof currentListingImages !== "undefined" && currentListingImages.length > 0) {
                    if (currentListingImages.length > dzi) {
                        const preloadedImageKey = "listing_image" + (dzi + 1);
                        recDropzonePreloaded[preloadedImageKey] = currentListingImages[dzi];
                        this.displayExistingFile({
                            name: preloadedImageKey,
                            size: 12345
                        }, currentListingImages[dzi], undefined, undefined, false);
                    }
                }
            }
        });
        dropzones[dzi].classList.add("dropzone");
    }
};



// Country list source: https://www.dhl.com/en/country_profile.html#.XwODEJNKjOQ 
// Country abbreviation source: https://planetarynames.wr.usgs.gov/Abbreviations
// Postal code: https://gist.githubusercontent.com/jamesbar2/1c677c22df8f21e869cca7e439fc3f5b/raw/21662445653ac861f8ab81caa8cfaee3185aed15/postal-codes.json
// Postal code: https://en.wikipedia.org/wiki/List_of_postal_codes
// Country/territory items with no postal code regexes or ranges either do not require postal codes
// or there may not be enough information for that country/territory
const $049226e24de48b73$var$COUNTRY_ADDRESS_POSTALS = [
    {
        abbrev: 'AF',
        name: 'Afghanistan',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'AL',
        name: 'Albania',
        postal: "(120|122)[0-9]{2}"
    },
    {
        abbrev: 'DZ',
        name: 'Algeria',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'AS',
        name: 'American Samoa',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'AD',
        name: 'Andorra',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'AO',
        name: 'Angola'
    },
    {
        abbrev: 'AI',
        name: 'Anguilla',
        postal: "AI-2640"
    },
    {
        abbrev: 'AG',
        name: 'Antigua and Barbuda'
    },
    {
        abbrev: 'AR',
        name: 'Argentina',
        postal: "[A-Z]{1}[0-9]{4}[A-Z]{3}"
    },
    {
        abbrev: 'AM',
        name: 'Armenia',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'AW',
        name: 'Aruba'
    },
    {
        abbrev: 'AU',
        name: 'Australia',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'AT',
        name: 'Austria',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'AZ',
        name: 'Azerbaijan',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'BS',
        name: 'Bahamas'
    },
    {
        abbrev: 'BH',
        name: 'Bahrain'
    },
    {
        abbrev: 'BD',
        name: 'Bangladesh',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'BB',
        name: 'Barbados',
        postal: "BB[0-9]{5}"
    },
    {
        abbrev: 'BY',
        name: 'Belarus',
        postal: "[0-9]{6}"
    },
    {
        abbrev: 'BE',
        name: 'Belgium',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'BZ',
        name: 'Belize'
    },
    {
        abbrev: 'BJ',
        name: 'Benin'
    },
    {
        abbrev: 'BM',
        name: 'Bermuda',
        postal: "[A-Z]{2}[0-9]{2}"
    },
    {
        abbrev: 'BT',
        name: 'Bhutan',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'BO',
        name: 'Bolivia'
    },
    {
        abbrev: 'BQ',
        name: 'Bonaire'
    },
    {
        abbrev: 'BA',
        name: 'Bosnia and Herzegovina',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'BW',
        name: 'Botswana'
    },
    {
        abbrev: 'BR',
        name: 'Brazil',
        postal: "[0-9]{5}-[0-9]{3}"
    },
    {
        abbrev: 'BN',
        name: 'Brunei',
        postal: "[A-Z]{2}[0-9]{4}"
    },
    {
        abbrev: 'BG',
        name: 'Bulgaria',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'BF',
        name: 'Burkina Faso'
    },
    {
        abbrev: 'BI',
        name: 'Burundi'
    },
    {
        abbrev: 'KH',
        name: 'Cambodia',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'CM',
        name: 'Cameroon'
    },
    {
        abbrev: 'CA',
        name: 'Canada',
        postal: "[A-Z][0-9][A-Z] ?[0-9][A-Z][0-9]"
    },
    {
        abbrev: 'CI',
        name: 'Canary Islands',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'CV',
        name: 'Cape Verde',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'KY',
        name: 'Cayman Islands',
        postal: "[A-Z]{2}[0-9]-[0-9]{4}"
    },
    {
        abbrev: 'CF',
        name: 'Central African Republic'
    },
    {
        abbrev: 'TD',
        name: 'Chad'
    },
    {
        abbrev: 'CI',
        name: 'Channel Islands',
        postal: "[A-Z]{2}[0-9]{2}"
    },
    {
        abbrev: 'CL',
        name: 'Chile',
        postal: "[0-9]{7}"
    },
    {
        abbrev: 'CN',
        name: "China, People's Republic",
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'CO',
        name: 'Colombia',
        postal: "[0-9]{6}"
    },
    {
        abbrev: 'KM',
        name: 'Comoros'
    },
    {
        abbrev: 'CG',
        name: 'Congo'
    },
    {
        abbrev: 'CD',
        name: 'Congo, The Democratic Republic of'
    },
    {
        abbrev: 'CK',
        name: 'Cook Islands'
    },
    {
        abbrev: 'CR',
        name: 'Costa Rica',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'CI',
        name: "C\xf4te d'Ivoire"
    },
    {
        abbrev: 'HR',
        name: 'Croatia',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'CU',
        name: 'Cuba',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'CW',
        name: 'Curacao'
    },
    {
        abbrev: 'CY',
        name: 'Cyprus',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'CZ',
        name: 'Czech Republic',
        postal: "[0-9]{3} [0-9]{2}"
    },
    {
        abbrev: 'DK',
        name: 'Denmark',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'DJ',
        name: 'Djibouti'
    },
    {
        abbrev: 'DM',
        name: 'Dominica'
    },
    {
        abbrev: 'DO',
        name: 'Dominican Republic',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'TL',
        name: 'East Timor'
    },
    {
        abbrev: 'EC',
        name: 'Ecuador',
        postal: "[0-9]{6}"
    },
    {
        abbrev: 'EG',
        name: 'Egypt',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'SV',
        name: 'El Salvador',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'ER',
        name: 'Eritrea'
    },
    {
        abbrev: 'EE',
        name: 'Estonia',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'ET',
        name: 'Ethiopia',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'FK',
        name: 'Falkland Islands',
        postal: "FIQQ 1ZZ"
    },
    {
        abbrev: 'FO',
        name: 'Faroe Islands',
        postal: "[0-9]{3}"
    },
    {
        abbrev: 'FJ',
        name: 'Fiji'
    },
    {
        abbrev: 'FI',
        name: 'Finland',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'FR',
        name: 'France',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'PF',
        name: 'French Polynesia',
        postal: "987[0-9]{2}",
        range: [
            '98700',
            '98790'
        ]
    },
    {
        abbrev: 'GA',
        name: 'Gabon'
    },
    {
        abbrev: 'GM',
        name: 'Gambia'
    },
    {
        abbrev: 'GE',
        name: 'Georgia'
    },
    {
        abbrev: 'DE',
        name: 'Germany',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'GH',
        name: 'Ghana'
    },
    {
        abbrev: 'GI',
        name: 'Gibraltar',
        postal: "GX11 1AA"
    },
    {
        abbrev: 'GR',
        name: 'Greece',
        postal: "[0-9]{3} [0-9]{2}"
    },
    {
        abbrev: 'GL',
        name: 'Greenland',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'GD',
        name: 'Grenada'
    },
    {
        abbrev: 'GP',
        name: 'Guadeloupe',
        postal: "971[0-9]{2}",
        range: [
            '97100',
            '97190'
        ]
    },
    {
        abbrev: 'GU',
        name: 'Guam',
        // US postal code
        // https://stackoverflow.com/questions/2577236/regex-for-zip-code
        postal: "^\d{5}(?:[-\s]\d{4})?$",
        range: [
            '96910',
            '96932'
        ]
    },
    {
        abbrev: 'GT',
        name: 'Guatemala',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'GG',
        name: 'Guernsey',
        // UK postal code
        // https://stackoverflow.com/questions/164979/regex-for-matching-uk-postcodes
        postal: "([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})"
    },
    {
        abbrev: 'GW',
        name: 'Guinea-Bissau',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'GQ',
        name: 'Guinea-Equatorial'
    },
    {
        abbrev: 'GN',
        name: 'Guinea Republic',
        postal: "[0-9]{3}"
    },
    {
        abbrev: 'GY',
        name: 'Guyana (British)'
    },
    {
        abbrev: 'GF',
        name: 'Guyana (French)',
        postal: "973[0-9]{2}",
        range: [
            '97300',
            '97390'
        ]
    },
    {
        abbrev: 'HT',
        name: 'Haiti',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'HN',
        name: 'Honduras',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'HK',
        name: 'Hong Kong'
    },
    {
        abbrev: 'HU',
        name: 'Hungary',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'IS',
        name: 'Iceland',
        postal: "[0-9]{3}"
    },
    {
        abbrev: 'IN',
        name: 'India',
        // https://stackoverflow.com/questions/33865525/indian-pincode-validation-regex-only-six-digits-shouldnt-start-with-0
        postal: "^[1-9][0-9]{5}$"
    },
    {
        abbrev: 'ID',
        name: 'Indonesia',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'IR',
        name: 'Iran',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'IQ',
        name: 'Iraq',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'IE',
        name: 'Ireland, Republic of',
        // https://stackoverflow.com/questions/33391412/validation-for-irish-eircode
        postal: "(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$"
    },
    {
        abbrev: 'FK',
        name: 'Islas Malvinas',
        postal: "FIQQ 1ZZ"
    },
    {
        abbrev: 'IL',
        name: 'Israel',
        postal: "[0-9]{5}|[0-9]{7}"
    },
    {
        abbrev: 'IT',
        name: 'Italy',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'CI',
        name: 'Ivory Coast'
    },
    {
        abbrev: 'JM',
        name: 'Jamaica'
    },
    {
        abbrev: 'JP',
        name: 'Japan',
        postal: "[0-9]{3}-[0-9]{4}"
    },
    {
        abbrev: 'JE',
        name: 'Jersey',
        postal: "([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})"
    },
    {
        abbrev: 'JO',
        name: 'Jordan',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'KZ',
        name: 'Kazakhstan',
        postal: "[0-9]{6}"
    },
    {
        abbrev: 'KE',
        name: 'Kenya',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'KI',
        name: 'Kiribati'
    },
    {
        abbrev: 'KR',
        name: 'Korea, Republic of',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'KP',
        name: 'Korea, The D.P.R of'
    },
    {
        abbrev: 'XK',
        name: 'Kosovo',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'KW',
        name: 'Kuwait',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'KG',
        name: 'Kyrgyzstan',
        postal: "[0-9]{6}"
    },
    {
        abbrev: 'LA',
        name: 'Laos',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'LV',
        name: 'Latvia',
        postal: "LV-[0-9]{4}"
    },
    {
        abbrev: 'LB',
        name: 'Lebanon',
        postal: "[0-9]{4} [0-9]{4}"
    },
    {
        abbrev: 'LS',
        name: 'Lesotho',
        postal: "[0-9]{3}"
    },
    {
        abbrev: 'LR',
        name: 'Liberia',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'LY',
        name: 'Libya'
    },
    {
        abbrev: 'LI',
        name: 'Liechtenstein',
        postal: "[0-9]{4}",
        range: [
            '9485',
            '9498'
        ]
    },
    {
        abbrev: 'LT',
        name: 'Lithuania',
        postal: "LT-[0-9]{5}"
    },
    {
        abbrev: 'LU',
        name: 'Luxembourg',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'MO',
        name: 'Macau'
    },
    {
        abbrev: 'MK',
        name: 'Macedonia, Republic of',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'MG',
        name: 'Madagascar',
        postal: "[0-9]{3}"
    },
    {
        abbrev: 'MW',
        name: 'Malawi'
    },
    {
        abbrev: 'MY',
        name: 'Malaysia',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'MV',
        name: 'Maldives',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'ML',
        name: 'Mali'
    },
    {
        abbrev: 'MT',
        name: 'Malta',
        postal: "[A-Z]{3} [0-9]{4}"
    },
    {
        abbrev: 'MH',
        name: 'Marshall Islands',
        postal: "^\d{5}(?:[-\s]\d{4})?$",
        range: [
            '96960',
            '96970'
        ]
    },
    {
        abbrev: 'MQ',
        name: 'Martinique',
        postal: "972[0-9]{2}",
        range: [
            '97200',
            '97290'
        ]
    },
    {
        abbrev: 'MR',
        name: 'Mauritania'
    },
    {
        abbrev: 'MU',
        name: 'Mauritius',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'YT',
        name: 'Mayotte',
        postal: "976[0-9]{2}",
        range: [
            '97600',
            '97690'
        ]
    },
    {
        abbrev: 'MX',
        name: 'Mexico',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'MD',
        name: 'Moldova, Republic of',
        postal: "MD-?[0-9]{4}"
    },
    {
        abbrev: 'MC',
        name: 'Monaco',
        postal: "980[0-9]{2}"
    },
    {
        abbrev: 'MN',
        name: 'Mongolia',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'ME',
        name: 'Montenegro',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'MS',
        name: 'Montserrat',
        postal: "MSR [0-9]{4}",
        range: [
            'MSR 1110',
            'MSR 1350'
        ]
    },
    {
        abbrev: 'MA',
        name: 'Morocco',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'MZ',
        name: 'Mozambique',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'MM',
        name: 'Myanmar',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'NA',
        name: 'Namibia'
    },
    {
        abbrev: 'NR',
        name: 'Nauru'
    },
    {
        abbrev: 'NP',
        name: 'Nepal',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'NL',
        name: 'Netherlands',
        postal: "^(?:NL-)?(\d{4})\s*([A-Z]{2})$"
    },
    {
        abbrev: 'NC',
        name: 'New Caledonia',
        postal: "988[0-9]{2}",
        range: [
            '96950',
            '96952'
        ]
    },
    {
        abbrev: 'NZ',
        name: 'New Zealand',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'NI',
        name: 'Nicaragua'
    },
    {
        abbrev: 'NE',
        name: 'Niger',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'NG',
        name: 'Nigeria',
        postal: "[0-9]{6}"
    },
    {
        abbrev: 'NU',
        name: 'Niue'
    },
    {
        abbrev: 'MP',
        name: 'Northern Mariana Islands',
        postal: "^\d{5}(?:[-\s]\d{4})?$"
    },
    {
        abbrev: 'NO',
        name: 'Norway',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'OM',
        name: 'Oman',
        postal: "[0-9]{3}"
    },
    {
        abbrev: 'PK',
        name: 'Pakistan',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'PW',
        name: 'Palau',
        postal: "^\d{5}(?:[-\s]\d{4})?$"
    },
    {
        abbrev: 'PA',
        name: 'Panama',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'PG',
        name: 'Papua New Guinea',
        postal: "[0-9]{3}"
    },
    {
        abbrev: 'PY',
        name: 'Paraguay',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'PE',
        name: 'Peru',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'PH',
        name: 'Philippines',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'PL',
        name: 'Poland',
        postal: "[0-9]{2}-[0-9]{3}"
    },
    {
        abbrev: 'PT',
        name: 'Portugal',
        postal: "[0-9]{4}-[0-9]{3}"
    },
    {
        abbrev: 'PR',
        name: 'Puerto Rico',
        postal: "^\d{5}(?:[-\s]\d{4})?$"
    },
    {
        abbrev: 'QA',
        name: 'Qatar'
    },
    {
        abbrev: 'RE',
        name: "R\xe9union",
        postal: "974[0-9]{2}",
        range: [
            '97400',
            '97490'
        ]
    },
    {
        abbrev: 'RO',
        name: 'Romania',
        postal: "[0-9]{6}"
    },
    {
        abbrev: 'RU',
        name: 'Russian Federation',
        postal: "[0-9]{6}"
    },
    {
        abbrev: 'RW',
        name: 'Rwanda'
    },
    {
        abbrev: 'MP',
        name: 'Saipan',
        postal: "96950"
    },
    {
        abbrev: 'WS',
        name: 'Samoa',
        postal: "WS[0-9]{4}"
    },
    {
        abbrev: 'ST',
        name: 'Sao Tome and Principe'
    },
    {
        abbrev: 'SA',
        name: 'Saudi Arabia',
        postal: "[0-9]{5}(-[0-9]{4})?"
    },
    {
        abbrev: 'SN',
        name: 'Senegal',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'RS',
        name: 'Serbia',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'SC',
        name: 'Seychelles'
    },
    {
        abbrev: 'SL',
        name: 'Sierra Leone'
    },
    {
        abbrev: 'SG',
        name: 'Singapore',
        postal: "[0-9]{6}"
    },
    {
        abbrev: 'SK',
        name: 'Slovakia',
        postal: "[0-9]{3} [0-9]{2}"
    },
    {
        abbrev: 'SI',
        name: 'Slovenia',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'SB',
        name: 'Solomon Islands'
    },
    {
        abbrev: 'SO',
        name: 'Somalia',
        postal: "[A-Z]{2} [0-9]{5}"
    },
    {
        abbrev: 'ZA',
        name: 'South Africa',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'SS',
        name: 'South Sudan'
    },
    {
        abbrev: 'ES',
        name: 'Spain',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'LK',
        name: 'Sri Lanka',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'BL',
        name: "St. Barth\xe9lemy",
        postal: "[0-9]{5}",
        range: [
            '97100',
            '97190'
        ]
    },
    {
        abbrev: 'VI',
        name: 'St. Croix',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'SE',
        name: 'St. Eustatius'
    },
    {
        abbrev: 'SH',
        name: 'St. Helena',
        postal: "STHL 1ZZ"
    },
    {
        abbrev: 'AG',
        name: 'St. John',
        postal: "^\d{5}(?:[-\s]\d{4})?$"
    },
    {
        abbrev: 'KN',
        name: 'St. Kitts and Nevis',
        postal: "[A-Z]{2}[0-9]{4}"
    },
    {
        abbrev: 'LC',
        name: 'St. Lucia',
        postal: "[A-Z]{2}[0-9]{2} [0-9]{3}"
    },
    {
        abbrev: 'SX',
        name: 'St. Maarten'
    },
    {
        abbrev: 'VI',
        name: 'St. Thomas'
    },
    {
        abbrev: 'VC',
        name: 'St. Vincent and the Grenadines',
        postal: "VC[0-9]{4}"
    },
    {
        abbrev: 'SD',
        name: 'Sudan',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'SR',
        name: 'Suriname'
    },
    {
        abbrev: 'SZ',
        name: 'Swaziland',
        postal: "[A-Z]{1}[0-9]{3}"
    },
    {
        abbrev: 'SE',
        name: 'Sweden',
        postal: "[0-9]{3} [0-9]{2}"
    },
    {
        abbrev: 'CH',
        name: 'Switzerland',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'SY',
        name: 'Syria'
    },
    {
        abbrev: 'PF',
        name: 'Tahiti',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'TW',
        name: 'Taiwan',
        postal: "[0-9]{3}(-[0-9]{2})?"
    },
    {
        abbrev: 'TZ',
        name: 'Tanzania',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'TH',
        name: 'Thailand',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'TG',
        name: 'Togo'
    },
    {
        abbrev: 'TO',
        name: 'Tonga'
    },
    {
        abbrev: 'VG',
        name: 'Tortola',
        postal: "VG[0-9]{4}"
    },
    {
        abbrev: 'TT',
        name: 'Trinidad and Tobago',
        postal: "[0-9]{6}"
    },
    {
        abbrev: 'TN',
        name: 'Tunisia',
        postal: "[0-9]{4}"
    },
    {
        abbrev: 'TR',
        name: 'Turkey',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'TM',
        name: 'Turkmenistan',
        postal: "[0-9]{6}"
    },
    {
        abbrev: 'TC',
        name: 'Turks and Caicos Islands',
        postal: "TKCA 1ZZ"
    },
    {
        abbrev: 'TV',
        name: 'Tuvalu'
    },
    {
        abbrev: 'UG',
        name: 'Uganda'
    },
    {
        abbrev: 'UA',
        name: 'Ukraine',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'AE',
        name: 'United Arab Emirates'
    },
    {
        abbrev: 'GB',
        name: 'United Kingdom',
        postal: "^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$"
    },
    {
        abbrev: 'US',
        name: 'United States of America',
        postal: "^\d{5}(?:[-\s]\d{4})?$"
    },
    {
        abbrev: 'UY',
        name: 'Uruguay',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'UZ',
        name: 'Uzbekistan',
        postal: "[0-9]{6}"
    },
    {
        abbrev: 'VU',
        name: 'Vanuatu'
    },
    {
        abbrev: 'VE',
        name: 'Venezuela',
        postal: "[0-9]{4}(-[A-Z]{1})?"
    },
    {
        abbrev: 'VN',
        name: 'Vietnam',
        postal: "[0-9]{6}"
    },
    {
        abbrev: 'VG',
        name: 'Virgin Islands (British)',
        postal: "VG[0-9]{4}"
    },
    {
        abbrev: 'VI',
        name: 'Virgin Islands (US)',
        range: [
            '00801',
            '00851'
        ],
        postal: "^\d{5}(?:[-\s]\d{4})?$"
    },
    {
        abbrev: 'YE',
        name: 'Yemen'
    },
    {
        abbrev: 'ZM',
        name: 'Zambia',
        postal: "[0-9]{5}"
    },
    {
        abbrev: 'ZW',
        name: 'Zimbabwe'
    }
];
function $049226e24de48b73$export$3549a5f628bb681(country, postalCode) {
    let postalRegex = $049226e24de48b73$var$COUNTRY_ADDRESS_POSTALS.reduce((previousValue, thisPostal)=>{
        if (thisPostal.name == country && "postal" in thisPostal) return thisPostal.postal ?? "";
        else return previousValue;
    }, "");
    if (postalRegex.length > 0) return new RegExp(postalRegex, 'g').test(postalCode);
    return true;
}



var $d05Lk = parcelRequire("d05Lk");
/**
 * Sanitizes a string by filtering out all HTML tags and potentially harmful content via the imported xss package.
 * @param {string} str - The string to be sanitized.
 * @returns {string} The sanitized string.
 */ const $36de584fe04094bb$var$sanitizeString = (str)=>{
    const xssOptions = {
        whiteList: {},
        stripIgnoreTag: true,
        stripIgnoreTagBody: [
            "script"
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($d05Lk)))(str, xssOptions);
};
const $36de584fe04094bb$export$5b1fedd534ce7f2b = (form, classIgnore)=>{
    let allRequirementsMet = true, applyError = false, firstError = true, applyToast = "toast-input-validation";
    form.querySelectorAll(".rec-input-error").forEach((thisCurrentError)=>{
        thisCurrentError.classList.remove("rec-input-error");
        thisCurrentError.removeAttribute("aria-invalid");
    });
    form.querySelectorAll(".rec-input-wrap-error").forEach((thisCurrentError)=>{
        thisCurrentError.classList.remove("rec-input-wrap-error");
    });
    form.querySelectorAll(".rec-input-group-error").forEach((thisCurrentError)=>{
        thisCurrentError.classList.remove("rec-input-group-error");
    });
    document.querySelectorAll(".rec-slf-listing-error-address").forEach((thisShippingError)=>{
        thisShippingError.classList.add("rec-hidden");
    });
    const formValues = form.tagName == "FORM" ? (0, $0aaed1fbbefba3fa$export$2bccf78e246a5305)(form) : (0, $0aaed1fbbefba3fa$export$f01be45804d2885c)(form);
    /* function to get the input's value for the various types of inputs */ form.querySelectorAll(".rec-required").forEach((element)=>{
        const recquiredField = element;
        let recquiredFieldValue = $36de584fe04094bb$var$sanitizeString(formValues[recquiredField.name]);
        //ignore?
        if (classIgnore && recquiredField.classList.contains(classIgnore)) ;
        else {
            applyError = false;
            const fieldEmpty = recquiredField.type == "checkbox" && recquiredField.classList.contains("check-required") ? !recquiredField.checked : recquiredFieldValue.length == 0 || recquiredFieldValue.trim() == "---";
            if (fieldEmpty) {
                applyError = true;
                //special case for listing address
                if (recquiredField.id.indexOf("shipping-address") >= 0) document.querySelectorAll(".rec-slf-listing-error-address").forEach((thisShippingError)=>{
                    thisShippingError.classList.remove("rec-hidden");
                });
                else if (recquiredField.id == "rec-listing-rating-rating") {
                    const ratingContainer = document.getElementById("rec-listing-rating-container");
                    if (ratingContainer) ratingContainer.classList.add("rec-input-group-error");
                    else console.error("Element with ID 'rec-listing-rating-container' not found.");
                }
            } else //special case for zip code
            if (recquiredField.classList.contains("rec-required-zip")) {
                //special case for postal code
                let selectedCountryElement = form.querySelector(".rec-shipping-address-country");
                let selectedCountry = selectedCountryElement ? selectedCountryElement.value : '';
                let selectedPostalCodeElement = form.querySelector(".rec-shipping-address-zip");
                let selectedPostalCode = selectedPostalCodeElement ? selectedPostalCodeElement.value.toUpperCase() : '';
                if (!(0, $049226e24de48b73$export$3549a5f628bb681)(selectedCountry, selectedPostalCode)) {
                    applyError = true;
                    applyToast = "toast-input-validation-zip";
                }
            }
            if (applyError) {
                allRequirementsMet = false;
                recquiredField.setAttribute("aria-invalid", "true");
                if (firstError) firstError = false;
                if (recquiredField.classList.contains("rec-input-group-control")) {
                    const inputGroupElement = recquiredField.closest(".rec-input-group");
                    if (inputGroupElement) inputGroupElement.classList.add("rec-input-group-error");
                }
                recquiredField.classList.add("rec-input-error");
                if (recquiredField.closest(".rec-slf-form-group")) {
                    const formGroupElement = recquiredField.closest(".rec-slf-form-group");
                    if (formGroupElement) formGroupElement.classList.add("rec-input-wrap-error");
                }
            }
        }
    });
    /* Now loop through any special validation fields (e.g. listing attributes) */ form.querySelectorAll("[data-rec-validation]").forEach((element)=>{
        const attributeValidation = element;
        let attributeValidationValue = $36de584fe04094bb$var$sanitizeString(formValues[attributeValidation.name]);
        applyError = false;
        try {
            if (attributeValidationValue.length > 0 && (!classIgnore || !attributeValidation.classList.contains(classIgnore))) {
                // TODO: generate a proper type for validation info. This would have to be reverse-engineered since the original implementation was JS.
                const validationInfo = JSON.parse(attributeValidation.getAttribute("data-rec-validation") || "");
                //special min/max values property for numerics
                if (validationInfo && "validation_min_value" in validationInfo && parseFloat(attributeValidationValue) < validationInfo.validation_min_value) applyError = true;
                if (validationInfo && "validation_max_value" in validationInfo && parseFloat(attributeValidationValue) > validationInfo.validation_max_value) applyError = true;
                //special validation for select_multi and checkbox fields to make sure we have n number options selected
                if (validationInfo && "validation_options_min" in validationInfo && attributeValidationValue.split(",").length < validationInfo.validation_options_min) applyError = true;
                if (validationInfo && "validation_options_max" in validationInfo && attributeValidationValue.split(",").length > validationInfo.validation_options_max) applyError = true;
                if (validationInfo && "validation_custom_type" in validationInfo) switch(validationInfo.validation_custom_type){
                    case "variant_weight":
                        const variantWeightElem = document.getElementById("variant-weight-grams");
                        if (variantWeightElem && variantWeightElem.value.toString().trim().length > 0) {
                            //Total weight in grams for this quantity
                            const listingWeight = parseFloat(variantWeightElem.value) * parseFloat(attributeValidationValue);
                            if (listingWeight > validationInfo.validation_weight_max_grams) applyError = true;
                        }
                        break;
                    case "price":
                        attributeValidationValue = attributeValidationValue.replace(/[$]/g, "");
                        if (isNaN(+attributeValidationValue) || attributeValidationValue === "") applyError = true;
                        else {
                            /* Confirm the value the seller entered meets our pricing criteria that we are getting from the settings file:
                                        - overall min price
                                        - overall max price
                                        - for matched listings, above the minimum percentage of the variant's MSRP
                                        - for matched listings, below the maximum percentage of the variant's MSRP
                                        */ attributeValidationValue = parseFloat(attributeValidationValue).toFixed(2);
                            attributeValidation.value = attributeValidationValue;
                            const variantPriceElem = form.querySelector("rec-variant-price");
                            if (validationInfo.validation_custom_min_price > 0 && attributeValidationValue < validationInfo.validation_custom_min_price) applyError = true;
                            else if (validationInfo.validation_custom_max_price > 0 && attributeValidationValue > validationInfo.validation_custom_max_price) applyError = true;
                            if (variantPriceElem) {
                                const variantPrice = parseFloat(variantPriceElem.value);
                                const minPriceMSRP = variantPrice * (validationInfo.validation_custom_min_msrp_percentage / 100);
                                const maxPriceMSRP = variantPrice * (validationInfo.validation_custom_max_msrp_percentage / 100);
                                if (validationInfo.validation_custom_min_msrp_percentage > 0 && Number(attributeValidationValue) < minPriceMSRP) applyError = true;
                                else if (validationInfo.validation_custom_max_msrp_percentage > 0 && Number(attributeValidationValue) > maxPriceMSRP) applyError = true;
                            }
                        }
                        break;
                    case "regex":
                        const regex = new RegExp(validationInfo.validation_regex);
                        applyError = !regex.test(attributeValidationValue);
                        break;
                }
            }
        } catch (err) {
            console.error("formValidation: ", err);
        }
        if (applyError) {
            allRequirementsMet = false;
            attributeValidation.setAttribute("aria-invalid", "true");
            if (firstError) firstError = false;
            if (attributeValidation.classList.contains("rec-input-group-control")) {
                const inputGroupElement = attributeValidation.closest(".rec-input-group");
                if (inputGroupElement) inputGroupElement.classList.add("rec-input-group-error");
            }
            attributeValidation.classList.add("rec-input-error");
            const formGroupElement = attributeValidation.closest(".rec-slf-form-group");
            if (formGroupElement) formGroupElement.classList.add("rec-input-wrap-error");
        }
    });
    if (!allRequirementsMet) {
        /* Apply focus on the first invalid input field (ADA) */ const inputErrorElements = document.querySelectorAll(".rec-input-error");
        if (inputErrorElements.length > 0) {
            const firstInputErrorElement = inputErrorElements[0];
            firstInputErrorElement.focus();
        }
        (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
        (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)(applyToast);
    }
    return allRequirementsMet;
};



const $47fe95dc40980865$export$2c21c80e7e8fcff = ()=>{
    // Setup functionality for stars interaction
    const listingRatingStars = document.querySelectorAll(".rec-listing-star");
    const listingRating = document.getElementById("rec-listing-rating-container");
    const listingRatingInput = document.getElementById("rec-listing-rating-rating");
    if (listingRating && listingRatingInput) listingRatingStars.forEach((thisRatingStar)=>{
        thisRatingStar.addEventListener("click", (e)=>{
            const target = e.target;
            const thisRating = target.classList.contains("rec-listing-star") ? target : target.closest(".rec-listing-star");
            if (thisRating) {
                const ratingValue = thisRating.getAttribute("data-rating");
                if (ratingValue !== null) {
                    listingRating.setAttribute("data-rating", ratingValue);
                    listingRatingInput.value = ratingValue;
                }
            }
        });
    });
    //submit it
    const buyerRatingExec = async (form)=>{
        try {
            // TODO: reverse-eng this form to generate a better type. This was originally written in JS.
            let formData = (0, $0aaed1fbbefba3fa$export$2bccf78e246a5305)(form);
            //cleanup of rating value
            formData.rate = parseInt(formData.rate);
            let buyerRatingResponse = await fetch(recAppProxyConfig.paths.pathRatingExec.replace("%lid%", formData.listing_id), {
                method: "POST",
                body: JSON.stringify(formData),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const buyerRatingResults = await buyerRatingResponse.json();
            if (!buyerRatingResults.errors) {
                if (recAppProxyConfig.settings.shop?.landing_page_url?.length > 0) document.location = recAppProxyConfig.settings.shop.landing_page_url;
                else {
                    const buyerRatingEntry = document.getElementById("rec-listing-rating-entry");
                    const buyerRatingComplete = document.getElementById("rec-listing-rating-complete");
                    if (buyerRatingEntry && buyerRatingComplete) {
                        buyerRatingEntry.classList.add("rec-hidden");
                        buyerRatingComplete.classList.remove("rec-hidden");
                    } else console.error("Required elements for rating entry and completion are missing.");
                }
            } else (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
        } catch (error) {
            (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
        }
        (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
    };
    //listening for form submission
    const buyerRatingForm = document.getElementById("rec-listing-rating-form");
    if (buyerRatingForm) buyerRatingForm.addEventListener("submit", async (e)=>{
        e.preventDefault();
        if ((0, $36de584fe04094bb$export$5b1fedd534ce7f2b)(buyerRatingForm)) {
            const ratingGoButton = document.getElementById("rec-listing-rating-go");
            if (ratingGoButton) (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(ratingGoButton);
            buyerRatingExec(buyerRatingForm);
        }
    });
};
const $47fe95dc40980865$export$a55cff1032a76238 = (dropzoneObjects, recDropzoneFiles, recDropzoneFilesCompressed, recDropzonePreloaded)=>{
    (0, $b00299261358dd80$export$d3cd5a45b9e13a7)("#rec-listing-dispute-form", false, dropzoneObjects, recDropzoneFiles, recDropzoneFilesCompressed, recDropzonePreloaded);
    //submit it
    const buyerDisputeExec = async (form)=>{
        try {
            // TODO: reverse-eng this form to generate a better type. This was originally written in JS.
            let formData = (0, $0aaed1fbbefba3fa$export$2bccf78e246a5305)(form);
            //check/append images
            let disputeImageKeys = [];
            document.querySelectorAll("#rec-listing-dispute-form .dz-preview").forEach((thisPreviewElem)=>{
                const imageKey = thisPreviewElem.getAttribute("data-image-key");
                if (imageKey === null) {
                    console.error("Image key is null");
                    return;
                }
                disputeImageKeys.push(imageKey);
            });
            if (disputeImageKeys.length === 0) {
                (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-dispute-images");
                (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                const imageValidationError = document.getElementById("rec-dispute-error-images");
                if (imageValidationError) imageValidationError.style.display = "block";
                return false;
            } else {
                for(let i = 0; i < disputeImageKeys.length; i++)formData["dispute_image" + (i + 1)] = recDropzoneFiles[disputeImageKeys[i]].dataURL;
                let buyerDisputeResponse = await fetch(recAppProxyConfig.paths.pathDisputeExec.replace("%lid%", formData.listing_id), {
                    method: "POST",
                    body: JSON.stringify(formData),
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
                const buyerDisputeResults = await buyerDisputeResponse.json();
                if (!buyerDisputeResults.errors) {
                    if (recAppProxyConfig.settings.shop?.landing_page_url?.length > 0) document.location = recAppProxyConfig.settings.shop.landing_page_url;
                    else {
                        const buyerDisputeEntry = document.getElementById("rec-listing-dispute-entry");
                        const buyerDisputeComplete = document.getElementById("rec-listing-dispute-complete");
                        if (buyerDisputeEntry && buyerDisputeComplete) {
                            buyerDisputeEntry.classList.add("rec-hidden");
                            buyerDisputeComplete.classList.remove("rec-hidden");
                        } else console.error("Required elements for dispute entry and completion are missing.");
                    }
                } else (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
            }
        } catch (error) {
            console.error("buyerDisputeExec: ", error);
            (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
        }
        (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
    };
    //listening for form submission
    const buyerDisputeForm = document.getElementById("rec-listing-dispute-form");
    if (buyerDisputeForm) buyerDisputeForm.addEventListener("submit", async (e)=>{
        e.preventDefault();
        if ((0, $36de584fe04094bb$export$5b1fedd534ce7f2b)(buyerDisputeForm)) {
            const disputeGoButton = document.getElementById("rec-listing-dispute-go");
            if (disputeGoButton) (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(disputeGoButton);
            buyerDisputeExec(buyerDisputeForm);
        }
    });
};



const $2832890a9d28dd4a$export$d1c479f0f4da1db4 = async (cashConfig, stripeAccountId)=>{
    //determine the URL Stripe should return to from completing/cancelling the onboarding process
    const stripeReturnUrl = document.location.href;
    const cashPayoutOption = document.querySelector(".rec-payout-option-cash");
    const params = new URL(document.location.toString()).searchParams;
    const returnFromStripeOnboarding = params.get("return");
    // If we have a stripe account, check its onboarding status
    let stripeAccountInfo = null;
    if (stripeAccountId.trim().length > 0) {
        stripeAccountInfo = await $2832890a9d28dd4a$var$sellerStripeManageLink(stripeAccountId, stripeReturnUrl, true);
        if (stripeAccountInfo && !stripeAccountInfo.errors) {
            if (cashPayoutOption) {
                if (!returnFromStripeOnboarding) cashPayoutOption.classList.add("rec-cash-loaded");
                if (stripeAccountInfo.data.onboarded) {
                    if (returnFromStripeOnboarding) {
                        const listingId = cashPayoutOption.getAttribute("data-listing");
                        if (listingId) {
                            const payoutExecPath = recAppProxyConfig.paths.pathPayoutExec.replace("%lid%", listingId).replace("%selection%", "cash").replace("%aid%", stripeAccountId);
                            const payoutResponse = await fetch(payoutExecPath, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            });
                            const payoutResults = await payoutResponse.json();
                            if (!payoutResults.errors) document.location.href = recAppProxyConfig.paths.pathListings + `&t=tlpo`;
                        } else console.error("Listing ID is null");
                    } else cashPayoutOption.classList.add("rec-cash-active");
                } else cashPayoutOption.classList.add("rec-cash-loaded");
            }
        } else (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
    } else if (cashPayoutOption && !returnFromStripeOnboarding) cashPayoutOption.classList.add("rec-cash-loaded");
    // Listen for clicking of seller payout choice
    document.querySelectorAll(".rec-payout-go").forEach((thisPayout)=>{
        thisPayout.addEventListener("click", async (e)=>{
            const target = e.currentTarget;
            (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(target);
            // Make the call to apply this payout preference to the listing
            const payoutListing = target.getAttribute("data-listing");
            const payoutType = target.getAttribute("data-payout");
            const payoutAccount = payoutType === "cash" ? stripeAccountId : target.getAttribute("data-account");
            if (payoutListing && payoutType && payoutAccount) {
                const payoutExecPath = recAppProxyConfig.paths.pathPayoutExec.replace("%lid%", payoutListing).replace("%selection%", payoutType).replace("%aid%", payoutAccount);
                try {
                    const listingPayoutResponse = await fetch(payoutExecPath, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                    const listingPayoutResults = await listingPayoutResponse.json();
                    if (!listingPayoutResults.errors) document.location.href = recAppProxyConfig.paths.pathListings + `&t=tlpo`;
                    else {
                        (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                        (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                    }
                } catch (error) {
                    console.error("Error processing payout:", error);
                    (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                    (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                }
            } else {
                console.error("Required attributes are missing.");
                (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
            }
        });
    });
    //listen for clicking of stripe setup/onboarding
    const stripeSetupBtn = document.querySelector(".rec-stripe-setup");
    if (stripeSetupBtn && cashConfig.vendors.map((vendor)=>vendor.toLowerCase()).includes("stripe") && cashConfig.enabled) stripeSetupBtn.addEventListener("click", async (e)=>{
        (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(e.currentTarget);
        //we already have a stripe account, simply redirect to onboarding
        if (stripeAccountId.trim().length > 0) {
            if (stripeAccountInfo === null || stripeAccountInfo.errors) (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
            else document.location = stripeAccountInfo.data.url;
        } else {
            cashConfig.business_profile.url = cashConfig.business_profile?.url?.length > 0 ? cashConfig.business_profile.url : recAppProxyConfig.settings.shop.url || "";
            cashConfig.country = stripeSetupBtn.dataset.country ?? recAppProxyConfig.settings.payout.cash.country;
            stripeAccountId = await $2832890a9d28dd4a$var$sellerStripeAccountCreate(cashConfig);
            if (stripeAccountId.length > 0) {
                const returnUrl = stripeReturnUrl + `?return=true`;
                const newStripeAccountDetails = await $2832890a9d28dd4a$var$sellerStripeManageLink(stripeAccountId, returnUrl, false);
                if (newStripeAccountDetails && !newStripeAccountDetails.errors) document.location = newStripeAccountDetails.data.url;
                else {
                    (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                    (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                }
            } else {
                (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
            }
        }
    });
};
/* Functions to Support Stripe Communication */ async function $2832890a9d28dd4a$var$sellerStripeManageLink(stripeAccountId, returnUrl, getAccountDetails) {
    if (stripeAccountId.length > 0) {
        let stripeDetailsPath = getAccountDetails ? recAppProxyConfig.paths.pathStripeDashboardGetDetails.replace("%aid%", stripeAccountId) : recAppProxyConfig.paths.pathStripeDashboardGet.replace("%aid%", stripeAccountId);
        const stripeLinkResponse = await fetch(`${stripeDetailsPath}&return_to=${encodeURIComponent(returnUrl)}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        return await stripeLinkResponse.json();
    }
    return null;
}
async function $2832890a9d28dd4a$var$sellerStripeAccountCreate(stripe) {
    let formData = {
        stripeData: {
            business_profile: stripe.business_profile
        }
    };
    try {
        const stripePath = recAppProxyConfig.paths.pathStripeAidPost.replace("%country%", stripe.country);
        let sripeAidResponse = await fetch(stripePath, {
            method: "POST",
            body: JSON.stringify(formData),
            headers: {
                "Content-Type": "application/json"
            }
        });
        const sripeAidResponseResults = await sripeAidResponse.json();
        if (!sripeAidResponseResults.errors) return sripeAidResponseResults.data.aid;
    } catch (err) {
        console.error("sellerStripeAccountCreate: ", err);
    }
    return "";
}




const $9f6cfacda726caad$export$1b41b520b899dc8a = async (dropzoneObjects, recDropzoneFiles, recDropzoneFilesCompressed, recDropzonePreloaded)=>{
    (0, $b00299261358dd80$export$d3cd5a45b9e13a7)("#rec-listing-qr-images-form", true, dropzoneObjects, recDropzoneFiles, recDropzoneFilesCompressed, recDropzonePreloaded);
    const listingQRImagesForm = document.getElementById("rec-listing-qr-images-form");
    if (listingQRImagesForm) {
        const qrImagesGoButton = document.getElementById("rec-listing-qr-images-go");
        if (qrImagesGoButton) qrImagesGoButton.addEventListener("click", async (e)=>{
            e.preventDefault();
            (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(e.target);
            if ((0, $0aaed1fbbefba3fa$export$554f10b70e241fff)(listingQRImagesForm, 1)) {
                // Package up form data and submit to the same URL but as a post.
                // TODO: reverse-eng this form to generate a better type. This was originally written in JS.
                let formData = (0, $0aaed1fbbefba3fa$export$2bccf78e246a5305)(listingQRImagesForm);
                // Check/append images
                document.querySelectorAll(".rec-slf-entry .dz-preview").forEach((thisPreviewElem, index)=>{
                    const thisImageKey = thisPreviewElem.getAttribute("data-image-key");
                    const thisImageInputName = `listing_image${index + 1}`;
                    if (thisImageKey) formData[thisImageInputName] = thisImageKey in recDropzoneFilesCompressed ? recDropzoneFilesCompressed[thisImageKey].dataURL : recDropzoneFiles[thisImageKey].dataURL;
                });
                try {
                    const qrImagesPost = await fetch(recAppProxyConfig.paths.pathQRListingImages.replace("%sid%", formData.session_id), {
                        method: "POST",
                        body: JSON.stringify(formData),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                    const qrImagesPostResponse = await qrImagesPost.json();
                    (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                    // Upon success, display confirmation screen
                    if (!qrImagesPostResponse.errors) {
                        const qrImagesConfirm = document.querySelector(".rec-listing-qr-images-confirm");
                        const qrImagesEntry = document.querySelector(".rec-listing-qr-images-entry");
                        if (qrImagesConfirm && qrImagesEntry) {
                            qrImagesConfirm.classList.remove("rec-hidden");
                            qrImagesEntry.classList.add("rec-hidden");
                        }
                    } else (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                } catch (error) {
                    (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                    (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                }
            }
        });
        else console.error("QR Images Go button not found.");
    } else console.error("Listing QR Images Form not found.");
};



/* Modal Functionality */ let $d6ee11c3a9c3c098$var$modalInitiatingElement = null;
const $d6ee11c3a9c3c098$export$4d5c5f543a633f69 = (modalId, initiatingElement)=>{
    const body = document.querySelector("body");
    const modal = document.getElementById(modalId);
    const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    if (modal && modal.querySelector(".rec-modal-body")) {
        $d6ee11c3a9c3c098$export$80c3b7a016a3dbc();
        if (!modal.classList.contains("rec-modal-active")) {
            const focusableContent = modal.querySelectorAll(focusableElements);
            const firstFocusableElement = focusableContent[0];
            const lastFocusableElement = focusableContent[focusableContent.length - 1];
            document.addEventListener("keydown", function(e) {
                const isTabPressed = e.key === "Tab";
                if (!isTabPressed) return;
                if (e.shiftKey) // if shift key pressed for shift + tab combination
                {
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement.focus(); // add focus for the last focusable element
                        e.preventDefault();
                    }
                } else // if tab key is pressed
                if (document.activeElement === lastFocusableElement) {
                    // if focused has reached to last focusable element then focus first focusable element after pressing tab
                    firstFocusableElement.focus(); // add focus for the first focusable element
                    e.preventDefault();
                }
            });
            if (firstFocusableElement) firstFocusableElement.focus();
            modal.classList.add("rec-modal-active");
        }
        modal.classList.remove("rec-opacity-0");
        modal.classList.remove("rec-hidden");
        modal.classList.remove("rec-pointer-events-none");
        body.classList.add("rec-modal-active");
        if (initiatingElement) $d6ee11c3a9c3c098$var$modalInitiatingElement = initiatingElement;
        modal.focus();
    } else $d6ee11c3a9c3c098$export$80c3b7a016a3dbc();
};
const $d6ee11c3a9c3c098$export$80c3b7a016a3dbc = ()=>{
    const body = document.querySelector("body");
    const recModals = document.querySelectorAll(".rec-modal");
    for(let i = 0; i < recModals.length; i++){
        recModals[i].classList.add("rec-opacity-0");
        recModals[i].classList.add("rec-hidden");
        recModals[i].classList.add("rec-pointer-events-none");
        body.classList.remove("rec-modal-active");
    }
    (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
    if ($d6ee11c3a9c3c098$var$modalInitiatingElement) {
        $d6ee11c3a9c3c098$var$modalInitiatingElement.focus();
        $d6ee11c3a9c3c098$var$modalInitiatingElement = null;
    }
};
const $d6ee11c3a9c3c098$export$cfee27000322576d = ()=>{
    document.querySelectorAll(".rec-modal-close").forEach((thisModalClose)=>{
        thisModalClose.addEventListener("click", (e)=>{
            e.preventDefault();
            $d6ee11c3a9c3c098$export$80c3b7a016a3dbc();
        });
    });
};
const $d6ee11c3a9c3c098$export$897e0f27d57ea211 = ()=>{
    document.onkeydown = function(evt) {
        let isEscape = false;
        if ("key" in evt) isEscape = evt.key === "Escape" || evt.key === "Esc";
        if (isEscape && document.body && document.body.classList.contains("rec-modal-active")) $d6ee11c3a9c3c098$export$80c3b7a016a3dbc();
    };
    /* modal openings and closures */ document.querySelectorAll(".rec-modal-open").forEach((thisModalOpen)=>{
        thisModalOpen.addEventListener("click", (e)=>{
            e.preventDefault();
            const target = e.target;
            const currentTarget = e.currentTarget;
            if (target && currentTarget) {
                const modalId = target.getAttribute("data-target");
                if (modalId) $d6ee11c3a9c3c098$export$4d5c5f543a633f69(modalId, currentTarget);
            }
        });
    });
    $d6ee11c3a9c3c098$export$cfee27000322576d();
};


/* Seller Home/Listings Features */ const $34f93e9d2fa8178e$export$c428c5fbb0f06e17 = ()=>{
    /* Hide purchase grid items for variants that are already part of active/pending/sold listings */ if (typeof recListingVariants !== "undefined") {
        let purchaseVariants = {};
        document.querySelectorAll(".rec-grid-item-purchase").forEach((thisPurchase)=>{
            const thisVariant = thisPurchase.getAttribute("data-rec-order-variant");
            const thisCTA = thisPurchase.querySelector(".rec-resell-cta");
            if (thisVariant !== null) {
                if (!(thisVariant in purchaseVariants)) purchaseVariants[thisVariant] = 0;
                purchaseVariants[thisVariant]++;
                if (thisVariant in recListingVariants && purchaseVariants[thisVariant] > recListingVariants[thisVariant]) {
                    thisCTA.classList.add("rec-disabled");
                    thisCTA.classList.add("rec-in-progress");
                    thisCTA.setAttribute("href", "javascript:;");
                }
            }
        });
    }
};
const $34f93e9d2fa8178e$export$dc16dc93176a931c = ()=>{
    const stripeSettingsElem = document.getElementById("rec-settings-stripe");
    const sellerStripeManageLink = async ()=>{
        if (recAppProxyConfig.customer.stripe.aid.length > 0) {
            const stripeLinkResponse = await fetch(recAppProxyConfig.paths.pathStripeDashboardGet.replace("%aid%", recAppProxyConfig.customer.stripe.aid) + "&return_to=" + encodeURIComponent(recAppProxyConfig.settings.shop.app_proxy_url ?? ""), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const stripeLinkResult = await stripeLinkResponse.json();
            if (stripeSettingsElem && !stripeLinkResult.errors) {
                const stripeDashboardLinkElem = document.getElementById("rec-settings-stripe-dashboard-link");
                if (stripeDashboardLinkElem) {
                    stripeDashboardLinkElem.href = stripeLinkResult.data.url;
                    stripeSettingsElem.classList.add("enabled");
                    if (stripeLinkResult.data.onboarded) {
                        stripeSettingsElem.classList.add("onboarded");
                        stripeDashboardLinkElem.innerHTML = stripeDashboardLinkElem.getAttribute("data-text-onboarded") || "";
                    } else stripeDashboardLinkElem.innerHTML = stripeDashboardLinkElem.getAttribute("data-text-pending") || "";
                }
            } else if (stripeSettingsElem) stripeSettingsElem.classList.add("error");
        }
    };
    if (stripeSettingsElem) sellerStripeManageLink();
};




const $5bfe79e248706619$export$820d2e5536553120 = (queryString)=>{
    const clearPreloginParams = ()=>{
        // Remove specific parameters to avoid redundant actions on refresh
        queryString.delete('preloginListingId');
        queryString.delete('preloginSellerUUID');
        queryString.delete('preloginListingProcessed');
        // Update URL with remaining parameters
        window.history.replaceState({}, "", window.location.pathname + (queryString.toString() ? '?' + queryString.toString() : ''));
    };
    const preloginListingId = localStorage.getItem('trove_preloginListingId');
    const preloginSellerUUID = localStorage.getItem('trove_preloginSellerUUID');
    const listingProcessed = queryString.get('preloginListingProcessed');
    if (preloginListingId && preloginSellerUUID) {
        localStorage.removeItem('trove_preloginListingId');
        localStorage.removeItem('trove_preloginSellerUUID');
        clearPreloginParams();
        // fetching the listings page again but with preloginListingId and preloginSellerUUID will allow the processPreloginDraft function to run
        if (!listingProcessed) {
            document.querySelector("#rec-message-process-prelogin")?.classList.remove("rec-hidden");
            window.location.href = `${recAppProxyConfig.paths.pathListings}&preloginListingId=${preloginListingId}&preloginSellerUUID=${preloginSellerUUID}`;
        }
    } else clearPreloginParams();
    /* Listings Status Toggle Utility */ document.querySelectorAll(".rec-listings-toggle a").forEach((thisElemToggle)=>{
        thisElemToggle.addEventListener("click", (e)=>{
            e.preventDefault();
            const target = e.currentTarget;
            const thisListingCategory = target.getAttribute("data-listing-category");
            if (thisListingCategory !== null) {
                document.querySelectorAll(".rec-listings-toggle").forEach((thisElemToggler)=>{
                    thisElemToggler.classList.remove("rec-listings-toggle-active");
                });
                target.parentElement?.classList.add("rec-listings-toggle-active");
                document.querySelectorAll(".rec-grid-item-listing[data-listing-category]").forEach((thisElemTarget)=>{
                    const listingCategory = thisElemTarget.getAttribute("data-listing-category");
                    if (thisListingCategory === "all" || listingCategory === thisListingCategory) thisElemTarget.classList.remove("rec-hidden");
                    else thisElemTarget.classList.add("rec-hidden");
                });
            }
        });
    });
    /* Listen for click on a button to pause a listing */ document.querySelectorAll(".rec-listing-pause").forEach((thisRecPauseAction)=>{
        thisRecPauseAction.addEventListener("click", async (e)=>{
            e.preventDefault();
            const target = e.target;
            const listingId = thisRecPauseAction.getAttribute("data-listing");
            if (listingId !== null) {
                const recListingContainer = document.getElementById("rec-listing-view-" + listingId);
                if (recListingContainer) {
                    (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(target);
                    try {
                        const listingPausePost = await fetch(recAppProxyConfig.paths.pathListingPausePost.replace("%lid%", listingId), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                        const listingPausePostResponse = await listingPausePost.json();
                        if (!listingPausePostResponse.errors && (0, $0aaed1fbbefba3fa$export$a6cdc56e425d0d0a)(listingPausePostResponse.data) && "listing_status" in listingPausePostResponse.data) {
                            (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-listing-paused");
                            recListingContainer.setAttribute("data-listing-status", listingPausePostResponse.data.listing_status);
                        } else (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                    } catch (error) {
                        console.error("Error pausing listing:", error);
                        (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                    } finally{
                        (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                    }
                } else console.error("recListingContainer not found for listingId:", listingId);
            } else console.error("listingId is null");
        });
    });
    /* Listen for click on a button to resume a listing */ document.querySelectorAll(".rec-listing-resume").forEach((thisRecResumeAction)=>{
        thisRecResumeAction.addEventListener("click", async (e)=>{
            e.preventDefault();
            const target = e.target;
            const listingId = thisRecResumeAction.getAttribute("data-listing");
            if (listingId !== null) {
                const recListingContainer = document.getElementById("rec-listing-view-" + listingId);
                if (recListingContainer) {
                    (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(target);
                    try {
                        const listingResumePost = await fetch(recAppProxyConfig.paths.pathListingResumePost.replace("%lid%", listingId), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                        const listingResumePostResponse = await listingResumePost.json();
                        if (!listingResumePostResponse.errors && (0, $0aaed1fbbefba3fa$export$a6cdc56e425d0d0a)(listingResumePostResponse.data) && "listing_status" in listingResumePostResponse.data) {
                            (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-listing-resumed");
                            recListingContainer.setAttribute("data-listing-status", listingResumePostResponse.data.listing_status);
                        } else (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                    } catch (error) {
                        console.error("Error resuming listing:", error);
                        (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                    } finally{
                        (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                    }
                } else console.error("recListingContainer not found for listingId:", listingId);
            } else console.error("listingId is null");
        });
    });
    /* Listen for click on a button to cancel/remove a listing */ document.querySelectorAll(".rec-listing-cancel").forEach((thisRecCancelAction)=>{
        thisRecCancelAction.addEventListener("click", async (e)=>{
            const target = e.currentTarget;
            const listingId = target.getAttribute("data-listing");
            const listingStatus = target.getAttribute("data-listing-status");
            const recCancelModalButton = document.getElementById("rec-listing-cancel-confirmed");
            const recListingContainer = document.getElementById(`rec-listing-view-${listingId}`);
            if (listingId && listingStatus && recCancelModalButton && recListingContainer) {
                if (!target.classList.contains("rec-listing-cancel-confirmed")) {
                    recCancelModalButton.setAttribute("data-listing", listingId);
                    recCancelModalButton.setAttribute("data-listing-status", listingStatus);
                    const cancelListingImage = document.querySelector(".rec-cancel-listing-image img");
                    const listingImage = recListingContainer.querySelector(".rec-grid-item-image img");
                    const cancelListingInfoTitle = document.querySelector(".rec-cancel-listing-info-title");
                    const listingTitle = recListingContainer.querySelector(".rec-grid-item-title-product");
                    if (cancelListingImage && listingImage && cancelListingInfoTitle && listingTitle) {
                        cancelListingImage.setAttribute("src", listingImage.src);
                        cancelListingInfoTitle.innerHTML = listingTitle.innerHTML;
                    }
                } else {
                    e.preventDefault();
                    (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(e.target);
                    try {
                        const listingCancelPost = await fetch(recAppProxyConfig.paths.pathListingCancelPost.replace("%lid%", listingId), {
                            method: "POST",
                            body: JSON.stringify({
                                listing_status: listingStatus
                            }),
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                        const listingCancelPostResponse = await listingCancelPost.json();
                        if (!listingCancelPostResponse.errors && (0, $0aaed1fbbefba3fa$export$a6cdc56e425d0d0a)(listingCancelPostResponse.data) && "listing_status" in listingCancelPostResponse.data) {
                            (0, $d6ee11c3a9c3c098$export$80c3b7a016a3dbc)();
                            (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-listing-cancelled");
                            recListingContainer.parentNode?.removeChild(recListingContainer);
                            target.removeAttribute("data-trigger-cancel");
                        } else (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                    } catch (error) {
                        console.error("Error cancelling listing:", error);
                        (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                    } finally{
                        (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                    }
                }
            } else console.error("Required elements or attributes are missing.");
        });
    });
    /* Look for special remove parameter and if we have a cancel button that is ready to be auto clicked */ if (queryString.has("remove") && document.querySelector("[data-trigger-cancel]")) (0, $d6ee11c3a9c3c098$export$4d5c5f543a633f69)("rec-modal-cancel-confirm");
};






/**!
 * Sortable 1.15.6
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $bf29d14931f01420$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bf29d14931f01420$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $bf29d14931f01420$var$ownKeys(Object(source), true).forEach(function(key) {
            $bf29d14931f01420$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $bf29d14931f01420$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bf29d14931f01420$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bf29d14931f01420$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $bf29d14931f01420$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bf29d14931f01420$var$_typeof(obj);
}
function $bf29d14931f01420$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bf29d14931f01420$var$_extends() {
    $bf29d14931f01420$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bf29d14931f01420$var$_extends.apply(this, arguments);
}
function $bf29d14931f01420$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bf29d14931f01420$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bf29d14931f01420$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bf29d14931f01420$var$_toConsumableArray(arr) {
    return $bf29d14931f01420$var$_arrayWithoutHoles(arr) || $bf29d14931f01420$var$_iterableToArray(arr) || $bf29d14931f01420$var$_unsupportedIterableToArray(arr) || $bf29d14931f01420$var$_nonIterableSpread();
}
function $bf29d14931f01420$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $bf29d14931f01420$var$_arrayLikeToArray(arr);
}
function $bf29d14931f01420$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $bf29d14931f01420$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bf29d14931f01420$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bf29d14931f01420$var$_arrayLikeToArray(o, minLen);
}
function $bf29d14931f01420$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bf29d14931f01420$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $bf29d14931f01420$var$version = "1.15.6";
function $bf29d14931f01420$var$userAgent(pattern) {
    if (typeof window !== 'undefined' && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $bf29d14931f01420$var$IE11OrLess = $bf29d14931f01420$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $bf29d14931f01420$var$Edge = $bf29d14931f01420$var$userAgent(/Edge/i);
var $bf29d14931f01420$var$FireFox = $bf29d14931f01420$var$userAgent(/firefox/i);
var $bf29d14931f01420$var$Safari = $bf29d14931f01420$var$userAgent(/safari/i) && !$bf29d14931f01420$var$userAgent(/chrome/i) && !$bf29d14931f01420$var$userAgent(/android/i);
var $bf29d14931f01420$var$IOS = $bf29d14931f01420$var$userAgent(/iP(ad|od|hone)/i);
var $bf29d14931f01420$var$ChromeForAndroid = $bf29d14931f01420$var$userAgent(/chrome/i) && $bf29d14931f01420$var$userAgent(/android/i);
var $bf29d14931f01420$var$captureMode = {
    capture: false,
    passive: false
};
function $bf29d14931f01420$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$bf29d14931f01420$var$IE11OrLess && $bf29d14931f01420$var$captureMode);
}
function $bf29d14931f01420$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$bf29d14931f01420$var$IE11OrLess && $bf29d14931f01420$var$captureMode);
}
function $bf29d14931f01420$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === '>' && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $bf29d14931f01420$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $bf29d14931f01420$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && $bf29d14931f01420$var$matches(el, selector) : $bf29d14931f01420$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $bf29d14931f01420$var$getParentOrHost(el));
    }
    return null;
}
var $bf29d14931f01420$var$R_SPACE = /\s+/g;
function $bf29d14931f01420$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? 'add' : 'remove'](name);
        else {
            var className = (' ' + el.className + ' ').replace($bf29d14931f01420$var$R_SPACE, ' ').replace(' ' + name + ' ', ' ');
            el.className = (className + (state ? ' ' + name : '')).replace($bf29d14931f01420$var$R_SPACE, ' ');
        }
    }
}
function $bf29d14931f01420$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, '');
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf('webkit') === -1) prop = '-webkit-' + prop;
            style[prop] = val + (typeof val === 'string' ? '' : 'px');
        }
    }
}
function $bf29d14931f01420$var$matrix(el, selfOnly) {
    var appliedTransforms = '';
    if (typeof el === 'string') appliedTransforms = el;
    else do {
        var transform = $bf29d14931f01420$var$css(el, 'transform');
        if (transform && transform !== 'none') appliedTransforms = transform + ' ' + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $bf29d14931f01420$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $bf29d14931f01420$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $bf29d14931f01420$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $bf29d14931f01420$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode;
        // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$bf29d14931f01420$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($bf29d14931f01420$var$css(container, 'transform') !== 'none' || relativeToNonStaticParent && $bf29d14931f01420$var$css(container, 'position') !== 'static')) {
                var containerRect = container.getBoundingClientRect();
                // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($bf29d14931f01420$var$css(container, 'border-top-width'));
                left -= containerRect.left + parseInt($bf29d14931f01420$var$css(container, 'border-left-width'));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $bf29d14931f01420$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $bf29d14931f01420$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $bf29d14931f01420$var$getParentAutoScrollElement(el, true), elSideVal = $bf29d14931f01420$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $bf29d14931f01420$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === 'top' || parentSide === 'left') visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $bf29d14931f01420$var$getWindowScrollingElement()) break;
        parent = $bf29d14931f01420$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $bf29d14931f01420$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== 'none' && children[i] !== $bf29d14931f01420$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $bf29d14931f01420$export$31b3ca70d8f57423.dragged) && $bf29d14931f01420$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $bf29d14931f01420$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $bf29d14931f01420$export$31b3ca70d8f57423.ghost || $bf29d14931f01420$var$css(last, 'display') === 'none' || selector && !$bf29d14931f01420$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $bf29d14931f01420$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== $bf29d14931f01420$export$31b3ca70d8f57423.clone && (!selector || $bf29d14931f01420$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $bf29d14931f01420$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $bf29d14931f01420$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $bf29d14931f01420$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $bf29d14931f01420$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $bf29d14931f01420$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $bf29d14931f01420$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $bf29d14931f01420$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
            if (!elem.getBoundingClientRect || elem === document.body) return $bf29d14931f01420$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $bf29d14931f01420$var$getWindowScrollingElement();
}
function $bf29d14931f01420$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $bf29d14931f01420$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $bf29d14931f01420$var$_throttleTimeout;
function $bf29d14931f01420$var$throttle(callback, ms) {
    return function() {
        if (!$bf29d14931f01420$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $bf29d14931f01420$var$_throttleTimeout = setTimeout(function() {
                $bf29d14931f01420$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $bf29d14931f01420$var$cancelThrottle() {
    clearTimeout($bf29d14931f01420$var$_throttleTimeout);
    $bf29d14931f01420$var$_throttleTimeout = void 0;
}
function $bf29d14931f01420$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $bf29d14931f01420$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $bf29d14931f01420$var$setRect(el, rect) {
    $bf29d14931f01420$var$css(el, 'position', 'absolute');
    $bf29d14931f01420$var$css(el, 'top', rect.top);
    $bf29d14931f01420$var$css(el, 'left', rect.left);
    $bf29d14931f01420$var$css(el, 'width', rect.width);
    $bf29d14931f01420$var$css(el, 'height', rect.height);
}
function $bf29d14931f01420$var$unsetRect(el) {
    $bf29d14931f01420$var$css(el, 'position', '');
    $bf29d14931f01420$var$css(el, 'top', '');
    $bf29d14931f01420$var$css(el, 'left', '');
    $bf29d14931f01420$var$css(el, 'width', '');
    $bf29d14931f01420$var$css(el, 'height', '');
}
function $bf29d14931f01420$var$getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!$bf29d14931f01420$var$closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
        var childRect = $bf29d14931f01420$var$getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var $bf29d14931f01420$var$expando = 'Sortable' + new Date().getTime();
function $bf29d14931f01420$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($bf29d14931f01420$var$css(child, 'display') === 'none' || child === $bf29d14931f01420$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $bf29d14931f01420$var$getRect(child)
                });
                var fromRect = $bf29d14931f01420$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect);
                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $bf29d14931f01420$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($bf29d14931f01420$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === 'function') callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $bf29d14931f01420$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $bf29d14931f01420$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($bf29d14931f01420$var$isRectEqual(prevFromRect, toRect) && !$bf29d14931f01420$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $bf29d14931f01420$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                // if fromRect != toRect: animate
                if (!$bf29d14931f01420$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === 'function') callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === 'function') callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $bf29d14931f01420$var$css(target, 'transition', '');
                $bf29d14931f01420$var$css(target, 'transform', '');
                var elMatrix = $bf29d14931f01420$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $bf29d14931f01420$var$css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
                this.forRepaintDummy = $bf29d14931f01420$var$repaint(target); // repaint
                $bf29d14931f01420$var$css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
                $bf29d14931f01420$var$css(target, 'transform', 'translate3d(0,0,0)');
                typeof target.animated === 'number' && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $bf29d14931f01420$var$css(target, 'transition', '');
                    $bf29d14931f01420$var$css(target, 'transform', '');
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $bf29d14931f01420$var$repaint(target) {
    return target.offsetWidth;
}
function $bf29d14931f01420$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $bf29d14931f01420$var$plugins = [];
var $bf29d14931f01420$var$defaults = {
    initializeByDefault: true
};
var $bf29d14931f01420$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $bf29d14931f01420$var$defaults)if ($bf29d14931f01420$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $bf29d14931f01420$var$defaults[option];
        $bf29d14931f01420$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $bf29d14931f01420$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + 'Global';
        $bf29d14931f01420$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($bf29d14931f01420$var$_objectSpread2({
                sortable: sortable
            }, evt));
            // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($bf29d14931f01420$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $bf29d14931f01420$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            // Add default options from plugin
            $bf29d14931f01420$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== 'undefined') sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $bf29d14931f01420$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== 'function') return;
            $bf29d14931f01420$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $bf29d14931f01420$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return;
            // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $bf29d14931f01420$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$bf29d14931f01420$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$bf29d14931f01420$var$IE11OrLess && !$bf29d14931f01420$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $bf29d14931f01420$var$_objectSpread2($bf29d14931f01420$var$_objectSpread2({}, extraEventProperties), $bf29d14931f01420$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $bf29d14931f01420$var$_excluded = [
    "evt"
];
var $bf29d14931f01420$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $bf29d14931f01420$var$_objectWithoutProperties(_ref, $bf29d14931f01420$var$_excluded);
    $bf29d14931f01420$var$PluginManager.pluginEvent.bind($bf29d14931f01420$export$31b3ca70d8f57423)(eventName, sortable, $bf29d14931f01420$var$_objectSpread2({
        dragEl: $bf29d14931f01420$var$dragEl,
        parentEl: $bf29d14931f01420$var$parentEl,
        ghostEl: $bf29d14931f01420$var$ghostEl,
        rootEl: $bf29d14931f01420$var$rootEl,
        nextEl: $bf29d14931f01420$var$nextEl,
        lastDownEl: $bf29d14931f01420$var$lastDownEl,
        cloneEl: $bf29d14931f01420$var$cloneEl,
        cloneHidden: $bf29d14931f01420$var$cloneHidden,
        dragStarted: $bf29d14931f01420$var$moved,
        putSortable: $bf29d14931f01420$var$putSortable,
        activeSortable: $bf29d14931f01420$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $bf29d14931f01420$var$oldIndex,
        oldDraggableIndex: $bf29d14931f01420$var$oldDraggableIndex,
        newIndex: $bf29d14931f01420$var$newIndex,
        newDraggableIndex: $bf29d14931f01420$var$newDraggableIndex,
        hideGhostForTarget: $bf29d14931f01420$var$_hideGhostForTarget,
        unhideGhostForTarget: $bf29d14931f01420$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $bf29d14931f01420$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $bf29d14931f01420$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $bf29d14931f01420$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $bf29d14931f01420$var$_dispatchEvent(info) {
    $bf29d14931f01420$var$dispatchEvent($bf29d14931f01420$var$_objectSpread2({
        putSortable: $bf29d14931f01420$var$putSortable,
        cloneEl: $bf29d14931f01420$var$cloneEl,
        targetEl: $bf29d14931f01420$var$dragEl,
        rootEl: $bf29d14931f01420$var$rootEl,
        oldIndex: $bf29d14931f01420$var$oldIndex,
        oldDraggableIndex: $bf29d14931f01420$var$oldDraggableIndex,
        newIndex: $bf29d14931f01420$var$newIndex,
        newDraggableIndex: $bf29d14931f01420$var$newDraggableIndex
    }, info));
}
var $bf29d14931f01420$var$dragEl, $bf29d14931f01420$var$parentEl, $bf29d14931f01420$var$ghostEl, $bf29d14931f01420$var$rootEl, $bf29d14931f01420$var$nextEl, $bf29d14931f01420$var$lastDownEl, $bf29d14931f01420$var$cloneEl, $bf29d14931f01420$var$cloneHidden, $bf29d14931f01420$var$oldIndex, $bf29d14931f01420$var$newIndex, $bf29d14931f01420$var$oldDraggableIndex, $bf29d14931f01420$var$newDraggableIndex, $bf29d14931f01420$var$activeGroup, $bf29d14931f01420$var$putSortable, $bf29d14931f01420$var$awaitingDragStarted = false, $bf29d14931f01420$var$ignoreNextClick = false, $bf29d14931f01420$var$sortables = [], $bf29d14931f01420$var$tapEvt, $bf29d14931f01420$var$touchEvt, $bf29d14931f01420$var$lastDx, $bf29d14931f01420$var$lastDy, $bf29d14931f01420$var$tapDistanceLeft, $bf29d14931f01420$var$tapDistanceTop, $bf29d14931f01420$var$moved, $bf29d14931f01420$var$lastTarget, $bf29d14931f01420$var$lastDirection, $bf29d14931f01420$var$pastFirstInvertThresh = false, $bf29d14931f01420$var$isCircumstantialInvert = false, $bf29d14931f01420$var$targetMoveDistance, // For positioning ghost absolutely
$bf29d14931f01420$var$ghostRelativeParent, $bf29d14931f01420$var$ghostRelativeParentInitialScroll = [], // (left, top)
$bf29d14931f01420$var$_silent = false, $bf29d14931f01420$var$savedInputChecked = [];
/** @const */ var $bf29d14931f01420$var$documentExists = typeof document !== 'undefined', $bf29d14931f01420$var$PositionGhostAbsolutely = $bf29d14931f01420$var$IOS, $bf29d14931f01420$var$CSSFloatProperty = $bf29d14931f01420$var$Edge || $bf29d14931f01420$var$IE11OrLess ? 'cssFloat' : 'float', // This will not pass for IE9, because IE9 DnD only works on anchors
$bf29d14931f01420$var$supportDraggable = $bf29d14931f01420$var$documentExists && !$bf29d14931f01420$var$ChromeForAndroid && !$bf29d14931f01420$var$IOS && 'draggable' in document.createElement('div'), $bf29d14931f01420$var$supportCssPointerEvents = function() {
    if (!$bf29d14931f01420$var$documentExists) return;
    // false when <= IE11
    if ($bf29d14931f01420$var$IE11OrLess) return false;
    var el = document.createElement('x');
    el.style.cssText = 'pointer-events:auto';
    return el.style.pointerEvents === 'auto';
}(), $bf29d14931f01420$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $bf29d14931f01420$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $bf29d14931f01420$var$getChild(el, 0, options), child2 = $bf29d14931f01420$var$getChild(el, 1, options), firstChildCSS = child1 && $bf29d14931f01420$var$css(child1), secondChildCSS = child2 && $bf29d14931f01420$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $bf29d14931f01420$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $bf29d14931f01420$var$getRect(child2).width;
    if (elCSS.display === 'flex') return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
    if (elCSS.display === 'grid') return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
        var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
        return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
    }
    return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[$bf29d14931f01420$var$CSSFloatProperty] === 'none' || child2 && elCSS[$bf29d14931f01420$var$CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
}, $bf29d14931f01420$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */ $bf29d14931f01420$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $bf29d14931f01420$var$sortables.some(function(sortable) {
        var threshold = sortable[$bf29d14931f01420$var$expando].options.emptyInsertThreshold;
        if (!threshold || $bf29d14931f01420$var$lastChild(sortable)) return;
        var rect = $bf29d14931f01420$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $bf29d14931f01420$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === 'clone') return value;
            else if (typeof value === 'function') return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $bf29d14931f01420$var$_typeof(originalGroup) != 'object') originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $bf29d14931f01420$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$bf29d14931f01420$var$supportCssPointerEvents && $bf29d14931f01420$var$ghostEl) $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'display', 'none');
}, $bf29d14931f01420$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$bf29d14931f01420$var$supportCssPointerEvents && $bf29d14931f01420$var$ghostEl) $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'display', '');
};
// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($bf29d14931f01420$var$documentExists && !$bf29d14931f01420$var$ChromeForAndroid) document.addEventListener('click', function(evt) {
    if ($bf29d14931f01420$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $bf29d14931f01420$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $bf29d14931f01420$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($bf29d14931f01420$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $bf29d14931f01420$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$bf29d14931f01420$var$expando]._onDragOver(event);
        }
    }
};
var $bf29d14931f01420$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($bf29d14931f01420$var$dragEl) $bf29d14931f01420$var$dragEl.parentNode[$bf29d14931f01420$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $bf29d14931f01420$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $bf29d14931f01420$var$_extends({}, options);
    // Export instance
    el[$bf29d14931f01420$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $bf29d14931f01420$var$_detectDirection(el, this.options);
        },
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',
        ignore: 'a, img',
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData('Text', dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: 'data-id',
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: 'sortable-fallback',
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
        supportPointer: $bf29d14931f01420$export$31b3ca70d8f57423.supportPointer !== false && 'PointerEvent' in window && (!$bf29d14931f01420$var$Safari || $bf29d14931f01420$var$IOS),
        emptyInsertThreshold: 5
    };
    $bf29d14931f01420$var$PluginManager.initializePlugins(this, el, defaults);
    // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $bf29d14931f01420$var$_prepareGroup(options);
    // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $bf29d14931f01420$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
    // Bind events
    if (options.supportPointer) $bf29d14931f01420$var$on(el, 'pointerdown', this._onTapStart);
    else {
        $bf29d14931f01420$var$on(el, 'mousedown', this._onTapStart);
        $bf29d14931f01420$var$on(el, 'touchstart', this._onTapStart);
    }
    if (this.nativeDraggable) {
        $bf29d14931f01420$var$on(el, 'dragover', this);
        $bf29d14931f01420$var$on(el, 'dragenter', this);
    }
    $bf29d14931f01420$var$sortables.push(this.el);
    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    // Add animation state manager
    $bf29d14931f01420$var$_extends(this, $bf29d14931f01420$var$AnimationStateManager());
}
$bf29d14931f01420$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $bf29d14931f01420$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $bf29d14931f01420$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, $bf29d14931f01420$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $bf29d14931f01420$var$_saveInputCheckedState(el);
        // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($bf29d14931f01420$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
        // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
        // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $bf29d14931f01420$var$Safari && target && target.tagName.toUpperCase() === 'SELECT') return;
        target = $bf29d14931f01420$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($bf29d14931f01420$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
        // Get the index of the dragged element within its parent
        $bf29d14931f01420$var$oldIndex = $bf29d14931f01420$var$index(target);
        $bf29d14931f01420$var$oldDraggableIndex = $bf29d14931f01420$var$index(target, options.draggable);
        // Check filter
        if (typeof filter === 'function') {
            if (filter.call(this, evt, target, this)) {
                $bf29d14931f01420$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: 'filter',
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $bf29d14931f01420$var$pluginEvent('filter', _this, {
                    evt: evt
                });
                preventOnFilter && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(',').some(function(criteria) {
                criteria = $bf29d14931f01420$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $bf29d14931f01420$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: 'filter',
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $bf29d14931f01420$var$pluginEvent('filter', _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$bf29d14931f01420$var$closest(originalTarget, options.handle, el, false)) return;
        // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$bf29d14931f01420$var$dragEl && target.parentNode === el) {
            var dragRect = $bf29d14931f01420$var$getRect(target);
            $bf29d14931f01420$var$rootEl = el;
            $bf29d14931f01420$var$dragEl = target;
            $bf29d14931f01420$var$parentEl = $bf29d14931f01420$var$dragEl.parentNode;
            $bf29d14931f01420$var$nextEl = $bf29d14931f01420$var$dragEl.nextSibling;
            $bf29d14931f01420$var$lastDownEl = target;
            $bf29d14931f01420$var$activeGroup = options.group;
            $bf29d14931f01420$export$31b3ca70d8f57423.dragged = $bf29d14931f01420$var$dragEl;
            $bf29d14931f01420$var$tapEvt = {
                target: $bf29d14931f01420$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $bf29d14931f01420$var$tapDistanceLeft = $bf29d14931f01420$var$tapEvt.clientX - dragRect.left;
            $bf29d14931f01420$var$tapDistanceTop = $bf29d14931f01420$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $bf29d14931f01420$var$dragEl.style['will-change'] = 'all';
            dragStartFn = function dragStartFn() {
                $bf29d14931f01420$var$pluginEvent('delayEnded', _this, {
                    evt: evt
                });
                if ($bf29d14931f01420$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$bf29d14931f01420$var$FireFox && _this.nativeDraggable) $bf29d14931f01420$var$dragEl.draggable = true;
                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);
                // Drag start event
                $bf29d14931f01420$var$_dispatchEvent({
                    sortable: _this,
                    name: 'choose',
                    originalEvent: evt
                });
                // Chosen item
                $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$dragEl, options.chosenClass, true);
            };
            // Disable "draggable"
            options.ignore.split(',').forEach(function(criteria) {
                $bf29d14931f01420$var$find($bf29d14931f01420$var$dragEl, criteria.trim(), $bf29d14931f01420$var$_disableDraggable);
            });
            $bf29d14931f01420$var$on(ownerDocument, 'dragover', $bf29d14931f01420$var$nearestEmptyInsertDetectEvent);
            $bf29d14931f01420$var$on(ownerDocument, 'mousemove', $bf29d14931f01420$var$nearestEmptyInsertDetectEvent);
            $bf29d14931f01420$var$on(ownerDocument, 'touchmove', $bf29d14931f01420$var$nearestEmptyInsertDetectEvent);
            if (options.supportPointer) {
                $bf29d14931f01420$var$on(ownerDocument, 'pointerup', _this._onDrop);
                // Native D&D triggers pointercancel
                !this.nativeDraggable && $bf29d14931f01420$var$on(ownerDocument, 'pointercancel', _this._onDrop);
            } else {
                $bf29d14931f01420$var$on(ownerDocument, 'mouseup', _this._onDrop);
                $bf29d14931f01420$var$on(ownerDocument, 'touchend', _this._onDrop);
                $bf29d14931f01420$var$on(ownerDocument, 'touchcancel', _this._onDrop);
            }
            // Make dragEl draggable (must be before delay for FireFox)
            if ($bf29d14931f01420$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $bf29d14931f01420$var$dragEl.draggable = true;
            }
            $bf29d14931f01420$var$pluginEvent('delayStart', this, {
                evt: evt
            });
            // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($bf29d14931f01420$var$Edge || $bf29d14931f01420$var$IE11OrLess))) {
                if ($bf29d14931f01420$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                if (options.supportPointer) {
                    $bf29d14931f01420$var$on(ownerDocument, 'pointerup', _this._disableDelayedDrag);
                    $bf29d14931f01420$var$on(ownerDocument, 'pointercancel', _this._disableDelayedDrag);
                } else {
                    $bf29d14931f01420$var$on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
                    $bf29d14931f01420$var$on(ownerDocument, 'touchend', _this._disableDelayedDrag);
                    $bf29d14931f01420$var$on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
                }
                $bf29d14931f01420$var$on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
                $bf29d14931f01420$var$on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
                options.supportPointer && $bf29d14931f01420$var$on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $bf29d14931f01420$var$dragEl && $bf29d14931f01420$var$_disableDraggable($bf29d14931f01420$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $bf29d14931f01420$var$off(ownerDocument, 'mouseup', this._disableDelayedDrag);
        $bf29d14931f01420$var$off(ownerDocument, 'touchend', this._disableDelayedDrag);
        $bf29d14931f01420$var$off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
        $bf29d14931f01420$var$off(ownerDocument, 'pointerup', this._disableDelayedDrag);
        $bf29d14931f01420$var$off(ownerDocument, 'pointercancel', this._disableDelayedDrag);
        $bf29d14931f01420$var$off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
        $bf29d14931f01420$var$off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
        $bf29d14931f01420$var$off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == 'touch' && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $bf29d14931f01420$var$on(document, 'pointermove', this._onTouchMove);
            else if (touch) $bf29d14931f01420$var$on(document, 'touchmove', this._onTouchMove);
            else $bf29d14931f01420$var$on(document, 'mousemove', this._onTouchMove);
        } else {
            $bf29d14931f01420$var$on($bf29d14931f01420$var$dragEl, 'dragend', this);
            $bf29d14931f01420$var$on($bf29d14931f01420$var$rootEl, 'dragstart', this._onDragStart);
        }
        try {
            if (document.selection) $bf29d14931f01420$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $bf29d14931f01420$var$awaitingDragStarted = false;
        if ($bf29d14931f01420$var$rootEl && $bf29d14931f01420$var$dragEl) {
            $bf29d14931f01420$var$pluginEvent('dragStarted', this, {
                evt: evt
            });
            if (this.nativeDraggable) $bf29d14931f01420$var$on(document, 'dragover', $bf29d14931f01420$var$_checkOutsideTargetEl);
            var options = this.options;
            // Apply effect
            !fallback && $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$dragEl, options.dragClass, false);
            $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$dragEl, options.ghostClass, true);
            $bf29d14931f01420$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost();
            // Drag start event
            $bf29d14931f01420$var$_dispatchEvent({
                sortable: this,
                name: 'start',
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($bf29d14931f01420$var$touchEvt) {
            this._lastX = $bf29d14931f01420$var$touchEvt.clientX;
            this._lastY = $bf29d14931f01420$var$touchEvt.clientY;
            $bf29d14931f01420$var$_hideGhostForTarget();
            var target = document.elementFromPoint($bf29d14931f01420$var$touchEvt.clientX, $bf29d14931f01420$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($bf29d14931f01420$var$touchEvt.clientX, $bf29d14931f01420$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $bf29d14931f01420$var$dragEl.parentNode[$bf29d14931f01420$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$bf29d14931f01420$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$bf29d14931f01420$var$expando]._onDragOver({
                        clientX: $bf29d14931f01420$var$touchEvt.clientX,
                        clientY: $bf29d14931f01420$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = $bf29d14931f01420$var$getParentOrHost(parent));
            $bf29d14931f01420$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($bf29d14931f01420$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $bf29d14931f01420$var$ghostEl && $bf29d14931f01420$var$matrix($bf29d14931f01420$var$ghostEl, true), scaleX = $bf29d14931f01420$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $bf29d14931f01420$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $bf29d14931f01420$var$PositionGhostAbsolutely && $bf29d14931f01420$var$ghostRelativeParent && $bf29d14931f01420$var$getRelativeScrollOffset($bf29d14931f01420$var$ghostRelativeParent), dx = (touch.clientX - $bf29d14931f01420$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $bf29d14931f01420$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $bf29d14931f01420$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $bf29d14931f01420$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            // only set the status to dragging, when we are actually dragging
            if (!$bf29d14931f01420$export$31b3ca70d8f57423.active && !$bf29d14931f01420$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($bf29d14931f01420$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($bf29d14931f01420$var$lastDx || 0);
                    ghostMatrix.f += dy - ($bf29d14931f01420$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'webkitTransform', cssMatrix);
                $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'mozTransform', cssMatrix);
                $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'msTransform', cssMatrix);
                $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'transform', cssMatrix);
                $bf29d14931f01420$var$lastDx = dx;
                $bf29d14931f01420$var$lastDy = dy;
                $bf29d14931f01420$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$bf29d14931f01420$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $bf29d14931f01420$var$rootEl, rect = $bf29d14931f01420$var$getRect($bf29d14931f01420$var$dragEl, true, $bf29d14931f01420$var$PositionGhostAbsolutely, true, container), options = this.options;
            // Position absolutely
            if ($bf29d14931f01420$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $bf29d14931f01420$var$ghostRelativeParent = container;
                while($bf29d14931f01420$var$css($bf29d14931f01420$var$ghostRelativeParent, 'position') === 'static' && $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostRelativeParent, 'transform') === 'none' && $bf29d14931f01420$var$ghostRelativeParent !== document)$bf29d14931f01420$var$ghostRelativeParent = $bf29d14931f01420$var$ghostRelativeParent.parentNode;
                if ($bf29d14931f01420$var$ghostRelativeParent !== document.body && $bf29d14931f01420$var$ghostRelativeParent !== document.documentElement) {
                    if ($bf29d14931f01420$var$ghostRelativeParent === document) $bf29d14931f01420$var$ghostRelativeParent = $bf29d14931f01420$var$getWindowScrollingElement();
                    rect.top += $bf29d14931f01420$var$ghostRelativeParent.scrollTop;
                    rect.left += $bf29d14931f01420$var$ghostRelativeParent.scrollLeft;
                } else $bf29d14931f01420$var$ghostRelativeParent = $bf29d14931f01420$var$getWindowScrollingElement();
                $bf29d14931f01420$var$ghostRelativeParentInitialScroll = $bf29d14931f01420$var$getRelativeScrollOffset($bf29d14931f01420$var$ghostRelativeParent);
            }
            $bf29d14931f01420$var$ghostEl = $bf29d14931f01420$var$dragEl.cloneNode(true);
            $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$ghostEl, options.ghostClass, false);
            $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$ghostEl, options.fallbackClass, true);
            $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$ghostEl, options.dragClass, true);
            $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'transition', '');
            $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'transform', '');
            $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'box-sizing', 'border-box');
            $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'margin', 0);
            $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'top', rect.top);
            $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'left', rect.left);
            $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'width', rect.width);
            $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'height', rect.height);
            $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'opacity', '0.8');
            $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'position', $bf29d14931f01420$var$PositionGhostAbsolutely ? 'absolute' : 'fixed');
            $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'zIndex', '100000');
            $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'pointerEvents', 'none');
            $bf29d14931f01420$export$31b3ca70d8f57423.ghost = $bf29d14931f01420$var$ghostEl;
            container.appendChild($bf29d14931f01420$var$ghostEl);
            // Set transform-origin
            $bf29d14931f01420$var$css($bf29d14931f01420$var$ghostEl, 'transform-origin', $bf29d14931f01420$var$tapDistanceLeft / parseInt($bf29d14931f01420$var$ghostEl.style.width) * 100 + '% ' + $bf29d14931f01420$var$tapDistanceTop / parseInt($bf29d14931f01420$var$ghostEl.style.height) * 100 + '%');
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $bf29d14931f01420$var$pluginEvent('dragStart', this, {
            evt: evt
        });
        if ($bf29d14931f01420$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $bf29d14931f01420$var$pluginEvent('setupClone', this);
        if (!$bf29d14931f01420$export$31b3ca70d8f57423.eventCanceled) {
            $bf29d14931f01420$var$cloneEl = $bf29d14931f01420$var$clone($bf29d14931f01420$var$dragEl);
            $bf29d14931f01420$var$cloneEl.removeAttribute("id");
            $bf29d14931f01420$var$cloneEl.draggable = false;
            $bf29d14931f01420$var$cloneEl.style['will-change'] = '';
            this._hideClone();
            $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$cloneEl, this.options.chosenClass, false);
            $bf29d14931f01420$export$31b3ca70d8f57423.clone = $bf29d14931f01420$var$cloneEl;
        }
        // #1143: IFrame support workaround
        _this.cloneId = $bf29d14931f01420$var$_nextTick(function() {
            $bf29d14931f01420$var$pluginEvent('clone', _this);
            if ($bf29d14931f01420$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $bf29d14931f01420$var$rootEl.insertBefore($bf29d14931f01420$var$cloneEl, $bf29d14931f01420$var$dragEl);
            _this._hideClone();
            $bf29d14931f01420$var$_dispatchEvent({
                sortable: _this,
                name: 'clone'
            });
        });
        !fallback && $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$dragEl, options.dragClass, true);
        // Set proper drop events
        if (fallback) {
            $bf29d14931f01420$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $bf29d14931f01420$var$off(document, 'mouseup', _this._onDrop);
            $bf29d14931f01420$var$off(document, 'touchend', _this._onDrop);
            $bf29d14931f01420$var$off(document, 'touchcancel', _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = 'move';
                options.setData && options.setData.call(_this, dataTransfer, $bf29d14931f01420$var$dragEl);
            }
            $bf29d14931f01420$var$on(document, 'drop', _this);
            // #1276 fix:
            $bf29d14931f01420$var$css($bf29d14931f01420$var$dragEl, 'transform', 'translateZ(0)');
        }
        $bf29d14931f01420$var$awaitingDragStarted = true;
        _this._dragStartId = $bf29d14931f01420$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $bf29d14931f01420$var$on(document, 'selectstart', _this);
        $bf29d14931f01420$var$moved = true;
        window.getSelection().removeAllRanges();
        if ($bf29d14931f01420$var$Safari) $bf29d14931f01420$var$css(document.body, 'user-select', 'none');
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $bf29d14931f01420$export$31b3ca70d8f57423.active, isOwner = $bf29d14931f01420$var$activeGroup === group, canSort = options.sort, fromSortable = $bf29d14931f01420$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($bf29d14931f01420$var$_silent) return;
        function dragOverEvent(name, extra) {
            $bf29d14931f01420$var$pluginEvent(name, _this, $bf29d14931f01420$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? 'vertical' : 'horizontal',
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $bf29d14931f01420$var$_onMove($bf29d14931f01420$var$rootEl, el, $bf29d14931f01420$var$dragEl, dragRect, target, $bf29d14931f01420$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        }
        // Capture animation state
        function capture() {
            dragOverEvent('dragOverAnimationCapture');
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent('dragOverCompleted', {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$dragEl, $bf29d14931f01420$var$putSortable ? $bf29d14931f01420$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$dragEl, options.ghostClass, true);
                }
                if ($bf29d14931f01420$var$putSortable !== _this && _this !== $bf29d14931f01420$export$31b3ca70d8f57423.active) $bf29d14931f01420$var$putSortable = _this;
                else if (_this === $bf29d14931f01420$export$31b3ca70d8f57423.active && $bf29d14931f01420$var$putSortable) $bf29d14931f01420$var$putSortable = null;
                // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent('dragOverAnimationComplete');
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            // Null lastTarget if it is not inside a previously swapped element
            if (target === $bf29d14931f01420$var$dragEl && !$bf29d14931f01420$var$dragEl.animated || target === el && !target.animated) $bf29d14931f01420$var$lastTarget = null;
            // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $bf29d14931f01420$var$dragEl.parentNode[$bf29d14931f01420$var$expando]._isOutsideThisEl(evt.target);
                // Do not detect for empty insert if already inserted
                !insertion && $bf29d14931f01420$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        // Call when dragEl has been inserted
        function changed() {
            $bf29d14931f01420$var$newIndex = $bf29d14931f01420$var$index($bf29d14931f01420$var$dragEl);
            $bf29d14931f01420$var$newDraggableIndex = $bf29d14931f01420$var$index($bf29d14931f01420$var$dragEl, options.draggable);
            $bf29d14931f01420$var$_dispatchEvent({
                sortable: _this,
                name: 'change',
                toEl: el,
                newIndex: $bf29d14931f01420$var$newIndex,
                newDraggableIndex: $bf29d14931f01420$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $bf29d14931f01420$var$closest(target, options.draggable, el, true);
        dragOverEvent('dragOver');
        if ($bf29d14931f01420$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($bf29d14931f01420$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $bf29d14931f01420$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $bf29d14931f01420$var$parentEl !== $bf29d14931f01420$var$rootEl // Reverting item into the original list
        ) : $bf29d14931f01420$var$putSortable === this || (this.lastPutMode = $bf29d14931f01420$var$activeGroup.checkPull(this, activeSortable, $bf29d14931f01420$var$dragEl, evt)) && group.checkPut(this, activeSortable, $bf29d14931f01420$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === 'vertical';
            dragRect = $bf29d14931f01420$var$getRect($bf29d14931f01420$var$dragEl);
            dragOverEvent('dragOverValid');
            if ($bf29d14931f01420$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $bf29d14931f01420$var$parentEl = $bf29d14931f01420$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent('revert');
                if (!$bf29d14931f01420$export$31b3ca70d8f57423.eventCanceled) {
                    if ($bf29d14931f01420$var$nextEl) $bf29d14931f01420$var$rootEl.insertBefore($bf29d14931f01420$var$dragEl, $bf29d14931f01420$var$nextEl);
                    else $bf29d14931f01420$var$rootEl.appendChild($bf29d14931f01420$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $bf29d14931f01420$var$lastChild(el, options.draggable);
            if (!elLastChild || $bf29d14931f01420$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $bf29d14931f01420$var$dragEl) return completed(false);
                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $bf29d14931f01420$var$getRect(target);
                if ($bf29d14931f01420$var$_onMove($bf29d14931f01420$var$rootEl, el, $bf29d14931f01420$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($bf29d14931f01420$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($bf29d14931f01420$var$dragEl);
                    $bf29d14931f01420$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $bf29d14931f01420$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $bf29d14931f01420$var$getChild(el, 0, options, true);
                if (firstChild === $bf29d14931f01420$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $bf29d14931f01420$var$getRect(target);
                if ($bf29d14931f01420$var$_onMove($bf29d14931f01420$var$rootEl, el, $bf29d14931f01420$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($bf29d14931f01420$var$dragEl, firstChild);
                    $bf29d14931f01420$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $bf29d14931f01420$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $bf29d14931f01420$var$dragEl.parentNode !== el, differentRowCol = !$bf29d14931f01420$var$_dragElInRowColumn($bf29d14931f01420$var$dragEl.animated && $bf29d14931f01420$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? 'top' : 'left', scrolledPastTop = $bf29d14931f01420$var$isScrolledPast(target, 'top', 'top') || $bf29d14931f01420$var$isScrolledPast($bf29d14931f01420$var$dragEl, 'top', 'top'), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($bf29d14931f01420$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $bf29d14931f01420$var$pastFirstInvertThresh = false;
                    $bf29d14931f01420$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $bf29d14931f01420$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $bf29d14931f01420$var$isCircumstantialInvert, $bf29d14931f01420$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $bf29d14931f01420$var$index($bf29d14931f01420$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $bf29d14931f01420$var$parentEl.children[dragIndex];
                    }while (sibling && ($bf29d14931f01420$var$css(sibling, 'display') === 'none' || sibling === $bf29d14931f01420$var$ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $bf29d14931f01420$var$lastTarget = target;
                $bf29d14931f01420$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $bf29d14931f01420$var$_onMove($bf29d14931f01420$var$rootEl, el, $bf29d14931f01420$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $bf29d14931f01420$var$_silent = true;
                    setTimeout($bf29d14931f01420$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($bf29d14931f01420$var$dragEl);
                    else target.parentNode.insertBefore($bf29d14931f01420$var$dragEl, after ? nextSibling : target);
                    // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $bf29d14931f01420$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $bf29d14931f01420$var$parentEl = $bf29d14931f01420$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$bf29d14931f01420$var$isCircumstantialInvert) $bf29d14931f01420$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $bf29d14931f01420$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($bf29d14931f01420$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $bf29d14931f01420$var$off(document, 'mousemove', this._onTouchMove);
        $bf29d14931f01420$var$off(document, 'touchmove', this._onTouchMove);
        $bf29d14931f01420$var$off(document, 'pointermove', this._onTouchMove);
        $bf29d14931f01420$var$off(document, 'dragover', $bf29d14931f01420$var$nearestEmptyInsertDetectEvent);
        $bf29d14931f01420$var$off(document, 'mousemove', $bf29d14931f01420$var$nearestEmptyInsertDetectEvent);
        $bf29d14931f01420$var$off(document, 'touchmove', $bf29d14931f01420$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $bf29d14931f01420$var$off(ownerDocument, 'mouseup', this._onDrop);
        $bf29d14931f01420$var$off(ownerDocument, 'touchend', this._onDrop);
        $bf29d14931f01420$var$off(ownerDocument, 'pointerup', this._onDrop);
        $bf29d14931f01420$var$off(ownerDocument, 'pointercancel', this._onDrop);
        $bf29d14931f01420$var$off(ownerDocument, 'touchcancel', this._onDrop);
        $bf29d14931f01420$var$off(document, 'selectstart', this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options;
        // Get the index of the dragged element within its parent
        $bf29d14931f01420$var$newIndex = $bf29d14931f01420$var$index($bf29d14931f01420$var$dragEl);
        $bf29d14931f01420$var$newDraggableIndex = $bf29d14931f01420$var$index($bf29d14931f01420$var$dragEl, options.draggable);
        $bf29d14931f01420$var$pluginEvent('drop', this, {
            evt: evt
        });
        $bf29d14931f01420$var$parentEl = $bf29d14931f01420$var$dragEl && $bf29d14931f01420$var$dragEl.parentNode;
        // Get again after plugin event
        $bf29d14931f01420$var$newIndex = $bf29d14931f01420$var$index($bf29d14931f01420$var$dragEl);
        $bf29d14931f01420$var$newDraggableIndex = $bf29d14931f01420$var$index($bf29d14931f01420$var$dragEl, options.draggable);
        if ($bf29d14931f01420$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $bf29d14931f01420$var$awaitingDragStarted = false;
        $bf29d14931f01420$var$isCircumstantialInvert = false;
        $bf29d14931f01420$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $bf29d14931f01420$var$_cancelNextTick(this.cloneId);
        $bf29d14931f01420$var$_cancelNextTick(this._dragStartId);
        // Unbind events
        if (this.nativeDraggable) {
            $bf29d14931f01420$var$off(document, 'drop', this);
            $bf29d14931f01420$var$off(el, 'dragstart', this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($bf29d14931f01420$var$Safari) $bf29d14931f01420$var$css(document.body, 'user-select', '');
        $bf29d14931f01420$var$css($bf29d14931f01420$var$dragEl, 'transform', '');
        if (evt) {
            if ($bf29d14931f01420$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $bf29d14931f01420$var$ghostEl && $bf29d14931f01420$var$ghostEl.parentNode && $bf29d14931f01420$var$ghostEl.parentNode.removeChild($bf29d14931f01420$var$ghostEl);
            if ($bf29d14931f01420$var$rootEl === $bf29d14931f01420$var$parentEl || $bf29d14931f01420$var$putSortable && $bf29d14931f01420$var$putSortable.lastPutMode !== 'clone') // Remove clone(s)
            $bf29d14931f01420$var$cloneEl && $bf29d14931f01420$var$cloneEl.parentNode && $bf29d14931f01420$var$cloneEl.parentNode.removeChild($bf29d14931f01420$var$cloneEl);
            if ($bf29d14931f01420$var$dragEl) {
                if (this.nativeDraggable) $bf29d14931f01420$var$off($bf29d14931f01420$var$dragEl, 'dragend', this);
                $bf29d14931f01420$var$_disableDraggable($bf29d14931f01420$var$dragEl);
                $bf29d14931f01420$var$dragEl.style['will-change'] = '';
                // Remove classes
                // ghostClass is added in dragStarted
                if ($bf29d14931f01420$var$moved && !$bf29d14931f01420$var$awaitingDragStarted) $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$dragEl, $bf29d14931f01420$var$putSortable ? $bf29d14931f01420$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$dragEl, this.options.chosenClass, false);
                // Drag stop event
                $bf29d14931f01420$var$_dispatchEvent({
                    sortable: this,
                    name: 'unchoose',
                    toEl: $bf29d14931f01420$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($bf29d14931f01420$var$rootEl !== $bf29d14931f01420$var$parentEl) {
                    if ($bf29d14931f01420$var$newIndex >= 0) {
                        // Add event
                        $bf29d14931f01420$var$_dispatchEvent({
                            rootEl: $bf29d14931f01420$var$parentEl,
                            name: 'add',
                            toEl: $bf29d14931f01420$var$parentEl,
                            fromEl: $bf29d14931f01420$var$rootEl,
                            originalEvent: evt
                        });
                        // Remove event
                        $bf29d14931f01420$var$_dispatchEvent({
                            sortable: this,
                            name: 'remove',
                            toEl: $bf29d14931f01420$var$parentEl,
                            originalEvent: evt
                        });
                        // drag from one list and drop into another
                        $bf29d14931f01420$var$_dispatchEvent({
                            rootEl: $bf29d14931f01420$var$parentEl,
                            name: 'sort',
                            toEl: $bf29d14931f01420$var$parentEl,
                            fromEl: $bf29d14931f01420$var$rootEl,
                            originalEvent: evt
                        });
                        $bf29d14931f01420$var$_dispatchEvent({
                            sortable: this,
                            name: 'sort',
                            toEl: $bf29d14931f01420$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $bf29d14931f01420$var$putSortable && $bf29d14931f01420$var$putSortable.save();
                } else {
                    if ($bf29d14931f01420$var$newIndex !== $bf29d14931f01420$var$oldIndex) {
                        if ($bf29d14931f01420$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $bf29d14931f01420$var$_dispatchEvent({
                                sortable: this,
                                name: 'update',
                                toEl: $bf29d14931f01420$var$parentEl,
                                originalEvent: evt
                            });
                            $bf29d14931f01420$var$_dispatchEvent({
                                sortable: this,
                                name: 'sort',
                                toEl: $bf29d14931f01420$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($bf29d14931f01420$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($bf29d14931f01420$var$newIndex == null || $bf29d14931f01420$var$newIndex === -1) {
                        $bf29d14931f01420$var$newIndex = $bf29d14931f01420$var$oldIndex;
                        $bf29d14931f01420$var$newDraggableIndex = $bf29d14931f01420$var$oldDraggableIndex;
                    }
                    $bf29d14931f01420$var$_dispatchEvent({
                        sortable: this,
                        name: 'end',
                        toEl: $bf29d14931f01420$var$parentEl,
                        originalEvent: evt
                    });
                    // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $bf29d14931f01420$var$pluginEvent('nulling', this);
        $bf29d14931f01420$var$rootEl = $bf29d14931f01420$var$dragEl = $bf29d14931f01420$var$parentEl = $bf29d14931f01420$var$ghostEl = $bf29d14931f01420$var$nextEl = $bf29d14931f01420$var$cloneEl = $bf29d14931f01420$var$lastDownEl = $bf29d14931f01420$var$cloneHidden = $bf29d14931f01420$var$tapEvt = $bf29d14931f01420$var$touchEvt = $bf29d14931f01420$var$moved = $bf29d14931f01420$var$newIndex = $bf29d14931f01420$var$newDraggableIndex = $bf29d14931f01420$var$oldIndex = $bf29d14931f01420$var$oldDraggableIndex = $bf29d14931f01420$var$lastTarget = $bf29d14931f01420$var$lastDirection = $bf29d14931f01420$var$putSortable = $bf29d14931f01420$var$activeGroup = $bf29d14931f01420$export$31b3ca70d8f57423.dragged = $bf29d14931f01420$export$31b3ca70d8f57423.ghost = $bf29d14931f01420$export$31b3ca70d8f57423.clone = $bf29d14931f01420$export$31b3ca70d8f57423.active = null;
        $bf29d14931f01420$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $bf29d14931f01420$var$savedInputChecked.length = $bf29d14931f01420$var$lastDx = $bf29d14931f01420$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case 'drop':
            case 'dragend':
                this._onDrop(evt);
                break;
            case 'dragenter':
            case 'dragover':
                if ($bf29d14931f01420$var$dragEl) {
                    this._onDragOver(evt);
                    $bf29d14931f01420$var$_globalDragOver(evt);
                }
                break;
            case 'selectstart':
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($bf29d14931f01420$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $bf29d14931f01420$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($bf29d14931f01420$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $bf29d14931f01420$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $bf29d14931f01420$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== 'undefined') options[name] = modifiedValue;
            else options[name] = value;
            if (name === 'group') $bf29d14931f01420$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $bf29d14931f01420$var$pluginEvent('destroy', this);
        var el = this.el;
        el[$bf29d14931f01420$var$expando] = null;
        $bf29d14931f01420$var$off(el, 'mousedown', this._onTapStart);
        $bf29d14931f01420$var$off(el, 'touchstart', this._onTapStart);
        $bf29d14931f01420$var$off(el, 'pointerdown', this._onTapStart);
        if (this.nativeDraggable) {
            $bf29d14931f01420$var$off(el, 'dragover', this);
            $bf29d14931f01420$var$off(el, 'dragenter', this);
        }
        // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function(el) {
            el.removeAttribute('draggable');
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $bf29d14931f01420$var$sortables.splice($bf29d14931f01420$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$bf29d14931f01420$var$cloneHidden) {
            $bf29d14931f01420$var$pluginEvent('hideClone', this);
            if ($bf29d14931f01420$export$31b3ca70d8f57423.eventCanceled) return;
            $bf29d14931f01420$var$css($bf29d14931f01420$var$cloneEl, 'display', 'none');
            if (this.options.removeCloneOnHide && $bf29d14931f01420$var$cloneEl.parentNode) $bf29d14931f01420$var$cloneEl.parentNode.removeChild($bf29d14931f01420$var$cloneEl);
            $bf29d14931f01420$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== 'clone') {
            this._hideClone();
            return;
        }
        if ($bf29d14931f01420$var$cloneHidden) {
            $bf29d14931f01420$var$pluginEvent('showClone', this);
            if ($bf29d14931f01420$export$31b3ca70d8f57423.eventCanceled) return;
            // show clone at dragEl or original position
            if ($bf29d14931f01420$var$dragEl.parentNode == $bf29d14931f01420$var$rootEl && !this.options.group.revertClone) $bf29d14931f01420$var$rootEl.insertBefore($bf29d14931f01420$var$cloneEl, $bf29d14931f01420$var$dragEl);
            else if ($bf29d14931f01420$var$nextEl) $bf29d14931f01420$var$rootEl.insertBefore($bf29d14931f01420$var$cloneEl, $bf29d14931f01420$var$nextEl);
            else $bf29d14931f01420$var$rootEl.appendChild($bf29d14931f01420$var$cloneEl);
            if (this.options.group.revertClone) this.animate($bf29d14931f01420$var$dragEl, $bf29d14931f01420$var$cloneEl);
            $bf29d14931f01420$var$css($bf29d14931f01420$var$cloneEl, 'display', '');
            $bf29d14931f01420$var$cloneHidden = false;
        }
    }
};
function $bf29d14931f01420$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = 'move';
    evt.cancelable && evt.preventDefault();
}
function $bf29d14931f01420$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$bf29d14931f01420$var$expando], onMoveFn = sortable.options.onMove, retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$bf29d14931f01420$var$IE11OrLess && !$bf29d14931f01420$var$Edge) evt = new CustomEvent('move', {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent('move', true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $bf29d14931f01420$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $bf29d14931f01420$var$_disableDraggable(el) {
    el.draggable = false;
}
function $bf29d14931f01420$var$_unsilent() {
    $bf29d14931f01420$var$_silent = false;
}
function $bf29d14931f01420$var$_ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = $bf29d14931f01420$var$getRect($bf29d14931f01420$var$getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = $bf29d14931f01420$var$getChildContainingRectFromElement(sortable.el, sortable.options, $bf29d14931f01420$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function $bf29d14931f01420$var$_ghostIsLast(evt, vertical, sortable) {
    var lastElRect = $bf29d14931f01420$var$getRect($bf29d14931f01420$var$lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = $bf29d14931f01420$var$getChildContainingRectFromElement(sortable.el, sortable.options, $bf29d14931f01420$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function $bf29d14931f01420$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $bf29d14931f01420$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$bf29d14931f01420$var$pastFirstInvertThresh && ($bf29d14931f01420$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $bf29d14931f01420$var$pastFirstInvertThresh = true;
            if (!$bf29d14931f01420$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($bf29d14931f01420$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $bf29d14931f01420$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $bf29d14931f01420$var$targetMoveDistance) return -$bf29d14931f01420$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $bf29d14931f01420$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $bf29d14931f01420$var$_getInsertDirection(target) {
    if ($bf29d14931f01420$var$index($bf29d14931f01420$var$dragEl) < $bf29d14931f01420$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $bf29d14931f01420$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $bf29d14931f01420$var$_saveInputCheckedState(root) {
    $bf29d14931f01420$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName('input');
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $bf29d14931f01420$var$savedInputChecked.push(el);
    }
}
function $bf29d14931f01420$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $bf29d14931f01420$var$_cancelNextTick(id) {
    return clearTimeout(id);
}
// Fixed #973:
if ($bf29d14931f01420$var$documentExists) $bf29d14931f01420$var$on(document, 'touchmove', function(evt) {
    if (($bf29d14931f01420$export$31b3ca70d8f57423.active || $bf29d14931f01420$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
// Export utils
$bf29d14931f01420$export$31b3ca70d8f57423.utils = {
    on: $bf29d14931f01420$var$on,
    off: $bf29d14931f01420$var$off,
    css: $bf29d14931f01420$var$css,
    find: $bf29d14931f01420$var$find,
    is: function is(el, selector) {
        return !!$bf29d14931f01420$var$closest(el, selector, el, false);
    },
    extend: $bf29d14931f01420$var$extend,
    throttle: $bf29d14931f01420$var$throttle,
    closest: $bf29d14931f01420$var$closest,
    toggleClass: $bf29d14931f01420$var$toggleClass,
    clone: $bf29d14931f01420$var$clone,
    index: $bf29d14931f01420$var$index,
    nextTick: $bf29d14931f01420$var$_nextTick,
    cancelNextTick: $bf29d14931f01420$var$_cancelNextTick,
    detectDirection: $bf29d14931f01420$var$_detectDirection,
    getChild: $bf29d14931f01420$var$getChild,
    expando: $bf29d14931f01420$var$expando
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $bf29d14931f01420$export$31b3ca70d8f57423.get = function(element) {
    return element[$bf29d14931f01420$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $bf29d14931f01420$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $bf29d14931f01420$export$31b3ca70d8f57423.utils = $bf29d14931f01420$var$_objectSpread2($bf29d14931f01420$var$_objectSpread2({}, $bf29d14931f01420$export$31b3ca70d8f57423.utils), plugin.utils);
        $bf29d14931f01420$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $bf29d14931f01420$export$31b3ca70d8f57423.create = function(el, options) {
    return new $bf29d14931f01420$export$31b3ca70d8f57423(el, options);
};
// Export
$bf29d14931f01420$export$31b3ca70d8f57423.version = $bf29d14931f01420$var$version;
var $bf29d14931f01420$var$autoScrolls = [], $bf29d14931f01420$var$scrollEl, $bf29d14931f01420$var$scrollRootEl, $bf29d14931f01420$var$scrolling = false, $bf29d14931f01420$var$lastAutoScrollX, $bf29d14931f01420$var$lastAutoScrollY, $bf29d14931f01420$var$touchEvt$1, $bf29d14931f01420$var$pointerElemChangedInterval;
function $bf29d14931f01420$var$AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $bf29d14931f01420$var$on(document, 'dragover', this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $bf29d14931f01420$var$on(document, 'pointermove', this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $bf29d14931f01420$var$on(document, 'touchmove', this._handleFallbackAutoScroll);
                else $bf29d14931f01420$var$on(document, 'mousemove', this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $bf29d14931f01420$var$off(document, 'dragover', this._handleAutoScroll);
            else {
                $bf29d14931f01420$var$off(document, 'pointermove', this._handleFallbackAutoScroll);
                $bf29d14931f01420$var$off(document, 'touchmove', this._handleFallbackAutoScroll);
                $bf29d14931f01420$var$off(document, 'mousemove', this._handleFallbackAutoScroll);
            }
            $bf29d14931f01420$var$clearPointerElemChangedInterval();
            $bf29d14931f01420$var$clearAutoScrolls();
            $bf29d14931f01420$var$cancelThrottle();
        },
        nulling: function nulling() {
            $bf29d14931f01420$var$touchEvt$1 = $bf29d14931f01420$var$scrollRootEl = $bf29d14931f01420$var$scrollEl = $bf29d14931f01420$var$scrolling = $bf29d14931f01420$var$pointerElemChangedInterval = $bf29d14931f01420$var$lastAutoScrollX = $bf29d14931f01420$var$lastAutoScrollY = null;
            $bf29d14931f01420$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $bf29d14931f01420$var$touchEvt$1 = evt;
            // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $bf29d14931f01420$var$Edge || $bf29d14931f01420$var$IE11OrLess || $bf29d14931f01420$var$Safari) {
                $bf29d14931f01420$var$autoScroll(evt, this.options, elem, fallback);
                // Listener for pointer element change
                var ogElemScroller = $bf29d14931f01420$var$getParentAutoScrollElement(elem, true);
                if ($bf29d14931f01420$var$scrolling && (!$bf29d14931f01420$var$pointerElemChangedInterval || x !== $bf29d14931f01420$var$lastAutoScrollX || y !== $bf29d14931f01420$var$lastAutoScrollY)) {
                    $bf29d14931f01420$var$pointerElemChangedInterval && $bf29d14931f01420$var$clearPointerElemChangedInterval();
                    // Detect for pointer elem change, emulating native DnD behaviour
                    $bf29d14931f01420$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $bf29d14931f01420$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $bf29d14931f01420$var$clearAutoScrolls();
                        }
                        $bf29d14931f01420$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $bf29d14931f01420$var$lastAutoScrollX = x;
                    $bf29d14931f01420$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $bf29d14931f01420$var$getParentAutoScrollElement(elem, true) === $bf29d14931f01420$var$getWindowScrollingElement()) {
                    $bf29d14931f01420$var$clearAutoScrolls();
                    return;
                }
                $bf29d14931f01420$var$autoScroll(evt, this.options, $bf29d14931f01420$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $bf29d14931f01420$var$_extends(AutoScroll, {
        pluginName: 'scroll',
        initializeByDefault: true
    });
}
function $bf29d14931f01420$var$clearAutoScrolls() {
    $bf29d14931f01420$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $bf29d14931f01420$var$autoScrolls = [];
}
function $bf29d14931f01420$var$clearPointerElemChangedInterval() {
    clearInterval($bf29d14931f01420$var$pointerElemChangedInterval);
}
var $bf29d14931f01420$var$autoScroll = $bf29d14931f01420$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $bf29d14931f01420$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    // New scroll root, set scrollEl
    if ($bf29d14931f01420$var$scrollRootEl !== rootEl) {
        $bf29d14931f01420$var$scrollRootEl = rootEl;
        $bf29d14931f01420$var$clearAutoScrolls();
        $bf29d14931f01420$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($bf29d14931f01420$var$scrollEl === true) $bf29d14931f01420$var$scrollEl = $bf29d14931f01420$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $bf29d14931f01420$var$scrollEl;
    do {
        var el = currentParent, rect = $bf29d14931f01420$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $bf29d14931f01420$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$bf29d14931f01420$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$bf29d14931f01420$var$autoScrolls[i]) $bf29d14931f01420$var$autoScrolls[i] = {};
        }
        if ($bf29d14931f01420$var$autoScrolls[layersOut].vx != vx || $bf29d14931f01420$var$autoScrolls[layersOut].vy != vy || $bf29d14931f01420$var$autoScrolls[layersOut].el !== el) {
            $bf29d14931f01420$var$autoScrolls[layersOut].el = el;
            $bf29d14931f01420$var$autoScrolls[layersOut].vx = vx;
            $bf29d14931f01420$var$autoScrolls[layersOut].vy = vy;
            clearInterval($bf29d14931f01420$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $bf29d14931f01420$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $bf29d14931f01420$export$31b3ca70d8f57423.active._onTouchMove($bf29d14931f01420$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $bf29d14931f01420$var$autoScrolls[this.layer].vy ? $bf29d14931f01420$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $bf29d14931f01420$var$autoScrolls[this.layer].vx ? $bf29d14931f01420$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === 'function') {
                        if (scrollCustomFn.call($bf29d14931f01420$export$31b3ca70d8f57423.dragged.parentNode[$bf29d14931f01420$var$expando], scrollOffsetX, scrollOffsetY, evt, $bf29d14931f01420$var$touchEvt$1, $bf29d14931f01420$var$autoScrolls[this.layer].el) !== 'continue') return;
                    }
                    $bf29d14931f01420$var$scrollBy($bf29d14931f01420$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $bf29d14931f01420$var$getParentAutoScrollElement(currentParent, false)));
    $bf29d14931f01420$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $bf29d14931f01420$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent('spill');
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $bf29d14931f01420$var$Revert() {}
$bf29d14931f01420$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $bf29d14931f01420$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $bf29d14931f01420$var$drop
};
$bf29d14931f01420$var$_extends($bf29d14931f01420$var$Revert, {
    pluginName: 'revertOnSpill'
});
function $bf29d14931f01420$var$Remove() {}
$bf29d14931f01420$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $bf29d14931f01420$var$drop
};
$bf29d14931f01420$var$_extends($bf29d14931f01420$var$Remove, {
    pluginName: 'removeOnSpill'
});
var $bf29d14931f01420$var$lastSwapEl;
function $bf29d14931f01420$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: 'sortable-swap-highlight'
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $bf29d14931f01420$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $bf29d14931f01420$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $bf29d14931f01420$var$toggleClass(target, options.swapClass, true);
                    $bf29d14931f01420$var$lastSwapEl = target;
                } else $bf29d14931f01420$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $bf29d14931f01420$var$lastSwapEl) $bf29d14931f01420$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $bf29d14931f01420$var$lastSwapEl && $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$lastSwapEl, options.swapClass, false);
            if ($bf29d14931f01420$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $bf29d14931f01420$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $bf29d14931f01420$var$swapNodes(dragEl, $bf29d14931f01420$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $bf29d14931f01420$var$lastSwapEl = null;
        }
    };
    return $bf29d14931f01420$var$_extends(Swap, {
        pluginName: 'swap',
        eventProperties: function eventProperties() {
            return {
                swapItem: $bf29d14931f01420$var$lastSwapEl
            };
        }
    });
}
function $bf29d14931f01420$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $bf29d14931f01420$var$index(n1);
    i2 = $bf29d14931f01420$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $bf29d14931f01420$var$multiDragElements = [], $bf29d14931f01420$var$multiDragClones = [], $bf29d14931f01420$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$bf29d14931f01420$var$multiDragSortable, $bf29d14931f01420$var$initialFolding = false, // Initial multi-drag fold when drag started
$bf29d14931f01420$var$folding = false, // Folding any other time
$bf29d14931f01420$var$dragStarted = false, $bf29d14931f01420$var$dragEl$1, $bf29d14931f01420$var$clonesFromRect, $bf29d14931f01420$var$clonesHidden;
function $bf29d14931f01420$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $bf29d14931f01420$var$on(document, 'pointerup', this._deselectMultiDrag);
            else {
                $bf29d14931f01420$var$on(document, 'mouseup', this._deselectMultiDrag);
                $bf29d14931f01420$var$on(document, 'touchend', this._deselectMultiDrag);
            }
        }
        $bf29d14931f01420$var$on(document, 'keydown', this._checkKeyDown);
        $bf29d14931f01420$var$on(document, 'keyup', this._checkKeyUp);
        this.defaults = {
            selectedClass: 'sortable-selected',
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = '';
                if ($bf29d14931f01420$var$multiDragElements.length && $bf29d14931f01420$var$multiDragSortable === sortable) $bf29d14931f01420$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? '' : ', ') + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData('Text', data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $bf29d14931f01420$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$bf29d14931f01420$var$multiDragElements.indexOf($bf29d14931f01420$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $bf29d14931f01420$var$multiDragElements.length; i++){
                $bf29d14931f01420$var$multiDragClones.push($bf29d14931f01420$var$clone($bf29d14931f01420$var$multiDragElements[i]));
                $bf29d14931f01420$var$multiDragClones[i].sortableIndex = $bf29d14931f01420$var$multiDragElements[i].sortableIndex;
                $bf29d14931f01420$var$multiDragClones[i].draggable = false;
                $bf29d14931f01420$var$multiDragClones[i].style['will-change'] = '';
                $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$multiDragClones[i], this.options.selectedClass, false);
                $bf29d14931f01420$var$multiDragElements[i] === $bf29d14931f01420$var$dragEl$1 && $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($bf29d14931f01420$var$multiDragElements.length && $bf29d14931f01420$var$multiDragSortable === sortable) {
                    $bf29d14931f01420$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent('clone');
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $bf29d14931f01420$var$insertMultiDragClones(false, rootEl);
            $bf29d14931f01420$var$multiDragClones.forEach(function(clone) {
                $bf29d14931f01420$var$css(clone, 'display', '');
            });
            cloneNowShown();
            $bf29d14931f01420$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $bf29d14931f01420$var$multiDragClones.forEach(function(clone) {
                $bf29d14931f01420$var$css(clone, 'display', 'none');
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $bf29d14931f01420$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $bf29d14931f01420$var$multiDragSortable) $bf29d14931f01420$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $bf29d14931f01420$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $bf29d14931f01420$var$index(multiDragElement);
            });
            // Sort multi-drag elements
            $bf29d14931f01420$var$multiDragElements = $bf29d14931f01420$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $bf29d14931f01420$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $bf29d14931f01420$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $bf29d14931f01420$var$dragEl$1) return;
                        $bf29d14931f01420$var$css(multiDragElement, 'position', 'absolute');
                    });
                    var dragRect = $bf29d14931f01420$var$getRect($bf29d14931f01420$var$dragEl$1, false, true, true);
                    $bf29d14931f01420$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $bf29d14931f01420$var$dragEl$1) return;
                        $bf29d14931f01420$var$setRect(multiDragElement, dragRect);
                    });
                    $bf29d14931f01420$var$folding = true;
                    $bf29d14931f01420$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $bf29d14931f01420$var$folding = false;
                $bf29d14931f01420$var$initialFolding = false;
                if (_this2.options.animation) $bf29d14931f01420$var$multiDragElements.forEach(function(multiDragElement) {
                    $bf29d14931f01420$var$unsetRect(multiDragElement);
                });
                // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $bf29d14931f01420$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($bf29d14931f01420$var$folding && ~$bf29d14931f01420$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($bf29d14931f01420$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $bf29d14931f01420$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $bf29d14931f01420$var$folding ? $bf29d14931f01420$var$getRect(multiDragElement) : dragRect
                    });
                    $bf29d14931f01420$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $bf29d14931f01420$var$folding = false;
                $bf29d14931f01420$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $bf29d14931f01420$var$initialFolding = false;
                // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $bf29d14931f01420$var$multiDragElements.length > 1 && ($bf29d14931f01420$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $bf29d14931f01420$var$getRect($bf29d14931f01420$var$dragEl$1, false, true, true);
                    $bf29d14931f01420$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $bf29d14931f01420$var$dragEl$1) return;
                        $bf29d14931f01420$var$setRect(multiDragElement, dragRectAbsolute);
                        // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $bf29d14931f01420$var$folding = true;
                }
                // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$bf29d14931f01420$var$folding) $bf29d14931f01420$var$removeMultiDragElements();
                    if ($bf29d14931f01420$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $bf29d14931f01420$var$clonesHidden;
                        activeSortable._showClone(sortable);
                        // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$bf29d14931f01420$var$clonesHidden && clonesHiddenBefore) $bf29d14931f01420$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $bf29d14931f01420$var$clonesFromRect
                            });
                            clone.fromRect = $bf29d14931f01420$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $bf29d14931f01420$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $bf29d14931f01420$var$clonesFromRect = $bf29d14931f01420$var$_extends({}, dragRect);
                var dragMatrix = $bf29d14931f01420$var$matrix($bf29d14931f01420$var$dragEl$1, true);
                $bf29d14931f01420$var$clonesFromRect.top -= dragMatrix.f;
                $bf29d14931f01420$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($bf29d14931f01420$var$folding) {
                $bf29d14931f01420$var$folding = false;
                $bf29d14931f01420$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children;
            // Multi-drag selection
            if (!$bf29d14931f01420$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $bf29d14931f01420$var$toggleClass($bf29d14931f01420$var$dragEl$1, options.selectedClass, !~$bf29d14931f01420$var$multiDragElements.indexOf($bf29d14931f01420$var$dragEl$1));
                if (!~$bf29d14931f01420$var$multiDragElements.indexOf($bf29d14931f01420$var$dragEl$1)) {
                    $bf29d14931f01420$var$multiDragElements.push($bf29d14931f01420$var$dragEl$1);
                    $bf29d14931f01420$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: 'select',
                        targetEl: $bf29d14931f01420$var$dragEl$1,
                        originalEvent: evt
                    });
                    // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $bf29d14931f01420$var$lastMultiDragSelect && sortable.el.contains($bf29d14931f01420$var$lastMultiDragSelect)) {
                        var lastIndex = $bf29d14931f01420$var$index($bf29d14931f01420$var$lastMultiDragSelect), currentIndex = $bf29d14931f01420$var$index($bf29d14931f01420$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) (function() {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            var filter = options.filter;
                            for(; i < n; i++){
                                if (~$bf29d14931f01420$var$multiDragElements.indexOf(children[i])) continue;
                                // Check if element is draggable
                                if (!$bf29d14931f01420$var$closest(children[i], options.draggable, parentEl, false)) continue;
                                // Check if element is filtered
                                var filtered = filter && (typeof filter === 'function' ? filter.call(sortable, evt, children[i], sortable) : filter.split(',').some(function(criteria) {
                                    return $bf29d14931f01420$var$closest(children[i], criteria.trim(), parentEl, false);
                                }));
                                if (filtered) continue;
                                $bf29d14931f01420$var$toggleClass(children[i], options.selectedClass, true);
                                $bf29d14931f01420$var$multiDragElements.push(children[i]);
                                $bf29d14931f01420$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: 'select',
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        })();
                    } else $bf29d14931f01420$var$lastMultiDragSelect = $bf29d14931f01420$var$dragEl$1;
                    $bf29d14931f01420$var$multiDragSortable = toSortable;
                } else {
                    $bf29d14931f01420$var$multiDragElements.splice($bf29d14931f01420$var$multiDragElements.indexOf($bf29d14931f01420$var$dragEl$1), 1);
                    $bf29d14931f01420$var$lastMultiDragSelect = null;
                    $bf29d14931f01420$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: 'deselect',
                        targetEl: $bf29d14931f01420$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            }
            // Multi-drag drop
            if ($bf29d14931f01420$var$dragStarted && this.isMultiDrag) {
                $bf29d14931f01420$var$folding = false;
                // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$bf29d14931f01420$var$expando].options.sort || parentEl !== rootEl) && $bf29d14931f01420$var$multiDragElements.length > 1) {
                    var dragRect = $bf29d14931f01420$var$getRect($bf29d14931f01420$var$dragEl$1), multiDragIndex = $bf29d14931f01420$var$index($bf29d14931f01420$var$dragEl$1, ':not(.' + this.options.selectedClass + ')');
                    if (!$bf29d14931f01420$var$initialFolding && options.animation) $bf29d14931f01420$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$bf29d14931f01420$var$initialFolding) {
                        if (options.animation) {
                            $bf29d14931f01420$var$dragEl$1.fromRect = dragRect;
                            $bf29d14931f01420$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $bf29d14931f01420$var$dragEl$1) {
                                    var rect = $bf29d14931f01420$var$folding ? $bf29d14931f01420$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect;
                                    // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        }
                        // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $bf29d14931f01420$var$removeMultiDragElements();
                        $bf29d14931f01420$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        });
                        // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $bf29d14931f01420$var$index($bf29d14931f01420$var$dragEl$1)) {
                            var update = false;
                            $bf29d14931f01420$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $bf29d14931f01420$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) {
                                dispatchSortableEvent('update');
                                dispatchSortableEvent('sort');
                            }
                        }
                    }
                    // Must be done after capturing individual rects (scroll bar)
                    $bf29d14931f01420$var$multiDragElements.forEach(function(multiDragElement) {
                        $bf29d14931f01420$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $bf29d14931f01420$var$multiDragSortable = toSortable;
            }
            // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') $bf29d14931f01420$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $bf29d14931f01420$var$dragStarted = false;
            $bf29d14931f01420$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $bf29d14931f01420$var$off(document, 'pointerup', this._deselectMultiDrag);
            $bf29d14931f01420$var$off(document, 'mouseup', this._deselectMultiDrag);
            $bf29d14931f01420$var$off(document, 'touchend', this._deselectMultiDrag);
            $bf29d14931f01420$var$off(document, 'keydown', this._checkKeyDown);
            $bf29d14931f01420$var$off(document, 'keyup', this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $bf29d14931f01420$var$dragStarted !== "undefined" && $bf29d14931f01420$var$dragStarted) return;
            // Only deselect if selection is in this sortable
            if ($bf29d14931f01420$var$multiDragSortable !== this.sortable) return;
            // Only deselect if target is not item in this sortable
            if (evt && $bf29d14931f01420$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return;
            // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($bf29d14931f01420$var$multiDragElements.length){
                var el = $bf29d14931f01420$var$multiDragElements[0];
                $bf29d14931f01420$var$toggleClass(el, this.options.selectedClass, false);
                $bf29d14931f01420$var$multiDragElements.shift();
                $bf29d14931f01420$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: 'deselect',
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $bf29d14931f01420$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: 'multiDrag',
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$bf29d14931f01420$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$bf29d14931f01420$var$multiDragElements.indexOf(el)) return;
                if ($bf29d14931f01420$var$multiDragSortable && $bf29d14931f01420$var$multiDragSortable !== sortable) {
                    $bf29d14931f01420$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $bf29d14931f01420$var$multiDragSortable = sortable;
                }
                $bf29d14931f01420$var$toggleClass(el, sortable.options.selectedClass, true);
                $bf29d14931f01420$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$bf29d14931f01420$var$expando], index = $bf29d14931f01420$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $bf29d14931f01420$var$toggleClass(el, sortable.options.selectedClass, false);
                $bf29d14931f01420$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $bf29d14931f01420$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                });
                // multiDragElements will already be sorted if folding
                var newIndex;
                if ($bf29d14931f01420$var$folding && multiDragElement !== $bf29d14931f01420$var$dragEl$1) newIndex = -1;
                else if ($bf29d14931f01420$var$folding) newIndex = $bf29d14931f01420$var$index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
                else newIndex = $bf29d14931f01420$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $bf29d14931f01420$var$_toConsumableArray($bf29d14931f01420$var$multiDragElements),
                clones: [].concat($bf29d14931f01420$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === 'ctrl') key = 'Control';
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $bf29d14931f01420$var$insertMultiDragElements(clonesInserted, rootEl) {
    $bf29d14931f01420$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $bf29d14931f01420$var$insertMultiDragClones(elementsInserted, rootEl) {
    $bf29d14931f01420$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $bf29d14931f01420$var$removeMultiDragElements() {
    $bf29d14931f01420$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $bf29d14931f01420$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
$bf29d14931f01420$export$31b3ca70d8f57423.mount(new $bf29d14931f01420$var$AutoScrollPlugin());
$bf29d14931f01420$export$31b3ca70d8f57423.mount($bf29d14931f01420$var$Remove, $bf29d14931f01420$var$Revert);
var $bf29d14931f01420$export$2e2bcd8739ae039 = $bf29d14931f01420$export$31b3ca70d8f57423;


class $f49b482c1c557a3e$export$aa78965f663452d {
    constructor(country_domid, province_domid, options){
        this.countryEl = document.getElementById(country_domid);
        this.provinceEl = document.getElementById(province_domid);
        this.provinceContainer = document.getElementById(options.hideElement || province_domid);
        if (!this.countryEl || !this.provinceEl || !this.provinceContainer) {
            console.error("One or more elements not found");
            return;
        }
        $f49b482c1c557a3e$var$countryProvinceAddListener(this.countryEl, "change", $f49b482c1c557a3e$var$countryProvinceBind(this.countryHandler, this));
        this.initCountry();
        this.initProvince();
    }
    initCountry() {
        const value = this.countryEl?.getAttribute("data-default");
        if (value) {
            $f49b482c1c557a3e$var$countryProvinceSetSelectorByValue(this.countryEl, value);
            this.countryHandler();
        }
    }
    initProvince() {
        const value = this.provinceEl?.getAttribute("data-default");
        // @ts-expect-error: per convo with Adam Siegel, we need to address wether this is suppod to be an input or select at some point in the future. There is conflicting logic in the original JS implementation and the listing-form.ejs template.
        if (value && this.provinceEl && this.provinceEl.options.length > 0) // @ts-expect-error: see above
        $f49b482c1c557a3e$var$countryProvinceSetSelectorByValue(this.provinceEl, value);
    }
    countryHandler(e) {
        const opt = this.countryEl?.options[this.countryEl.selectedIndex];
        const raw = opt?.getAttribute("data-provinces");
        const provinces = raw ? JSON.parse(raw) : [];
        const provinceInput = document.getElementById("rec-shipping-address-state");
        this.clearOptions(this.provinceEl);
        if (provinces.length === 0) {
            this.provinceContainer.style.display = "none";
            if (provinceInput) {
                provinceInput.classList.remove("rec-required");
                provinceInput.setAttribute("aria-required", "false");
            }
        } else {
            this.setProvinceOptions(opt.value);
            for(let i = 0; i < provinces.length; i++){
                const option = document.createElement("option");
                option.value = provinces[i][0];
                option.innerHTML = provinces[i][1];
                this.provinceEl?.appendChild(option);
            }
        }
    }
    clearOptions(selector) {
        while(selector?.firstChild)selector.removeChild(selector.firstChild);
    }
    setOptions(selector, values) {
        for(let i = 0, count = values.length; i < count; i++){
            const opt = document.createElement("option");
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector?.appendChild(opt);
        }
    }
    setProvinceOptions(opt) {
        const provinceInput = document.getElementById("rec-shipping-address-state");
        if (!provinceInput) {
            console.error("Province input element not found");
            return;
        }
        if (opt === "Australia") {
            provinceInput.placeholder = "State/Territory";
            this.provinceContainer.style.display = "";
            provinceInput.classList.add("rec-required");
            provinceInput.setAttribute("aria-required", "true");
        } else if (opt === "Spain" || opt === "Italy") {
            provinceInput.placeholder = "Province";
            this.provinceContainer.style.display = "";
            provinceInput.classList.add("rec-required");
            provinceInput.setAttribute("aria-required", "true");
        } else if (opt === "United Kingdom") {
            provinceInput.setAttribute("aria-required", "false");
            provinceInput.classList.remove("rec-required");
            this.provinceContainer.style.display = "none";
        } else if (opt === "Portugal") {
            provinceInput.placeholder = "Region";
            this.provinceContainer.style.display = "";
            provinceInput.classList.add("rec-required");
            provinceInput.setAttribute("aria-required", "true");
        } else if (opt === "United States" || opt === "Canada") {
            provinceInput.placeholder = "State/Province";
            this.provinceContainer.style.display = "";
            provinceInput.classList.add("rec-required");
            provinceInput.setAttribute("aria-required", "true");
        } else {
            provinceInput.placeholder = "Province";
            this.provinceContainer.style.display = "";
            provinceInput.classList.add("rec-required");
            provinceInput.setAttribute("aria-required", "true");
        }
    }
}
// Helper functions
const $f49b482c1c557a3e$var$countryProvinceBind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    };
};
const $f49b482c1c557a3e$var$countryProvinceSetSelectorByValue = function(selector, value) {
    if (!selector) return;
    for(let i = 0, count = selector.options.length; i < count; i++){
        const option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};
const $f49b482c1c557a3e$var$countryProvinceAddListener = function(target, eventName, callback) {
    if (!target) return;
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};


/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $f3a1bd61f40a4011$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $b0498e8fcf4922fe$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $412a21054ec8649b$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $b0498e8fcf4922fe$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $412a21054ec8649b$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $b0498e8fcf4922fe$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $412a21054ec8649b$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $b0498e8fcf4922fe$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $a827d5adc2136ba5$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $412a21054ec8649b$export$1b3bfaa9684536aa)(element) || !(0, $f3a1bd61f40a4011$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $a827d5adc2136ba5$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $412a21054ec8649b$export$1b3bfaa9684536aa)(element) || !(0, $f3a1bd61f40a4011$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $a827d5adc2136ba5$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $a827d5adc2136ba5$var$applyStyles,
    effect: $a827d5adc2136ba5$var$effect,
    requires: [
        'computeStyles'
    ]
};


var $dbcee1e9d7b6e39c$export$8960430cfd85939f = Math.max;
var $dbcee1e9d7b6e39c$export$96ec731ed4dcb222 = Math.min;
var $dbcee1e9d7b6e39c$export$2077e0241d6afd3c = Math.round;



function $fcf5d5e2ad3a3e01$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $3c346c9c99905ea7$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $fcf5d5e2ad3a3e01$export$2e2bcd8739ae039)());
}


function $081840cddcd30a89$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $412a21054ec8649b$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $dbcee1e9d7b6e39c$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $dbcee1e9d7b6e39c$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $412a21054ec8649b$export$45a5e7f76e0caa8d)(element) ? (0, $b0498e8fcf4922fe$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $3c346c9c99905ea7$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $e9cb6b5c41a5dc94$export$2e2bcd8739ae039(node) {
    var win = (0, $b0498e8fcf4922fe$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $acdfdeadc2df90af$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $babd723f4b49d2b8$export$2e2bcd8739ae039(node) {
    if (node === (0, $b0498e8fcf4922fe$export$2e2bcd8739ae039)(node) || !(0, $412a21054ec8649b$export$1b3bfaa9684536aa)(node)) return (0, $e9cb6b5c41a5dc94$export$2e2bcd8739ae039)(node);
    else return (0, $acdfdeadc2df90af$export$2e2bcd8739ae039)(node);
}






function $4a7ca155babcb39f$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $412a21054ec8649b$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $a1badc75137a5bdf$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $081840cddcd30a89$export$2e2bcd8739ae039)((0, $4a7ca155babcb39f$export$2e2bcd8739ae039)(element)).left + (0, $e9cb6b5c41a5dc94$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $6a6a35fe021e6ddb$export$2e2bcd8739ae039(element) {
    return (0, $b0498e8fcf4922fe$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $45e2d86a1b9ccb58$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $6a6a35fe021e6ddb$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $259e28eaa123904d$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $dbcee1e9d7b6e39c$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $dbcee1e9d7b6e39c$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $259e28eaa123904d$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $412a21054ec8649b$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $412a21054ec8649b$export$1b3bfaa9684536aa)(offsetParent) && $259e28eaa123904d$var$isElementScaled(offsetParent);
    var documentElement = (0, $4a7ca155babcb39f$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $081840cddcd30a89$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f3a1bd61f40a4011$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $45e2d86a1b9ccb58$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $babd723f4b49d2b8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $412a21054ec8649b$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $081840cddcd30a89$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $a1badc75137a5bdf$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $752e70744e8e89f7$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $081840cddcd30a89$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $5247b5e27169932f$export$2e2bcd8739ae039(element) {
    if ((0, $f3a1bd61f40a4011$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $412a21054ec8649b$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $4a7ca155babcb39f$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $21e98bece4079bdd$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $f3a1bd61f40a4011$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $412a21054ec8649b$export$1b3bfaa9684536aa)(node) && (0, $45e2d86a1b9ccb58$export$2e2bcd8739ae039)(node)) return node;
    return $21e98bece4079bdd$export$2e2bcd8739ae039((0, $5247b5e27169932f$export$2e2bcd8739ae039)(node));
}





function $b81f818b763a5faf$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $21e98bece4079bdd$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $b0498e8fcf4922fe$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $45e2d86a1b9ccb58$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($b81f818b763a5faf$export$2e2bcd8739ae039((0, $5247b5e27169932f$export$2e2bcd8739ae039)(target)));
}







function $3e068cda1315ea07$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $f3a1bd61f40a4011$export$2e2bcd8739ae039)(element)) >= 0;
}




function $cbe0da579a33579a$var$getTrueOffsetParent(element) {
    if (!(0, $412a21054ec8649b$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $6a6a35fe021e6ddb$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $cbe0da579a33579a$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $fcf5d5e2ad3a3e01$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $fcf5d5e2ad3a3e01$export$2e2bcd8739ae039)());
    if (isIE && (0, $412a21054ec8649b$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $6a6a35fe021e6ddb$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $5247b5e27169932f$export$2e2bcd8739ae039)(element);
    if ((0, $412a21054ec8649b$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $412a21054ec8649b$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $f3a1bd61f40a4011$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $6a6a35fe021e6ddb$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $cbe0da579a33579a$export$2e2bcd8739ae039(element) {
    var window = (0, $b0498e8fcf4922fe$export$2e2bcd8739ae039)(element);
    var offsetParent = $cbe0da579a33579a$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $3e068cda1315ea07$export$2e2bcd8739ae039)(offsetParent) && (0, $6a6a35fe021e6ddb$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $cbe0da579a33579a$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $f3a1bd61f40a4011$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $f3a1bd61f40a4011$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $6a6a35fe021e6ddb$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $cbe0da579a33579a$var$getContainingBlock(element) || window;
}


var $34dd09044d183355$export$1e95b668f3b82d = 'top';
var $34dd09044d183355$export$40e543e69a8b3fbb = 'bottom';
var $34dd09044d183355$export$79ffe56a765070d2 = 'right';
var $34dd09044d183355$export$eabcd2c8791e7bf4 = 'left';
var $34dd09044d183355$export$dfb5619354ba860 = 'auto';
var $34dd09044d183355$export$aec2ce47c367b8c3 = [
    $34dd09044d183355$export$1e95b668f3b82d,
    $34dd09044d183355$export$40e543e69a8b3fbb,
    $34dd09044d183355$export$79ffe56a765070d2,
    $34dd09044d183355$export$eabcd2c8791e7bf4
];
var $34dd09044d183355$export$b3571188c770cc5a = 'start';
var $34dd09044d183355$export$bd5df0f255a350f8 = 'end';
var $34dd09044d183355$export$390fd549c5303b4d = 'clippingParents';
var $34dd09044d183355$export$d7b7311ec04a3e8f = 'viewport';
var $34dd09044d183355$export$ae5ab1c730825774 = 'popper';
var $34dd09044d183355$export$ca50aac9f3ba507f = 'reference';
var $34dd09044d183355$export$368f9a87e87fa4e1 = /*#__PURE__*/ $34dd09044d183355$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $34dd09044d183355$export$b3571188c770cc5a,
        placement + "-" + $34dd09044d183355$export$bd5df0f255a350f8
    ]);
}, []);
var $34dd09044d183355$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($34dd09044d183355$export$aec2ce47c367b8c3, [
    $34dd09044d183355$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $34dd09044d183355$export$b3571188c770cc5a,
        placement + "-" + $34dd09044d183355$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $34dd09044d183355$export$421679a7c3d56e = 'beforeRead';
var $34dd09044d183355$export$aafa59e2e03f2942 = 'read';
var $34dd09044d183355$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $34dd09044d183355$export$c65e99957a05207c = 'beforeMain';
var $34dd09044d183355$export$f22da7240b7add18 = 'main';
var $34dd09044d183355$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $34dd09044d183355$export$8d4d2d70e7d46032 = 'beforeWrite';
var $34dd09044d183355$export$68d8715fc104d294 = 'write';
var $34dd09044d183355$export$70a6e5159acce2e6 = 'afterWrite';
var $34dd09044d183355$export$d087d3878fdf71d5 = [
    $34dd09044d183355$export$421679a7c3d56e,
    $34dd09044d183355$export$aafa59e2e03f2942,
    $34dd09044d183355$export$6964f6c886723980,
    $34dd09044d183355$export$c65e99957a05207c,
    $34dd09044d183355$export$f22da7240b7add18,
    $34dd09044d183355$export$bab79516f2d662fe,
    $34dd09044d183355$export$8d4d2d70e7d46032,
    $34dd09044d183355$export$68d8715fc104d294,
    $34dd09044d183355$export$70a6e5159acce2e6
];


function $09b7854603022a8f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $09b7854603022a8f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $09b7854603022a8f$var$order(modifiers); // order based on phase
    return (0, $34dd09044d183355$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $f472b385fc651127$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $ae85318c7a825ce7$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $cfdf61d392a8b3fc$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $cfdf61d392a8b3fc$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $cfdf61d392a8b3fc$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $cfdf61d392a8b3fc$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $cfdf61d392a8b3fc$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $412a21054ec8649b$export$45a5e7f76e0caa8d)(reference) ? (0, $b81f818b763a5faf$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $b81f818b763a5faf$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $b81f818b763a5faf$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $09b7854603022a8f$export$2e2bcd8739ae039)((0, $ae85318c7a825ce7$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$cfdf61d392a8b3fc$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $259e28eaa123904d$export$2e2bcd8739ae039)(reference, (0, $cbe0da579a33579a$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $752e70744e8e89f7$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $f472b385fc651127$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$cfdf61d392a8b3fc$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $cfdf61d392a8b3fc$export$8f7491d57c8f97a9 = /*#__PURE__*/ $cfdf61d392a8b3fc$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $fbfba1dc9de8fd78$var$passive = {
    passive: true
};
function $fbfba1dc9de8fd78$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $b0498e8fcf4922fe$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $fbfba1dc9de8fd78$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $fbfba1dc9de8fd78$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $fbfba1dc9de8fd78$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $fbfba1dc9de8fd78$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fbfba1dc9de8fd78$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $fbfba1dc9de8fd78$var$effect,
    data: {}
};



function $e83d3f98e56b165c$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $d319ae0117940004$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $0aed400163d08e6e$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $d271b23e683ec45a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $e83d3f98e56b165c$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $d319ae0117940004$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $34dd09044d183355$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $34dd09044d183355$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $34dd09044d183355$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $34dd09044d183355$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $0aed400163d08e6e$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $34dd09044d183355$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $34dd09044d183355$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $bd030b89a788550f$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $d271b23e683ec45a$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $bd030b89a788550f$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $bd030b89a788550f$var$popperOffsets,
    data: {}
};










var $885ded6e8b9497b8$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $885ded6e8b9497b8$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $dbcee1e9d7b6e39c$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $dbcee1e9d7b6e39c$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $885ded6e8b9497b8$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $34dd09044d183355$export$eabcd2c8791e7bf4);
    var sideY = (0, $34dd09044d183355$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $cbe0da579a33579a$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $b0498e8fcf4922fe$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $4a7ca155babcb39f$export$2e2bcd8739ae039)(popper);
            if ((0, $6a6a35fe021e6ddb$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $34dd09044d183355$export$1e95b668f3b82d) || (placement === (0, $34dd09044d183355$export$eabcd2c8791e7bf4) || placement === (0, $34dd09044d183355$export$79ffe56a765070d2)) && variation === (0, $34dd09044d183355$export$bd5df0f255a350f8)) {
            sideY = (0, $34dd09044d183355$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $34dd09044d183355$export$eabcd2c8791e7bf4) || (placement === (0, $34dd09044d183355$export$1e95b668f3b82d) || placement === (0, $34dd09044d183355$export$40e543e69a8b3fbb)) && variation === (0, $34dd09044d183355$export$bd5df0f255a350f8)) {
            sideX = (0, $34dd09044d183355$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $885ded6e8b9497b8$var$unsetSides);
    var _ref4 = roundOffsets === true ? $885ded6e8b9497b8$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $b0498e8fcf4922fe$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $885ded6e8b9497b8$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $e83d3f98e56b165c$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $d319ae0117940004$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $885ded6e8b9497b8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $885ded6e8b9497b8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $885ded6e8b9497b8$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $885ded6e8b9497b8$var$computeStyles,
    data: {}
};





function $d1a50030e1cc8881$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $e83d3f98e56b165c$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $34dd09044d183355$export$eabcd2c8791e7bf4),
        (0, $34dd09044d183355$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $34dd09044d183355$export$eabcd2c8791e7bf4),
        (0, $34dd09044d183355$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $d1a50030e1cc8881$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $34dd09044d183355$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $d1a50030e1cc8881$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $d1a50030e1cc8881$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $d1a50030e1cc8881$var$offset
};


var $7ec4ae70e02befc3$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $7ec4ae70e02befc3$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $7ec4ae70e02befc3$var$hash[matched];
    });
}



var $603ea6d8152de79f$var$hash = {
    start: 'end',
    end: 'start'
};
function $603ea6d8152de79f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $603ea6d8152de79f$var$hash[matched];
    });
}







function $7ef3687ef27de8e8$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $b0498e8fcf4922fe$export$2e2bcd8739ae039)(element);
    var html = (0, $4a7ca155babcb39f$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $3c346c9c99905ea7$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $a1badc75137a5bdf$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $734fd5b70e62ebd0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $4a7ca155babcb39f$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $e9cb6b5c41a5dc94$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $dbcee1e9d7b6e39c$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $dbcee1e9d7b6e39c$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $a1badc75137a5bdf$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $6a6a35fe021e6ddb$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $dbcee1e9d7b6e39c$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $74b20a24e4823ce4$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $412a21054ec8649b$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $add7cd38efeb3ef6$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $bc1d07f91d0958f1$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $081840cddcd30a89$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $bc1d07f91d0958f1$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $34dd09044d183355$export$d7b7311ec04a3e8f) ? (0, $add7cd38efeb3ef6$export$2e2bcd8739ae039)((0, $7ef3687ef27de8e8$export$2e2bcd8739ae039)(element, strategy)) : (0, $412a21054ec8649b$export$45a5e7f76e0caa8d)(clippingParent) ? $bc1d07f91d0958f1$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $add7cd38efeb3ef6$export$2e2bcd8739ae039)((0, $734fd5b70e62ebd0$export$2e2bcd8739ae039)((0, $4a7ca155babcb39f$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $bc1d07f91d0958f1$var$getClippingParents(element) {
    var clippingParents = (0, $b81f818b763a5faf$export$2e2bcd8739ae039)((0, $5247b5e27169932f$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $6a6a35fe021e6ddb$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $412a21054ec8649b$export$1b3bfaa9684536aa)(element) ? (0, $cbe0da579a33579a$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $412a21054ec8649b$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $412a21054ec8649b$export$45a5e7f76e0caa8d)(clippingParent) && (0, $74b20a24e4823ce4$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $f3a1bd61f40a4011$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $bc1d07f91d0958f1$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $bc1d07f91d0958f1$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $bc1d07f91d0958f1$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $dbcee1e9d7b6e39c$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $dbcee1e9d7b6e39c$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $dbcee1e9d7b6e39c$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $dbcee1e9d7b6e39c$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $bc1d07f91d0958f1$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $b967f0134e34702a$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $916a062651a023f0$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $b967f0134e34702a$export$2e2bcd8739ae039)(), paddingObject);
}


function $111f33c10da84468$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $29e1e3ea2f372f61$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $34dd09044d183355$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $34dd09044d183355$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $34dd09044d183355$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $916a062651a023f0$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $111f33c10da84468$export$2e2bcd8739ae039)(padding, (0, $34dd09044d183355$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $34dd09044d183355$export$ae5ab1c730825774) ? (0, $34dd09044d183355$export$ca50aac9f3ba507f) : (0, $34dd09044d183355$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $bc1d07f91d0958f1$export$2e2bcd8739ae039)((0, $412a21054ec8649b$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $4a7ca155babcb39f$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $081840cddcd30a89$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $d271b23e683ec45a$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $add7cd38efeb3ef6$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $34dd09044d183355$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $34dd09044d183355$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $34dd09044d183355$export$79ffe56a765070d2),
                (0, $34dd09044d183355$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $34dd09044d183355$export$1e95b668f3b82d),
                (0, $34dd09044d183355$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $f9322322cc72291e$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $34dd09044d183355$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $d319ae0117940004$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $34dd09044d183355$export$368f9a87e87fa4e1) : (0, $34dd09044d183355$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $d319ae0117940004$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $34dd09044d183355$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $29e1e3ea2f372f61$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $e83d3f98e56b165c$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $38e0010f4008cc49$var$getExpandedFallbackPlacements(placement) {
    if ((0, $e83d3f98e56b165c$export$2e2bcd8739ae039)(placement) === (0, $34dd09044d183355$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $7ec4ae70e02befc3$export$2e2bcd8739ae039)(placement);
    return [
        (0, $603ea6d8152de79f$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $603ea6d8152de79f$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $38e0010f4008cc49$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $e83d3f98e56b165c$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $7ec4ae70e02befc3$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $38e0010f4008cc49$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $e83d3f98e56b165c$export$2e2bcd8739ae039)(placement) === (0, $34dd09044d183355$export$dfb5619354ba860) ? (0, $f9322322cc72291e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $e83d3f98e56b165c$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $d319ae0117940004$export$2e2bcd8739ae039)(placement) === (0, $34dd09044d183355$export$b3571188c770cc5a);
        var isVertical = [
            (0, $34dd09044d183355$export$1e95b668f3b82d),
            (0, $34dd09044d183355$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $29e1e3ea2f372f61$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $34dd09044d183355$export$79ffe56a765070d2) : (0, $34dd09044d183355$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $34dd09044d183355$export$40e543e69a8b3fbb) : (0, $34dd09044d183355$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $7ec4ae70e02befc3$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $7ec4ae70e02befc3$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $38e0010f4008cc49$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $38e0010f4008cc49$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $f3a8e18c2c0a9113$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $9559e82e7780e6ea$export$f28d906d67a997f3(min, value, max) {
    return (0, $dbcee1e9d7b6e39c$export$8960430cfd85939f)(min, (0, $dbcee1e9d7b6e39c$export$96ec731ed4dcb222)(value, max));
}
function $9559e82e7780e6ea$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $9559e82e7780e6ea$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $e071847006951bc0$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $29e1e3ea2f372f61$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $e83d3f98e56b165c$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $d319ae0117940004$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $0aed400163d08e6e$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $f3a8e18c2c0a9113$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $34dd09044d183355$export$1e95b668f3b82d) : (0, $34dd09044d183355$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $34dd09044d183355$export$40e543e69a8b3fbb) : (0, $34dd09044d183355$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $34dd09044d183355$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $34dd09044d183355$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $752e70744e8e89f7$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $b967f0134e34702a$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $9559e82e7780e6ea$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $cbe0da579a33579a$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $9559e82e7780e6ea$export$f28d906d67a997f3)(tether ? (0, $dbcee1e9d7b6e39c$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $dbcee1e9d7b6e39c$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $34dd09044d183355$export$1e95b668f3b82d) : (0, $34dd09044d183355$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $34dd09044d183355$export$40e543e69a8b3fbb) : (0, $34dd09044d183355$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $34dd09044d183355$export$1e95b668f3b82d),
            (0, $34dd09044d183355$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $9559e82e7780e6ea$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $9559e82e7780e6ea$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $e071847006951bc0$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $e071847006951bc0$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $0d407aea0a304617$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $916a062651a023f0$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $111f33c10da84468$export$2e2bcd8739ae039)(padding, (0, $34dd09044d183355$export$aec2ce47c367b8c3)));
};
function $0d407aea0a304617$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $e83d3f98e56b165c$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $0aed400163d08e6e$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $34dd09044d183355$export$eabcd2c8791e7bf4),
        (0, $34dd09044d183355$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $0d407aea0a304617$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $752e70744e8e89f7$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $34dd09044d183355$export$1e95b668f3b82d) : (0, $34dd09044d183355$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $34dd09044d183355$export$40e543e69a8b3fbb) : (0, $34dd09044d183355$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $cbe0da579a33579a$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $9559e82e7780e6ea$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0d407aea0a304617$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $74b20a24e4823ce4$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $0d407aea0a304617$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $0d407aea0a304617$var$arrow,
    effect: $0d407aea0a304617$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $e89180c3ee04956e$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $e89180c3ee04956e$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $34dd09044d183355$export$1e95b668f3b82d),
        (0, $34dd09044d183355$export$79ffe56a765070d2),
        (0, $34dd09044d183355$export$40e543e69a8b3fbb),
        (0, $34dd09044d183355$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $e89180c3ee04956e$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $29e1e3ea2f372f61$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $29e1e3ea2f372f61$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $e89180c3ee04956e$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $e89180c3ee04956e$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $e89180c3ee04956e$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $e89180c3ee04956e$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $e89180c3ee04956e$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $e89180c3ee04956e$var$hide
};




var $8962409f60eef84f$export$d34966752335dd47 = [
    (0, $fbfba1dc9de8fd78$export$2e2bcd8739ae039),
    (0, $bd030b89a788550f$export$2e2bcd8739ae039),
    (0, $885ded6e8b9497b8$export$2e2bcd8739ae039),
    (0, $a827d5adc2136ba5$export$2e2bcd8739ae039),
    (0, $d1a50030e1cc8881$export$2e2bcd8739ae039),
    (0, $38e0010f4008cc49$export$2e2bcd8739ae039),
    (0, $e071847006951bc0$export$2e2bcd8739ae039),
    (0, $0d407aea0a304617$export$2e2bcd8739ae039),
    (0, $e89180c3ee04956e$export$2e2bcd8739ae039)
];
var $8962409f60eef84f$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $cfdf61d392a8b3fc$export$ed5e13716264f202)({
    defaultModifiers: $8962409f60eef84f$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $7ca46a970818c27d$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $7ca46a970818c27d$var$BOX_CLASS = "tippy-box";
var $7ca46a970818c27d$var$CONTENT_CLASS = "tippy-content";
var $7ca46a970818c27d$var$BACKDROP_CLASS = "tippy-backdrop";
var $7ca46a970818c27d$var$ARROW_CLASS = "tippy-arrow";
var $7ca46a970818c27d$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $7ca46a970818c27d$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $7ca46a970818c27d$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $7ca46a970818c27d$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $7ca46a970818c27d$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $7ca46a970818c27d$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function $7ca46a970818c27d$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function $7ca46a970818c27d$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $7ca46a970818c27d$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $7ca46a970818c27d$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $7ca46a970818c27d$var$normalizeToArray(value) {
    return [].concat(value);
}
function $7ca46a970818c27d$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $7ca46a970818c27d$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $7ca46a970818c27d$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $7ca46a970818c27d$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $7ca46a970818c27d$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $7ca46a970818c27d$var$div() {
    return document.createElement('div');
}
function $7ca46a970818c27d$var$isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return $7ca46a970818c27d$var$isType(value, type);
    });
}
function $7ca46a970818c27d$var$isNodeList(value) {
    return $7ca46a970818c27d$var$isType(value, 'NodeList');
}
function $7ca46a970818c27d$var$isMouseEvent(value) {
    return $7ca46a970818c27d$var$isType(value, 'MouseEvent');
}
function $7ca46a970818c27d$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $7ca46a970818c27d$var$getArrayOfElements(value) {
    if ($7ca46a970818c27d$var$isElement(value)) return [
        value
    ];
    if ($7ca46a970818c27d$var$isNodeList(value)) return $7ca46a970818c27d$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $7ca46a970818c27d$var$arrayFrom(document.querySelectorAll(value));
}
function $7ca46a970818c27d$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $7ca46a970818c27d$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function $7ca46a970818c27d$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $7ca46a970818c27d$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $7ca46a970818c27d$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $7ca46a970818c27d$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $7ca46a970818c27d$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $7ca46a970818c27d$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $7ca46a970818c27d$var$currentInput = {
    isTouch: false
};
var $7ca46a970818c27d$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $7ca46a970818c27d$var$onDocumentTouchStart() {
    if ($7ca46a970818c27d$var$currentInput.isTouch) return;
    $7ca46a970818c27d$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', $7ca46a970818c27d$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $7ca46a970818c27d$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $7ca46a970818c27d$var$lastMouseMoveTime < 20) {
        $7ca46a970818c27d$var$currentInput.isTouch = false;
        document.removeEventListener('mousemove', $7ca46a970818c27d$var$onDocumentMouseMove);
    }
    $7ca46a970818c27d$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $7ca46a970818c27d$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($7ca46a970818c27d$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $7ca46a970818c27d$var$bindGlobalEventListeners() {
    document.addEventListener('touchstart', $7ca46a970818c27d$var$onDocumentTouchStart, $7ca46a970818c27d$var$TOUCH_OPTIONS);
    window.addEventListener('blur', $7ca46a970818c27d$var$onWindowBlur);
}
var $7ca46a970818c27d$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $7ca46a970818c27d$var$isIE11 = $7ca46a970818c27d$var$isBrowser ? !!window.msCrypto : false;
function $7ca46a970818c27d$var$createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function $7ca46a970818c27d$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function $7ca46a970818c27d$var$getDevMessage(message) {
    return $7ca46a970818c27d$var$clean("\n  %ctippy.js\n\n  %c" + $7ca46a970818c27d$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $7ca46a970818c27d$var$getFormattedMessage(message) {
    return [
        $7ca46a970818c27d$var$getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var $7ca46a970818c27d$var$visitedMessages;
function $7ca46a970818c27d$var$resetVisitedMessages() {
    $7ca46a970818c27d$var$visitedMessages = new Set();
}
function $7ca46a970818c27d$var$warnWhen(condition, message) {
    if (condition && !$7ca46a970818c27d$var$visitedMessages.has(message)) {
        var _console;
        $7ca46a970818c27d$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $7ca46a970818c27d$var$getFormattedMessage(message));
    }
}
function $7ca46a970818c27d$var$errorWhen(condition, message) {
    if (condition && !$7ca46a970818c27d$var$visitedMessages.has(message)) {
        var _console2;
        $7ca46a970818c27d$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $7ca46a970818c27d$var$getFormattedMessage(message));
    }
}
function $7ca46a970818c27d$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    $7ca46a970818c27d$var$errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    $7ca46a970818c27d$var$errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var $7ca46a970818c27d$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $7ca46a970818c27d$var$renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var $7ca46a970818c27d$var$defaultProps = Object.assign({
    appendTo: $7ca46a970818c27d$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, $7ca46a970818c27d$var$pluginProps, $7ca46a970818c27d$var$renderProps);
var $7ca46a970818c27d$var$defaultKeys = Object.keys($7ca46a970818c27d$var$defaultProps);
var $7ca46a970818c27d$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $7ca46a970818c27d$var$defaultProps[key] = partialProps[key];
    });
};
function $7ca46a970818c27d$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $7ca46a970818c27d$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $7ca46a970818c27d$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($7ca46a970818c27d$var$getExtendedPassedProps(Object.assign({}, $7ca46a970818c27d$var$defaultProps, {
        plugins: plugins
    }))) : $7ca46a970818c27d$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $7ca46a970818c27d$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $7ca46a970818c27d$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $7ca46a970818c27d$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $7ca46a970818c27d$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function $7ca46a970818c27d$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $7ca46a970818c27d$var$removeProperties($7ca46a970818c27d$var$defaultProps, Object.keys($7ca46a970818c27d$var$pluginProps));
        var didPassUnknownProp = !$7ca46a970818c27d$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $7ca46a970818c27d$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var $7ca46a970818c27d$var$innerHTML = function innerHTML() {
    return 'innerHTML';
};
function $7ca46a970818c27d$var$dangerouslySetInnerHTML(element, html) {
    element[$7ca46a970818c27d$var$innerHTML()] = html;
}
function $7ca46a970818c27d$var$createArrowElement(value) {
    var arrow = $7ca46a970818c27d$var$div();
    if (value === true) arrow.className = $7ca46a970818c27d$var$ARROW_CLASS;
    else {
        arrow.className = $7ca46a970818c27d$var$SVG_ARROW_CLASS;
        if ($7ca46a970818c27d$var$isElement(value)) arrow.appendChild(value);
        else $7ca46a970818c27d$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $7ca46a970818c27d$var$setContent(content, props) {
    if ($7ca46a970818c27d$var$isElement(props.content)) {
        $7ca46a970818c27d$var$dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) $7ca46a970818c27d$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $7ca46a970818c27d$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $7ca46a970818c27d$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($7ca46a970818c27d$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($7ca46a970818c27d$var$ARROW_CLASS) || node.classList.contains($7ca46a970818c27d$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($7ca46a970818c27d$var$BACKDROP_CLASS);
        })
    };
}
function $7ca46a970818c27d$var$render(instance) {
    var popper = $7ca46a970818c27d$var$div();
    var box = $7ca46a970818c27d$var$div();
    box.className = $7ca46a970818c27d$var$BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = $7ca46a970818c27d$var$div();
    content.className = $7ca46a970818c27d$var$CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    $7ca46a970818c27d$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $7ca46a970818c27d$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $7ca46a970818c27d$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($7ca46a970818c27d$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($7ca46a970818c27d$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$7ca46a970818c27d$var$render.$$tippy = true;
var $7ca46a970818c27d$var$idCounter = 1;
var $7ca46a970818c27d$var$mouseMoveListeners = []; // Used by `hideAll()`
var $7ca46a970818c27d$var$mountedInstances = [];
function $7ca46a970818c27d$var$createTippy(reference, passedProps) {
    var props = $7ca46a970818c27d$var$evaluateProps(reference, Object.assign({}, $7ca46a970818c27d$var$defaultProps, $7ca46a970818c27d$var$getExtendedPassedProps($7ca46a970818c27d$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $7ca46a970818c27d$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $7ca46a970818c27d$var$idCounter++;
    var popperInstance = null;
    var plugins = $7ca46a970818c27d$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $7ca46a970818c27d$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $7ca46a970818c27d$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $7ca46a970818c27d$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $7ca46a970818c27d$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return $7ca46a970818c27d$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $7ca46a970818c27d$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $7ca46a970818c27d$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $7ca46a970818c27d$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        $7ca46a970818c27d$var$mouseMoveListeners = $7ca46a970818c27d$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($7ca46a970818c27d$var$currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $7ca46a970818c27d$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($7ca46a970818c27d$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $7ca46a970818c27d$var$actualContains(el, actualTarget);
        })) {
            if ($7ca46a970818c27d$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, $7ca46a970818c27d$var$TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, $7ca46a970818c27d$var$TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, $7ca46a970818c27d$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, $7ca46a970818c27d$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, $7ca46a970818c27d$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, $7ca46a970818c27d$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $7ca46a970818c27d$var$updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $7ca46a970818c27d$var$updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        $7ca46a970818c27d$var$updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $7ca46a970818c27d$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        $7ca46a970818c27d$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on($7ca46a970818c27d$var$isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $7ca46a970818c27d$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $7ca46a970818c27d$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($7ca46a970818c27d$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $7ca46a970818c27d$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $7ca46a970818c27d$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $8962409f60eef84f$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $7ca46a970818c27d$var$TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = $7ca46a970818c27d$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $7ca46a970818c27d$var$arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($7ca46a970818c27d$var$currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $7ca46a970818c27d$var$evaluateProps(reference, Object.assign({}, prevProps, $7ca46a970818c27d$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $7ca46a970818c27d$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $7ca46a970818c27d$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $7ca46a970818c27d$var$currentInput.isTouch && !instance.props.touch;
        var duration = $7ca46a970818c27d$var$getValueAtIndexOrReturn(instance.props.duration, 0, $7ca46a970818c27d$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $7ca46a970818c27d$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $7ca46a970818c27d$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $7ca46a970818c27d$var$setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $7ca46a970818c27d$var$pushIfUnique($7ca46a970818c27d$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $7ca46a970818c27d$var$getValueAtIndexOrReturn(instance.props.duration, 1, $7ca46a970818c27d$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $7ca46a970818c27d$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $7ca46a970818c27d$var$setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        $7ca46a970818c27d$var$pushIfUnique($7ca46a970818c27d$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $7ca46a970818c27d$var$mountedInstances = $7ca46a970818c27d$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function $7ca46a970818c27d$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $7ca46a970818c27d$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $7ca46a970818c27d$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $7ca46a970818c27d$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $7ca46a970818c27d$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $7ca46a970818c27d$var$isElement(targets) ? instances[0] : instances;
}
$7ca46a970818c27d$var$tippy.defaultProps = $7ca46a970818c27d$var$defaultProps;
$7ca46a970818c27d$var$tippy.setDefaultProps = $7ca46a970818c27d$var$setDefaultProps;
$7ca46a970818c27d$var$tippy.currentInput = $7ca46a970818c27d$var$currentInput;
var $7ca46a970818c27d$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $7ca46a970818c27d$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $7ca46a970818c27d$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $7ca46a970818c27d$var$applyStylesModifier = Object.assign({}, (0, $a827d5adc2136ba5$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $7ca46a970818c27d$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $7ca46a970818c27d$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $7ca46a970818c27d$var$tippy($7ca46a970818c27d$var$div(), Object.assign({}, $7ca46a970818c27d$var$removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $7ca46a970818c27d$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $7ca46a970818c27d$var$BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $7ca46a970818c27d$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $7ca46a970818c27d$var$removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: $7ca46a970818c27d$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $7ca46a970818c27d$var$tippy(targets, parentProps);
    var normalizedReturnValue = $7ca46a970818c27d$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || $7ca46a970818c27d$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf($7ca46a970818c27d$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $7ca46a970818c27d$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, $7ca46a970818c27d$var$TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $7ca46a970818c27d$export$dd8ded329c01db79 = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $7ca46a970818c27d$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $7ca46a970818c27d$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $7ca46a970818c27d$var$setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) $7ca46a970818c27d$var$setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function $7ca46a970818c27d$var$createBackdropElement() {
    var backdrop = $7ca46a970818c27d$var$div();
    backdrop.className = $7ca46a970818c27d$var$BACKDROP_CLASS;
    $7ca46a970818c27d$var$setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var $7ca46a970818c27d$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $7ca46a970818c27d$var$activeInstances = [];
function $7ca46a970818c27d$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $7ca46a970818c27d$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $7ca46a970818c27d$var$addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', $7ca46a970818c27d$var$storeMouseCoords);
}
function $7ca46a970818c27d$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', $7ca46a970818c27d$var$storeMouseCoords);
}
var $7ca46a970818c27d$export$ac81526b64504ab6 = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $7ca46a970818c27d$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $7ca46a970818c27d$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $7ca46a970818c27d$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $7ca46a970818c27d$var$activeInstances = $7ca46a970818c27d$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($7ca46a970818c27d$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $7ca46a970818c27d$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($7ca46a970818c27d$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($7ca46a970818c27d$var$isMouseEvent(event)) $7ca46a970818c27d$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $7ca46a970818c27d$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $7ca46a970818c27d$export$e2b668424a9c728 = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $7ca46a970818c27d$var$getInlineBoundingClientRect($7ca46a970818c27d$var$getBasePlacement(placement), reference.getBoundingClientRect(), $7ca46a970818c27d$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($7ca46a970818c27d$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($7ca46a970818c27d$var$isMouseEvent(event)) {
                    var rects = $7ca46a970818c27d$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $7ca46a970818c27d$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $7ca46a970818c27d$export$4bd4b47501432316 = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $7ca46a970818c27d$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $7ca46a970818c27d$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $7ca46a970818c27d$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$7ca46a970818c27d$var$tippy.setDefaultProps({
    render: $7ca46a970818c27d$var$render
});
var $7ca46a970818c27d$export$2e2bcd8739ae039 = $7ca46a970818c27d$var$tippy;


/* Enable Tooltips */ (0, $7ca46a970818c27d$export$2e2bcd8739ae039)("[data-tippy-content]", {
    allowHTML: true
});
const $50e8f9f0fac5fdeb$export$9765e84a85f76198 = (dropzoneObjects, recDropzoneFiles, recDropzoneFilesCompressed, recDropzonePreloaded)=>{
    /* Shipping Address Country/Province Selector */ const setupAddressCountries = ()=>{
        new (0, $f49b482c1c557a3e$export$aa78965f663452d)(`rec-shipping-address-country`, `rec-shipping-address-state`, {
            hideElement: `rec-shipping-address-state-container`
        });
        /* If we have specific countries included, limit address countries to this list */ if ("countries" in recAppProxyConfig.settings.geo && recAppProxyConfig.settings.geo.countries.length > 0) document.querySelectorAll("[data-address-country-select] option").forEach((countryOption)=>{
            const option = countryOption;
            if (option.value !== "---" && recAppProxyConfig.settings.geo.countries.indexOf(option.value) < 0) option.remove();
        });
    };
    /* Shipping Address Modal Set */ /* Shipping Address Form Submission */ document.querySelectorAll(".rec-shipping-address-submit").forEach((shippingAddressBtn)=>{
        shippingAddressBtn.addEventListener("click", async (e)=>{
            e.preventDefault();
            const target = e.target;
            const shippingAddressForm = target.closest(".rec-shipping-address-form");
            const sellerForm = target.closest("form");
            if (!shippingAddressForm || !sellerForm) {
                console.error("Form elements not found");
                return;
            }
            (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(target);
            if ((0, $36de584fe04094bb$export$5b1fedd534ce7f2b)(shippingAddressForm, "")) {
                const shippingAddressFormData = (0, $0aaed1fbbefba3fa$export$f01be45804d2885c)(shippingAddressForm);
                /* save address data */ const addressData = await fetch(recAppProxyConfig.paths.pathAddressSave.replace("%aid%", shippingAddressFormData.seller_address_id_edit), {
                    method: "POST",
                    body: JSON.stringify({
                        address: shippingAddressFormData
                    }),
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
                const addressDataResponse = await addressData.json();
                if (!addressDataResponse.errors && (0, $0aaed1fbbefba3fa$export$a6cdc56e425d0d0a)(addressDataResponse.data) && "address" in addressDataResponse.data) {
                    /* for a new address, clone the UI for the address display and input */ let shippingAddressDisplayElem;
                    if (shippingAddressFormData.seller_address_id_edit == "0") {
                        const shippingAddressList = sellerForm.querySelector(".rec-slf-shipping-address-list");
                        if (!shippingAddressList) {
                            console.error("Shipping address list element not found");
                            return;
                        }
                        let shippingAddressDisplayNew = sellerForm.querySelector(`.rec-slf-shipping-address-display[data-addr-id="default"]`)?.cloneNode(true);
                        if (!shippingAddressDisplayNew) {
                            console.error("Shipping address display new element not found");
                            return;
                        }
                        shippingAddressDisplayNew.classList.remove("rec-hidden");
                        shippingAddressDisplayNew.setAttribute("data-addr-id", addressDataResponse.data.address.id);
                        const inputElement = shippingAddressDisplayNew.querySelector("input");
                        if (inputElement) {
                            inputElement.disabled = false;
                            inputElement.value = addressDataResponse.data.address.id;
                            inputElement.setAttribute("data-addr", JSON.stringify(addressDataResponse.data.address));
                            inputElement.checked = true;
                        }
                        const editElement = shippingAddressDisplayNew.querySelector(".rec-slf-shipping-address-edit");
                        if (editElement) {
                            editElement.setAttribute("data-addr-id", addressDataResponse.data.address.id);
                            editElement.addEventListener("click", async (e)=>{
                                e.preventDefault();
                                await addressFieldsSelect(e.target);
                            });
                        }
                        shippingAddressList.appendChild(shippingAddressDisplayNew);
                        shippingAddressDisplayElem = shippingAddressDisplayNew;
                    } else shippingAddressDisplayElem = sellerForm.querySelector(`.rec-slf-shipping-address-display[data-addr-id="${shippingAddressFormData.seller_address_id_edit}"]`);
                    if (shippingAddressDisplayElem) {
                        let shippingAddressDisplay = addressDataResponse.data.address.firstName + " " + addressDataResponse.data.address.lastName;
                        shippingAddressDisplay += "<br>" + addressDataResponse.data.address.address1 + " " + addressDataResponse.data.address.address2 + "<br>" + addressDataResponse.data.address.city + ", " + addressDataResponse.data.address.province + " " + addressDataResponse.data.address.zip + " " + addressDataResponse.data.address.country;
                        const contentElement = shippingAddressDisplayElem.querySelector(".rec-slf-shipping-address-content");
                        if (contentElement) contentElement.innerHTML = shippingAddressDisplay;
                        shippingAddressDisplayElem.classList.remove("rec-hidden");
                        (0, $d6ee11c3a9c3c098$export$80c3b7a016a3dbc)();
                    } else console.error("Shipping address display element not found");
                } else (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-address-error");
            }
            (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
        });
    });
    /* First/Default Address Display */ document.querySelectorAll(".rec-slf-first-address").forEach((firstAddress)=>{
        const firstAddressElement = firstAddress;
        document.querySelectorAll(".rec-slf-shipping-address-modal").forEach((shipModal)=>{
            const shipModalElement = shipModal;
            const parentForm = shipModalElement.closest(".rec-slf-form");
            if (parentForm) {
                const thisShippingForm = parentForm.querySelector(".rec-modal-body");
                if (thisShippingForm) firstAddressElement.appendChild(thisShippingForm);
                else console.error("Shipping form element not found");
            } else console.error("Parent form element not found");
        });
    });
    /* Shipping Address Add/Edit */ const addressFieldsApply = async (parentForm)=>{
        const addressInput = parentForm.querySelector(".rec-slf-shipping-address-select:checked");
        const firstAddress = parentForm.querySelector(".rec-slf-first-address");
        if (addressInput && !firstAddress) addressFieldsSet(parentForm, JSON.parse(addressInput.getAttribute("data-addr") || ""));
    };
    // TODO: The any type below needs to be reverse-engineered. It could be null or an object representing some shape of address.
    const addressFieldsSet = (parentForm, addressData)=>{
        // null check so we aren't erroring when trying to reassign values
        if (addressData) // reassign the firstName & lastName due to props being set differently in different places
        addressData = {
            ...addressData,
            firstName: addressData.firstName !== undefined ? addressData.firstName : addressData.first_name,
            lastName: addressData.lastName !== undefined ? addressData.lastName : addressData.last_name
        };
        const addressFieldClasses = [
            {
                input: "rec-shipping-address-id",
                field: "id"
            },
            {
                input: "rec-shipping-address-first_name",
                field: "firstName"
            },
            {
                input: "rec-shipping-address-last_name",
                field: "lastName"
            },
            {
                input: "rec-shipping-address-phone",
                field: "phone"
            },
            {
                input: "rec-shipping-address-address1",
                field: "address1"
            },
            {
                input: "rec-shipping-address-address2",
                field: "address2"
            },
            {
                input: "rec-shipping-address-country",
                field: "country"
            },
            {
                input: "rec-shipping-address-city",
                field: "city"
            },
            {
                input: "rec-shipping-address-state",
                field: "province"
            },
            {
                input: "rec-shipping-address-zip",
                field: "zip"
            }
        ];
        for (let addressInput of addressFieldClasses){
            let thisField = parentForm.querySelector(`.${addressInput.input}`);
            if (thisField !== null) {
                let thisFieldDefault = addressInput.field == "country" ? thisField.options[0].value : "";
                thisFieldDefault = addressInput.field == "id" ? "0" : thisFieldDefault;
                thisField.value = addressData && addressInput.field in addressData && addressData[addressInput.field] && addressData[addressInput.field].toString().trim().length > 0 ? addressData[addressInput.field] : thisFieldDefault;
                thisField.dispatchEvent(new Event("change"));
            }
        }
    //parentForm.querySelector(".rec-shipping-address-default").checked = false;
    };
    const addressFieldsSelect = async (selectCta)=>{
        const listingForm = selectCta.closest("form");
        let addressId = selectCta.getAttribute("data-addr-id") || "";
        if (listingForm !== null) {
            const addressModal = listingForm.querySelector(".rec-slf-shipping-address-modal");
            /* New Address */ if (addressId == "0" && addressModal !== null) {
                addressModal.classList.remove("rec-slf-shipping-address-editing");
                addressFieldsSet(listingForm, null);
                (0, $d6ee11c3a9c3c098$export$4d5c5f543a633f69)("rec-slf-shipping-address-modal", selectCta);
            } else if (addressModal !== null) addressModal.classList.add("rec-slf-shipping-address-editing");
            // convert to legacy id for path
            if (addressId.includes("gid")) addressId = addressId.split("?")[0].replace("gid://shopify/MailingAddress/", "");
            /* Retrieve address data */ const addressData = await fetch(recAppProxyConfig.paths.pathAddressGet.replace("%aid%", addressId), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const addressDataResponse = await addressData.json();
            // convert id to legacy id
            if (addressDataResponse.id.length > 0) {
                const id = addressDataResponse.id.split("?")[0].replace("gid://shopify/MailingAddress/", "");
                addressDataResponse.id = id;
            }
            if (addressDataResponse && (0, $0aaed1fbbefba3fa$export$a6cdc56e425d0d0a)(addressDataResponse)) {
                addressFieldsSet(listingForm, addressDataResponse);
                (0, $d6ee11c3a9c3c098$export$4d5c5f543a633f69)("rec-slf-shipping-address-modal", selectCta);
            } else (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
        }
    };
    document.querySelectorAll(".rec-slf-shipping-address-edit").forEach((shippingAddressEdit)=>{
        shippingAddressEdit.addEventListener("click", async (e)=>{
            e.preventDefault();
            await addressFieldsSelect(e.target);
        });
    });
    setupAddressCountries();
    /* Listen for the change of the listing condition field in order to obtain a price recommendation */ if (recAppProxyConfig.settings.slf.pricing.price_recommendation_enabled) document.querySelectorAll(".rec-slf-listing-condition").forEach((conditionSelect)=>{
        conditionSelect.addEventListener("change", async (e)=>{
            e.preventDefault();
            const target = e.target;
            if (target.value !== "") {
                const sellerForm = target.closest("form");
                const retailPriceElem = sellerForm?.querySelector(".rec-variant-price");
                const usedPriceElem = sellerForm?.querySelector(".rec-slf-listing-price");
                const shippingPriceElem = sellerForm?.querySelector(".rec-shipping-price");
                if (retailPriceElem && shippingPriceElem && usedPriceElem) {
                    // ok, let's go fetch a recommended price for this item
                    const currentSearchParams = new URLSearchParams(document.location.search);
                    const today = currentSearchParams.has("pd") && parseInt(currentSearchParams.get("pd")) ? new Date(parseInt(currentSearchParams.get("pd")) * 1000) : new Date();
                    const priceRecommendation = await fetch(recAppProxyConfig.paths.pathPriceRecommendation, {
                        method: "POST",
                        body: JSON.stringify({
                            purchase_date: today.toISOString().split("T")[0],
                            product_price: parseFloat(retailPriceElem.value),
                            listing_condition: parseInt(target.value),
                            shipping_price: parseFloat(shippingPriceElem.value)
                        }),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                    const priceRecommendationResponse = await priceRecommendation.json();
                    if (!priceRecommendationResponse.errors) {
                        usedPriceElem.setAttribute("placeholder", usedPriceElem.getAttribute("data-recommended-text") + recAppProxyConfig.settings.shop.currency_code + parseFloat(priceRecommendationResponse.pricing.recommended_price).toFixed(0));
                        usedPriceElem.setAttribute("data-price-default", parseFloat(priceRecommendationResponse.pricing.recommended_price).toFixed(2));
                    }
                }
            }
        });
    });
    /* Listen for change/keyup of pricing field and modify/populate description prompts accordingly */ const listingPriceChange = (e)=>{
        const target = e.currentTarget;
        const listingPrice = parseFloat(target.value);
        const shippingPriceElem = document.querySelector("#rec-shipping-price");
        const pricingDescriptionDefault = document.querySelector(".rec-slf-description-listing-price-default");
        const pricingDescriptionCalculated = document.querySelector(".rec-slf-description-listing-price-calculated");
        const salePriceSpan = document.querySelector(".pricing-sale-price");
        const payoutCreditSpan = document.querySelector(".pricing-payout-credit");
        const payoutCashSpan = document.querySelector(".pricing-payout-cash");
        if (!shippingPriceElem) {
            console.error("Shipping price element not found");
            return;
        }
        const shippingPrice = parseFloat(shippingPriceElem.value);
        if (!isNaN(listingPrice) && listingPrice > 0) {
            if (pricingDescriptionDefault) pricingDescriptionDefault.classList.add("rec-hidden");
            if (pricingDescriptionCalculated) {
                // Apply the calculations needed
                const salePrice = listingPrice + shippingPrice;
                if (salePriceSpan) salePriceSpan.innerHTML = recAppProxyConfig.settings.shop.currency_code + salePrice.toString();
                const payoutCash = parseFloat((listingPrice * recAppProxyConfig.settings.payout.cash.payout_percentage).toFixed(2));
                if (payoutCashSpan) payoutCashSpan.innerHTML = recAppProxyConfig.settings.shop.currency_code + payoutCash.toString();
                const payoutCredit = parseFloat((listingPrice * recAppProxyConfig.settings.payout.credit.payout_percentage).toFixed(2));
                if (payoutCreditSpan) payoutCreditSpan.innerHTML = recAppProxyConfig.settings.shop.currency_code + payoutCredit.toString();
                pricingDescriptionCalculated.classList.remove("rec-hidden");
            }
        } else {
            if (pricingDescriptionDefault) pricingDescriptionDefault.classList.remove("rec-hidden");
            if (pricingDescriptionCalculated) pricingDescriptionCalculated.classList.add("rec-hidden");
        }
    };
    const listingPriceInput = document.querySelector("#rec-slf-listing-price");
    if (listingPriceInput) {
        listingPriceInput.addEventListener("change", listingPriceChange);
        listingPriceInput.addEventListener("keyup", listingPriceChange);
    } else console.error("Listing price input element not found");
    /* Main function to submit the listing form as either a new/updated listing or new/updated draft */ const sellerListingFormExec = async (sellerListingForm, options)=>{
        /* Simple function to check the size of our payload array before submission */ const getSizeInMB = (obj)=>{
            let str = null;
            if (typeof obj === "string") // If obj is a string, then use it
            str = obj;
            else // Else, make obj into a string
            str = JSON.stringify(obj);
            // Get the length of the Uint8Array
            const bytes = new TextEncoder().encode(str).length / 1000 / 1000;
            return bytes;
        };
        const thisCaller = options?.caller || "";
        //retrieve form data
        let formData = (0, $0aaed1fbbefba3fa$export$2bccf78e246a5305)(sellerListingForm);
        //handle AVS selection and remove data from form data
        if (formData.rec_slf_avs_choice == "avs") {
            formData.seller_address_line1 = formData.seller_address_line1_avs;
            formData.seller_address_line2 = formData.seller_address_line2_avs;
            formData.seller_city = formData.seller_city_avs;
            formData.seller_state = formData.seller_state_avs;
            formData.seller_postal = formData.seller_postal_avs;
            formData.seller_address_resave = 1; // force flag to resave this address data to Shopify
        }
        delete formData.rec_slf_avs_choice;
        delete formData.seller_first_name_avs;
        delete formData.seller_last_name_avs;
        delete formData.seller_address_line1_avs;
        delete formData.seller_address_line2_avs;
        delete formData.seller_city_avs;
        delete formData.seller_state_avs;
        delete formData.seller_postal_avs;
        delete formData.seller_country_avs;
        let postPath = "";
        let toastVar = "";
        let isDraft = false;
        let isPriceDrop = false;
        switch(formData.action_type){
            case "listing":
                postPath = recAppProxyConfig.paths.pathListingPost;
                toastVar = "tlc";
                break;
            case "draft":
                postPath = recAppProxyConfig.paths.pathDraftPost;
                toastVar = "tds";
                isDraft = true;
                break;
            case "patch":
                if (thisCaller == "priceDrop") {
                    postPath = recAppProxyConfig.paths.pathListingPatch.replace("%lid%", `${formData["listing_id"]}/price_drop`);
                    isPriceDrop = true;
                } else postPath = recAppProxyConfig.paths.pathListingPatch.replace("%lid%", formData["listing_id"]);
                toastVar = "tls";
                break;
            case "patch_draft":
                postPath = recAppProxyConfig.paths.pathDraftPatch.replace("%lid%", formData["listing_id"]);
                toastVar = "tds";
                isDraft = true;
                break;
        }
        if (isPriceDrop || (0, $0aaed1fbbefba3fa$export$554f10b70e241fff)(sellerListingForm, -1)) {
            //check/append images
            sellerListingForm.querySelectorAll(".rec-slf-entry .dz-preview").forEach((thisPreviewElem, index)=>{
                const thisImageKey = thisPreviewElem.getAttribute("data-image-key");
                const thisImageInputName = `listing_image${index + 1}`;
                if (thisImageKey !== null) {
                    const thisImageInputKey = thisImageKey.replace("-", "_");
                    if (thisImageKey.indexOf("listing-image") === 0) formData[thisImageInputName] = recDropzonePreloaded[recDropzoneFiles[thisImageKey].name] ? recDropzonePreloaded[recDropzoneFiles[thisImageKey].name] : recDropzonePreloaded[thisImageInputKey];
                    else formData[thisImageInputName] = thisImageKey in recDropzoneFilesCompressed ? recDropzoneFilesCompressed[thisImageKey].dataURL : recDropzoneFiles[thisImageKey].dataURL;
                }
            });
            //apply any cleanup on payload data
            delete formData.action_type;
            formData.listing_price = parseFloat(formData.listing_price);
            formData.listing_price = formData.listing_price ? formData.listing_price : 0;
            //create attributes array
            formData.listing_attributes = {};
            formData.listing_attributes["seller_address_id"] = formData.seller_address_id;
            // handle dynamic list of attributes from proxy settings
            for (let la of recAppProxyConfig.settings.listing_attributes)if (`listing_attribute_${la.attribute_name}` in formData) {
                formData.listing_attributes[la.attribute_name] = formData[`listing_attribute_${la.attribute_name}`];
                delete formData[`listing_attribute_${la.attribute_name}`];
            }
            //remove fields for an unmatched listing
            if (formData.product_variant_id.length == 0) {
                delete formData.product_variant_id;
                delete formData.product_id;
            }
            /* Do a final check on the size of our payload and error/alert if it looks too big */ if (getSizeInMB(formData) > 8) {
                (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-listing-request-size");
                return false;
            }
            try {
                let listingOrDraftPost = await fetch(postPath, {
                    method: "POST",
                    body: JSON.stringify(formData),
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
                const listingOrDraftResponse = await listingOrDraftPost.json();
                if (!listingOrDraftResponse.errors && (0, $0aaed1fbbefba3fa$export$a6cdc56e425d0d0a)(listingOrDraftResponse.data) && "listing_status" in listingOrDraftResponse.data) {
                    let confirmUrl = recAppProxyConfig.paths.pathListingConfirmation.replace("%lid%", listingOrDraftResponse.data.listing_id);
                    if (isDraft) confirmUrl += "&rdraft";
                    if ("seller_prelogin" in formData) confirmUrl += `&preloginSellerUUID=${formData.seller_id}&preloginListingId=${listingOrDraftResponse.data.listing_id}`;
                    if (thisCaller == "priceDrop") document.location = recAppProxyConfig.paths.pathListings + `&t=tlpd`;
                    else document.location = confirmUrl;
                } else {
                    (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                    (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-listing-error");
                }
            } catch (error) {
                (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-listing-error");
            }
        }
    };
    /* Listen for the submission of the seller listing form and do the thing */ const sellerListingForms = document.querySelectorAll(".rec-slf-form");
    sellerListingForms.forEach((element)=>{
        const sellerListingForm = element;
        const sellerListingFormActionType = sellerListingForm.querySelector(".rec-slf-form-action-type");
        const sellerListingFormActionDraft = sellerListingForm.querySelector(".rec-slf-action-draft-create");
        const sellerListingFormActionSaveDraft = sellerListingForm.querySelector(".rec-slf-action-draft-save");
        const sellerListingFormActionCreate = sellerListingForm.querySelector(".rec-slf-action-create");
        const sellerListingFormActionSave = sellerListingForm.querySelector(".rec-slf-action-save");
        const sellerAddressForm = sellerListingForm.querySelector(".rec-shipping-address-form");
        const sellerAddressAvsContinue = sellerListingForm.querySelector(".rec-slf-avs-complete");
        if (sellerAddressAvsContinue) sellerAddressAvsContinue.addEventListener("click", async (e)=>{
            e.preventDefault();
            (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(e.target);
            await sellerListingFormExec(sellerListingForm, {
                caller: "avs"
            });
        });
        /* Price Drop Functionality */ const priceDropModal = document.getElementById("rec-slf-price-drop");
        if (priceDropModal) {
            (0, $d6ee11c3a9c3c098$export$4d5c5f543a633f69)(priceDropModal.id);
            const priceDropCompleteButton = document.querySelector(".rec-slf-price-drop-complete");
            if (priceDropCompleteButton) priceDropCompleteButton.addEventListener("click", async (e)=>{
                e.preventDefault();
                (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(e.target);
                await sellerListingFormExec(sellerListingForm, {
                    caller: "priceDrop"
                });
            });
            else console.error("Price drop complete button not found");
        }
        /* Removal Functionality */ const removalModal = document.getElementById("rec-slf-removal");
        if (removalModal) {
            (0, $d6ee11c3a9c3c098$export$4d5c5f543a633f69)(removalModal.id);
            const removalCompleteButton = document.querySelector(".rec-slf-removal-complete");
            if (removalCompleteButton) removalCompleteButton.addEventListener("click", async (e)=>{
                e.preventDefault();
                const target = e.currentTarget;
                (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(target);
                const listingId = target.getAttribute("data-listing");
                const listingStatus = target.getAttribute("data-listing-status");
                if (listingId && listingStatus) {
                    const listingCancelPost = await fetch(recAppProxyConfig.paths.pathListingCancelPost.replace("%lid%", listingId), {
                        method: "POST",
                        body: JSON.stringify({
                            listing_status: listingStatus
                        }),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                    const listingCancelPostResponse = await listingCancelPost.json();
                    if (!listingCancelPostResponse.errors && (0, $0aaed1fbbefba3fa$export$a6cdc56e425d0d0a)(listingCancelPostResponse.data) && "listing_status" in listingCancelPostResponse.data) document.location = recAppProxyConfig.paths.pathListings + `&t=tlcl`;
                    else {
                        (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                        (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                    }
                } else {
                    console.error("Listing ID or status not found");
                    (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                }
            });
            else console.error("Removal complete button not found");
        }
        /* New Listing */ if (sellerListingFormActionCreate) sellerListingFormActionCreate.addEventListener("click", async (e)=>{
            e.preventDefault();
            const callerValue = sellerListingForm.seller_prelogin ? "createDraft" : "create";
            if (sellerListingFormActionType) sellerListingFormActionType.value = sellerListingForm.seller_prelogin ? "draft" : "listing";
            else console.error("Seller listing form action type input not found");
            await addressFieldsApply(sellerListingForm);
            if ((0, $36de584fe04094bb$export$5b1fedd534ce7f2b)(sellerListingForm, "") && (0, $0aaed1fbbefba3fa$export$554f10b70e241fff)(sellerListingForm, -1)) {
                (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(e.target);
                if (recAppProxyConfig.settings.addresses?.avs && sellerAddressForm !== null) {
                    const addressValidation = await $50e8f9f0fac5fdeb$var$addressValidator(sellerAddressForm);
                    if (addressValidation.errors) {
                        (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                        (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                    } else if (addressValidation.data.addressesDiffer || !addressValidation.data.avs.success) {
                        const avsBody = document.getElementById("rec-modal-avs-body");
                        if (avsBody) {
                            avsBody.innerHTML = addressValidation.avsModalContent;
                            (0, $d6ee11c3a9c3c098$export$4d5c5f543a633f69)("rec-slf-avs", sellerListingFormActionCreate);
                        } else console.error("AVS modal body element not found");
                    } else await sellerListingFormExec(sellerListingForm, {
                        caller: callerValue
                    });
                } else await sellerListingFormExec(sellerListingForm, {
                    caller: callerValue
                });
            }
        });
        else console.error("Seller listing form action create button not found");
        /* Save Listing */ if (sellerListingFormActionSave) sellerListingFormActionSave.addEventListener("click", async (e)=>{
            e.preventDefault();
            await addressFieldsApply(sellerListingForm);
            if ((0, $36de584fe04094bb$export$5b1fedd534ce7f2b)(sellerListingForm, "") && (0, $0aaed1fbbefba3fa$export$554f10b70e241fff)(sellerListingForm, -1)) {
                (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(e.target);
                if (recAppProxyConfig.settings.addresses?.avs) {
                    if (sellerAddressForm !== null) {
                        const addressValidation = await $50e8f9f0fac5fdeb$var$addressValidator(sellerAddressForm);
                        if (addressValidation.errors) {
                            (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
                            (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
                        } else if (addressValidation.data.addressesDiffer || !addressValidation.data.avs.success) {
                            const avsBody = document.getElementById("rec-modal-avs-body");
                            if (avsBody) {
                                avsBody.innerHTML = addressValidation.avsModalContent;
                                (0, $d6ee11c3a9c3c098$export$4d5c5f543a633f69)("rec-slf-avs", sellerListingFormActionSave);
                            } else console.error("AVS modal body element not found");
                        } else await sellerListingFormExec(sellerListingForm, {
                            caller: "save"
                        });
                    } else await sellerListingFormExec(sellerListingForm, {
                        caller: "save"
                    });
                } else await sellerListingFormExec(sellerListingForm, {
                    caller: "save"
                });
            }
        });
        /* New Draft */ if (sellerListingFormActionDraft) sellerListingFormActionDraft.addEventListener("click", async (e)=>{
            e.preventDefault();
            if (sellerListingFormActionType) sellerListingFormActionType.value = "draft";
            else console.error("Seller listing form action type input not found");
            addressFieldsApply(sellerListingForm);
            if ((0, $36de584fe04094bb$export$5b1fedd534ce7f2b)(sellerListingForm, "rec-required-draft-ignore")) {
                (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(e.target);
                await sellerListingFormExec(sellerListingForm, {
                    caller: "createDraft"
                });
            }
        });
        /* Save Draft */ if (sellerListingFormActionSaveDraft) sellerListingFormActionSaveDraft.addEventListener("click", async (e)=>{
            e.preventDefault();
            await addressFieldsApply(sellerListingForm);
            if ((0, $36de584fe04094bb$export$5b1fedd534ce7f2b)(sellerListingForm, "rec-required-draft-ignore")) {
                (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(e.target);
                await sellerListingFormExec(sellerListingForm, {
                    caller: "saveDraft"
                });
            }
        });
        (0, $b00299261358dd80$export$d3cd5a45b9e13a7)(`#${sellerListingForm.id}`, true, dropzoneObjects, recDropzoneFiles, recDropzoneFilesCompressed, recDropzonePreloaded);
        const isMobile = (0, $0aaed1fbbefba3fa$export$677c23edf9caf375)();
        /* Setup the Drag n Drop capability of the seller listing form's image dropzones */ if (!isMobile) {
            const sortableElement = sellerListingForm.querySelector(".rec-images-sortable");
            if (sortableElement) $50e8f9f0fac5fdeb$var$imageDropzonesDnD(sortableElement);
            else console.error("Sortable element not found");
        }
    });
    /* Initialize an interval to check for QR listing images every X seconds */ if (recAppProxyConfig.settings.slf.qr_images) {
        const checkQRImages = async ()=>{
            try {
                const sessionId = document.querySelector("#session-id");
                let sessionIdReplace = "";
                if (sessionId === null) {
                    console.error("Session ID input element not found");
                    sessionIdReplace = "no-session-id";
                } else sessionIdReplace = sessionId.value;
                const qrImageCheckPath = recAppProxyConfig.paths.pathQRListingImagesCheck.replace("%sid%", sessionIdReplace);
                const qrImagesCheck = await fetch(qrImageCheckPath, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
                const qrImagesPostResponse = await qrImagesCheck.json();
                if (!qrImagesPostResponse.errors && qrImagesPostResponse.hasImages) {
                    for(let i = 1; i <= 5; i++){
                        const preloadedImageKey = "listing_image" + i;
                        if (preloadedImageKey in qrImagesPostResponse) {
                            recDropzonePreloaded[preloadedImageKey] = qrImagesPostResponse[preloadedImageKey];
                            dropzoneObjects[i - 1].displayExistingFile({
                                name: preloadedImageKey,
                                size: 12345
                            }, qrImagesPostResponse[preloadedImageKey], undefined, undefined, false);
                        }
                    }
                    /**
           * Temporary solution?
           * Hide qr code and clear checkQRImages interval to prevent unwanted behavior
           */ const qrImagesQR = document.querySelector("#rec-qr-image-container");
                    if (qrImagesQR) qrImagesQR.style.visibility = "hidden";
                    clearInterval(intervalId);
                }
            } catch (error) {
                clearInterval(intervalId);
            }
        };
        var intervalId = window.setInterval(checkQRImages, 5000);
        window.setTimeout(function() {
            clearInterval(intervalId);
        }, 300000);
    }
};
async function $50e8f9f0fac5fdeb$var$addressValidator(addressInputContainer) {
    const addressFormData = (0, $0aaed1fbbefba3fa$export$f01be45804d2885c)(addressInputContainer);
    //normalize field property names of the address
    const addressVerifyInput = {
        first_name: addressFormData.seller_first_name,
        last_name: addressFormData.seller_last_name,
        street1: addressFormData.seller_address_line1,
        street2: addressFormData.seller_address_line2,
        city: addressFormData.seller_city,
        state: addressFormData.seller_state,
        zip: addressFormData.seller_postal,
        country: addressFormData.seller_country,
        phone: addressFormData.seller_phone,
        company: ""
    };
    let addressVerifyPost = await fetch(recAppProxyConfig.paths.pathAddressVerify, {
        method: "POST",
        body: JSON.stringify(addressVerifyInput),
        headers: {
            "Content-Type": "application/json"
        }
    });
    const addressVerifyResponse = await addressVerifyPost.json();
    return addressVerifyResponse;
}
/* Drag n Drop */ function $50e8f9f0fac5fdeb$var$imageDropzonesDnD(elem) {
    // Pull the texts of the various dropzones so we preserve that order
    let dropzoneHTMLs = [], dropzoneTexts = [], dropzoneLabels = [];
    elem.querySelectorAll(".rec-image-dropzone-text").forEach((thisDropText)=>{
        dropzoneTexts.push(thisDropText.textContent?.trim() || "");
        dropzoneHTMLs.push(thisDropText.innerHTML.trim());
        dropzoneLabels.push(thisDropText.closest(".rec-image-dropzone")?.getAttribute("aria-label") || null);
    });
    new (0, $bf29d14931f01420$export$2e2bcd8739ae039)(elem, {
        touchStartThreshold: 4,
        animation: 150,
        ghostClass: "rec-sortable-ghost",
        chosenClass: "rec-sortable-chosen",
        dragClass: "rec-sortable-drag",
        onChange: function(evt) {
            elem.querySelectorAll(".rec-image-dropzone-text").forEach((thisDropText, index)=>{
                thisDropText.innerHTML = dropzoneHTMLs[index];
                const dzParent = thisDropText.closest(".rec-image-dropzone");
                if (dzParent) {
                    dzParent.setAttribute("data-rec-text", dropzoneTexts[index]);
                    dzParent.setAttribute("aria-label", dropzoneLabels[index] || "");
                    const removeLink = dzParent.querySelector("a.dz-remove");
                    if (removeLink) removeLink.setAttribute("aria-label", `Remove ${dropzoneTexts[index].toLowerCase()} image`);
                }
            });
        }
    });
}





const $4e83a1d90236ef1a$export$a09e3aef42bc79e4 = ()=>{
    /* Pull the form and results div */ const sellerSearchForm = document.getElementById("rec-seller-search-form-search");
    const searchResultsElem = document.getElementById("rec-seller-search-results");
    /* Ajax based search exec */ const sellerSearchExec = async ()=>{
        const sellerSearchQuery = document.getElementById("rec-seller-search-query");
        const searchResultsElem = document.getElementById("rec-seller-search-results");
        if (!sellerSearchQuery || sellerSearchQuery.value.length == 0) return false;
        if (!searchResultsElem) return false;
        const searchResultsCursor = searchResultsElem.getAttribute("data-cursor") || "";
        try {
            let formData = (0, $0aaed1fbbefba3fa$export$2bccf78e246a5305)(sellerSearchForm);
            formData.cursor = searchResultsCursor;
            formData.ati = parseInt(searchResultsElem.getAttribute("data-ati") || "0");
            formData.searchPost = 1;
            let productSearchResponse = await fetch(recAppProxyConfig.paths.pathSearchExec, {
                method: "POST",
                body: JSON.stringify(formData),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            let productSearchResults = await productSearchResponse.json();
            const searchFiltersElem = document.getElementById("rec-seller-search-filters");
            /* Replace or append search results depending on the cursor value */ if (productSearchResults.content?.length > 0) {
                if (searchResultsCursor.length == 0) searchResultsElem.innerHTML = productSearchResults.content;
                else searchResultsElem.innerHTML += productSearchResults.content;
            } else productSearchResults.resultCount = 0;
            searchResultsElem.classList.add("rec-search-results-rendered");
            searchResultsElem.setAttribute("data-cursor", productSearchResults.cursor);
            searchResultsElem.setAttribute("data-ati", productSearchResults.ati.toString());
            if (productSearchResults.cursor.length == 0 && productSearchResults.resultCount == 0) searchResultsElem.classList.add("rec-search-results-empty");
            else {
                searchResultsElem.classList.remove("rec-search-results-empty");
                if (searchFiltersElem) searchFiltersElem.classList.remove("rec-hidden");
            }
            if (productSearchResults.hasNextPage) searchResultsElem.classList.add("rec-search-results-has-next-page");
            else searchResultsElem.classList.remove("rec-search-results-has-next-page");
            (0, $d6ee11c3a9c3c098$export$cfee27000322576d)();
        } catch (error) {
            console.error("sellerSearchExec: ", error);
            (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
        }
        (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
    };
    /* Evaluate/handle search filters/tags */ const initSellerSearchFiltering = ()=>{
        const evaluateSearchFilterTags = ()=>{
            /* Find filters that are active and pull out tags */ let searchFilterTags = [];
            const searchTagsInput = document.getElementById("rec-seller-search-tags");
            document.querySelectorAll(".rec-seller-search-filter.rec-search-filter-active").forEach((thisActiveSearchFilter)=>{
                searchFilterTags.push(thisActiveSearchFilter.getAttribute("data-filter"));
            });
            /* Assign tags field */ if (searchTagsInput) searchTagsInput.value = searchFilterTags.filter((tag)=>tag !== null).join(",");
            else console.error("Search tags input element not found");
            /* Submit search */ const searchGoButton = document.getElementById("rec-seller-search-go");
            if (searchGoButton) (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(searchGoButton);
            else console.error("Search go button not found");
            const searchResultsElem = document.getElementById("rec-seller-search-results");
            if (searchResultsElem) {
                searchResultsElem.setAttribute("data-cursor", "");
                searchResultsElem.setAttribute("data-ati", "-1");
            } else console.error("Search results element not found");
            sellerSearchExec();
        };
        const searchFilterParents = document.querySelectorAll(".rec-seller-search-filter-parent");
        const searchFilterChildren = document.querySelectorAll(".rec-seller-search-filter-child");
        document.querySelectorAll(".rec-seller-search-filter").forEach((thisSearchFilter)=>{
            thisSearchFilter.addEventListener("click", (e)=>{
                e.preventDefault();
                const target = e.target;
                const secondaryFiltersElem = document.getElementById("rec-seller-search-filters-secondary");
                if (secondaryFiltersElem) secondaryFiltersElem.style.display = "block";
                else console.error("Secondary filters element not found");
                // Reset parents if this is a parent filter
                if (target.classList.contains("rec-seller-search-filter-parent")) {
                    if (target.classList.contains("rec-search-filter-active")) return false;
                    searchFilterParents.forEach((thisSearchFilterParent)=>{
                        thisSearchFilterParent.classList.remove("rec-search-filter-active");
                    });
                }
                // Reset children
                searchFilterChildren.forEach((thisSearchFilterChild)=>{
                    if (target.classList.contains("rec-seller-search-filter-parent")) {
                        thisSearchFilterChild.classList.remove("rec-search-filter-active");
                        thisSearchFilterChild.classList.remove("rec-search-filter-parent-active");
                        if (thisSearchFilterChild.getAttribute("data-filter-parent") === target.getAttribute("data-filter")) thisSearchFilterChild.classList.add("rec-search-filter-parent-active");
                    } else if (!target.classList.contains("rec-search-filter-active")) thisSearchFilterChild.classList.remove("rec-search-filter-active");
                });
                if (target.classList.contains("rec-seller-search-filter-parent")) target.classList.add("rec-search-filter-active");
                else target.classList.toggle("rec-search-filter-active");
                // All filters have been adjusted, determine what tags are active
                evaluateSearchFilterTags();
            });
        });
    };
    /* Based on variant options selected, determine which variant is selected */ // TODO: The any type below needs to be reverse-engineered.
    const sellerSearchSelectVariant = (variantData, optionGroups, variantImage, sellBtn)=>{
        let thisKey = [];
        let oneOptionBlank = false;
        const sellBtnParent = sellBtn.closest(".rec-variant-selection-options");
        optionGroups.forEach((thisGroup)=>{
            const thisGroupSelectedOptions = thisGroup.querySelectorAll("button.rec-variant-selection-option-selected");
            if (thisGroupSelectedOptions.length == 0) oneOptionBlank = true;
            thisGroupSelectedOptions.forEach((thisBtn)=>{
                thisKey.push((0, $0aaed1fbbefba3fa$export$7272b5ee9aadcdd9)(thisBtn.value, false));
            });
        });
        let thisKeyString = thisKey.join("-");
        if (thisKeyString in variantData) {
            const selectedText = sellBtn.getAttribute("data-text-selected");
            if (selectedText !== null) sellBtn.innerHTML = selectedText;
            sellBtn.removeAttribute("disabled");
            sellBtn.classList.remove("disabled");
            if (variantData[thisKeyString].image) variantImage.setAttribute("src", variantData[thisKeyString].image.url);
            else {
                const defaultSrc = variantImage.getAttribute("data-default");
                if (defaultSrc !== null) variantImage.setAttribute("src", defaultSrc);
            }
            sellBtn.setAttribute("href", sellBtn.getAttribute("data-url") + variantData[thisKeyString].legacyResourceId);
        } else {
            if (oneOptionBlank) {
                const defaultText = sellBtn.getAttribute("data-text-default");
                if (defaultText !== null) sellBtn.innerHTML = defaultText;
            } else {
                const unavailableText = sellBtn.getAttribute("data-text-unavailable");
                if (unavailableText !== null) sellBtn.innerHTML = unavailableText;
            }
            sellBtn.setAttribute("disabled", "");
            sellBtn.classList.add("disabled");
        }
    };
    /* Button clicked to retrieve variant options information and display variant option selectors */ const sellerSearchSetupOptions = async (btn)=>{
        /* Do nothing for no resale items */ if (btn.classList.contains("rec-noresale")) return false;
        const thisProductId = btn.getAttribute("data-product-id") || "";
        const thisSearchItem = btn.closest(".rec-search-result");
        const thisSearchItemModal = btn.getAttribute("data-modal-id") || "";
        const thisSearchItemModalImage = thisSearchItem?.querySelector(".rec-variant-selection-img img");
        const thisSearchItemOptionGroups = thisSearchItem?.querySelectorAll(".rec-variant-selection-option");
        const thisSearchItemOptionButtons = thisSearchItem?.querySelectorAll(".rec-variant-selection-option-values button");
        const thisSearchItemVariantChoose = thisSearchItem?.querySelector(".rec-search-result-variant-choose");
        (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(btn);
        try {
            let productVariantsResponse = await fetch(recAppProxyConfig.paths.pathProductVariants.replace("%pid%", thisProductId.replace(/\//g, "_")), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const productVariants = await productVariantsResponse.json();
            if (productVariants.errors) (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
            else {
                (0, $d6ee11c3a9c3c098$export$4d5c5f543a633f69)(thisSearchItemModal, btn);
                const searchResultElement = thisSearchItem.closest(".rec-search-result");
                if (searchResultElement) searchResultElement.classList.add("rec-search-result-selected");
                thisSearchItemOptionButtons.forEach((thisSelector)=>{
                    thisSelector.addEventListener("click", (e)=>{
                        e.preventDefault();
                        const currentTarget = e.currentTarget;
                        if (currentTarget) {
                            const variantOption = currentTarget.closest(".rec-variant-selection-option");
                            if (variantOption) {
                                variantOption.querySelectorAll("button").forEach((thisBtn)=>{
                                    thisBtn.classList.remove("rec-variant-selection-option-selected");
                                });
                                currentTarget.classList.add("rec-variant-selection-option-selected");
                            }
                        }
                        sellerSearchSelectVariant(productVariants.data, thisSearchItemOptionGroups, thisSearchItemModalImage, thisSearchItemVariantChoose);
                    });
                });
                sellerSearchSelectVariant(productVariants.data, thisSearchItemOptionGroups, thisSearchItemModalImage, thisSearchItemVariantChoose);
            }
        } catch (error) {
            console.error("sellerSearchSetupOptions: ", error);
        }
    };
    /* Listen for the submission of the search form and do the thing */ if (sellerSearchForm) sellerSearchForm.addEventListener("submit", async (e)=>{
        e.preventDefault();
        if ((0, $36de584fe04094bb$export$5b1fedd534ce7f2b)(sellerSearchForm)) {
            const sellerSearchQuery = document.getElementById("rec-seller-search-query");
            if (sellerSearchQuery && sellerSearchQuery.value.length > 0) {
                const searchGoButton = document.getElementById("rec-seller-search-go");
                if (searchGoButton) (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(searchGoButton);
                else console.error("Search go button not found");
                const searchResultsElem = document.getElementById("rec-seller-search-results");
                if (searchResultsElem) {
                    searchResultsElem.setAttribute("data-cursor", "");
                    searchResultsElem.setAttribute("data-ati", "-1");
                } else console.error("Search results element not found");
                sellerSearchExec();
            }
        }
    });
    /* Listen for the clicking of dynamically loaded content */ document.addEventListener("click", async (e)=>{
        const target = e.target;
        /* item selection buttons to load that item's variant selector */ if (target && target.classList.contains("rec-search-result-select")) await sellerSearchSetupOptions(target);
        else if (target && target.parentElement && target.parentElement.classList.contains("rec-search-result-select")) await sellerSearchSetupOptions(target.parentElement);
        else if (/* load more buttons */ target && target.classList.contains("rec-search-results-load-more")) {
            const sellerSearchQuery = document.getElementById("rec-seller-search-query");
            if (sellerSearchQuery && sellerSearchQuery.value.length > 0) {
                (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).loadingToggle(target);
                sellerSearchExec();
            }
        }
    });
    /* Setup filtering handling */ initSellerSearchFiltering();
};



/* Some helpful global vars */ var $c50833cb1adc392d$var$recPageActive = "", $c50833cb1adc392d$var$dropzoneObjects = [], $c50833cb1adc392d$var$recDropzoneFiles = {}, $c50833cb1adc392d$var$recDropzonePreloaded = {}, $c50833cb1adc392d$var$recDropzoneFilesCompressed = {};
/* Define our possible paths */ recAppProxyConfig.paths = {
    pathPrimary: `${recAppProxyConfig.settings.shop.app_proxy_path}?rp`,
    pathListings: `${recAppProxyConfig.settings.shop.app_proxy_path}/listings?rp`,
    pathListingPost: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/?rp`,
    pathListingPatch: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%?rp`,
    pathListingConfirmation: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%/confirm?rp`,
    pathListingPausePost: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%/pause/?rp`,
    pathListingResumePost: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%/resume/?rp`,
    pathListingCancelPost: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%/cancel/?rp`,
    pathRatingExec: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%/rating/?rp`,
    pathDisputeExec: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%/dispute/?rp`,
    pathPayoutExec: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%/payout/%selection%/%aid%?rp`,
    pathDraftPost: `${recAppProxyConfig.settings.shop.app_proxy_path}/draft/?rp`,
    pathDraftPatch: `${recAppProxyConfig.settings.shop.app_proxy_path}/draft/%lid%?rp`,
    pathSearchExec: `${recAppProxyConfig.settings.shop.app_proxy_path}/search/?rp`,
    pathPriceRecommendation: `${recAppProxyConfig.settings.shop.app_proxy_path}/price/?rp`,
    pathProductVariants: `${recAppProxyConfig.settings.shop.app_proxy_path}/products/%pid%/variants?rp`,
    pathStripeAidPost: `${recAppProxyConfig.settings.shop.app_proxy_path}/stripe/%country%?rp`,
    pathStripeDashboardGet: `${recAppProxyConfig.settings.shop.app_proxy_path}/stripe/%aid%/link?rp`,
    pathStripeDashboardGetDetails: `${recAppProxyConfig.settings.shop.app_proxy_path}/stripe/%aid%/link/details?rp`,
    pathAddressVerify: `${recAppProxyConfig.settings.shop.app_proxy_path}/address/verify?rp`,
    pathQRListingImages: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing-images-pub/%sid%?rp`,
    pathQRListingImagesCheck: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing-images-check/%sid%?rp`,
    pathAddressGet: `${recAppProxyConfig.settings.shop.app_proxy_path}/address/%aid%?rp`,
    pathAddressSave: `${recAppProxyConfig.settings.shop.app_proxy_path}/address/%aid%?rp`
};
/* Retrieve active page and URL params */ const $c50833cb1adc392d$var$queryString = new URLSearchParams(document.location.search);
const $c50833cb1adc392d$var$recPage = document.querySelector(".rec-page");
if ($c50833cb1adc392d$var$recPage) {
    const activePage = $c50833cb1adc392d$var$recPage.getAttribute("data-active-page");
    if (activePage !== null) $c50833cb1adc392d$var$recPageActive = activePage;
    else console.error("Error: data-active-page attribute is missing on .rec-page element.");
} else console.error("Error: .rec-page element not found.");
/* "button" role spacebar clicks */ document.querySelectorAll(`#rec-outer-wrap div[role="button"]`).forEach((thisBtn)=>{
    thisBtn.addEventListener("keydown", (e)=>{
        const keyboardEvent = e;
        if (keyboardEvent.key === " ") {
            // Check for the spacebar key
            keyboardEvent.preventDefault();
            (0, $0aaed1fbbefba3fa$export$3441ccf90c75f0cd)(keyboardEvent.currentTarget);
        }
    });
});
document.querySelectorAll(".rec-toast-close").forEach((thisToastClosure)=>{
    thisToastClosure.addEventListener("click", (e)=>{
        e.preventDefault();
        const target = e.target;
        const closestToast = target.closest(".rec-toast");
        if (closestToast) closestToast.classList.add("rec-hidden");
    });
});
const $c50833cb1adc392d$var$listingPreloginConfirm = document.querySelector("#rec-prelogin-confirm");
if ($c50833cb1adc392d$var$listingPreloginConfirm) {
    const preloginListingId = $c50833cb1adc392d$var$queryString.get('preloginListingId');
    const preloginSellerUUID = $c50833cb1adc392d$var$queryString.get('preloginSellerUUID');
    if (preloginListingId && preloginSellerUUID) {
        localStorage.setItem('trove_preloginListingId', preloginListingId);
        localStorage.setItem('trove_preloginSellerUUID', preloginSellerUUID);
    }
    $c50833cb1adc392d$var$listingPreloginConfirm.addEventListener("click", async (e)=>{
        e.preventDefault();
        // START if btnUtils.loadingToggle gets updated to use classList.add instead of classList.toggle replace this block below
        if (e.target !== null) {
            const buttonElement = e.target;
            buttonElement.setAttribute("data-default-text", buttonElement.innerHTML);
            buttonElement.innerHTML = `<div class="rec-flex rec-justify-center rec-items-center">
                <?xml version="1.0" ?><svg class="rec-animate-spin" fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M10 3.5C6.41015 3.5 3.5 6.41015 3.5 10C3.5 10.4142 3.16421 10.75 2.75 10.75C2.33579 10.75 2 10.4142 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C9.58579 18 9.25 17.6642 9.25 17.25C9.25 16.8358 9.58579 16.5 10 16.5C13.5899 16.5 16.5 13.5899 16.5 10C16.5 6.41015 13.5899 3.5 10 3.5Z" fill="#212121"/></svg>
                </div>`;
            buttonElement.classList.add("rec-is-loading");
            buttonElement.classList.add("disabled");
            buttonElement.disabled = true;
        } else {
            console.error("listingPreloginConfirm: button element is null");
            return;
        }
        // END
        try {
            const customerLoginForm = document.querySelector("#customer_login");
            if (customerLoginForm !== null) {
                // @ts-expect-error: This file will only load in a Shopify page
                if (window.Shopify?.captcha) // @ts-expect-error: This file will only load in a Shopify page
                window.Shopify?.captcha?.protect(customerLoginForm, ()=>{
                    customerLoginForm.submit();
                });
                else customerLoginForm.submit();
            }
        } catch (error) {
            console.error("listingPreloginConfirm: ", error);
            (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)("toast-ajax-error");
            (0, $0aaed1fbbefba3fa$export$3e9bb9a32e7ba1b3).reset();
        }
    });
}
/* Logic to replace the display of an element based on its condition value */ const $c50833cb1adc392d$var$conditionDisplayInit = ()=>{
    document.querySelectorAll(".rec-condition-display").forEach((thisConditionDisplayElem)=>{
        const conditionValue = thisConditionDisplayElem.getAttribute("data-rec-condition");
        if (conditionValue !== null) {
            const conditionIndex = parseInt(conditionValue);
            if (!isNaN(conditionIndex) && recAppProxyConfig.settings.conditionsLang.length >= conditionIndex) thisConditionDisplayElem.innerHTML = recAppProxyConfig.settings.conditionsLang[conditionIndex - 1];
        }
    });
};
/* On Load Toast Features */ const $c50833cb1adc392d$var$onLoadToasts = ()=>{
    if ($c50833cb1adc392d$var$queryString.has("t")) {
        const toastElem = document.querySelector(`[data-toast="${$c50833cb1adc392d$var$queryString.get("t")}"]`);
        if (toastElem) (0, $0aaed1fbbefba3fa$export$6779263a4a120d42)(toastElem.id);
    }
};
//Setup JS for home page
if ($c50833cb1adc392d$var$recPageActive == "home") (0, $34f93e9d2fa8178e$export$c428c5fbb0f06e17)();
else if ($c50833cb1adc392d$var$recPageActive == "listings") (0, $5bfe79e248706619$export$820d2e5536553120)($c50833cb1adc392d$var$queryString);
else if ($c50833cb1adc392d$var$recPageActive == "search") (0, $4e83a1d90236ef1a$export$a09e3aef42bc79e4)();
else if ($c50833cb1adc392d$var$recPageActive == "list" || $c50833cb1adc392d$var$recPageActive == "listing") (0, $50e8f9f0fac5fdeb$export$9765e84a85f76198)($c50833cb1adc392d$var$dropzoneObjects, $c50833cb1adc392d$var$recDropzoneFiles, $c50833cb1adc392d$var$recDropzoneFilesCompressed, $c50833cb1adc392d$var$recDropzonePreloaded);
else if ($c50833cb1adc392d$var$recPageActive == "settings") (0, $34f93e9d2fa8178e$export$dc16dc93176a931c)();
else if ($c50833cb1adc392d$var$recPageActive == "rating") (0, $47fe95dc40980865$export$2c21c80e7e8fcff)();
else if ($c50833cb1adc392d$var$recPageActive == "dispute") (0, $47fe95dc40980865$export$a55cff1032a76238)($c50833cb1adc392d$var$dropzoneObjects, $c50833cb1adc392d$var$recDropzoneFiles, $c50833cb1adc392d$var$recDropzoneFilesCompressed, $c50833cb1adc392d$var$recDropzonePreloaded);
else if ($c50833cb1adc392d$var$recPageActive == "listing-qr-images") (0, $9f6cfacda726caad$export$1b41b520b899dc8a)($c50833cb1adc392d$var$dropzoneObjects, $c50833cb1adc392d$var$recDropzoneFiles, $c50833cb1adc392d$var$recDropzoneFilesCompressed, $c50833cb1adc392d$var$recDropzonePreloaded);
else if ($c50833cb1adc392d$var$recPageActive == "payout") (0, $2832890a9d28dd4a$export$d1c479f0f4da1db4)(recAppProxyConfig.settings.payout.cash, recAppProxyConfig.customer.stripe.aid);
//display a specific toast based on what's in the query string
$c50833cb1adc392d$var$onLoadToasts();
//setup modals
(0, $d6ee11c3a9c3c098$export$897e0f27d57ea211)();
//setup global replacements of condition
$c50833cb1adc392d$var$conditionDisplayInit();


//# sourceMappingURL=app-proxy-main.js.map
